const Bg = [
  // Visibility-only: visible Back Office where shown, hidden elsewhere.
  "useType",
  "engineBrand",
  "engineModel",
  "width",
  "height",
  // Responsibility-varying: always visible; Back Office/Inspector and required both vary.
  "length",
  "axles",
  "wheels",
  "wheelsSizeAxle1",
  "wheelsSizeAxle2",
  "wheelsSizeAxle3",
  "inspectionExpiryDate",
  "cylinders",
  // Inspector or hidden.
  "hasDepotService"
], Hn = { visibility: "hidden" }, k = { visibility: "visible", responsibility: "BackOffice", required: !0 }, $t = { visibility: "visible", responsibility: "BackOffice", required: !1 }, dr = { visibility: "visible", responsibility: "Inspector", required: !0 }, Kn = { visibility: "visible", responsibility: "Inspector", required: !1 }, Mi = {
  useType: { default: Hn, overrides: { IT: k } },
  engineBrand: {
    default: Hn,
    overrides: {
      IT: k,
      ES: k,
      PT: k,
      BE: k,
      AT: k,
      NL: k
    }
  },
  engineModel: { default: Hn, overrides: { IT: k, ES: k, AT: k } },
  width: {
    default: Hn,
    overrides: { IT: k, ES: k, DE: k, AT: k, LU: k }
  },
  height: {
    default: Hn,
    overrides: { IT: k, ES: k, DE: k, AT: k, LU: k }
  },
  length: {
    default: dr,
    overrides: {
      IT: k,
      ES: k,
      BE: k,
      DE: k,
      AT: k,
      CZ: k,
      NL: k,
      LU: k,
      PT: Kn
    }
  },
  axles: {
    default: dr,
    overrides: {
      IT: k,
      ES: k,
      DE: k,
      AT: k,
      LU: k,
      PT: Kn
    }
  },
  wheels: {
    default: dr,
    overrides: {
      IT: k,
      ES: k,
      DE: k,
      AT: k,
      LU: k,
      PT: Kn
    }
  },
  wheelsSizeAxle1: {
    default: Kn,
    overrides: { IT: k, ES: k, DE: k, AT: k, LU: k }
  },
  wheelsSizeAxle2: {
    default: Kn,
    overrides: { IT: k, ES: k, DE: k, AT: k, LU: $t }
  },
  wheelsSizeAxle3: {
    default: Kn,
    overrides: { IT: k, ES: k, DE: k, AT: k, LU: $t }
  },
  inspectionExpiryDate: { default: k, overrides: { PT: dr, DE: dr } },
  cylinders: { default: dr, overrides: { ES: k } },
  hasDepotService: { default: Hn, overrides: { IT: Kn } }
}, ki = {
  cocDocument: { default: $t, overrides: { BE: k, NL: k } },
  registrationDocument: { default: k },
  maintenanceCard: { default: $t },
  technicalSheet: { default: Hn, overrides: { ES: k } }
};
function gr(n, t) {
  const { default: o, overrides: a } = n;
  if (t != null && a !== void 0) {
    const u = a[t];
    if (u !== void 0) return u;
  }
  return o;
}
function z1(n, t) {
  return gr(Mi[n], t).visibility === "hidden";
}
function Pg(n, t) {
  const o = gr(Mi[n], t);
  return o.visibility === "visible" && o.required;
}
function L1(n, t) {
  const o = gr(Mi[n], t);
  return o.visibility === "visible" ? o.responsibility : void 0;
}
function F1(n) {
  return Bg.filter((t) => Pg(t, n));
}
function G1(n, t) {
  return gr(ki[n], t).visibility === "hidden";
}
function D1(n, t) {
  const o = gr(ki[n], t);
  return o.visibility === "visible" && o.required;
}
function Z1(n, t) {
  const o = gr(ki[n], t);
  return o.visibility === "visible" ? o.responsibility : void 0;
}
function T(n, t, o) {
  function a(g, S) {
    if (g._zod || Object.defineProperty(g, "_zod", {
      value: {
        def: S,
        constr: p,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), g._zod.traits.has(n))
      return;
    g._zod.traits.add(n), t(g, S);
    const E = p.prototype, w = Object.keys(E);
    for (let G = 0; G < w.length; G++) {
      const B = w[G];
      B in g || (g[B] = E[B].bind(g));
    }
  }
  const u = o?.Parent ?? Object;
  class f extends u {
  }
  Object.defineProperty(f, "name", { value: n });
  function p(g) {
    var S;
    const E = o?.Parent ? new f() : this;
    a(E, g), (S = E._zod).deferred ?? (S.deferred = []);
    for (const w of E._zod.deferred)
      w();
    return E;
  }
  return Object.defineProperty(p, "init", { value: a }), Object.defineProperty(p, Symbol.hasInstance, {
    value: (g) => o?.Parent && g instanceof o.Parent ? !0 : g?._zod?.traits?.has(n)
  }), Object.defineProperty(p, "name", { value: n }), p;
}
class hr extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class Wu extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const Vu = {};
function qn(n) {
  return Vu;
}
function Ju(n) {
  const t = Object.values(n).filter((a) => typeof a == "number");
  return Object.entries(n).filter(([a, u]) => t.indexOf(+a) === -1).map(([a, u]) => u);
}
function yi(n, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Bi(n) {
  return {
    get value() {
      {
        const t = n();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Pi(n) {
  return n == null;
}
function Ri(n) {
  const t = n.startsWith("^") ? 1 : 0, o = n.endsWith("$") ? n.length - 1 : n.length;
  return n.slice(t, o);
}
function Rg(n, t) {
  const o = (n.toString().split(".")[1] || "").length, a = t.toString();
  let u = (a.split(".")[1] || "").length;
  if (u === 0 && /\d?e-\d?/.test(a)) {
    const S = a.match(/\d?e-(\d?)/);
    S?.[1] && (u = Number.parseInt(S[1]));
  }
  const f = o > u ? o : u, p = Number.parseInt(n.toFixed(f).replace(".", "")), g = Number.parseInt(t.toFixed(f).replace(".", ""));
  return p % g / 10 ** f;
}
const Au = /* @__PURE__ */ Symbol("evaluating");
function j(n, t, o) {
  let a;
  Object.defineProperty(n, t, {
    get() {
      if (a !== Au)
        return a === void 0 && (a = Au, a = o()), a;
    },
    set(u) {
      Object.defineProperty(n, t, {
        value: u
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Vn(n, t, o) {
  Object.defineProperty(n, t, {
    value: o,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function kn(...n) {
  const t = {};
  for (const o of n) {
    const a = Object.getOwnPropertyDescriptors(o);
    Object.assign(t, a);
  }
  return Object.defineProperties({}, t);
}
function Tu(n) {
  return JSON.stringify(n);
}
function Og(n) {
  return n.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const ju = "captureStackTrace" in Error ? Error.captureStackTrace : (...n) => {
};
function Kt(n) {
  return typeof n == "object" && n !== null && !Array.isArray(n);
}
const zg = Bi(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const n = Function;
    return new n(""), !0;
  } catch {
    return !1;
  }
});
function qr(n) {
  if (Kt(n) === !1)
    return !1;
  const t = n.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const o = t.prototype;
  return !(Kt(o) === !1 || Object.prototype.hasOwnProperty.call(o, "isPrototypeOf") === !1);
}
function Yu(n) {
  return qr(n) ? { ...n } : Array.isArray(n) ? [...n] : n;
}
const Lg = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function mr(n) {
  return n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Bn(n, t, o) {
  const a = new n._zod.constr(t ?? n._zod.def);
  return (!t || o?.parent) && (a._zod.parent = n), a;
}
function P(n) {
  const t = n;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Fg(n) {
  return Object.keys(n).filter((t) => n[t]._zod.optin === "optional" && n[t]._zod.optout === "optional");
}
const Gg = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function Dg(n, t) {
  const o = n._zod.def, a = o.checks;
  if (a && a.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const f = kn(n._zod.def, {
    get shape() {
      const p = {};
      for (const g in t) {
        if (!(g in o.shape))
          throw new Error(`Unrecognized key: "${g}"`);
        t[g] && (p[g] = o.shape[g]);
      }
      return Vn(this, "shape", p), p;
    },
    checks: []
  });
  return Bn(n, f);
}
function Zg(n, t) {
  const o = n._zod.def, a = o.checks;
  if (a && a.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const f = kn(n._zod.def, {
    get shape() {
      const p = { ...n._zod.def.shape };
      for (const g in t) {
        if (!(g in o.shape))
          throw new Error(`Unrecognized key: "${g}"`);
        t[g] && delete p[g];
      }
      return Vn(this, "shape", p), p;
    },
    checks: []
  });
  return Bn(n, f);
}
function Ug(n, t) {
  if (!qr(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const o = n._zod.def.checks;
  if (o && o.length > 0) {
    const f = n._zod.def.shape;
    for (const p in t)
      if (Object.getOwnPropertyDescriptor(f, p) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const u = kn(n._zod.def, {
    get shape() {
      const f = { ...n._zod.def.shape, ...t };
      return Vn(this, "shape", f), f;
    }
  });
  return Bn(n, u);
}
function $g(n, t) {
  if (!qr(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const o = kn(n._zod.def, {
    get shape() {
      const a = { ...n._zod.def.shape, ...t };
      return Vn(this, "shape", a), a;
    }
  });
  return Bn(n, o);
}
function Kg(n, t) {
  const o = kn(n._zod.def, {
    get shape() {
      const a = { ...n._zod.def.shape, ...t._zod.def.shape };
      return Vn(this, "shape", a), a;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Bn(n, o);
}
function Hg(n, t, o) {
  const u = t._zod.def.checks;
  if (u && u.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const p = kn(t._zod.def, {
    get shape() {
      const g = t._zod.def.shape, S = { ...g };
      if (o)
        for (const E in o) {
          if (!(E in g))
            throw new Error(`Unrecognized key: "${E}"`);
          o[E] && (S[E] = n ? new n({
            type: "optional",
            innerType: g[E]
          }) : g[E]);
        }
      else
        for (const E in g)
          S[E] = n ? new n({
            type: "optional",
            innerType: g[E]
          }) : g[E];
      return Vn(this, "shape", S), S;
    },
    checks: []
  });
  return Bn(t, p);
}
function qg(n, t, o) {
  const a = kn(t._zod.def, {
    get shape() {
      const u = t._zod.def.shape, f = { ...u };
      if (o)
        for (const p in o) {
          if (!(p in f))
            throw new Error(`Unrecognized key: "${p}"`);
          o[p] && (f[p] = new n({
            type: "nonoptional",
            innerType: u[p]
          }));
        }
      else
        for (const p in u)
          f[p] = new n({
            type: "nonoptional",
            innerType: u[p]
          });
      return Vn(this, "shape", f), f;
    }
  });
  return Bn(t, a);
}
function pr(n, t = 0) {
  if (n.aborted === !0)
    return !0;
  for (let o = t; o < n.issues.length; o++)
    if (n.issues[o]?.continue !== !0)
      return !0;
  return !1;
}
function Xu(n, t) {
  return t.map((o) => {
    var a;
    return (a = o).path ?? (a.path = []), o.path.unshift(n), o;
  });
}
function Dt(n) {
  return typeof n == "string" ? n : n?.message;
}
function Wn(n, t, o) {
  const a = { ...n, path: n.path ?? [] };
  if (!n.message) {
    const u = Dt(n.inst?._zod.def?.error?.(n)) ?? Dt(t?.error?.(n)) ?? Dt(o.customError?.(n)) ?? Dt(o.localeError?.(n)) ?? "Invalid input";
    a.message = u;
  }
  return delete a.inst, delete a.continue, t?.reportInput || delete a.input, a;
}
function Oi(n) {
  return Array.isArray(n) ? "array" : typeof n == "string" ? "string" : "unknown";
}
function Wr(...n) {
  const [t, o, a] = n;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: o,
    inst: a
  } : { ...t };
}
const Qu = (n, t) => {
  n.name = "$ZodError", Object.defineProperty(n, "_zod", {
    value: n._zod,
    enumerable: !1
  }), Object.defineProperty(n, "issues", {
    value: t,
    enumerable: !1
  }), n.message = JSON.stringify(t, yi, 2), Object.defineProperty(n, "toString", {
    value: () => n.message,
    enumerable: !1
  });
}, ec = T("$ZodError", Qu), nc = T("$ZodError", Qu, { Parent: Error });
function Wg(n, t = (o) => o.message) {
  const o = {}, a = [];
  for (const u of n.issues)
    u.path.length > 0 ? (o[u.path[0]] = o[u.path[0]] || [], o[u.path[0]].push(t(u))) : a.push(t(u));
  return { formErrors: a, fieldErrors: o };
}
function Vg(n, t = (o) => o.message) {
  const o = { _errors: [] }, a = (u) => {
    for (const f of u.issues)
      if (f.code === "invalid_union" && f.errors.length)
        f.errors.map((p) => a({ issues: p }));
      else if (f.code === "invalid_key")
        a({ issues: f.issues });
      else if (f.code === "invalid_element")
        a({ issues: f.issues });
      else if (f.path.length === 0)
        o._errors.push(t(f));
      else {
        let p = o, g = 0;
        for (; g < f.path.length; ) {
          const S = f.path[g];
          g === f.path.length - 1 ? (p[S] = p[S] || { _errors: [] }, p[S]._errors.push(t(f))) : p[S] = p[S] || { _errors: [] }, p = p[S], g++;
        }
      }
  };
  return a(n), o;
}
const zi = (n) => (t, o, a, u) => {
  const f = a ? Object.assign(a, { async: !1 }) : { async: !1 }, p = t._zod.run({ value: o, issues: [] }, f);
  if (p instanceof Promise)
    throw new hr();
  if (p.issues.length) {
    const g = new (u?.Err ?? n)(p.issues.map((S) => Wn(S, f, qn())));
    throw ju(g, u?.callee), g;
  }
  return p.value;
}, Li = (n) => async (t, o, a, u) => {
  const f = a ? Object.assign(a, { async: !0 }) : { async: !0 };
  let p = t._zod.run({ value: o, issues: [] }, f);
  if (p instanceof Promise && (p = await p), p.issues.length) {
    const g = new (u?.Err ?? n)(p.issues.map((S) => Wn(S, f, qn())));
    throw ju(g, u?.callee), g;
  }
  return p.value;
}, Jt = (n) => (t, o, a) => {
  const u = a ? { ...a, async: !1 } : { async: !1 }, f = t._zod.run({ value: o, issues: [] }, u);
  if (f instanceof Promise)
    throw new hr();
  return f.issues.length ? {
    success: !1,
    error: new (n ?? ec)(f.issues.map((p) => Wn(p, u, qn())))
  } : { success: !0, data: f.value };
}, Jg = /* @__PURE__ */ Jt(nc), jt = (n) => async (t, o, a) => {
  const u = a ? Object.assign(a, { async: !0 }) : { async: !0 };
  let f = t._zod.run({ value: o, issues: [] }, u);
  return f instanceof Promise && (f = await f), f.issues.length ? {
    success: !1,
    error: new n(f.issues.map((p) => Wn(p, u, qn())))
  } : { success: !0, data: f.value };
}, jg = /* @__PURE__ */ jt(nc), Yg = (n) => (t, o, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return zi(n)(t, o, u);
}, Xg = (n) => (t, o, a) => zi(n)(t, o, a), Qg = (n) => async (t, o, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return Li(n)(t, o, u);
}, ev = (n) => async (t, o, a) => Li(n)(t, o, a), nv = (n) => (t, o, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return Jt(n)(t, o, u);
}, rv = (n) => (t, o, a) => Jt(n)(t, o, a), tv = (n) => async (t, o, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return jt(n)(t, o, u);
}, ov = (n) => async (t, o, a) => jt(n)(t, o, a), iv = /^[cC][^\s-]{8,}$/, av = /^[0-9a-z]+$/, sv = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, uv = /^[0-9a-vA-V]{20}$/, cv = /^[A-Za-z0-9]{27}$/, lv = /^[a-zA-Z0-9_-]{21}$/, dv = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, pv = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Cu = (n) => n ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${n}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, fv = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, hv = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function mv() {
  return new RegExp(hv, "u");
}
const _v = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, gv = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, vv = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Iv = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, bv = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, rc = /^[A-Za-z0-9_-]*$/, Sv = /^\+[1-9]\d{6,14}$/, tc = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Av = /* @__PURE__ */ new RegExp(`^${tc}$`);
function oc(n) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof n.precision == "number" ? n.precision === -1 ? `${t}` : n.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${n.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Tv(n) {
  return new RegExp(`^${oc(n)}$`);
}
function Cv(n) {
  const t = oc({ precision: n.precision }), o = ["Z"];
  n.local && o.push(""), n.offset && o.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const a = `${t}(?:${o.join("|")})`;
  return new RegExp(`^${tc}T(?:${a})$`);
}
const yv = (n) => {
  const t = n ? `[\\s\\S]{${n?.minimum ?? 0},${n?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Ev = /^-?\d+$/, Nv = /^-?\d+(?:\.\d+)?$/, xv = /^[^A-Z]*$/, wv = /^[^a-z]*$/, Me = /* @__PURE__ */ T("$ZodCheck", (n, t) => {
  var o;
  n._zod ?? (n._zod = {}), n._zod.def = t, (o = n._zod).onattach ?? (o.onattach = []);
}), ic = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, ac = /* @__PURE__ */ T("$ZodCheckLessThan", (n, t) => {
  Me.init(n, t);
  const o = ic[typeof t.value];
  n._zod.onattach.push((a) => {
    const u = a._zod.bag, f = (t.inclusive ? u.maximum : u.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < f && (t.inclusive ? u.maximum = t.value : u.exclusiveMaximum = t.value);
  }), n._zod.check = (a) => {
    (t.inclusive ? a.value <= t.value : a.value < t.value) || a.issues.push({
      origin: o,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: a.value,
      inclusive: t.inclusive,
      inst: n,
      continue: !t.abort
    });
  };
}), sc = /* @__PURE__ */ T("$ZodCheckGreaterThan", (n, t) => {
  Me.init(n, t);
  const o = ic[typeof t.value];
  n._zod.onattach.push((a) => {
    const u = a._zod.bag, f = (t.inclusive ? u.minimum : u.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > f && (t.inclusive ? u.minimum = t.value : u.exclusiveMinimum = t.value);
  }), n._zod.check = (a) => {
    (t.inclusive ? a.value >= t.value : a.value > t.value) || a.issues.push({
      origin: o,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: a.value,
      inclusive: t.inclusive,
      inst: n,
      continue: !t.abort
    });
  };
}), Mv = /* @__PURE__ */ T("$ZodCheckMultipleOf", (n, t) => {
  Me.init(n, t), n._zod.onattach.push((o) => {
    var a;
    (a = o._zod.bag).multipleOf ?? (a.multipleOf = t.value);
  }), n._zod.check = (o) => {
    if (typeof o.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof o.value == "bigint" ? o.value % t.value === BigInt(0) : Rg(o.value, t.value) === 0) || o.issues.push({
      origin: typeof o.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: o.value,
      inst: n,
      continue: !t.abort
    });
  };
}), kv = /* @__PURE__ */ T("$ZodCheckNumberFormat", (n, t) => {
  Me.init(n, t), t.format = t.format || "float64";
  const o = t.format?.includes("int"), a = o ? "int" : "number", [u, f] = Gg[t.format];
  n._zod.onattach.push((p) => {
    const g = p._zod.bag;
    g.format = t.format, g.minimum = u, g.maximum = f, o && (g.pattern = Ev);
  }), n._zod.check = (p) => {
    const g = p.value;
    if (o) {
      if (!Number.isInteger(g)) {
        p.issues.push({
          expected: a,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: g,
          inst: n
        });
        return;
      }
      if (!Number.isSafeInteger(g)) {
        g > 0 ? p.issues.push({
          input: g,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: n,
          origin: a,
          inclusive: !0,
          continue: !t.abort
        }) : p.issues.push({
          input: g,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: n,
          origin: a,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    g < u && p.issues.push({
      origin: "number",
      input: g,
      code: "too_small",
      minimum: u,
      inclusive: !0,
      inst: n,
      continue: !t.abort
    }), g > f && p.issues.push({
      origin: "number",
      input: g,
      code: "too_big",
      maximum: f,
      inclusive: !0,
      inst: n,
      continue: !t.abort
    });
  };
}), Bv = /* @__PURE__ */ T("$ZodCheckMaxLength", (n, t) => {
  var o;
  Me.init(n, t), (o = n._zod.def).when ?? (o.when = (a) => {
    const u = a.value;
    return !Pi(u) && u.length !== void 0;
  }), n._zod.onattach.push((a) => {
    const u = a._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < u && (a._zod.bag.maximum = t.maximum);
  }), n._zod.check = (a) => {
    const u = a.value;
    if (u.length <= t.maximum)
      return;
    const p = Oi(u);
    a.issues.push({
      origin: p,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: u,
      inst: n,
      continue: !t.abort
    });
  };
}), Pv = /* @__PURE__ */ T("$ZodCheckMinLength", (n, t) => {
  var o;
  Me.init(n, t), (o = n._zod.def).when ?? (o.when = (a) => {
    const u = a.value;
    return !Pi(u) && u.length !== void 0;
  }), n._zod.onattach.push((a) => {
    const u = a._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > u && (a._zod.bag.minimum = t.minimum);
  }), n._zod.check = (a) => {
    const u = a.value;
    if (u.length >= t.minimum)
      return;
    const p = Oi(u);
    a.issues.push({
      origin: p,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: u,
      inst: n,
      continue: !t.abort
    });
  };
}), Rv = /* @__PURE__ */ T("$ZodCheckLengthEquals", (n, t) => {
  var o;
  Me.init(n, t), (o = n._zod.def).when ?? (o.when = (a) => {
    const u = a.value;
    return !Pi(u) && u.length !== void 0;
  }), n._zod.onattach.push((a) => {
    const u = a._zod.bag;
    u.minimum = t.length, u.maximum = t.length, u.length = t.length;
  }), n._zod.check = (a) => {
    const u = a.value, f = u.length;
    if (f === t.length)
      return;
    const p = Oi(u), g = f > t.length;
    a.issues.push({
      origin: p,
      ...g ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: a.value,
      inst: n,
      continue: !t.abort
    });
  };
}), Yt = /* @__PURE__ */ T("$ZodCheckStringFormat", (n, t) => {
  var o, a;
  Me.init(n, t), n._zod.onattach.push((u) => {
    const f = u._zod.bag;
    f.format = t.format, t.pattern && (f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(t.pattern));
  }), t.pattern ? (o = n._zod).check ?? (o.check = (u) => {
    t.pattern.lastIndex = 0, !t.pattern.test(u.value) && u.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: u.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: n,
      continue: !t.abort
    });
  }) : (a = n._zod).check ?? (a.check = () => {
  });
}), Ov = /* @__PURE__ */ T("$ZodCheckRegex", (n, t) => {
  Yt.init(n, t), n._zod.check = (o) => {
    t.pattern.lastIndex = 0, !t.pattern.test(o.value) && o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: o.value,
      pattern: t.pattern.toString(),
      inst: n,
      continue: !t.abort
    });
  };
}), zv = /* @__PURE__ */ T("$ZodCheckLowerCase", (n, t) => {
  t.pattern ?? (t.pattern = xv), Yt.init(n, t);
}), Lv = /* @__PURE__ */ T("$ZodCheckUpperCase", (n, t) => {
  t.pattern ?? (t.pattern = wv), Yt.init(n, t);
}), Fv = /* @__PURE__ */ T("$ZodCheckIncludes", (n, t) => {
  Me.init(n, t);
  const o = mr(t.includes), a = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${o}` : o);
  t.pattern = a, n._zod.onattach.push((u) => {
    const f = u._zod.bag;
    f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(a);
  }), n._zod.check = (u) => {
    u.value.includes(t.includes, t.position) || u.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: u.value,
      inst: n,
      continue: !t.abort
    });
  };
}), Gv = /* @__PURE__ */ T("$ZodCheckStartsWith", (n, t) => {
  Me.init(n, t);
  const o = new RegExp(`^${mr(t.prefix)}.*`);
  t.pattern ?? (t.pattern = o), n._zod.onattach.push((a) => {
    const u = a._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(o);
  }), n._zod.check = (a) => {
    a.value.startsWith(t.prefix) || a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: a.value,
      inst: n,
      continue: !t.abort
    });
  };
}), Dv = /* @__PURE__ */ T("$ZodCheckEndsWith", (n, t) => {
  Me.init(n, t);
  const o = new RegExp(`.*${mr(t.suffix)}$`);
  t.pattern ?? (t.pattern = o), n._zod.onattach.push((a) => {
    const u = a._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(o);
  }), n._zod.check = (a) => {
    a.value.endsWith(t.suffix) || a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: a.value,
      inst: n,
      continue: !t.abort
    });
  };
}), Zv = /* @__PURE__ */ T("$ZodCheckOverwrite", (n, t) => {
  Me.init(n, t), n._zod.check = (o) => {
    o.value = t.tx(o.value);
  };
});
class Uv {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const a = t.split(`
`).filter((p) => p), u = Math.min(...a.map((p) => p.length - p.trimStart().length)), f = a.map((p) => p.slice(u)).map((p) => " ".repeat(this.indent * 2) + p);
    for (const p of f)
      this.content.push(p);
  }
  compile() {
    const t = Function, o = this?.args, u = [...(this?.content ?? [""]).map((f) => `  ${f}`)];
    return new t(...o, u.join(`
`));
  }
}
const $v = {
  major: 4,
  minor: 3,
  patch: 6
}, le = /* @__PURE__ */ T("$ZodType", (n, t) => {
  var o;
  n ?? (n = {}), n._zod.def = t, n._zod.bag = n._zod.bag || {}, n._zod.version = $v;
  const a = [...n._zod.def.checks ?? []];
  n._zod.traits.has("$ZodCheck") && a.unshift(n);
  for (const u of a)
    for (const f of u._zod.onattach)
      f(n);
  if (a.length === 0)
    (o = n._zod).deferred ?? (o.deferred = []), n._zod.deferred?.push(() => {
      n._zod.run = n._zod.parse;
    });
  else {
    const u = (p, g, S) => {
      let E = pr(p), w;
      for (const G of g) {
        if (G._zod.def.when) {
          if (!G._zod.def.when(p))
            continue;
        } else if (E)
          continue;
        const B = p.issues.length, L = G._zod.check(p);
        if (L instanceof Promise && S?.async === !1)
          throw new hr();
        if (w || L instanceof Promise)
          w = (w ?? Promise.resolve()).then(async () => {
            await L, p.issues.length !== B && (E || (E = pr(p, B)));
          });
        else {
          if (p.issues.length === B)
            continue;
          E || (E = pr(p, B));
        }
      }
      return w ? w.then(() => p) : p;
    }, f = (p, g, S) => {
      if (pr(p))
        return p.aborted = !0, p;
      const E = u(g, a, S);
      if (E instanceof Promise) {
        if (S.async === !1)
          throw new hr();
        return E.then((w) => n._zod.parse(w, S));
      }
      return n._zod.parse(E, S);
    };
    n._zod.run = (p, g) => {
      if (g.skipChecks)
        return n._zod.parse(p, g);
      if (g.direction === "backward") {
        const E = n._zod.parse({ value: p.value, issues: [] }, { ...g, skipChecks: !0 });
        return E instanceof Promise ? E.then((w) => f(w, p, g)) : f(E, p, g);
      }
      const S = n._zod.parse(p, g);
      if (S instanceof Promise) {
        if (g.async === !1)
          throw new hr();
        return S.then((E) => u(E, a, g));
      }
      return u(S, a, g);
    };
  }
  j(n, "~standard", () => ({
    validate: (u) => {
      try {
        const f = Jg(n, u);
        return f.success ? { value: f.data } : { issues: f.error?.issues };
      } catch {
        return jg(n, u).then((p) => p.success ? { value: p.data } : { issues: p.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Fi = /* @__PURE__ */ T("$ZodString", (n, t) => {
  le.init(n, t), n._zod.pattern = [...n?._zod.bag?.patterns ?? []].pop() ?? yv(n._zod.bag), n._zod.parse = (o, a) => {
    if (t.coerce)
      try {
        o.value = String(o.value);
      } catch {
      }
    return typeof o.value == "string" || o.issues.push({
      expected: "string",
      code: "invalid_type",
      input: o.value,
      inst: n
    }), o;
  };
}), te = /* @__PURE__ */ T("$ZodStringFormat", (n, t) => {
  Yt.init(n, t), Fi.init(n, t);
}), Kv = /* @__PURE__ */ T("$ZodGUID", (n, t) => {
  t.pattern ?? (t.pattern = pv), te.init(n, t);
}), Hv = /* @__PURE__ */ T("$ZodUUID", (n, t) => {
  if (t.version) {
    const a = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (a === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Cu(a));
  } else
    t.pattern ?? (t.pattern = Cu());
  te.init(n, t);
}), qv = /* @__PURE__ */ T("$ZodEmail", (n, t) => {
  t.pattern ?? (t.pattern = fv), te.init(n, t);
}), Wv = /* @__PURE__ */ T("$ZodURL", (n, t) => {
  te.init(n, t), n._zod.check = (o) => {
    try {
      const a = o.value.trim(), u = new URL(a);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(u.hostname) || o.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: o.value,
        inst: n,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(u.protocol.endsWith(":") ? u.protocol.slice(0, -1) : u.protocol) || o.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: o.value,
        inst: n,
        continue: !t.abort
      })), t.normalize ? o.value = u.href : o.value = a;
      return;
    } catch {
      o.issues.push({
        code: "invalid_format",
        format: "url",
        input: o.value,
        inst: n,
        continue: !t.abort
      });
    }
  };
}), Vv = /* @__PURE__ */ T("$ZodEmoji", (n, t) => {
  t.pattern ?? (t.pattern = mv()), te.init(n, t);
}), Jv = /* @__PURE__ */ T("$ZodNanoID", (n, t) => {
  t.pattern ?? (t.pattern = lv), te.init(n, t);
}), jv = /* @__PURE__ */ T("$ZodCUID", (n, t) => {
  t.pattern ?? (t.pattern = iv), te.init(n, t);
}), Yv = /* @__PURE__ */ T("$ZodCUID2", (n, t) => {
  t.pattern ?? (t.pattern = av), te.init(n, t);
}), Xv = /* @__PURE__ */ T("$ZodULID", (n, t) => {
  t.pattern ?? (t.pattern = sv), te.init(n, t);
}), Qv = /* @__PURE__ */ T("$ZodXID", (n, t) => {
  t.pattern ?? (t.pattern = uv), te.init(n, t);
}), eI = /* @__PURE__ */ T("$ZodKSUID", (n, t) => {
  t.pattern ?? (t.pattern = cv), te.init(n, t);
}), nI = /* @__PURE__ */ T("$ZodISODateTime", (n, t) => {
  t.pattern ?? (t.pattern = Cv(t)), te.init(n, t);
}), rI = /* @__PURE__ */ T("$ZodISODate", (n, t) => {
  t.pattern ?? (t.pattern = Av), te.init(n, t);
}), tI = /* @__PURE__ */ T("$ZodISOTime", (n, t) => {
  t.pattern ?? (t.pattern = Tv(t)), te.init(n, t);
}), oI = /* @__PURE__ */ T("$ZodISODuration", (n, t) => {
  t.pattern ?? (t.pattern = dv), te.init(n, t);
}), iI = /* @__PURE__ */ T("$ZodIPv4", (n, t) => {
  t.pattern ?? (t.pattern = _v), te.init(n, t), n._zod.bag.format = "ipv4";
}), aI = /* @__PURE__ */ T("$ZodIPv6", (n, t) => {
  t.pattern ?? (t.pattern = gv), te.init(n, t), n._zod.bag.format = "ipv6", n._zod.check = (o) => {
    try {
      new URL(`http://[${o.value}]`);
    } catch {
      o.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: o.value,
        inst: n,
        continue: !t.abort
      });
    }
  };
}), sI = /* @__PURE__ */ T("$ZodCIDRv4", (n, t) => {
  t.pattern ?? (t.pattern = vv), te.init(n, t);
}), uI = /* @__PURE__ */ T("$ZodCIDRv6", (n, t) => {
  t.pattern ?? (t.pattern = Iv), te.init(n, t), n._zod.check = (o) => {
    const a = o.value.split("/");
    try {
      if (a.length !== 2)
        throw new Error();
      const [u, f] = a;
      if (!f)
        throw new Error();
      const p = Number(f);
      if (`${p}` !== f)
        throw new Error();
      if (p < 0 || p > 128)
        throw new Error();
      new URL(`http://[${u}]`);
    } catch {
      o.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: o.value,
        inst: n,
        continue: !t.abort
      });
    }
  };
});
function uc(n) {
  if (n === "")
    return !0;
  if (n.length % 4 !== 0)
    return !1;
  try {
    return atob(n), !0;
  } catch {
    return !1;
  }
}
const cI = /* @__PURE__ */ T("$ZodBase64", (n, t) => {
  t.pattern ?? (t.pattern = bv), te.init(n, t), n._zod.bag.contentEncoding = "base64", n._zod.check = (o) => {
    uc(o.value) || o.issues.push({
      code: "invalid_format",
      format: "base64",
      input: o.value,
      inst: n,
      continue: !t.abort
    });
  };
});
function lI(n) {
  if (!rc.test(n))
    return !1;
  const t = n.replace(/[-_]/g, (a) => a === "-" ? "+" : "/"), o = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return uc(o);
}
const dI = /* @__PURE__ */ T("$ZodBase64URL", (n, t) => {
  t.pattern ?? (t.pattern = rc), te.init(n, t), n._zod.bag.contentEncoding = "base64url", n._zod.check = (o) => {
    lI(o.value) || o.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: o.value,
      inst: n,
      continue: !t.abort
    });
  };
}), pI = /* @__PURE__ */ T("$ZodE164", (n, t) => {
  t.pattern ?? (t.pattern = Sv), te.init(n, t);
});
function fI(n, t = null) {
  try {
    const o = n.split(".");
    if (o.length !== 3)
      return !1;
    const [a] = o;
    if (!a)
      return !1;
    const u = JSON.parse(atob(a));
    return !("typ" in u && u?.typ !== "JWT" || !u.alg || t && (!("alg" in u) || u.alg !== t));
  } catch {
    return !1;
  }
}
const hI = /* @__PURE__ */ T("$ZodJWT", (n, t) => {
  te.init(n, t), n._zod.check = (o) => {
    fI(o.value, t.alg) || o.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: o.value,
      inst: n,
      continue: !t.abort
    });
  };
}), cc = /* @__PURE__ */ T("$ZodNumber", (n, t) => {
  le.init(n, t), n._zod.pattern = n._zod.bag.pattern ?? Nv, n._zod.parse = (o, a) => {
    if (t.coerce)
      try {
        o.value = Number(o.value);
      } catch {
      }
    const u = o.value;
    if (typeof u == "number" && !Number.isNaN(u) && Number.isFinite(u))
      return o;
    const f = typeof u == "number" ? Number.isNaN(u) ? "NaN" : Number.isFinite(u) ? void 0 : "Infinity" : void 0;
    return o.issues.push({
      expected: "number",
      code: "invalid_type",
      input: u,
      inst: n,
      ...f ? { received: f } : {}
    }), o;
  };
}), mI = /* @__PURE__ */ T("$ZodNumberFormat", (n, t) => {
  kv.init(n, t), cc.init(n, t);
}), _I = /* @__PURE__ */ T("$ZodUnknown", (n, t) => {
  le.init(n, t), n._zod.parse = (o) => o;
}), gI = /* @__PURE__ */ T("$ZodNever", (n, t) => {
  le.init(n, t), n._zod.parse = (o, a) => (o.issues.push({
    expected: "never",
    code: "invalid_type",
    input: o.value,
    inst: n
  }), o);
});
function yu(n, t, o) {
  n.issues.length && t.issues.push(...Xu(o, n.issues)), t.value[o] = n.value;
}
const vI = /* @__PURE__ */ T("$ZodArray", (n, t) => {
  le.init(n, t), n._zod.parse = (o, a) => {
    const u = o.value;
    if (!Array.isArray(u))
      return o.issues.push({
        expected: "array",
        code: "invalid_type",
        input: u,
        inst: n
      }), o;
    o.value = Array(u.length);
    const f = [];
    for (let p = 0; p < u.length; p++) {
      const g = u[p], S = t.element._zod.run({
        value: g,
        issues: []
      }, a);
      S instanceof Promise ? f.push(S.then((E) => yu(E, o, p))) : yu(S, o, p);
    }
    return f.length ? Promise.all(f).then(() => o) : o;
  };
});
function Ht(n, t, o, a, u) {
  if (n.issues.length) {
    if (u && !(o in a))
      return;
    t.issues.push(...Xu(o, n.issues));
  }
  n.value === void 0 ? o in a && (t.value[o] = void 0) : t.value[o] = n.value;
}
function lc(n) {
  const t = Object.keys(n.shape);
  for (const a of t)
    if (!n.shape?.[a]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${a}": expected a Zod schema`);
  const o = Fg(n.shape);
  return {
    ...n,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(o)
  };
}
function dc(n, t, o, a, u, f) {
  const p = [], g = u.keySet, S = u.catchall._zod, E = S.def.type, w = S.optout === "optional";
  for (const G in t) {
    if (g.has(G))
      continue;
    if (E === "never") {
      p.push(G);
      continue;
    }
    const B = S.run({ value: t[G], issues: [] }, a);
    B instanceof Promise ? n.push(B.then((L) => Ht(L, o, G, t, w))) : Ht(B, o, G, t, w);
  }
  return p.length && o.issues.push({
    code: "unrecognized_keys",
    keys: p,
    input: t,
    inst: f
  }), n.length ? Promise.all(n).then(() => o) : o;
}
const II = /* @__PURE__ */ T("$ZodObject", (n, t) => {
  if (le.init(n, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
    const g = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const S = { ...g };
        return Object.defineProperty(t, "shape", {
          value: S
        }), S;
      }
    });
  }
  const a = Bi(() => lc(t));
  j(n._zod, "propValues", () => {
    const g = t.shape, S = {};
    for (const E in g) {
      const w = g[E]._zod;
      if (w.values) {
        S[E] ?? (S[E] = /* @__PURE__ */ new Set());
        for (const G of w.values)
          S[E].add(G);
      }
    }
    return S;
  });
  const u = Kt, f = t.catchall;
  let p;
  n._zod.parse = (g, S) => {
    p ?? (p = a.value);
    const E = g.value;
    if (!u(E))
      return g.issues.push({
        expected: "object",
        code: "invalid_type",
        input: E,
        inst: n
      }), g;
    g.value = {};
    const w = [], G = p.shape;
    for (const B of p.keys) {
      const L = G[B], ae = L._zod.optout === "optional", ee = L._zod.run({ value: E[B], issues: [] }, S);
      ee instanceof Promise ? w.push(ee.then((cn) => Ht(cn, g, B, E, ae))) : Ht(ee, g, B, E, ae);
    }
    return f ? dc(w, E, g, S, a.value, n) : w.length ? Promise.all(w).then(() => g) : g;
  };
}), bI = /* @__PURE__ */ T("$ZodObjectJIT", (n, t) => {
  II.init(n, t);
  const o = n._zod.parse, a = Bi(() => lc(t)), u = (B) => {
    const L = new Uv(["shape", "payload", "ctx"]), ae = a.value, ee = (Be) => {
      const ne = Tu(Be);
      return `shape[${ne}]._zod.run({ value: input[${ne}], issues: [] }, ctx)`;
    };
    L.write("const input = payload.value;");
    const cn = /* @__PURE__ */ Object.create(null);
    let ke = 0;
    for (const Be of ae.keys)
      cn[Be] = `key_${ke++}`;
    L.write("const newResult = {};");
    for (const Be of ae.keys) {
      const ne = cn[Be], me = Tu(Be), Pn = B[Be]?._zod?.optout === "optional";
      L.write(`const ${ne} = ${ee(Be)};`), Pn ? L.write(`
        if (${ne}.issues.length) {
          if (${me} in input) {
            payload.issues = payload.issues.concat(${ne}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${me}, ...iss.path] : [${me}]
            })));
          }
        }
        
        if (${ne}.value === undefined) {
          if (${me} in input) {
            newResult[${me}] = undefined;
          }
        } else {
          newResult[${me}] = ${ne}.value;
        }
        
      `) : L.write(`
        if (${ne}.issues.length) {
          payload.issues = payload.issues.concat(${ne}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${me}, ...iss.path] : [${me}]
          })));
        }
        
        if (${ne}.value === undefined) {
          if (${me} in input) {
            newResult[${me}] = undefined;
          }
        } else {
          newResult[${me}] = ${ne}.value;
        }
        
      `);
    }
    L.write("payload.value = newResult;"), L.write("return payload;");
    const bn = L.compile();
    return (Be, ne) => bn(B, Be, ne);
  };
  let f;
  const p = Kt, g = !Vu.jitless, E = g && zg.value, w = t.catchall;
  let G;
  n._zod.parse = (B, L) => {
    G ?? (G = a.value);
    const ae = B.value;
    return p(ae) ? g && E && L?.async === !1 && L.jitless !== !0 ? (f || (f = u(t.shape)), B = f(B, L), w ? dc([], ae, B, L, G, n) : B) : o(B, L) : (B.issues.push({
      expected: "object",
      code: "invalid_type",
      input: ae,
      inst: n
    }), B);
  };
});
function Eu(n, t, o, a) {
  for (const f of n)
    if (f.issues.length === 0)
      return t.value = f.value, t;
  const u = n.filter((f) => !pr(f));
  return u.length === 1 ? (t.value = u[0].value, u[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: o,
    errors: n.map((f) => f.issues.map((p) => Wn(p, a, qn())))
  }), t);
}
const SI = /* @__PURE__ */ T("$ZodUnion", (n, t) => {
  le.init(n, t), j(n._zod, "optin", () => t.options.some((u) => u._zod.optin === "optional") ? "optional" : void 0), j(n._zod, "optout", () => t.options.some((u) => u._zod.optout === "optional") ? "optional" : void 0), j(n._zod, "values", () => {
    if (t.options.every((u) => u._zod.values))
      return new Set(t.options.flatMap((u) => Array.from(u._zod.values)));
  }), j(n._zod, "pattern", () => {
    if (t.options.every((u) => u._zod.pattern)) {
      const u = t.options.map((f) => f._zod.pattern);
      return new RegExp(`^(${u.map((f) => Ri(f.source)).join("|")})$`);
    }
  });
  const o = t.options.length === 1, a = t.options[0]._zod.run;
  n._zod.parse = (u, f) => {
    if (o)
      return a(u, f);
    let p = !1;
    const g = [];
    for (const S of t.options) {
      const E = S._zod.run({
        value: u.value,
        issues: []
      }, f);
      if (E instanceof Promise)
        g.push(E), p = !0;
      else {
        if (E.issues.length === 0)
          return E;
        g.push(E);
      }
    }
    return p ? Promise.all(g).then((S) => Eu(S, u, n, f)) : Eu(g, u, n, f);
  };
}), AI = /* @__PURE__ */ T("$ZodIntersection", (n, t) => {
  le.init(n, t), n._zod.parse = (o, a) => {
    const u = o.value, f = t.left._zod.run({ value: u, issues: [] }, a), p = t.right._zod.run({ value: u, issues: [] }, a);
    return f instanceof Promise || p instanceof Promise ? Promise.all([f, p]).then(([S, E]) => Nu(o, S, E)) : Nu(o, f, p);
  };
});
function Ei(n, t) {
  if (n === t)
    return { valid: !0, data: n };
  if (n instanceof Date && t instanceof Date && +n == +t)
    return { valid: !0, data: n };
  if (qr(n) && qr(t)) {
    const o = Object.keys(t), a = Object.keys(n).filter((f) => o.indexOf(f) !== -1), u = { ...n, ...t };
    for (const f of a) {
      const p = Ei(n[f], t[f]);
      if (!p.valid)
        return {
          valid: !1,
          mergeErrorPath: [f, ...p.mergeErrorPath]
        };
      u[f] = p.data;
    }
    return { valid: !0, data: u };
  }
  if (Array.isArray(n) && Array.isArray(t)) {
    if (n.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const o = [];
    for (let a = 0; a < n.length; a++) {
      const u = n[a], f = t[a], p = Ei(u, f);
      if (!p.valid)
        return {
          valid: !1,
          mergeErrorPath: [a, ...p.mergeErrorPath]
        };
      o.push(p.data);
    }
    return { valid: !0, data: o };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Nu(n, t, o) {
  const a = /* @__PURE__ */ new Map();
  let u;
  for (const g of t.issues)
    if (g.code === "unrecognized_keys") {
      u ?? (u = g);
      for (const S of g.keys)
        a.has(S) || a.set(S, {}), a.get(S).l = !0;
    } else
      n.issues.push(g);
  for (const g of o.issues)
    if (g.code === "unrecognized_keys")
      for (const S of g.keys)
        a.has(S) || a.set(S, {}), a.get(S).r = !0;
    else
      n.issues.push(g);
  const f = [...a].filter(([, g]) => g.l && g.r).map(([g]) => g);
  if (f.length && u && n.issues.push({ ...u, keys: f }), pr(n))
    return n;
  const p = Ei(t.value, o.value);
  if (!p.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(p.mergeErrorPath)}`);
  return n.value = p.data, n;
}
const TI = /* @__PURE__ */ T("$ZodEnum", (n, t) => {
  le.init(n, t);
  const o = Ju(t.entries), a = new Set(o);
  n._zod.values = a, n._zod.pattern = new RegExp(`^(${o.filter((u) => Lg.has(typeof u)).map((u) => typeof u == "string" ? mr(u) : u.toString()).join("|")})$`), n._zod.parse = (u, f) => {
    const p = u.value;
    return a.has(p) || u.issues.push({
      code: "invalid_value",
      values: o,
      input: p,
      inst: n
    }), u;
  };
}), CI = /* @__PURE__ */ T("$ZodLiteral", (n, t) => {
  if (le.init(n, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const o = new Set(t.values);
  n._zod.values = o, n._zod.pattern = new RegExp(`^(${t.values.map((a) => typeof a == "string" ? mr(a) : a ? mr(a.toString()) : String(a)).join("|")})$`), n._zod.parse = (a, u) => {
    const f = a.value;
    return o.has(f) || a.issues.push({
      code: "invalid_value",
      values: t.values,
      input: f,
      inst: n
    }), a;
  };
}), yI = /* @__PURE__ */ T("$ZodTransform", (n, t) => {
  le.init(n, t), n._zod.parse = (o, a) => {
    if (a.direction === "backward")
      throw new Wu(n.constructor.name);
    const u = t.transform(o.value, o);
    if (a.async)
      return (u instanceof Promise ? u : Promise.resolve(u)).then((p) => (o.value = p, o));
    if (u instanceof Promise)
      throw new hr();
    return o.value = u, o;
  };
});
function xu(n, t) {
  return n.issues.length && t === void 0 ? { issues: [], value: void 0 } : n;
}
const pc = /* @__PURE__ */ T("$ZodOptional", (n, t) => {
  le.init(n, t), n._zod.optin = "optional", n._zod.optout = "optional", j(n._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), j(n._zod, "pattern", () => {
    const o = t.innerType._zod.pattern;
    return o ? new RegExp(`^(${Ri(o.source)})?$`) : void 0;
  }), n._zod.parse = (o, a) => {
    if (t.innerType._zod.optin === "optional") {
      const u = t.innerType._zod.run(o, a);
      return u instanceof Promise ? u.then((f) => xu(f, o.value)) : xu(u, o.value);
    }
    return o.value === void 0 ? o : t.innerType._zod.run(o, a);
  };
}), EI = /* @__PURE__ */ T("$ZodExactOptional", (n, t) => {
  pc.init(n, t), j(n._zod, "values", () => t.innerType._zod.values), j(n._zod, "pattern", () => t.innerType._zod.pattern), n._zod.parse = (o, a) => t.innerType._zod.run(o, a);
}), NI = /* @__PURE__ */ T("$ZodNullable", (n, t) => {
  le.init(n, t), j(n._zod, "optin", () => t.innerType._zod.optin), j(n._zod, "optout", () => t.innerType._zod.optout), j(n._zod, "pattern", () => {
    const o = t.innerType._zod.pattern;
    return o ? new RegExp(`^(${Ri(o.source)}|null)$`) : void 0;
  }), j(n._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), n._zod.parse = (o, a) => o.value === null ? o : t.innerType._zod.run(o, a);
}), xI = /* @__PURE__ */ T("$ZodDefault", (n, t) => {
  le.init(n, t), n._zod.optin = "optional", j(n._zod, "values", () => t.innerType._zod.values), n._zod.parse = (o, a) => {
    if (a.direction === "backward")
      return t.innerType._zod.run(o, a);
    if (o.value === void 0)
      return o.value = t.defaultValue, o;
    const u = t.innerType._zod.run(o, a);
    return u instanceof Promise ? u.then((f) => wu(f, t)) : wu(u, t);
  };
});
function wu(n, t) {
  return n.value === void 0 && (n.value = t.defaultValue), n;
}
const wI = /* @__PURE__ */ T("$ZodPrefault", (n, t) => {
  le.init(n, t), n._zod.optin = "optional", j(n._zod, "values", () => t.innerType._zod.values), n._zod.parse = (o, a) => (a.direction === "backward" || o.value === void 0 && (o.value = t.defaultValue), t.innerType._zod.run(o, a));
}), MI = /* @__PURE__ */ T("$ZodNonOptional", (n, t) => {
  le.init(n, t), j(n._zod, "values", () => {
    const o = t.innerType._zod.values;
    return o ? new Set([...o].filter((a) => a !== void 0)) : void 0;
  }), n._zod.parse = (o, a) => {
    const u = t.innerType._zod.run(o, a);
    return u instanceof Promise ? u.then((f) => Mu(f, n)) : Mu(u, n);
  };
});
function Mu(n, t) {
  return !n.issues.length && n.value === void 0 && n.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: n.value,
    inst: t
  }), n;
}
const kI = /* @__PURE__ */ T("$ZodCatch", (n, t) => {
  le.init(n, t), j(n._zod, "optin", () => t.innerType._zod.optin), j(n._zod, "optout", () => t.innerType._zod.optout), j(n._zod, "values", () => t.innerType._zod.values), n._zod.parse = (o, a) => {
    if (a.direction === "backward")
      return t.innerType._zod.run(o, a);
    const u = t.innerType._zod.run(o, a);
    return u instanceof Promise ? u.then((f) => (o.value = f.value, f.issues.length && (o.value = t.catchValue({
      ...o,
      error: {
        issues: f.issues.map((p) => Wn(p, a, qn()))
      },
      input: o.value
    }), o.issues = []), o)) : (o.value = u.value, u.issues.length && (o.value = t.catchValue({
      ...o,
      error: {
        issues: u.issues.map((f) => Wn(f, a, qn()))
      },
      input: o.value
    }), o.issues = []), o);
  };
}), BI = /* @__PURE__ */ T("$ZodPipe", (n, t) => {
  le.init(n, t), j(n._zod, "values", () => t.in._zod.values), j(n._zod, "optin", () => t.in._zod.optin), j(n._zod, "optout", () => t.out._zod.optout), j(n._zod, "propValues", () => t.in._zod.propValues), n._zod.parse = (o, a) => {
    if (a.direction === "backward") {
      const f = t.out._zod.run(o, a);
      return f instanceof Promise ? f.then((p) => Zt(p, t.in, a)) : Zt(f, t.in, a);
    }
    const u = t.in._zod.run(o, a);
    return u instanceof Promise ? u.then((f) => Zt(f, t.out, a)) : Zt(u, t.out, a);
  };
});
function Zt(n, t, o) {
  return n.issues.length ? (n.aborted = !0, n) : t._zod.run({ value: n.value, issues: n.issues }, o);
}
const PI = /* @__PURE__ */ T("$ZodReadonly", (n, t) => {
  le.init(n, t), j(n._zod, "propValues", () => t.innerType._zod.propValues), j(n._zod, "values", () => t.innerType._zod.values), j(n._zod, "optin", () => t.innerType?._zod?.optin), j(n._zod, "optout", () => t.innerType?._zod?.optout), n._zod.parse = (o, a) => {
    if (a.direction === "backward")
      return t.innerType._zod.run(o, a);
    const u = t.innerType._zod.run(o, a);
    return u instanceof Promise ? u.then(ku) : ku(u);
  };
});
function ku(n) {
  return n.value = Object.freeze(n.value), n;
}
const RI = /* @__PURE__ */ T("$ZodCustom", (n, t) => {
  Me.init(n, t), le.init(n, t), n._zod.parse = (o, a) => o, n._zod.check = (o) => {
    const a = o.value, u = t.fn(a);
    if (u instanceof Promise)
      return u.then((f) => Bu(f, o, a, n));
    Bu(u, o, a, n);
  };
});
function Bu(n, t, o, a) {
  if (!n) {
    const u = {
      code: "custom",
      input: o,
      inst: a,
      // incorporates params.error into issue reporting
      path: [...a._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !a._zod.def.abort
      // params: inst._zod.def.params,
    };
    a._zod.def.params && (u.params = a._zod.def.params), t.issues.push(Wr(u));
  }
}
var Pu;
class OI {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...o) {
    const a = o[0];
    return this._map.set(t, a), a && typeof a == "object" && "id" in a && this._idmap.set(a.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const o = this._map.get(t);
    return o && typeof o == "object" && "id" in o && this._idmap.delete(o.id), this._map.delete(t), this;
  }
  get(t) {
    const o = t._zod.parent;
    if (o) {
      const a = { ...this.get(o) ?? {} };
      delete a.id;
      const u = { ...a, ...this._map.get(t) };
      return Object.keys(u).length ? u : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function zI() {
  return new OI();
}
(Pu = globalThis).__zod_globalRegistry ?? (Pu.__zod_globalRegistry = zI());
const Ur = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function LI(n, t) {
  return new n({
    type: "string",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function FI(n, t) {
  return new n({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ru(n, t) {
  return new n({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fc(n, t) {
  return new n({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function GI(n, t) {
  return new n({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function DI(n, t) {
  return new n({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ZI(n, t) {
  return new n({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function UI(n, t) {
  return new n({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function $I(n, t) {
  return new n({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function KI(n, t) {
  return new n({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function HI(n, t) {
  return new n({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qI(n, t) {
  return new n({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function WI(n, t) {
  return new n({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function VI(n, t) {
  return new n({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function JI(n, t) {
  return new n({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function jI(n, t) {
  return new n({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function YI(n, t) {
  return new n({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function XI(n, t) {
  return new n({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function QI(n, t) {
  return new n({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function eb(n, t) {
  return new n({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function nb(n, t) {
  return new n({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rb(n, t) {
  return new n({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function tb(n, t) {
  return new n({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ob(n, t) {
  return new n({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ib(n, t) {
  return new n({
    type: "string",
    format: "date",
    check: "string_format",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ab(n, t) {
  return new n({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sb(n, t) {
  return new n({
    type: "string",
    format: "duration",
    check: "string_format",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ub(n, t) {
  return new n({
    type: "number",
    checks: [],
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function cb(n, t) {
  return new n({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function lb(n) {
  return new n({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function db(n, t) {
  return new n({
    type: "never",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ou(n, t) {
  return new ac({
    check: "less_than",
    ...P(t),
    value: n,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Ti(n, t) {
  return new ac({
    check: "less_than",
    ...P(t),
    value: n,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function zu(n, t) {
  return new sc({
    check: "greater_than",
    ...P(t),
    value: n,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Ci(n, t) {
  return new sc({
    check: "greater_than",
    ...P(t),
    value: n,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Lu(n, t) {
  return new Mv({
    check: "multiple_of",
    ...P(t),
    value: n
  });
}
// @__NO_SIDE_EFFECTS__
function hc(n, t) {
  return new Bv({
    check: "max_length",
    ...P(t),
    maximum: n
  });
}
// @__NO_SIDE_EFFECTS__
function qt(n, t) {
  return new Pv({
    check: "min_length",
    ...P(t),
    minimum: n
  });
}
// @__NO_SIDE_EFFECTS__
function mc(n, t) {
  return new Rv({
    check: "length_equals",
    ...P(t),
    length: n
  });
}
// @__NO_SIDE_EFFECTS__
function pb(n, t) {
  return new Ov({
    check: "string_format",
    format: "regex",
    ...P(t),
    pattern: n
  });
}
// @__NO_SIDE_EFFECTS__
function fb(n) {
  return new zv({
    check: "string_format",
    format: "lowercase",
    ...P(n)
  });
}
// @__NO_SIDE_EFFECTS__
function hb(n) {
  return new Lv({
    check: "string_format",
    format: "uppercase",
    ...P(n)
  });
}
// @__NO_SIDE_EFFECTS__
function mb(n, t) {
  return new Fv({
    check: "string_format",
    format: "includes",
    ...P(t),
    includes: n
  });
}
// @__NO_SIDE_EFFECTS__
function _b(n, t) {
  return new Gv({
    check: "string_format",
    format: "starts_with",
    ...P(t),
    prefix: n
  });
}
// @__NO_SIDE_EFFECTS__
function gb(n, t) {
  return new Dv({
    check: "string_format",
    format: "ends_with",
    ...P(t),
    suffix: n
  });
}
// @__NO_SIDE_EFFECTS__
function vr(n) {
  return new Zv({
    check: "overwrite",
    tx: n
  });
}
// @__NO_SIDE_EFFECTS__
function vb(n) {
  return /* @__PURE__ */ vr((t) => t.normalize(n));
}
// @__NO_SIDE_EFFECTS__
function Ib() {
  return /* @__PURE__ */ vr((n) => n.trim());
}
// @__NO_SIDE_EFFECTS__
function bb() {
  return /* @__PURE__ */ vr((n) => n.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function Sb() {
  return /* @__PURE__ */ vr((n) => n.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function Ab() {
  return /* @__PURE__ */ vr((n) => Og(n));
}
// @__NO_SIDE_EFFECTS__
function Tb(n, t, o) {
  return new n({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...P(o)
  });
}
// @__NO_SIDE_EFFECTS__
function Cb(n, t, o) {
  return new n({
    type: "custom",
    check: "custom",
    fn: t,
    ...P(o)
  });
}
// @__NO_SIDE_EFFECTS__
function yb(n) {
  const t = /* @__PURE__ */ Eb((o) => (o.addIssue = (a) => {
    if (typeof a == "string")
      o.issues.push(Wr(a, o.value, t._zod.def));
    else {
      const u = a;
      u.fatal && (u.continue = !1), u.code ?? (u.code = "custom"), u.input ?? (u.input = o.value), u.inst ?? (u.inst = t), u.continue ?? (u.continue = !t._zod.def.abort), o.issues.push(Wr(u));
    }
  }, n(o.value, o)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function Eb(n, t) {
  const o = new Me({
    check: "custom",
    ...P(t)
  });
  return o._zod.check = n, o;
}
function _c(n) {
  let t = n?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: n.processors ?? {},
    metadataRegistry: n?.metadata ?? Ur,
    target: t,
    unrepresentable: n?.unrepresentable ?? "throw",
    override: n?.override ?? (() => {
    }),
    io: n?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: n?.cycles ?? "ref",
    reused: n?.reused ?? "inline",
    external: n?.external ?? void 0
  };
}
function ve(n, t, o = { path: [], schemaPath: [] }) {
  var a;
  const u = n._zod.def, f = t.seen.get(n);
  if (f)
    return f.count++, o.schemaPath.includes(n) && (f.cycle = o.path), f.schema;
  const p = { schema: {}, count: 1, cycle: void 0, path: o.path };
  t.seen.set(n, p);
  const g = n._zod.toJSONSchema?.();
  if (g)
    p.schema = g;
  else {
    const w = {
      ...o,
      schemaPath: [...o.schemaPath, n],
      path: o.path
    };
    if (n._zod.processJSONSchema)
      n._zod.processJSONSchema(t, p.schema, w);
    else {
      const B = p.schema, L = t.processors[u.type];
      if (!L)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${u.type}`);
      L(n, t, B, w);
    }
    const G = n._zod.parent;
    G && (p.ref || (p.ref = G), ve(G, t, w), t.seen.get(G).isParent = !0);
  }
  const S = t.metadataRegistry.get(n);
  return S && Object.assign(p.schema, S), t.io === "input" && Ce(n) && (delete p.schema.examples, delete p.schema.default), t.io === "input" && p.schema._prefault && ((a = p.schema).default ?? (a.default = p.schema._prefault)), delete p.schema._prefault, t.seen.get(n).schema;
}
function gc(n, t) {
  const o = n.seen.get(t);
  if (!o)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = /* @__PURE__ */ new Map();
  for (const p of n.seen.entries()) {
    const g = n.metadataRegistry.get(p[0])?.id;
    if (g) {
      const S = a.get(g);
      if (S && S !== p[0])
        throw new Error(`Duplicate schema id "${g}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      a.set(g, p[0]);
    }
  }
  const u = (p) => {
    const g = n.target === "draft-2020-12" ? "$defs" : "definitions";
    if (n.external) {
      const G = n.external.registry.get(p[0])?.id, B = n.external.uri ?? ((ae) => ae);
      if (G)
        return { ref: B(G) };
      const L = p[1].defId ?? p[1].schema.id ?? `schema${n.counter++}`;
      return p[1].defId = L, { defId: L, ref: `${B("__shared")}#/${g}/${L}` };
    }
    if (p[1] === o)
      return { ref: "#" };
    const E = `#/${g}/`, w = p[1].schema.id ?? `__schema${n.counter++}`;
    return { defId: w, ref: E + w };
  }, f = (p) => {
    if (p[1].schema.$ref)
      return;
    const g = p[1], { ref: S, defId: E } = u(p);
    g.def = { ...g.schema }, E && (g.defId = E);
    const w = g.schema;
    for (const G in w)
      delete w[G];
    w.$ref = S;
  };
  if (n.cycles === "throw")
    for (const p of n.seen.entries()) {
      const g = p[1];
      if (g.cycle)
        throw new Error(`Cycle detected: #/${g.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const p of n.seen.entries()) {
    const g = p[1];
    if (t === p[0]) {
      f(p);
      continue;
    }
    if (n.external) {
      const E = n.external.registry.get(p[0])?.id;
      if (t !== p[0] && E) {
        f(p);
        continue;
      }
    }
    if (n.metadataRegistry.get(p[0])?.id) {
      f(p);
      continue;
    }
    if (g.cycle) {
      f(p);
      continue;
    }
    if (g.count > 1 && n.reused === "ref") {
      f(p);
      continue;
    }
  }
}
function vc(n, t) {
  const o = n.seen.get(t);
  if (!o)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = (p) => {
    const g = n.seen.get(p);
    if (g.ref === null)
      return;
    const S = g.def ?? g.schema, E = { ...S }, w = g.ref;
    if (g.ref = null, w) {
      a(w);
      const B = n.seen.get(w), L = B.schema;
      if (L.$ref && (n.target === "draft-07" || n.target === "draft-04" || n.target === "openapi-3.0") ? (S.allOf = S.allOf ?? [], S.allOf.push(L)) : Object.assign(S, L), Object.assign(S, E), p._zod.parent === w)
        for (const ee in S)
          ee === "$ref" || ee === "allOf" || ee in E || delete S[ee];
      if (L.$ref && B.def)
        for (const ee in S)
          ee === "$ref" || ee === "allOf" || ee in B.def && JSON.stringify(S[ee]) === JSON.stringify(B.def[ee]) && delete S[ee];
    }
    const G = p._zod.parent;
    if (G && G !== w) {
      a(G);
      const B = n.seen.get(G);
      if (B?.schema.$ref && (S.$ref = B.schema.$ref, B.def))
        for (const L in S)
          L === "$ref" || L === "allOf" || L in B.def && JSON.stringify(S[L]) === JSON.stringify(B.def[L]) && delete S[L];
    }
    n.override({
      zodSchema: p,
      jsonSchema: S,
      path: g.path ?? []
    });
  };
  for (const p of [...n.seen.entries()].reverse())
    a(p[0]);
  const u = {};
  if (n.target === "draft-2020-12" ? u.$schema = "https://json-schema.org/draft/2020-12/schema" : n.target === "draft-07" ? u.$schema = "http://json-schema.org/draft-07/schema#" : n.target === "draft-04" ? u.$schema = "http://json-schema.org/draft-04/schema#" : n.target, n.external?.uri) {
    const p = n.external.registry.get(t)?.id;
    if (!p)
      throw new Error("Schema is missing an `id` property");
    u.$id = n.external.uri(p);
  }
  Object.assign(u, o.def ?? o.schema);
  const f = n.external?.defs ?? {};
  for (const p of n.seen.entries()) {
    const g = p[1];
    g.def && g.defId && (f[g.defId] = g.def);
  }
  n.external || Object.keys(f).length > 0 && (n.target === "draft-2020-12" ? u.$defs = f : u.definitions = f);
  try {
    const p = JSON.parse(JSON.stringify(u));
    return Object.defineProperty(p, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: Wt(t, "input", n.processors),
          output: Wt(t, "output", n.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), p;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function Ce(n, t) {
  const o = t ?? { seen: /* @__PURE__ */ new Set() };
  if (o.seen.has(n))
    return !1;
  o.seen.add(n);
  const a = n._zod.def;
  if (a.type === "transform")
    return !0;
  if (a.type === "array")
    return Ce(a.element, o);
  if (a.type === "set")
    return Ce(a.valueType, o);
  if (a.type === "lazy")
    return Ce(a.getter(), o);
  if (a.type === "promise" || a.type === "optional" || a.type === "nonoptional" || a.type === "nullable" || a.type === "readonly" || a.type === "default" || a.type === "prefault")
    return Ce(a.innerType, o);
  if (a.type === "intersection")
    return Ce(a.left, o) || Ce(a.right, o);
  if (a.type === "record" || a.type === "map")
    return Ce(a.keyType, o) || Ce(a.valueType, o);
  if (a.type === "pipe")
    return Ce(a.in, o) || Ce(a.out, o);
  if (a.type === "object") {
    for (const u in a.shape)
      if (Ce(a.shape[u], o))
        return !0;
    return !1;
  }
  if (a.type === "union") {
    for (const u of a.options)
      if (Ce(u, o))
        return !0;
    return !1;
  }
  if (a.type === "tuple") {
    for (const u of a.items)
      if (Ce(u, o))
        return !0;
    return !!(a.rest && Ce(a.rest, o));
  }
  return !1;
}
const Nb = (n, t = {}) => (o) => {
  const a = _c({ ...o, processors: t });
  return ve(n, a), gc(a, n), vc(a, n);
}, Wt = (n, t, o = {}) => (a) => {
  const { libraryOptions: u, target: f } = a ?? {}, p = _c({ ...u ?? {}, target: f, io: t, processors: o });
  return ve(n, p), gc(p, n), vc(p, n);
}, xb = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, wb = (n, t, o, a) => {
  const u = o;
  u.type = "string";
  const { minimum: f, maximum: p, format: g, patterns: S, contentEncoding: E } = n._zod.bag;
  if (typeof f == "number" && (u.minLength = f), typeof p == "number" && (u.maxLength = p), g && (u.format = xb[g] ?? g, u.format === "" && delete u.format, g === "time" && delete u.format), E && (u.contentEncoding = E), S && S.size > 0) {
    const w = [...S];
    w.length === 1 ? u.pattern = w[0].source : w.length > 1 && (u.allOf = [
      ...w.map((G) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: G.source
      }))
    ]);
  }
}, Mb = (n, t, o, a) => {
  const u = o, { minimum: f, maximum: p, format: g, multipleOf: S, exclusiveMaximum: E, exclusiveMinimum: w } = n._zod.bag;
  typeof g == "string" && g.includes("int") ? u.type = "integer" : u.type = "number", typeof w == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (u.minimum = w, u.exclusiveMinimum = !0) : u.exclusiveMinimum = w), typeof f == "number" && (u.minimum = f, typeof w == "number" && t.target !== "draft-04" && (w >= f ? delete u.minimum : delete u.exclusiveMinimum)), typeof E == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (u.maximum = E, u.exclusiveMaximum = !0) : u.exclusiveMaximum = E), typeof p == "number" && (u.maximum = p, typeof E == "number" && t.target !== "draft-04" && (E <= p ? delete u.maximum : delete u.exclusiveMaximum)), typeof S == "number" && (u.multipleOf = S);
}, kb = (n, t, o, a) => {
  o.not = {};
}, Bb = (n, t, o, a) => {
}, Pb = (n, t, o, a) => {
  const u = n._zod.def, f = Ju(u.entries);
  f.every((p) => typeof p == "number") && (o.type = "number"), f.every((p) => typeof p == "string") && (o.type = "string"), o.enum = f;
}, Rb = (n, t, o, a) => {
  const u = n._zod.def, f = [];
  for (const p of u.values)
    if (p === void 0) {
      if (t.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof p == "bigint") {
      if (t.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      f.push(Number(p));
    } else
      f.push(p);
  if (f.length !== 0) if (f.length === 1) {
    const p = f[0];
    o.type = p === null ? "null" : typeof p, t.target === "draft-04" || t.target === "openapi-3.0" ? o.enum = [p] : o.const = p;
  } else
    f.every((p) => typeof p == "number") && (o.type = "number"), f.every((p) => typeof p == "string") && (o.type = "string"), f.every((p) => typeof p == "boolean") && (o.type = "boolean"), f.every((p) => p === null) && (o.type = "null"), o.enum = f;
}, Ob = (n, t, o, a) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, zb = (n, t, o, a) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, Lb = (n, t, o, a) => {
  const u = o, f = n._zod.def, { minimum: p, maximum: g } = n._zod.bag;
  typeof p == "number" && (u.minItems = p), typeof g == "number" && (u.maxItems = g), u.type = "array", u.items = ve(f.element, t, { ...a, path: [...a.path, "items"] });
}, Fb = (n, t, o, a) => {
  const u = o, f = n._zod.def;
  u.type = "object", u.properties = {};
  const p = f.shape;
  for (const E in p)
    u.properties[E] = ve(p[E], t, {
      ...a,
      path: [...a.path, "properties", E]
    });
  const g = new Set(Object.keys(p)), S = new Set([...g].filter((E) => {
    const w = f.shape[E]._zod;
    return t.io === "input" ? w.optin === void 0 : w.optout === void 0;
  }));
  S.size > 0 && (u.required = Array.from(S)), f.catchall?._zod.def.type === "never" ? u.additionalProperties = !1 : f.catchall ? f.catchall && (u.additionalProperties = ve(f.catchall, t, {
    ...a,
    path: [...a.path, "additionalProperties"]
  })) : t.io === "output" && (u.additionalProperties = !1);
}, Gb = (n, t, o, a) => {
  const u = n._zod.def, f = u.inclusive === !1, p = u.options.map((g, S) => ve(g, t, {
    ...a,
    path: [...a.path, f ? "oneOf" : "anyOf", S]
  }));
  f ? o.oneOf = p : o.anyOf = p;
}, Db = (n, t, o, a) => {
  const u = n._zod.def, f = ve(u.left, t, {
    ...a,
    path: [...a.path, "allOf", 0]
  }), p = ve(u.right, t, {
    ...a,
    path: [...a.path, "allOf", 1]
  }), g = (E) => "allOf" in E && Object.keys(E).length === 1, S = [
    ...g(f) ? f.allOf : [f],
    ...g(p) ? p.allOf : [p]
  ];
  o.allOf = S;
}, Zb = (n, t, o, a) => {
  const u = n._zod.def, f = ve(u.innerType, t, a), p = t.seen.get(n);
  t.target === "openapi-3.0" ? (p.ref = u.innerType, o.nullable = !0) : o.anyOf = [f, { type: "null" }];
}, Ub = (n, t, o, a) => {
  const u = n._zod.def;
  ve(u.innerType, t, a);
  const f = t.seen.get(n);
  f.ref = u.innerType;
}, $b = (n, t, o, a) => {
  const u = n._zod.def;
  ve(u.innerType, t, a);
  const f = t.seen.get(n);
  f.ref = u.innerType, o.default = JSON.parse(JSON.stringify(u.defaultValue));
}, Kb = (n, t, o, a) => {
  const u = n._zod.def;
  ve(u.innerType, t, a);
  const f = t.seen.get(n);
  f.ref = u.innerType, t.io === "input" && (o._prefault = JSON.parse(JSON.stringify(u.defaultValue)));
}, Hb = (n, t, o, a) => {
  const u = n._zod.def;
  ve(u.innerType, t, a);
  const f = t.seen.get(n);
  f.ref = u.innerType;
  let p;
  try {
    p = u.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  o.default = p;
}, qb = (n, t, o, a) => {
  const u = n._zod.def, f = t.io === "input" ? u.in._zod.def.type === "transform" ? u.out : u.in : u.out;
  ve(f, t, a);
  const p = t.seen.get(n);
  p.ref = f;
}, Wb = (n, t, o, a) => {
  const u = n._zod.def;
  ve(u.innerType, t, a);
  const f = t.seen.get(n);
  f.ref = u.innerType, o.readOnly = !0;
}, Ic = (n, t, o, a) => {
  const u = n._zod.def;
  ve(u.innerType, t, a);
  const f = t.seen.get(n);
  f.ref = u.innerType;
}, Vb = /* @__PURE__ */ T("ZodISODateTime", (n, t) => {
  nI.init(n, t), ie.init(n, t);
});
function Jb(n) {
  return /* @__PURE__ */ ob(Vb, n);
}
const jb = /* @__PURE__ */ T("ZodISODate", (n, t) => {
  rI.init(n, t), ie.init(n, t);
});
function Yb(n) {
  return /* @__PURE__ */ ib(jb, n);
}
const Xb = /* @__PURE__ */ T("ZodISOTime", (n, t) => {
  tI.init(n, t), ie.init(n, t);
});
function Qb(n) {
  return /* @__PURE__ */ ab(Xb, n);
}
const eS = /* @__PURE__ */ T("ZodISODuration", (n, t) => {
  oI.init(n, t), ie.init(n, t);
});
function nS(n) {
  return /* @__PURE__ */ sb(eS, n);
}
const rS = (n, t) => {
  ec.init(n, t), n.name = "ZodError", Object.defineProperties(n, {
    format: {
      value: (o) => Vg(n, o)
      // enumerable: false,
    },
    flatten: {
      value: (o) => Wg(n, o)
      // enumerable: false,
    },
    addIssue: {
      value: (o) => {
        n.issues.push(o), n.message = JSON.stringify(n.issues, yi, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (o) => {
        n.issues.push(...o), n.message = JSON.stringify(n.issues, yi, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return n.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, We = T("ZodError", rS, {
  Parent: Error
}), tS = /* @__PURE__ */ zi(We), oS = /* @__PURE__ */ Li(We), iS = /* @__PURE__ */ Jt(We), aS = /* @__PURE__ */ jt(We), sS = /* @__PURE__ */ Yg(We), uS = /* @__PURE__ */ Xg(We), cS = /* @__PURE__ */ Qg(We), lS = /* @__PURE__ */ ev(We), dS = /* @__PURE__ */ nv(We), pS = /* @__PURE__ */ rv(We), fS = /* @__PURE__ */ tv(We), hS = /* @__PURE__ */ ov(We), de = /* @__PURE__ */ T("ZodType", (n, t) => (le.init(n, t), Object.assign(n["~standard"], {
  jsonSchema: {
    input: Wt(n, "input"),
    output: Wt(n, "output")
  }
}), n.toJSONSchema = Nb(n, {}), n.def = t, n.type = t.type, Object.defineProperty(n, "_def", { value: t }), n.check = (...o) => n.clone(kn(t, {
  checks: [
    ...t.checks ?? [],
    ...o.map((a) => typeof a == "function" ? { _zod: { check: a, def: { check: "custom" }, onattach: [] } } : a)
  ]
}), {
  parent: !0
}), n.with = n.check, n.clone = (o, a) => Bn(n, o, a), n.brand = () => n, n.register = ((o, a) => (o.add(n, a), n)), n.parse = (o, a) => tS(n, o, a, { callee: n.parse }), n.safeParse = (o, a) => iS(n, o, a), n.parseAsync = async (o, a) => oS(n, o, a, { callee: n.parseAsync }), n.safeParseAsync = async (o, a) => aS(n, o, a), n.spa = n.safeParseAsync, n.encode = (o, a) => sS(n, o, a), n.decode = (o, a) => uS(n, o, a), n.encodeAsync = async (o, a) => cS(n, o, a), n.decodeAsync = async (o, a) => lS(n, o, a), n.safeEncode = (o, a) => dS(n, o, a), n.safeDecode = (o, a) => pS(n, o, a), n.safeEncodeAsync = async (o, a) => fS(n, o, a), n.safeDecodeAsync = async (o, a) => hS(n, o, a), n.refine = (o, a) => n.check(s1(o, a)), n.superRefine = (o) => n.check(u1(o)), n.overwrite = (o) => n.check(/* @__PURE__ */ vr(o)), n.optional = () => Uu(n), n.exactOptional = () => VS(n), n.nullable = () => $u(n), n.nullish = () => Uu($u(n)), n.nonoptional = (o) => e1(n, o), n.array = () => FS(n), n.or = (o) => Ac([n, o]), n.and = (o) => US(n, o), n.transform = (o) => Ku(n, qS(o)), n.default = (o) => YS(n, o), n.prefault = (o) => QS(n, o), n.catch = (o) => r1(n, o), n.pipe = (o) => Ku(n, o), n.readonly = () => i1(n), n.describe = (o) => {
  const a = n.clone();
  return Ur.add(a, { description: o }), a;
}, Object.defineProperty(n, "description", {
  get() {
    return Ur.get(n)?.description;
  },
  configurable: !0
}), n.meta = (...o) => {
  if (o.length === 0)
    return Ur.get(n);
  const a = n.clone();
  return Ur.add(a, o[0]), a;
}, n.isOptional = () => n.safeParse(void 0).success, n.isNullable = () => n.safeParse(null).success, n.apply = (o) => o(n), n)), bc = /* @__PURE__ */ T("_ZodString", (n, t) => {
  Fi.init(n, t), de.init(n, t), n._zod.processJSONSchema = (a, u, f) => wb(n, a, u);
  const o = n._zod.bag;
  n.format = o.format ?? null, n.minLength = o.minimum ?? null, n.maxLength = o.maximum ?? null, n.regex = (...a) => n.check(/* @__PURE__ */ pb(...a)), n.includes = (...a) => n.check(/* @__PURE__ */ mb(...a)), n.startsWith = (...a) => n.check(/* @__PURE__ */ _b(...a)), n.endsWith = (...a) => n.check(/* @__PURE__ */ gb(...a)), n.min = (...a) => n.check(/* @__PURE__ */ qt(...a)), n.max = (...a) => n.check(/* @__PURE__ */ hc(...a)), n.length = (...a) => n.check(/* @__PURE__ */ mc(...a)), n.nonempty = (...a) => n.check(/* @__PURE__ */ qt(1, ...a)), n.lowercase = (a) => n.check(/* @__PURE__ */ fb(a)), n.uppercase = (a) => n.check(/* @__PURE__ */ hb(a)), n.trim = () => n.check(/* @__PURE__ */ Ib()), n.normalize = (...a) => n.check(/* @__PURE__ */ vb(...a)), n.toLowerCase = () => n.check(/* @__PURE__ */ bb()), n.toUpperCase = () => n.check(/* @__PURE__ */ Sb()), n.slugify = () => n.check(/* @__PURE__ */ Ab());
}), mS = /* @__PURE__ */ T("ZodString", (n, t) => {
  Fi.init(n, t), bc.init(n, t), n.email = (o) => n.check(/* @__PURE__ */ FI(_S, o)), n.url = (o) => n.check(/* @__PURE__ */ UI(gS, o)), n.jwt = (o) => n.check(/* @__PURE__ */ tb(BS, o)), n.emoji = (o) => n.check(/* @__PURE__ */ $I(vS, o)), n.guid = (o) => n.check(/* @__PURE__ */ Ru(Fu, o)), n.uuid = (o) => n.check(/* @__PURE__ */ fc($r, o)), n.uuidv4 = (o) => n.check(/* @__PURE__ */ GI($r, o)), n.uuidv6 = (o) => n.check(/* @__PURE__ */ DI($r, o)), n.uuidv7 = (o) => n.check(/* @__PURE__ */ ZI($r, o)), n.nanoid = (o) => n.check(/* @__PURE__ */ KI(IS, o)), n.guid = (o) => n.check(/* @__PURE__ */ Ru(Fu, o)), n.cuid = (o) => n.check(/* @__PURE__ */ HI(bS, o)), n.cuid2 = (o) => n.check(/* @__PURE__ */ qI(SS, o)), n.ulid = (o) => n.check(/* @__PURE__ */ WI(AS, o)), n.base64 = (o) => n.check(/* @__PURE__ */ eb(wS, o)), n.base64url = (o) => n.check(/* @__PURE__ */ nb(MS, o)), n.xid = (o) => n.check(/* @__PURE__ */ VI(TS, o)), n.ksuid = (o) => n.check(/* @__PURE__ */ JI(CS, o)), n.ipv4 = (o) => n.check(/* @__PURE__ */ jI(yS, o)), n.ipv6 = (o) => n.check(/* @__PURE__ */ YI(ES, o)), n.cidrv4 = (o) => n.check(/* @__PURE__ */ XI(NS, o)), n.cidrv6 = (o) => n.check(/* @__PURE__ */ QI(xS, o)), n.e164 = (o) => n.check(/* @__PURE__ */ rb(kS, o)), n.datetime = (o) => n.check(Jb(o)), n.date = (o) => n.check(Yb(o)), n.time = (o) => n.check(Qb(o)), n.duration = (o) => n.check(nS(o));
});
function ye(n) {
  return /* @__PURE__ */ LI(mS, n);
}
const ie = /* @__PURE__ */ T("ZodStringFormat", (n, t) => {
  te.init(n, t), bc.init(n, t);
}), _S = /* @__PURE__ */ T("ZodEmail", (n, t) => {
  qv.init(n, t), ie.init(n, t);
}), Fu = /* @__PURE__ */ T("ZodGUID", (n, t) => {
  Kv.init(n, t), ie.init(n, t);
}), $r = /* @__PURE__ */ T("ZodUUID", (n, t) => {
  Hv.init(n, t), ie.init(n, t);
});
function Vt(n) {
  return /* @__PURE__ */ fc($r, n);
}
const gS = /* @__PURE__ */ T("ZodURL", (n, t) => {
  Wv.init(n, t), ie.init(n, t);
}), vS = /* @__PURE__ */ T("ZodEmoji", (n, t) => {
  Vv.init(n, t), ie.init(n, t);
}), IS = /* @__PURE__ */ T("ZodNanoID", (n, t) => {
  Jv.init(n, t), ie.init(n, t);
}), bS = /* @__PURE__ */ T("ZodCUID", (n, t) => {
  jv.init(n, t), ie.init(n, t);
}), SS = /* @__PURE__ */ T("ZodCUID2", (n, t) => {
  Yv.init(n, t), ie.init(n, t);
}), AS = /* @__PURE__ */ T("ZodULID", (n, t) => {
  Xv.init(n, t), ie.init(n, t);
}), TS = /* @__PURE__ */ T("ZodXID", (n, t) => {
  Qv.init(n, t), ie.init(n, t);
}), CS = /* @__PURE__ */ T("ZodKSUID", (n, t) => {
  eI.init(n, t), ie.init(n, t);
}), yS = /* @__PURE__ */ T("ZodIPv4", (n, t) => {
  iI.init(n, t), ie.init(n, t);
}), ES = /* @__PURE__ */ T("ZodIPv6", (n, t) => {
  aI.init(n, t), ie.init(n, t);
}), NS = /* @__PURE__ */ T("ZodCIDRv4", (n, t) => {
  sI.init(n, t), ie.init(n, t);
}), xS = /* @__PURE__ */ T("ZodCIDRv6", (n, t) => {
  uI.init(n, t), ie.init(n, t);
}), wS = /* @__PURE__ */ T("ZodBase64", (n, t) => {
  cI.init(n, t), ie.init(n, t);
}), MS = /* @__PURE__ */ T("ZodBase64URL", (n, t) => {
  dI.init(n, t), ie.init(n, t);
}), kS = /* @__PURE__ */ T("ZodE164", (n, t) => {
  pI.init(n, t), ie.init(n, t);
}), BS = /* @__PURE__ */ T("ZodJWT", (n, t) => {
  hI.init(n, t), ie.init(n, t);
}), Sc = /* @__PURE__ */ T("ZodNumber", (n, t) => {
  cc.init(n, t), de.init(n, t), n._zod.processJSONSchema = (a, u, f) => Mb(n, a, u), n.gt = (a, u) => n.check(/* @__PURE__ */ zu(a, u)), n.gte = (a, u) => n.check(/* @__PURE__ */ Ci(a, u)), n.min = (a, u) => n.check(/* @__PURE__ */ Ci(a, u)), n.lt = (a, u) => n.check(/* @__PURE__ */ Ou(a, u)), n.lte = (a, u) => n.check(/* @__PURE__ */ Ti(a, u)), n.max = (a, u) => n.check(/* @__PURE__ */ Ti(a, u)), n.int = (a) => n.check(Du(a)), n.safe = (a) => n.check(Du(a)), n.positive = (a) => n.check(/* @__PURE__ */ zu(0, a)), n.nonnegative = (a) => n.check(/* @__PURE__ */ Ci(0, a)), n.negative = (a) => n.check(/* @__PURE__ */ Ou(0, a)), n.nonpositive = (a) => n.check(/* @__PURE__ */ Ti(0, a)), n.multipleOf = (a, u) => n.check(/* @__PURE__ */ Lu(a, u)), n.step = (a, u) => n.check(/* @__PURE__ */ Lu(a, u)), n.finite = () => n;
  const o = n._zod.bag;
  n.minValue = Math.max(o.minimum ?? Number.NEGATIVE_INFINITY, o.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, n.maxValue = Math.min(o.maximum ?? Number.POSITIVE_INFINITY, o.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, n.isInt = (o.format ?? "").includes("int") || Number.isSafeInteger(o.multipleOf ?? 0.5), n.isFinite = !0, n.format = o.format ?? null;
});
function Gu(n) {
  return /* @__PURE__ */ ub(Sc, n);
}
const PS = /* @__PURE__ */ T("ZodNumberFormat", (n, t) => {
  mI.init(n, t), Sc.init(n, t);
});
function Du(n) {
  return /* @__PURE__ */ cb(PS, n);
}
const RS = /* @__PURE__ */ T("ZodUnknown", (n, t) => {
  _I.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => Bb();
});
function Zu() {
  return /* @__PURE__ */ lb(RS);
}
const OS = /* @__PURE__ */ T("ZodNever", (n, t) => {
  gI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => kb(n, o, a);
});
function zS(n) {
  return /* @__PURE__ */ db(OS, n);
}
const LS = /* @__PURE__ */ T("ZodArray", (n, t) => {
  vI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => Lb(n, o, a, u), n.element = t.element, n.min = (o, a) => n.check(/* @__PURE__ */ qt(o, a)), n.nonempty = (o) => n.check(/* @__PURE__ */ qt(1, o)), n.max = (o, a) => n.check(/* @__PURE__ */ hc(o, a)), n.length = (o, a) => n.check(/* @__PURE__ */ mc(o, a)), n.unwrap = () => n.element;
});
function FS(n, t) {
  return /* @__PURE__ */ Tb(LS, n, t);
}
const GS = /* @__PURE__ */ T("ZodObject", (n, t) => {
  bI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => Fb(n, o, a, u), j(n, "shape", () => t.shape), n.keyof = () => Tc(Object.keys(n._zod.def.shape)), n.catchall = (o) => n.clone({ ...n._zod.def, catchall: o }), n.passthrough = () => n.clone({ ...n._zod.def, catchall: Zu() }), n.loose = () => n.clone({ ...n._zod.def, catchall: Zu() }), n.strict = () => n.clone({ ...n._zod.def, catchall: zS() }), n.strip = () => n.clone({ ...n._zod.def, catchall: void 0 }), n.extend = (o) => Ug(n, o), n.safeExtend = (o) => $g(n, o), n.merge = (o) => Kg(n, o), n.pick = (o) => Dg(n, o), n.omit = (o) => Zg(n, o), n.partial = (...o) => Hg(Cc, n, o[0]), n.required = (...o) => qg(yc, n, o[0]);
});
function Xt(n, t) {
  const o = {
    type: "object",
    shape: n ?? {},
    ...P(t)
  };
  return new GS(o);
}
const DS = /* @__PURE__ */ T("ZodUnion", (n, t) => {
  SI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => Gb(n, o, a, u), n.options = t.options;
});
function Ac(n, t) {
  return new DS({
    type: "union",
    options: n,
    ...P(t)
  });
}
const ZS = /* @__PURE__ */ T("ZodIntersection", (n, t) => {
  AI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => Db(n, o, a, u);
});
function US(n, t) {
  return new ZS({
    type: "intersection",
    left: n,
    right: t
  });
}
const Ni = /* @__PURE__ */ T("ZodEnum", (n, t) => {
  TI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (a, u, f) => Pb(n, a, u), n.enum = t.entries, n.options = Object.values(t.entries);
  const o = new Set(Object.keys(t.entries));
  n.extract = (a, u) => {
    const f = {};
    for (const p of a)
      if (o.has(p))
        f[p] = t.entries[p];
      else
        throw new Error(`Key ${p} not found in enum`);
    return new Ni({
      ...t,
      checks: [],
      ...P(u),
      entries: f
    });
  }, n.exclude = (a, u) => {
    const f = { ...t.entries };
    for (const p of a)
      if (o.has(p))
        delete f[p];
      else
        throw new Error(`Key ${p} not found in enum`);
    return new Ni({
      ...t,
      checks: [],
      ...P(u),
      entries: f
    });
  };
});
function Tc(n, t) {
  const o = Array.isArray(n) ? Object.fromEntries(n.map((a) => [a, a])) : n;
  return new Ni({
    type: "enum",
    entries: o,
    ...P(t)
  });
}
const $S = /* @__PURE__ */ T("ZodLiteral", (n, t) => {
  CI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => Rb(n, o, a), n.values = new Set(t.values), Object.defineProperty(n, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function KS(n, t) {
  return new $S({
    type: "literal",
    values: Array.isArray(n) ? n : [n],
    ...P(t)
  });
}
const HS = /* @__PURE__ */ T("ZodTransform", (n, t) => {
  yI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => zb(n, o), n._zod.parse = (o, a) => {
    if (a.direction === "backward")
      throw new Wu(n.constructor.name);
    o.addIssue = (f) => {
      if (typeof f == "string")
        o.issues.push(Wr(f, o.value, t));
      else {
        const p = f;
        p.fatal && (p.continue = !1), p.code ?? (p.code = "custom"), p.input ?? (p.input = o.value), p.inst ?? (p.inst = n), o.issues.push(Wr(p));
      }
    };
    const u = t.transform(o.value, o);
    return u instanceof Promise ? u.then((f) => (o.value = f, o)) : (o.value = u, o);
  };
});
function qS(n) {
  return new HS({
    type: "transform",
    transform: n
  });
}
const Cc = /* @__PURE__ */ T("ZodOptional", (n, t) => {
  pc.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => Ic(n, o, a, u), n.unwrap = () => n._zod.def.innerType;
});
function Uu(n) {
  return new Cc({
    type: "optional",
    innerType: n
  });
}
const WS = /* @__PURE__ */ T("ZodExactOptional", (n, t) => {
  EI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => Ic(n, o, a, u), n.unwrap = () => n._zod.def.innerType;
});
function VS(n) {
  return new WS({
    type: "optional",
    innerType: n
  });
}
const JS = /* @__PURE__ */ T("ZodNullable", (n, t) => {
  NI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => Zb(n, o, a, u), n.unwrap = () => n._zod.def.innerType;
});
function $u(n) {
  return new JS({
    type: "nullable",
    innerType: n
  });
}
const jS = /* @__PURE__ */ T("ZodDefault", (n, t) => {
  xI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => $b(n, o, a, u), n.unwrap = () => n._zod.def.innerType, n.removeDefault = n.unwrap;
});
function YS(n, t) {
  return new jS({
    type: "default",
    innerType: n,
    get defaultValue() {
      return typeof t == "function" ? t() : Yu(t);
    }
  });
}
const XS = /* @__PURE__ */ T("ZodPrefault", (n, t) => {
  wI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => Kb(n, o, a, u), n.unwrap = () => n._zod.def.innerType;
});
function QS(n, t) {
  return new XS({
    type: "prefault",
    innerType: n,
    get defaultValue() {
      return typeof t == "function" ? t() : Yu(t);
    }
  });
}
const yc = /* @__PURE__ */ T("ZodNonOptional", (n, t) => {
  MI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => Ub(n, o, a, u), n.unwrap = () => n._zod.def.innerType;
});
function e1(n, t) {
  return new yc({
    type: "nonoptional",
    innerType: n,
    ...P(t)
  });
}
const n1 = /* @__PURE__ */ T("ZodCatch", (n, t) => {
  kI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => Hb(n, o, a, u), n.unwrap = () => n._zod.def.innerType, n.removeCatch = n.unwrap;
});
function r1(n, t) {
  return new n1({
    type: "catch",
    innerType: n,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const t1 = /* @__PURE__ */ T("ZodPipe", (n, t) => {
  BI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => qb(n, o, a, u), n.in = t.in, n.out = t.out;
});
function Ku(n, t) {
  return new t1({
    type: "pipe",
    in: n,
    out: t
    // ...util.normalizeParams(params),
  });
}
const o1 = /* @__PURE__ */ T("ZodReadonly", (n, t) => {
  PI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => Wb(n, o, a, u), n.unwrap = () => n._zod.def.innerType;
});
function i1(n) {
  return new o1({
    type: "readonly",
    innerType: n
  });
}
const a1 = /* @__PURE__ */ T("ZodCustom", (n, t) => {
  RI.init(n, t), de.init(n, t), n._zod.processJSONSchema = (o, a, u) => Ob(n, o);
});
function s1(n, t = {}) {
  return /* @__PURE__ */ Cb(a1, n, t);
}
function u1(n) {
  return /* @__PURE__ */ yb(n);
}
const Ec = Xt({
  userId: Vt(),
  companyId: Vt()
}), c1 = Ec.extend({
  auctionId: Vt()
}), l1 = Ec.extend({
  directSaleId: Vt()
}), U1 = Ac([c1, l1]), $1 = 50, K1 = 1, H1 = "bnk_", q1 = {
  // Exteriors
  photo_front: {
    name: "photo_front",
    position: 10,
    position_admin: 30,
    label: "front photo",
    group: "exteriors",
    description: "A photo capturing the front view of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_front_side_left: {
    name: "photo_3_4_front_side_left",
    position: 20,
    position_admin: 40,
    label: "3/4 front left",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the left.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_side_left: {
    name: "photo_side_left",
    position: 30,
    position_admin: 70,
    label: "left side photo",
    group: "exteriors",
    description: "A photo showing the left side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_left_rear: {
    name: "photo_3_4_side_left_rear",
    position: 40,
    position_admin: 120,
    label: "3/4 left rear side",
    group: "exteriors",
    description: "A 3/4 angled photo of the left rear side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_closed: {
    name: "photo_rear_hatch_closed",
    position: 50,
    position_admin: 130,
    label: "rear hatch closed",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_closed: {
    name: "photo_3_4_side_right_rear_doors_closed",
    position: 60,
    position_admin: 190,
    label: "3/4 right rear doors closed",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_closed: {
    name: "photo_side_right_doors_closed",
    position: 70,
    position_admin: 200,
    label: "right side doors closed",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  turntable_photo_external_if_present_only_18mt: {
    name: "turntable_photo_external_if_present_only_18mt",
    position: 80,
    position_admin: 210,
    label: "turntable external (18m)",
    group: "exteriors",
    description: "An external photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_front_side_right_doors_closed: {
    name: "photo_3_4_front_side_right_doors_closed",
    position: 90,
    position_admin: 10,
    label: "3/4 front right doors",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the right, with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_side_right_front_doors_open: {
    name: "photo_3_4_side_right_front_doors_open",
    position: 100,
    position_admin: 230,
    label: "3/4 right front doors open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right front side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_1: {
    name: "front_photo_per_door_doors_open_door_1",
    position: 110,
    position_admin: 300,
    label: "front door 1 open",
    group: "exteriors",
    description: "A photo of the front door 1 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_open: {
    name: "photo_side_right_doors_open",
    position: 120,
    position_admin: 240,
    label: "right side doors open",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_2: {
    name: "front_photo_per_door_doors_open_door_2",
    position: 130,
    position_admin: 270,
    label: "front door 2 open",
    group: "exteriors",
    description: "A photo of the front door 2 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_3: {
    name: "front_photo_per_door_doors_open_door_3",
    position: 140,
    position_admin: 260,
    label: "front door 3 open",
    group: "exteriors",
    description: "A photo of the front door 3 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_open: {
    name: "photo_3_4_side_right_rear_doors_open",
    position: 150,
    position_admin: 250,
    label: "3/4 right rear doors open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage: {
    name: "photo_luggage",
    position: 160,
    position_admin: 80,
    label: "luggage rack photo",
    group: "exteriors",
    description: "A photo showing the luggage rack in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_internal_frame_for_potential_rust: {
    name: "photo_internal_frame_for_potential_rust",
    position: 170,
    position_admin: 90,
    label: "internal frame rust check",
    group: "exteriors",
    description: "A photo showing the internal frame of the vehicle to check for potential rust.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_under_carpet_if_carpet_present: {
    name: "photo_under_carpet_if_carpet_present",
    position: 180,
    position_admin: 95,
    label: "under carpet photo",
    group: "exteriors",
    description: "A photo showing the area under the carpet if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_open: {
    name: "photo_rear_hatch_open",
    position: 190,
    position_admin: 140,
    label: "rear hatch open",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch open.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_compressor_air_conditioning: {
    name: "photo_compressor_air_conditioning",
    position: 200,
    position_admin: 150,
    label: "air conditioning compressor",
    group: "exteriors",
    description: "A photo showing the air conditioning compressor.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_preheater_webasto_if_present: {
    name: "photo_preheater_webasto_if_present",
    position: 210,
    position_admin: 170,
    label: "preheater webasto photo",
    group: "exteriors",
    description: "A photo of the preheater (webasto) system if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_fire_extinguishing_system: {
    name: "photo_fire_extinguishing_system",
    position: 220,
    position_admin: 160,
    label: "fire extinguishing system",
    group: "exteriors",
    description: "A photo showing the fire extinguishing system of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_external_compartments_various_internal_photo: {
    name: "photo_external_compartments_various_internal_photo",
    position: 230,
    position_admin: 60,
    label: "external compartments photo",
    group: "exteriors",
    description: "A photo showing various external compartments.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_platform_open_platform: {
    name: "photo_platform_open_platform",
    position: 240,
    position_admin: 215,
    label: "platform open photo",
    group: "exteriors",
    description: "A photo of the platform in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_platform_code: {
    name: "photo_platform_code",
    position: 250,
    position_admin: 216,
    label: "platform code photo",
    group: "exteriors",
    description: "A photo showing the platform's code.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  engine_plate_photo_if_present: {
    name: "engine_plate_photo_if_present",
    position: 260,
    position_admin: 165,
    label: "engine plate photo",
    group: "exteriors",
    description: "A photo showing the engine plate if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_plate_vehicle: {
    name: "photo_plate_vehicle",
    position: 270,
    position_admin: 310,
    label: "vehicle plate photo",
    group: "exteriors",
    description: "A photo showing the vehicle's plate.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  // Interiors
  photo_plate_seats: {
    name: "photo_plate_seats",
    position: 280,
    position_admin: 320,
    label: "seat plate photo",
    group: "interiors",
    description: "A photo showing the seat plate inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_driver_microphone: {
    name: "photo_accessories_driver_microphone",
    position: 290,
    position_admin: 330,
    label: "driver microphone accessories photo",
    group: "interiors",
    description: "A photo showing the driver's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_drive_seat: {
    name: "photo_drive_seat",
    position: 300,
    position_admin: 340,
    label: "driver's seat photo",
    group: "interiors",
    description: "A photo of the driver's seat.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_steering_wheel: {
    name: "photo_steering_wheel",
    position: 310,
    position_admin: 350,
    label: "steering wheel photo",
    group: "interiors",
    description: "A photo of the steering wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_dashboard_on_for_number_km_and_lights_on: {
    name: "photo_dashboard_on_for_number_km_and_lights_on",
    position: 320,
    position_admin: 360,
    label: "dashboard lights on",
    group: "interiors",
    description: "A photo showing the dashboard with the vehicle's odometer reading and warning lights illuminated.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_buttons_e_panels_on: {
    name: "photo_buttons_e_panels_on",
    position: 330,
    position_admin: 370,
    label: "buttons panels on",
    group: "interiors",
    description: "A photo showing the vehicle's buttons and panels in an 'on' state.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_tachograph: {
    name: "photo_tachograph",
    position: 340,
    position_admin: 380,
    label: "Tachograph",
    group: "interiors",
    description: "A photo of the Tachograph.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_radio: {
    name: "photo_accessories_radio",
    position: 350,
    position_admin: 390,
    label: "radio accessories photo",
    group: "interiors",
    description: "A photo showing the radio accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_1: {
    name: "photo_any_devices_onboard_1",
    position: 360,
    position_admin: 400,
    label: "onboard devices 1",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_2: {
    name: "photo_any_devices_onboard_2",
    position: 370,
    position_admin: 410,
    label: "onboard devices 2",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  control_unit_command_signs_indicators: {
    name: "control_unit_command_signs_indicators",
    position: 380,
    position_admin: 430,
    label: "command unit indicators",
    group: "interiors",
    description: "A photo of the control unit for signs and indicators.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_seat_hostess: {
    name: "photo_seat_hostess",
    position: 390,
    position_admin: 440,
    label: "hostess seat photo",
    group: "interiors",
    description: "A photo of the hostess seat in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_hostes_microphone: {
    name: "photo_accessories_hostes_microphone",
    position: 400,
    position_admin: 450,
    label: "hostes microphone accessories photo",
    group: "interiors",
    description: "A photo showing the hostes's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_handrails: {
    name: "photo_handrails",
    position: 410,
    position_admin: 460,
    label: "handrails photo",
    group: "interiors",
    description: "A photo showing the handrails inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_door_mechanism_internal_photo: {
    name: "photo_door_mechanism_internal_photo",
    position: 420,
    position_admin: 470,
    label: "door mechanism photo",
    group: "interiors",
    description: "A photo of the internal door mechanism.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista: {
    name: "photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista",
    position: 430,
    position_admin: 480,
    label: "interior reverse seats driver height",
    group: "interiors",
    description: "A photo showing the interior seats in reverse view, including driver seat height.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_interior_reverse_view_from_middle_aisle: {
    name: "photo_interior_reverse_view_from_middle_aisle",
    position: 440,
    position_admin: 490,
    label: "reverse view middle aisle",
    group: "interiors",
    description: "A reverse view photo from the middle aisle of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila: {
    name: "photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila",
    position: 450,
    position_admin: 500,
    label: "forward view all seats last row height",
    group: "interiors",
    description: "A forward view photo showing all seats, focusing on the height of the last row.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_overhead_compartments: {
    name: "photo_overhead_compartments",
    position: 460,
    position_admin: 510,
    label: "overhead compartments photo",
    group: "interiors",
    description: "A photo showing the overhead compartments inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_toilette: {
    name: "photo_accessories_toilette",
    position: 470,
    position_admin: 520,
    label: "toilette accessories photo",
    group: "interiors",
    description: "A photo showing the toilette accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_forward_view_from_middle_aisle: {
    name: "photo_interior_forward_view_from_middle_aisle",
    position: 480,
    position_admin: 530,
    label: "forward view middle aisle",
    group: "interiors",
    description: "A forward view photo from the middle aisle of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_floor: {
    name: "photo_hatches_floor",
    position: 490,
    position_admin: 535,
    label: "floor hatches photo",
    group: "interiors",
    description: "A photo of the floor hatches in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_central_seat_with_safety_belt_fastened: {
    name: "photo_central_seat_with_safety_belt_fastened",
    position: 500,
    position_admin: 540,
    label: "central seat safety belt",
    group: "interiors",
    description: "A photo showing the central seat with the safety belt fastened.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  turntable_photo_internal_if_present_only_18mt: {
    name: "turntable_photo_internal_if_present_only_18mt",
    position: 510,
    position_admin: 550,
    label: "turntable internal (18m)",
    group: "interiors",
    description: "An internal photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_1: {
    name: "photo_hatches_roof_1",
    position: 520,
    position_admin: 560,
    label: "roof hatch 1",
    group: "interiors",
    description: "A photo of the roof hatch number 1.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_2: {
    name: "photo_hatches_roof_2",
    position: 530,
    position_admin: 570,
    label: "roof hatch 2",
    group: "interiors",
    description: "A photo of the roof hatch number 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_3: {
    name: "photo_hatches_roof_3",
    position: 540,
    position_admin: 575,
    label: "roof hatch 3",
    group: "interiors",
    description: "A photo of the roof hatch number 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_disabled_area: {
    name: "photo_disabled_area",
    position: 550,
    position_admin: 580,
    label: "disabled area photo",
    group: "interiors",
    description: "A photo showing the designated disabled area in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_folding_seat: {
    name: "photo_folding_seat",
    position: 560,
    position_admin: 590,
    label: "folding seat photo",
    group: "interiors",
    description: "A photo showing the folding seat in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_single_seat: {
    name: "photo_detail_of_single_seat",
    position: 570,
    position_admin: 620,
    label: "single seat detail",
    group: "interiors",
    description: "A detailed photo of a single seat in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_mesh: {
    name: "photo_detail_of_mesh",
    position: 580,
    position_admin: 630,
    label: "mesh detail photo",
    group: "interiors",
    description: "A detailed photo of the mesh inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_table_detail: {
    name: "photo_table_detail",
    position: 590,
    position_admin: 640,
    label: "table detail photo",
    group: "interiors",
    description: "A detailed photo of the table inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_charging_usb_detail: {
    name: "photo_charging_usb_detail",
    position: 600,
    position_admin: 650,
    label: "usb charging detail",
    group: "interiors",
    description: "A detailed photo showing the USB charging ports.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_armrest_detail: {
    name: "photo_armrest_detail",
    position: 610,
    position_admin: 660,
    label: "armrest detail photo",
    group: "interiors",
    description: "A detailed photo of the armrest in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_footrest_detail: {
    name: "photo_footrest_detail",
    position: 620,
    position_admin: 670,
    label: "footrest detail photo",
    group: "interiors",
    description: "A detailed photo of the footrest in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_monitor_detail: {
    name: "photo_monitor_detail",
    position: 630,
    position_admin: 680,
    label: "monitor detail photo",
    group: "interiors",
    description: "A detailed photo of the monitor in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_outlets_di_current_detail: {
    name: "photo_outlets_di_current_detail",
    position: 640,
    position_admin: 690,
    label: "power outlets detail",
    group: "interiors",
    description: "A detailed photo of the power outlets in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_coffee_machine_accessories: {
    name: "photo_coffee_machine_accessories",
    position: 650,
    position_admin: 710,
    label: "coffee machine accessories",
    group: "interiors",
    description: "A photo of the coffee machine accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_brackets_seats: {
    name: "photo_brackets_seats",
    position: 660,
    position_admin: 710,
    label: "seat brackets photo",
    group: "interiors",
    description: "A photo showing the seat brackets in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_cameras: {
    name: "photo_accessories_cameras",
    position: 670,
    position_admin: 720,
    label: "camera accessories photo",
    group: "interiors",
    description: "A photo showing the camera accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  jack_e_keys_for_driver: {
    name: "jack_e_keys_for_driver",
    position: 680,
    position_admin: 730,
    label: "jack and driver keys",
    group: "interiors",
    description: "A photo showing the jack and keys for the driver.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Tire sizes
  spare_wheel: {
    name: "spare_wheel",
    position: 690,
    position_admin: 20,
    label: "spare wheel",
    group: "tire-sizes",
    description: "A photo of the spare wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_front_left_measurements: {
    name: "photo_tire_front_left_measurements",
    position: 700,
    position_admin: 50,
    label: "front left tire measurements",
    group: "tire-sizes",
    description: "A photo showing the measurements of the front left tire.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_rear_left: {
    name: "photo_tire_rear_left",
    position: 710,
    position_admin: 110,
    label: "rear left tire photo",
    group: "tire-sizes",
    description: "A photo showing the rear left tire of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_right",
    position: 720,
    position_admin: 760,
    label: "tread condition front tires right",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the front tires right.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_left",
    position: 730,
    position_admin: 1190,
    label: "tread condition front tires left",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the front tires left.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_left",
    position: 740,
    position_admin: 1190,
    label: "tread condition second axle tires left",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the second axle tires left.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_right",
    position: 750,
    position_admin: 1200,
    label: "tread condition second axle tires right",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the second axle tires right.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_left",
    position: 760,
    position_admin: 1210,
    label: "tread condition third axle tires left",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the third axle tires left.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_right",
    position: 770,
    position_admin: 1220,
    label: "tread condition third axle tires right",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the third axle tires right.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Undercarriage
  photo_undercarriage_front_part_from_front: {
    name: "photo_undercarriage_front_part_from_front",
    position: 780,
    position_admin: 740,
    label: "front undercarriage from front",
    group: "undercarriage",
    description: "A photo showing the front part of the undercarriage from the front.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_right: {
    name: "photo_undercarriage_axle_front_side_right",
    position: 790,
    position_admin: 770,
    label: "front axle right side",
    group: "undercarriage",
    description: "A photo of the front axle from the right side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_right: {
    name: "photo_front_discs_right",
    position: 800,
    position_admin: 780,
    label: "front discs right",
    group: "undercarriage",
    description: "A photo of the right front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_right: {
    name: "photo_front_brake_calipers_right",
    position: 810,
    position_admin: 790,
    label: "front brake calipers right",
    group: "undercarriage",
    description: "A photo of the right front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_right: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_right",
    position: 820,
    position_admin: 800,
    label: "front shock absorbers right",
    group: "undercarriage",
    description: "A photo of the right front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right",
    position: 830,
    position_admin: 810,
    label: "front air springs right",
    group: "undercarriage",
    description: "A photo of the right front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_central: {
    name: "photo_undercarriage_axle_front_central",
    position: 840,
    position_admin: 820,
    label: "front axle central",
    group: "undercarriage",
    description: "A photo of the front axle from the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_left: {
    name: "photo_undercarriage_axle_front_side_left",
    position: 850,
    position_admin: 830,
    label: "front axle left side",
    group: "undercarriage",
    description: "A photo of the front axle from the left side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_left: {
    name: "photo_front_discs_left",
    position: 860,
    position_admin: 840,
    label: "front discs left",
    group: "undercarriage",
    description: "A photo of the left front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_left: {
    name: "photo_front_brake_calipers_left",
    position: 870,
    position_admin: 850,
    label: "front brake calipers left",
    group: "undercarriage",
    description: "A photo of the left front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_left: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_left",
    position: 880,
    position_admin: 860,
    label: "front shock absorbers left",
    group: "undercarriage",
    description: "A photo of the left front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left",
    position: 890,
    position_admin: 870,
    label: "front air springs left",
    group: "undercarriage",
    description: "A photo of the left front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_central: {
    name: "photo_undercarriage_central",
    position: 900,
    position_admin: 880,
    label: "central undercarriage photo",
    group: "undercarriage",
    description: "A photo of the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_right: {
    name: "photo_discs_axle_central_right",
    position: 910,
    position_admin: 890,
    label: "axle 2 discs right",
    group: "undercarriage",
    description: "A photo of the right brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_right: {
    name: "photo_caliper_brakes_axle_central_right",
    position: 920,
    position_admin: 900,
    label: "axle 2 caliper brakes right",
    group: "undercarriage",
    description: "A photo of the right brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_1",
    position: 930,
    position_admin: 910,
    label: "axle 2 shock absorbers 1 right",
    group: "undercarriage",
    description: "A photo of the first right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_2",
    position: 940,
    position_admin: 920,
    label: "axle 2 shock absorbers 2 left",
    group: "undercarriage",
    description: "A photo of the second right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1",
    position: 950,
    position_admin: 930,
    label: "axel 2 air springs 1 right",
    group: "undercarriage",
    description: "A photo of the first right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2",
    position: 960,
    position_admin: 940,
    label: "axel 2 air springs 2 right",
    group: "undercarriage",
    description: "A photo of the second right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_left: {
    name: "photo_discs_axle_central_left",
    position: 970,
    position_admin: 950,
    label: "axle 2 discs left",
    group: "undercarriage",
    description: "A photo of the left brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_left: {
    name: "photo_caliper_brakes_axle_central_left",
    position: 980,
    position_admin: 960,
    label: "axle 2 caliper brakes left",
    group: "undercarriage",
    description: "A photo of the left brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_1",
    position: 990,
    position_admin: 970,
    label: "axle 2 shock absorbers 1 left",
    group: "undercarriage",
    description: "A photo of the first left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1",
    position: 1e3,
    position_admin: 980,
    label: "axel 2 air springs 1 left",
    group: "undercarriage",
    description: "A photo of the first left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_2",
    position: 1010,
    position_admin: 990,
    label: "axle 2 shock absorbers 2 left",
    group: "undercarriage",
    description: "A photo of the second left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2",
    position: 1020,
    position_admin: 1e3,
    label: "axel 2 air springs 2 left",
    group: "undercarriage",
    description: "A photo of the second left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_central: {
    name: "photo_undercarriage_axle_rear_central",
    position: 1030,
    position_admin: 1010,
    label: "axle 3 central",
    group: "undercarriage",
    description: "A photo of the central part of the axle 3 undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_right: {
    name: "photo_undercarriage_axle_rear_side_right",
    position: 1040,
    position_admin: 1020,
    label: "axle 3 right side",
    group: "undercarriage",
    description: "A photo of the right side of the axle 3 undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_right: {
    name: "photo_discs_rear_right",
    position: 1050,
    position_admin: 1030,
    label: "axel 3  discs right",
    group: "undercarriage",
    description: "A photo of the right brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_right: {
    name: "photo_caliper_brakes_rear_right",
    position: 1060,
    position_admin: 1040,
    label: "axel 3 caliper brakes right",
    group: "undercarriage",
    description: "A photo of the right caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_1: {
    name: "photo_rear_shock_absorbers_right_1",
    position: 1070,
    position_admin: 1050,
    label: "axel 3 shock absorbers 1 right",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_1: {
    name: "photo_rear_air_springs_if_present_right_1",
    position: 1080,
    position_admin: 1060,
    label: "axle 3 air springs 1 right",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_2: {
    name: "photo_rear_shock_absorbers_right_2",
    position: 1090,
    position_admin: 1070,
    label: "axel 3 shock absorbers 2 right",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 2) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_2: {
    name: "photo_rear_air_springs_if_present_right_2",
    position: 1100,
    position_admin: 1080,
    label: "axle 3 air springs 2 right",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 2) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_right: {
    name: "photo_rear_leaf_spring_if_present_right",
    position: 1110,
    position_admin: 1090,
    label: "axel 2 leaf spring right",
    group: "undercarriage",
    description: "A photo of the right leaf spring if present axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_left: {
    name: "photo_undercarriage_axle_rear_side_left",
    position: 1120,
    position_admin: 1100,
    label: "axle 3 left side",
    group: "undercarriage",
    description: "A photo of the left side of the axle 3 undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_left: {
    name: "photo_discs_rear_left",
    position: 1130,
    position_admin: 1110,
    label: "axel 3 discs left",
    group: "undercarriage",
    description: "A photo of the left brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_left: {
    name: "photo_caliper_brakes_rear_left",
    position: 1140,
    position_admin: 1120,
    label: "axel 3 caliper brakes left",
    group: "undercarriage",
    description: "A photo of the left caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_1: {
    name: "photo_rear_shock_absorbers_left_1",
    position: 1150,
    position_admin: 1130,
    label: "axel 3 shock absorbers 1 left",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_2: {
    name: "photo_rear_shock_absorbers_left_2",
    position: 1160,
    position_admin: 1140,
    label: "axel 3 shock absorbers 2 left",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 2) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_1: {
    name: "photo_rear_air_springs_if_present_left_1",
    position: 1170,
    position_admin: 1150,
    label: "axle 3 air springs 1 left",
    group: "undercarriage",
    description: "A photo of the left air springs if present (position 1) axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_2: {
    name: "photo_rear_air_springs_if_present_left_2",
    position: 1180,
    position_admin: 1160,
    label: "axle 3 air springs 2 left",
    group: "undercarriage",
    description: "A photo of the left rear air springs if present (position 2).",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_left: {
    name: "photo_rear_leaf_spring_if_present_left",
    position: 1190,
    position_admin: 1170,
    label: "axel 3 leaf spring left",
    group: "undercarriage",
    description: "A photo of the left leaf spring if present. Axle 3",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_differential: {
    name: "photo_differential",
    position: 1200,
    position_admin: 1180,
    label: "differential photo",
    group: "undercarriage",
    description: "A photo of the vehicle's differential.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_gearbox: {
    name: "photo_gearbox",
    position: 1210,
    position_admin: 1230,
    label: "gearbox photo",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_plate_gearbox: {
    name: "photo_plate_gearbox",
    position: 1220,
    position_admin: 1240,
    label: "gearbox plate photo",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox plate.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driveshaft: {
    name: "photo_driveshaft",
    position: 1230,
    position_admin: 1250,
    label: "driveshaft photo",
    group: "undercarriage",
    description: "A photo of the vehicle's driveshaft.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_engine_below_without_protection: {
    name: "photo_engine_below_without_protection",
    position: 1240,
    position_admin: 1260,
    label: "engine without protection",
    group: "undercarriage",
    description: "A photo showing the engine from below without any protection.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_exhaust: {
    name: "photo_exhaust",
    position: 1250,
    position_admin: 1270,
    label: "exhaust photo",
    group: "undercarriage",
    description: "A photo showing the vehicle's exhaust.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_axle_central_18_meters: {
    name: "photo_axle_central_18_meters",
    position: 1260,
    position_admin: 1280,
    label: "central axle (18m)",
    group: "undercarriage",
    description: "A photo of the central axle for 18-meter vehicles.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_bellows_turntable_18_meters: {
    name: "photo_bellows_turntable_18_meters",
    position: 1270,
    position_admin: 1290,
    label: "bellows turntable (18m)",
    group: "undercarriage",
    description: "A photo showing the bellows of the turntable for 18-meter vehicles.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Technical Data
  photo_chassis_vin: {
    name: "photo_chassis_vin",
    position: 1280,
    position_admin: 1300,
    label: "chassis VIN photo",
    group: "technical-data",
    description: "A photo of the vehicle's chassis VIN.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_any_devices_onboard_3: {
    name: "photo_any_devices_onboard_3",
    position: 1290,
    position_admin: 1310,
    label: "onboard devices 3",
    group: "technical-data",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  }
}, W1 = {
  photo_cover_base: {
    name: "photo_cover_base",
    position: 2e3,
    position_admin: 2e3,
    label: "Base cover photo",
    group: "cover",
    description: "The photo displayed in the listing page (default: photo_3_4_front_side_right_doors_closed)",
    performTextInpaint: !0
  },
  photo_cover_hover: {
    name: "photo_cover_hover",
    position: 2010,
    position_admin: 2010,
    label: "Hover cover photo",
    group: "cover",
    description: "The photo usually on mouse hover in the listing page, (default: photo_front)",
    performTextInpaint: !0
  }
}, d1 = [
  {
    name: "Baden-Württemberg",
    code: "DE-BW",
    provinces: [{ name: "Baden-Württemberg", code: "BW" }]
  },
  {
    name: "Bayern",
    code: "DE-BY",
    provinces: [{ name: "Bayern", code: "BY" }]
  },
  {
    name: "Berlin",
    code: "DE-BE",
    provinces: [{ name: "Berlin", code: "BE" }]
  },
  {
    name: "Brandenburg",
    code: "DE-BB",
    provinces: [{ name: "Brandenburg", code: "BB" }]
  },
  {
    name: "Bremen",
    code: "DE-HB",
    provinces: [{ name: "Bremen", code: "HB" }]
  },
  {
    name: "Hamburg",
    code: "DE-HH",
    provinces: [{ name: "Hamburg", code: "HH" }]
  },
  {
    name: "Hessen",
    code: "DE-HE",
    provinces: [{ name: "Hessen", code: "HE" }]
  },
  {
    name: "Mecklenburg-Vorpommern",
    code: "DE-MV",
    provinces: [{ name: "Mecklenburg-Vorpommern", code: "MV" }]
  },
  {
    name: "Niedersachsen",
    code: "DE-NI",
    provinces: [{ name: "Niedersachsen", code: "NI" }]
  },
  {
    name: "Nordrhein-Westfalen",
    code: "DE-NW",
    provinces: [{ name: "Nordrhein-Westfalen", code: "NW" }]
  },
  {
    name: "Rheinland-Pfalz",
    code: "DE-RP",
    provinces: [{ name: "Rheinland-Pfalz", code: "RP" }]
  },
  {
    name: "Saarland",
    code: "DE-SL",
    provinces: [{ name: "Saarland", code: "SL" }]
  },
  {
    name: "Sachsen",
    code: "DE-SN",
    provinces: [{ name: "Sachsen", code: "SN" }]
  },
  {
    name: "Sachsen-Anhalt",
    code: "DE-ST",
    provinces: [{ name: "Sachsen-Anhalt", code: "ST" }]
  },
  {
    name: "Schleswig-Holstein",
    code: "DE-SH",
    provinces: [{ name: "Schleswig-Holstein", code: "SH" }]
  },
  {
    name: "Thüringen",
    code: "DE-TH",
    provinces: [{ name: "Thüringen", code: "TH" }]
  }
], p1 = [
  {
    name: "Abruzzo",
    code: "IT-65",
    provinces: [
      { name: "L'Aquila", code: "AQ" },
      { name: "Chieti", code: "CH" },
      { name: "Pescara", code: "PE" },
      { name: "Teramo", code: "TE" }
    ]
  },
  {
    name: "Basilicata",
    code: "IT-77",
    provinces: [
      { name: "Matera", code: "MT" },
      { name: "Potenza", code: "PZ" }
    ]
  },
  {
    name: "Calabria",
    code: "IT-78",
    provinces: [
      { name: "Cosenza", code: "CS" },
      { name: "Catanzaro", code: "CZ" },
      { name: "Crotone", code: "KR" },
      { name: "Reggio Calabria", code: "RC" },
      { name: "Vibo Valentia", code: "VV" }
    ]
  },
  {
    name: "Campania",
    code: "IT-72",
    provinces: [
      { name: "Avellino", code: "AV" },
      { name: "Benevento", code: "BN" },
      { name: "Caserta", code: "CE" },
      { name: "Napoli", code: "NA" },
      { name: "Salerno", code: "SA" }
    ]
  },
  {
    name: "Emilia-Romagna",
    code: "IT-45",
    provinces: [
      { name: "Bologna", code: "BO" },
      { name: "Forlì-Cesena", code: "FC" },
      { name: "Ferrara", code: "FE" },
      { name: "Modena", code: "MO" },
      { name: "Piacenza", code: "PC" },
      { name: "Parma", code: "PR" },
      { name: "Ravenna", code: "RA" },
      { name: "Reggio Emilia", code: "RE" },
      { name: "Rimini", code: "RN" }
    ]
  },
  {
    name: "Friuli-Venezia Giulia",
    code: "IT-36",
    provinces: [
      { name: "Gorizia", code: "GO" },
      { name: "Pordenone", code: "PN" },
      { name: "Trieste", code: "TS" },
      { name: "Udine", code: "UD" }
    ]
  },
  {
    name: "Lazio",
    code: "IT-62",
    provinces: [
      { name: "Frosinone", code: "FR" },
      { name: "Latina", code: "LT" },
      { name: "Rieti", code: "RI" },
      { name: "Roma", code: "RM" },
      { name: "Viterbo", code: "VT" }
    ]
  },
  {
    name: "Liguria",
    code: "IT-42",
    provinces: [
      { name: "Genova", code: "GE" },
      { name: "Imperia", code: "IM" },
      { name: "La Spezia", code: "SP" },
      { name: "Savona", code: "SV" }
    ]
  },
  {
    name: "Lombardia",
    code: "IT-25",
    provinces: [
      { name: "Bergamo", code: "BG" },
      { name: "Brescia", code: "BS" },
      { name: "Como", code: "CO" },
      { name: "Cremona", code: "CR" },
      { name: "Lecco", code: "LC" },
      { name: "Lodi", code: "LO" },
      { name: "Monza e della Brianza", code: "MB" },
      { name: "Milano", code: "MI" },
      { name: "Mantova", code: "MN" },
      { name: "Pavia", code: "PV" },
      { name: "Sondrio", code: "SO" },
      { name: "Varese", code: "VA" }
    ]
  },
  {
    name: "Marche",
    code: "IT-57",
    provinces: [
      { name: "Ancona", code: "AN" },
      { name: "Ascoli Piceno", code: "AP" },
      { name: "Fermo", code: "FM" },
      { name: "Macerata", code: "MC" },
      { name: "Pesaro e Urbino", code: "PU" }
    ]
  },
  {
    name: "Molise",
    code: "IT-67",
    provinces: [
      { name: "Campobasso", code: "CB" },
      { name: "Isernia", code: "IS" }
    ]
  },
  {
    name: "Piemonte",
    code: "IT-21",
    provinces: [
      { name: "Alessandria", code: "AL" },
      { name: "Asti", code: "AT" },
      { name: "Biella", code: "BI" },
      { name: "Cuneo", code: "CN" },
      { name: "Novara", code: "NO" },
      { name: "Torino", code: "TO" },
      { name: "Verbano-Cusio-Ossola", code: "VB" },
      { name: "Vercelli", code: "VC" }
    ]
  },
  {
    name: "Puglia",
    code: "IT-75",
    provinces: [
      { name: "Bari", code: "BA" },
      { name: "Brindisi", code: "BR" },
      { name: "Barletta-Andria-Trani", code: "BT" },
      { name: "Foggia", code: "FG" },
      { name: "Lecce", code: "LE" },
      { name: "Taranto", code: "TA" }
    ]
  },
  {
    name: "Sardegna",
    code: "IT-88",
    provinces: [
      { name: "Cagliari", code: "CA" },
      { name: "Nuoro", code: "NU" },
      { name: "Oristano", code: "OR" },
      { name: "Sassari", code: "SS" },
      { name: "Carbonia-Iglesias", code: "CI" },
      { name: "Olbia-Tempio", code: "OT" },
      { name: "Medio Campidano", code: "VS" },
      { name: "Ogliastra", code: "OG" }
    ]
  },
  {
    name: "Sicilia",
    code: "IT-82",
    provinces: [
      { name: "Agrigento", code: "AG" },
      { name: "Caltanissetta", code: "CL" },
      { name: "Catania", code: "CT" },
      { name: "Enna", code: "EN" },
      { name: "Messina", code: "ME" },
      { name: "Palermo", code: "PA" },
      { name: "Ragusa", code: "RG" },
      { name: "Siracusa", code: "SR" },
      { name: "Trapani", code: "TP" }
    ]
  },
  {
    name: "Toscana",
    code: "IT-52",
    provinces: [
      { name: "Arezzo", code: "AR" },
      { name: "Firenze", code: "FI" },
      { name: "Grosseto", code: "GR" },
      { name: "Livorno", code: "LI" },
      { name: "Lucca", code: "LU" },
      { name: "Massa-Carrara", code: "MS" },
      { name: "Pisa", code: "PI" },
      { name: "Prato", code: "PO" },
      { name: "Pistoia", code: "PT" },
      { name: "Siena", code: "SI" }
    ]
  },
  {
    name: "Trentino-Alto Adige, Trentino-Südtirol",
    code: "IT-32",
    provinces: [
      { name: "Bolzano", code: "BZ" },
      { name: "Trento", code: "TN" }
    ]
  },
  {
    name: "Umbria",
    code: "IT-55",
    provinces: [
      { name: "Perugia", code: "PG" },
      { name: "Terni", code: "TR" }
    ]
  },
  { name: "Valle d'Aosta, Vallée d'Aoste", code: "IT-23", provinces: [{ name: "Aosta", code: "AO" }] },
  {
    name: "Veneto",
    code: "IT-34",
    provinces: [
      { name: "Belluno", code: "BL" },
      { name: "Padova", code: "PD" },
      { name: "Rovigo", code: "RO" },
      { name: "Treviso", code: "TV" },
      { name: "Venezia", code: "VE" },
      { name: "Vicenza", code: "VI" },
      { name: "Verona", code: "VR" }
    ]
  }
], f1 = [
  {
    name: "Dolnośląskie",
    code: "PL-02",
    provinces: [{ name: "Dolnośląskie", code: "DS" }]
  },
  {
    name: "Kujawsko-Pomorskie",
    code: "PL-04",
    provinces: [{ name: "Kujawsko-Pomorskie", code: "KP" }]
  },
  {
    name: "Lubelskie",
    code: "PL-06",
    provinces: [{ name: "Lubelskie", code: "LU" }]
  },
  {
    name: "Lubuskie",
    code: "PL-08",
    provinces: [{ name: "Lubuskie", code: "LB" }]
  },
  {
    name: "Łódzkie",
    code: "PL-10",
    provinces: [{ name: "Łódzkie", code: "LD" }]
  },
  {
    name: "Małopolskie",
    code: "PL-12",
    provinces: [{ name: "Małopolskie", code: "MP" }]
  },
  {
    name: "Mazowieckie",
    code: "PL-14",
    provinces: [{ name: "Mazowieckie", code: "MZ" }]
  },
  {
    name: "Opolskie",
    code: "PL-16",
    provinces: [{ name: "Opolskie", code: "OP" }]
  },
  {
    name: "Podkarpackie",
    code: "PL-18",
    provinces: [{ name: "Podkarpackie", code: "PK" }]
  },
  {
    name: "Podlaskie",
    code: "PL-20",
    provinces: [{ name: "Podlaskie", code: "PD" }]
  },
  {
    name: "Pomorskie",
    code: "PL-22",
    provinces: [{ name: "Pomorskie", code: "PM" }]
  },
  {
    name: "Śląskie",
    code: "PL-24",
    provinces: [{ name: "Śląskie", code: "SL" }]
  },
  {
    name: "Świętokrzyskie",
    code: "PL-26",
    provinces: [{ name: "Świętokrzyskie", code: "SK" }]
  },
  {
    name: "Warmińsko-Mazurskie",
    code: "PL-28",
    provinces: [{ name: "Warmińsko-Mazurskie", code: "WM" }]
  },
  {
    name: "Wielkopolskie",
    code: "PL-30",
    provinces: [{ name: "Wielkopolskie", code: "WP" }]
  },
  {
    name: "Zachodniopomorskie",
    code: "PL-32",
    provinces: [{ name: "Zachodniopomorskie", code: "ZP" }]
  }
], h1 = [
  {
    name: "Andalucía",
    code: "ES-AN",
    provinces: [
      { name: "Almería", code: "AL" },
      { name: "Cádiz", code: "CA" },
      { name: "Córdoba", code: "CO" },
      { name: "Granada", code: "GR" },
      { name: "Huelva", code: "H" },
      { name: "Jaén", code: "J" },
      { name: "Málaga", code: "MA" },
      { name: "Sevilla", code: "SE" }
    ]
  },
  {
    name: "Aragón",
    code: "ES-AR",
    provinces: [
      { name: "Huesca", code: "HU" },
      { name: "Teruel", code: "TE" },
      { name: "Zaragoza", code: "Z" }
    ]
  },
  {
    name: "Asturias",
    code: "ES-AS",
    provinces: [{ name: "Asturias", code: "AS" }]
  },
  {
    name: "Islas Baleares",
    code: "ES-IB",
    provinces: [{ name: "Islas Baleares", code: "IB" }]
  },
  {
    name: "País Vasco",
    code: "ES-PV",
    provinces: [
      { name: "Álava", code: "VI" },
      { name: "Bizkaia", code: "BI" },
      { name: "Gipuzkoa", code: "SS" }
    ]
  },
  {
    name: "Canarias",
    code: "ES-CN",
    provinces: [
      { name: "Las Palmas", code: "GC" },
      { name: "Santa Cruz de Tenerife", code: "TF" }
    ]
  },
  {
    name: "Cantabria",
    code: "ES-CB",
    provinces: [{ name: "Cantabria", code: "CB" }]
  },
  {
    name: "Castilla y León",
    code: "ES-CL",
    provinces: [
      { name: "Ávila", code: "AV" },
      { name: "Burgos", code: "BU" },
      { name: "León", code: "LE" },
      { name: "Palencia", code: "P" },
      { name: "Salamanca", code: "SA" },
      { name: "Segovia", code: "SG" },
      { name: "Soria", code: "SO" },
      { name: "Valladolid", code: "VA" },
      { name: "Zamora", code: "ZA" }
    ]
  },
  {
    name: "Castilla-La Mancha",
    code: "ES-CM",
    provinces: [
      { name: "Albacete", code: "AB" },
      { name: "Ciudad Real", code: "CR" },
      { name: "Cuenca", code: "CU" },
      { name: "Guadalajara", code: "GU" },
      { name: "Toledo", code: "TO" }
    ]
  },
  {
    name: "Cataluña",
    code: "ES-CT",
    provinces: [
      { name: "Barcelona", code: "B" },
      { name: "Girona", code: "GI" },
      { name: "Lleida", code: "L" },
      { name: "Tarragona", code: "T" }
    ]
  },
  {
    name: "Extremadura",
    code: "ES-EX",
    provinces: [
      { name: "Badajoz", code: "BA" },
      { name: "Cáceres", code: "CC" }
    ]
  },
  {
    name: "Galicia",
    code: "ES-GA",
    provinces: [
      { name: "A Coruña", code: "C" },
      { name: "Lugo", code: "LU" },
      { name: "Ourense", code: "OR" },
      { name: "Pontevedra", code: "PO" }
    ]
  },
  {
    name: "La Rioja",
    code: "ES-RI",
    provinces: [{ name: "La Rioja", code: "RI" }]
  },
  {
    name: "Comunidad de Madrid",
    code: "ES-MD",
    provinces: [{ name: "Madrid", code: "MD" }]
  },
  {
    name: "Región de Murcia",
    code: "ES-MC",
    provinces: [{ name: "Murcia", code: "MC" }]
  },
  {
    name: "Navarra",
    code: "ES-NC",
    provinces: [{ name: "Navarra", code: "NC" }]
  },
  {
    name: "Comunidad Valenciana",
    code: "ES-VC",
    provinces: [
      { name: "Alicante", code: "A" },
      { name: "Castellón", code: "CS" },
      { name: "Valencia", code: "V" }
    ]
  },
  {
    name: "Ceuta",
    code: "ES-CE",
    provinces: [{ name: "Ceuta", code: "CE" }]
  },
  {
    name: "Melilla",
    code: "ES-ML",
    provinces: [{ name: "Melilla", code: "ML" }]
  }
], Gi = {
  AD: {
    i18nNames: {
      en: "Andorra",
      it: "Andorra",
      es: "Andorra",
      de: "Andorra",
      pl: "Andora",
      fr: "Andorre",
      nl: "Andorra",
      pt: "Andorra",
      cs: "Andorra",
      ro: "Andorra",
      ru: "Андорра"
    },
    rootIddCode: "+376",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^[A-Z]-\\d{6}-[A-Z]$",
    taxIdExample: "X-123456-Y"
  },
  AE: {
    i18nNames: {
      en: "United Arab Emirates",
      es: "Emiratos Árabes Unidos",
      it: "Emirati Arabi Uniti",
      de: "Vereinigte Arabische Emirate",
      pl: "Zjednoczone Emiraty Arabskie",
      fr: "Émirats arabes unis",
      nl: "Verenigde Arabische Emiraten",
      pt: "Emirados Árabes Unidos",
      cs: "Spojené arabské emiráty",
      ro: "Emiratele Arabe Unite",
      ru: "Объединённые Арабские Эмираты"
    },
    rootIddCode: "+971",
    continent: "Asia",
    taxIdMandatory: !1,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  AF: {
    i18nNames: {
      en: "Afghanistan",
      it: "Afghanistan",
      es: "Afganistán",
      de: "Afghanistan",
      pl: "Afganistan",
      fr: "Afghanistan",
      nl: "Afghanistan",
      pt: "Afeganistão",
      cs: "Afghánistán",
      ro: "Afganistan",
      ru: "Афганистан"
    },
    rootIddCode: "+93",
    continent: "Asia"
  },
  AG: {
    i18nNames: {
      en: "Antigua and Barbuda",
      es: "Antigua y Barbuda",
      it: "Antigua e Barbuda",
      de: "Antigua und Barbuda",
      pl: "Antigua i Barbuda",
      fr: "Antigua-et-Barbuda",
      nl: "Antigua en Barbuda",
      pt: "Antígua e Barbuda",
      cs: "Antigua a Barbuda",
      ro: "Antigua și Barbuda",
      ru: "Антигуа и Барбуда"
    },
    rootIddCode: "+1268",
    continent: "NorthAmerica"
  },
  AI: {
    i18nNames: {
      en: "Anguilla",
      it: "Anguilla",
      es: "Anguila",
      de: "Anguilla",
      pl: "Anguilla",
      fr: "Anguilla",
      nl: "Anguilla",
      pt: "Anguila",
      cs: "Anguilla",
      ro: "Anguilla",
      ru: "Ангилья"
    },
    rootIddCode: "+1264",
    continent: "NorthAmerica"
  },
  AL: {
    i18nNames: {
      en: "Albania",
      it: "Albania",
      es: "Albania",
      de: "Albanien",
      pl: "Albania",
      fr: "Albanie",
      nl: "Albanië",
      pt: "Albânia",
      cs: "Albánie",
      ro: "Albania",
      ru: "Албания"
    },
    rootIddCode: "+355",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^[JKLM]\\d{8}[A-Z]$",
    taxIdExample: "J12345678K"
  },
  AM: {
    i18nNames: {
      en: "Armenia",
      it: "Armenia",
      es: "Armenia",
      de: "Armenien",
      pl: "Armenia",
      fr: "Arménie",
      nl: "Armenië",
      pt: "Arménia",
      cs: "Arménie",
      ro: "Armenia",
      ru: "Армения"
    },
    rootIddCode: "+374",
    continent: "Asia"
  },
  AO: {
    i18nNames: {
      en: "Angola",
      it: "Angola",
      es: "Angola",
      de: "Angola",
      pl: "Angola",
      fr: "Angola",
      nl: "Angola",
      pt: "Angola",
      cs: "Angola",
      ro: "Angola",
      ru: "Ангола"
    },
    rootIddCode: "+244",
    continent: "Africa"
  },
  AQ: {
    i18nNames: {
      en: "Antarctica",
      it: "Antartide",
      es: "Antártida",
      de: "Antarktis",
      pl: "Antarktyka",
      fr: "Antarctique",
      nl: "Antarctica",
      pt: "Antártica",
      cs: "Antarktida",
      ro: "Antarctica",
      ru: "Антарктида"
    },
    rootIddCode: "undefined",
    continent: "Antarctica"
  },
  AR: {
    i18nNames: {
      en: "Argentina",
      it: "Argentina",
      es: "Argentina",
      de: "Argentinien",
      pl: "Argentyna",
      fr: "Argentine",
      nl: "Argentinië",
      pt: "Argentina",
      cs: "Argentina",
      ro: "Argentina",
      ru: "Аргентина"
    },
    rootIddCode: "+54",
    continent: "SouthAmerica"
  },
  AS: {
    i18nNames: {
      en: "American Samoa",
      it: "Samoa Americane",
      es: "Samoa Americana",
      de: "Amerikanisch-Samoa",
      pl: "Samoa Amerykańskie",
      fr: "Samoa américaines",
      nl: "Amerikaans-Samoa",
      pt: "Samoa Americana",
      cs: "Americká Samoa",
      ro: "Samoa Americană",
      ru: "Американское Самоа"
    },
    rootIddCode: "+1684",
    continent: "Oceania"
  },
  AT: {
    i18nNames: {
      en: "Austria",
      it: "Austria",
      es: "Austria",
      de: "Österreich",
      pl: "Austria",
      fr: "Autriche",
      nl: "Oostenrijk",
      pt: "Áustria",
      cs: "Rakousko",
      ro: "Austria",
      ru: "Австрия"
    },
    rootIddCode: "+43",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^ATU\\d{8}$",
    taxIdExample: "ATU12345678"
  },
  AU: {
    i18nNames: {
      en: "Australia",
      it: "Australia",
      es: "Australia",
      de: "Australien",
      pl: "Australia",
      fr: "Australie",
      nl: "Australië",
      pt: "Austrália",
      cs: "Austrálie",
      ro: "Australia",
      ru: "Австралия"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  AW: {
    i18nNames: {
      en: "Aruba",
      it: "Aruba",
      es: "Aruba",
      de: "Aruba",
      pl: "Aruba",
      fr: "Aruba",
      nl: "Aruba",
      pt: "Aruba",
      cs: "Aruba",
      ro: "Aruba",
      ru: "Аруба"
    },
    rootIddCode: "+297",
    continent: "NorthAmerica"
  },
  AX: {
    i18nNames: {
      en: "Åland Islands",
      it: "Isole Aland",
      es: "Islas Åland",
      de: "Ålandinseln",
      pl: "Wyspy Alandzkie",
      fr: "Îles Åland",
      nl: "Ålandeilanden",
      pt: "Ilhas Åland",
      cs: "Ålandské ostrovy",
      ro: "Insulele Åland",
      ru: "Аландские острова"
    },
    rootIddCode: "+35818",
    continent: "Europe",
    blocMemberships: ["EU"]
  },
  AZ: {
    i18nNames: {
      en: "Azerbaijan",
      it: "Azerbaijan",
      es: "Azerbaiyán",
      de: "Aserbaidschan",
      pl: "Azerbejdżan",
      fr: "Azerbaïdjan",
      nl: "Azerbeidzjan",
      pt: "Azerbaijão",
      cs: "Ázerbájdžán",
      ro: "Azerbaidjan",
      ru: "Азербайджан"
    },
    rootIddCode: "+994",
    continent: "Asia"
  },
  BB: {
    i18nNames: {
      en: "Barbados",
      it: "Barbados",
      es: "Barbados",
      de: "Barbados",
      pl: "Barbados",
      fr: "Barbade",
      nl: "Barbados",
      pt: "Barbados",
      cs: "Barbados",
      ro: "Barbados",
      ru: "Барбадос"
    },
    rootIddCode: "+1246",
    continent: "NorthAmerica"
  },
  BD: {
    i18nNames: {
      en: "Bangladesh",
      it: "Bangladesh",
      es: "Bangladés",
      de: "Bangladesch",
      pl: "Bangladesz",
      fr: "Bangladesh",
      nl: "Bangladesh",
      pt: "Bangladesh",
      cs: "Bangladéš",
      ro: "Bangladesh",
      ru: "Бангладеш"
    },
    rootIddCode: "+880",
    continent: "Asia"
  },
  BE: {
    i18nNames: {
      en: "Belgium",
      it: "Belgio",
      es: "Bélgica",
      de: "Belgien",
      pl: "Belgia",
      fr: "Belgique",
      nl: "België",
      pt: "Bélgica",
      cs: "Belgie",
      ro: "Belgia",
      ru: "Бельгия"
    },
    rootIddCode: "+32",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BE\\d{10}$",
    taxIdExample: "BE0123456789"
  },
  BF: {
    i18nNames: {
      en: "Burkina Faso",
      it: "Burkina Faso",
      es: "Burkina Faso",
      de: "Burkina Faso",
      pl: "Burkina Faso",
      fr: "Burkina Faso",
      nl: "Burkina Faso",
      pt: "Burquina Faso",
      cs: "Burkina Faso",
      ro: "Burkina Faso",
      ru: "Буркина-Фасо"
    },
    rootIddCode: "+226",
    continent: "Africa"
  },
  BG: {
    i18nNames: {
      en: "Bulgaria",
      it: "Bulgaria",
      es: "Bulgaria",
      de: "Bulgarien",
      pl: "Bułgaria",
      fr: "Bulgarie",
      nl: "Bulgarije",
      pt: "Bulgária",
      cs: "Bulharsko",
      ro: "Bulgaria",
      ru: "Болгария"
    },
    rootIddCode: "+359",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BG(\\d{9}|\\d{10})$",
    taxIdExample: "BG123456789"
  },
  BH: {
    i18nNames: {
      en: "Bahrain",
      it: "Bahrein",
      es: "Baréin",
      de: "Bahrain",
      pl: "Bahrajn",
      fr: "Bahreïn",
      nl: "Bahrein",
      pt: "Bahrein",
      cs: "Bahrajn",
      ro: "Bahrein",
      ru: "Бахрейн"
    },
    rootIddCode: "+973",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BI: {
    i18nNames: {
      en: "Burundi",
      it: "Burundi",
      es: "Burundi",
      de: "Burundi",
      pl: "Burundi",
      fr: "Burundi",
      nl: "Burundi",
      pt: "Burundi",
      cs: "Burundi",
      ro: "Burundi",
      ru: "Бурунди"
    },
    rootIddCode: "+257",
    continent: "Africa"
  },
  BJ: {
    i18nNames: {
      en: "Benin",
      it: "Benin",
      es: "Benín",
      de: "Benin",
      pl: "Benin",
      fr: "Bénin",
      nl: "Benin",
      pt: "Benim",
      cs: "Benin",
      ro: "Benin",
      ru: "Бенин"
    },
    rootIddCode: "+229",
    continent: "Africa"
  },
  BL: {
    i18nNames: {
      en: "Saint Barthélemy",
      es: "San Bartolomé",
      it: "Antille Francesi",
      de: "Saint-Barthélemy",
      pl: "Saint-Barthélemy",
      fr: "Saint-Barthélemy",
      nl: "Saint-Barthélemy",
      pt: "São Bartolomeu",
      cs: "Svatý Bartoloměj",
      ro: "Sfântul Bartolomeu",
      ru: "Сен-Бартелеми"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  BM: {
    i18nNames: {
      en: "Bermuda",
      it: "Bermuda",
      es: "Bermudas",
      de: "Bermuda",
      pl: "Bermudy",
      fr: "Bermudes",
      nl: "Bermuda",
      pt: "Bermudas",
      cs: "Bermudy",
      ro: "Bermuda",
      ru: "Бермуды"
    },
    rootIddCode: "+1441",
    continent: "NorthAmerica"
  },
  BN: {
    i18nNames: {
      en: "Brunei",
      it: "Brunei",
      es: "Brunéi",
      de: "Brunei",
      pl: "Brunei",
      fr: "Brunei",
      nl: "Brunei",
      pt: "Brunei",
      cs: "Brunej",
      ro: "Brunei",
      ru: "Бруней"
    },
    rootIddCode: "+673",
    continent: "Asia"
  },
  BO: {
    i18nNames: {
      en: "Bolivia",
      it: "Bolivia",
      es: "Bolivia",
      de: "Bolivien",
      pl: "Boliwia",
      fr: "Bolivie",
      nl: "Bolivia",
      pt: "Bolívia",
      cs: "Bolívie",
      ro: "Bolivia",
      ru: "Боливия"
    },
    rootIddCode: "+591",
    continent: "SouthAmerica"
  },
  BQ: {
    i18nNames: {
      en: "Caribbean Netherlands",
      es: "Bonaire, San Eustaquio y Saba",
      it: "Paesi Bassi caraibici",
      de: "Karibische Niederlande",
      pl: "Niderlandy Karaibskie",
      fr: "Pays-Bas caribéens",
      nl: "Caribisch Nederland",
      pt: "Países Baixos Caribenhos",
      cs: "Karibské Nizozemsko",
      ro: "Antilele Olandeze",
      ru: "Карибские Нидерланды"
    },
    rootIddCode: "+599",
    continent: "NorthAmerica"
  },
  BR: {
    i18nNames: {
      en: "Brazil",
      it: "Brasile",
      es: "Brasil",
      de: "Brasilien",
      pl: "Brazylia",
      fr: "Brésil",
      nl: "Brazilië",
      pt: "Brasil",
      cs: "Brazílie",
      ro: "Brazilia",
      ru: "Бразилия"
    },
    rootIddCode: "+55",
    continent: "SouthAmerica"
  },
  BS: {
    i18nNames: {
      en: "Bahamas",
      it: "Bahamas",
      es: "Bahamas",
      de: "Bahamas",
      pl: "Bahamy",
      fr: "Bahamas",
      nl: "Bahama's",
      pt: "Bahamas",
      cs: "Bahamy",
      ro: "Bahamas",
      ru: "Багамы"
    },
    rootIddCode: "+1242",
    continent: "NorthAmerica"
  },
  BT: {
    i18nNames: {
      en: "Bhutan",
      it: "Bhutan",
      es: "Bután",
      de: "Bhutan",
      pl: "Bhutan",
      fr: "Bhoutan",
      nl: "Bhutan",
      pt: "Butão",
      cs: "Bhútán",
      ro: "Bhutan",
      ru: "Бутан"
    },
    rootIddCode: "+975",
    continent: "Asia"
  },
  BV: {
    i18nNames: {
      en: "Bouvet Island",
      it: "Isola Bouvet",
      es: "Isla Bouvet",
      de: "Bouvetinsel",
      pl: "Wyspa Bouveta",
      fr: "Île Bouvet",
      nl: "Bouveteiland",
      pt: "Ilha Bouvet",
      cs: "Bouvetův ostrov",
      ro: "Insula Bouvet",
      ru: "Остров Буве"
    },
    rootIddCode: "+47",
    continent: "Antarctica"
  },
  BW: {
    i18nNames: {
      en: "Botswana",
      it: "Botswana",
      es: "Botsuana",
      de: "Botswana",
      pl: "Botswana",
      fr: "Botswana",
      nl: "Botswana",
      pt: "Botsuana",
      cs: "Botswana",
      ro: "Botswana",
      ru: "Ботсвана"
    },
    rootIddCode: "+267",
    continent: "Africa"
  },
  BY: {
    i18nNames: {
      en: "Belarus",
      it: "Bielorussia",
      es: "Bielorrusia",
      de: "Weißrussland",
      pl: "Białoruś",
      fr: "Biélorussie",
      nl: "Wit-Rusland",
      pt: "Bielorrússia",
      cs: "Bělorusko",
      ro: "Belarus",
      ru: "Беларусь"
    },
    rootIddCode: "+375",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  BZ: {
    i18nNames: {
      en: "Belize",
      it: "Belize",
      es: "Belice",
      de: "Belize",
      pl: "Belize",
      fr: "Belize",
      nl: "Belize",
      pt: "Belize",
      cs: "Belize",
      ro: "Belize",
      ru: "Белиз"
    },
    rootIddCode: "+501",
    continent: "NorthAmerica"
  },
  CA: {
    i18nNames: {
      en: "Canada",
      it: "Canada",
      es: "Canadá",
      de: "Kanada",
      pl: "Kanada",
      fr: "Canada",
      nl: "Canada",
      pt: "Canadá",
      cs: "Kanada",
      ro: "Canada",
      ru: "Канада"
    },
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
    rootIddCode: "+1",
    continent: "NorthAmerica"
  },
  CC: {
    i18nNames: {
      en: "Cocos (Keeling) Islands",
      es: "Islas Cocos",
      it: "Isole Cocos e Keeling",
      de: "Kokosinseln",
      pl: "Wyspy Kokosowe",
      fr: "Îles Cocos",
      nl: "Cocoseilanden",
      pt: "Ilhas Cocos (Keeling)",
      cs: "Kokosové ostrovy",
      ro: "Insulele Cocos (Keeling)",
      ru: "Кокосовые (Килинг) острова"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  CD: {
    i18nNames: {
      en: "DR Congo",
      it: "Congo (Rep. Dem.)",
      es: "República Democrática del Congo",
      de: "Demokratische Republik Kongo",
      pl: "Demokratyczna Republika Konga",
      fr: "RDC (République Démocratique du Congo)",
      nl: "Congo (DRC)",
      pt: "RD Congo",
      cs: "Demokratická republika Kongo",
      ro: "Congo (R.D.)",
      ru: "Демократическая Республика Конго"
    },
    rootIddCode: "+243",
    continent: "Africa"
  },
  CF: {
    i18nNames: {
      en: "Central African Republic",
      es: "República Centroafricana",
      it: "Repubblica Centrafricana",
      de: "Zentralafrikanische Republik",
      pl: "Republika Środkowoafrykańska",
      fr: "République centrafricaine",
      nl: "Centraal-Afrikaanse Republiek",
      pt: "República Centro-Africana",
      cs: "Středoafrická republika",
      ro: "Republica Centrafricană",
      ru: "Центральноафриканская Республика"
    },
    rootIddCode: "+236",
    continent: "Africa"
  },
  CG: {
    i18nNames: {
      en: "Republic of the Congo",
      it: "Congo",
      es: "República del Congo",
      de: "Republik Kongo",
      pl: "Kongo",
      fr: "République du Congo",
      nl: "Republiek Congo",
      pt: "República do Congo",
      cs: "Republika Kongo",
      ro: "Republica Congo",
      ru: "Республика Конго"
    },
    rootIddCode: "+242",
    continent: "Africa"
  },
  CH: {
    i18nNames: {
      en: "Switzerland",
      it: "Svizzera",
      es: "Suiza",
      de: "Schweiz",
      pl: "Szwajcaria",
      fr: "Suisse",
      nl: "Zwitserland",
      pt: "Suíça",
      cs: "Švýcarsko",
      ro: "Elveția",
      ru: "Швейцария"
    },
    rootIddCode: "+41",
    continent: "Europe",
    taxIdMandatory: !1,
    taxIdPattern: "^CHE\\d{9}(MWST|TVA|IVA)?$",
    taxIdExample: "CHE123456789MWST"
  },
  CI: {
    i18nNames: {
      en: "Ivory Coast",
      it: "Costa d'Avorio",
      es: "Costa de Marfil",
      de: "Elfenbeinküste",
      pl: "Wybrzeże Kości Słoniowej",
      fr: "Côte d'Ivoire",
      nl: "Ivoorkust",
      pt: "Costa do Marfim",
      cs: "Pobřeží slonoviny",
      ro: "Coasta de Fildeș",
      ru: "Кот-д’Ивуар"
    },
    rootIddCode: "+225",
    continent: "Africa"
  },
  CK: {
    i18nNames: {
      en: "Cook Islands",
      it: "Isole Cook",
      es: "Islas Cook",
      de: "Cookinseln",
      pl: "Wyspy Cooka",
      fr: "Îles Cook",
      nl: "Cookeilanden",
      pt: "Ilhas Cook",
      cs: "Cookovy ostrovy",
      ro: "Insulele Cook",
      ru: "Острова Кука"
    },
    rootIddCode: "+682",
    continent: "Oceania"
  },
  CL: {
    i18nNames: {
      en: "Chile",
      it: "Cile",
      es: "Chile",
      de: "Chile",
      pl: "Chile",
      fr: "Chili",
      nl: "Chili",
      pt: "Chile",
      cs: "Chile",
      ro: "Chile",
      ru: "Чили"
    },
    rootIddCode: "+56",
    continent: "SouthAmerica"
  },
  CM: {
    i18nNames: {
      en: "Cameroon",
      it: "Camerun",
      es: "Camerún",
      de: "Kamerun",
      pl: "Kamerun",
      fr: "Cameroun",
      nl: "Kameroen",
      pt: "Camarões",
      cs: "Kamerun",
      ro: "Camerun",
      ru: "Камерун"
    },
    rootIddCode: "+237",
    continent: "Africa"
  },
  CN: {
    i18nNames: {
      en: "China",
      it: "Cina",
      es: "China",
      de: "China",
      pl: "Chiny",
      fr: "Chine",
      nl: "China",
      pt: "China",
      cs: "Čína",
      ro: "China",
      ru: "Китай"
    },
    rootIddCode: "+86",
    continent: "Asia"
  },
  CO: {
    i18nNames: {
      en: "Colombia",
      it: "Colombia",
      es: "Colombia",
      de: "Kolumbien",
      pl: "Kolumbia",
      fr: "Colombie",
      nl: "Colombia",
      pt: "Colômbia",
      cs: "Kolumbie",
      ro: "Columbia",
      ru: "Колумбия"
    },
    rootIddCode: "+57",
    continent: "SouthAmerica"
  },
  CR: {
    i18nNames: {
      en: "Costa Rica",
      it: "Costa Rica",
      es: "Costa Rica",
      de: "Costa Rica",
      pl: "Kostaryka",
      fr: "Costa Rica",
      nl: "Costa Rica",
      pt: "Costa Rica",
      cs: "Kostarika",
      ro: "Costa Rica",
      ru: "Коста-Рика"
    },
    rootIddCode: "+506",
    continent: "NorthAmerica"
  },
  CU: {
    i18nNames: {
      en: "Cuba",
      it: "Cuba",
      es: "Cuba",
      de: "Kuba",
      pl: "Kuba",
      fr: "Cuba",
      nl: "Cuba",
      pt: "Cuba",
      cs: "Kuba",
      ro: "Cuba",
      ru: "Куба"
    },
    rootIddCode: "+53",
    continent: "NorthAmerica"
  },
  CV: {
    i18nNames: {
      en: "Cape Verde",
      it: "Capo Verde",
      es: "Cabo Verde",
      de: "Kap Verde",
      pl: "Republika Zielonego Przylądka",
      fr: "Cap-Vert",
      nl: "Kaapverdië",
      pt: "Cabo Verde",
      cs: "Kapverdy",
      ro: "Capul Verde",
      ru: "Кабо-Верде"
    },
    rootIddCode: "+238",
    continent: "Africa"
  },
  CW: {
    i18nNames: {
      en: "Curaçao",
      it: "Curaçao",
      es: "Curazao",
      de: "Curaçao",
      pl: "Curaçao",
      fr: "Curaçao",
      nl: "Curaçao",
      pt: "Curaçau",
      cs: "Curaçao",
      ro: "Curaçao",
      ru: "Кюрасао"
    },
    rootIddCode: "+599",
    continent: "NorthAmerica"
  },
  CX: {
    i18nNames: {
      en: "Christmas Island",
      es: "Isla Christmas",
      it: "Isola di Natale",
      de: "Weihnachtsinsel",
      pl: "Wyspa Bożego Narodzenia",
      fr: "Île Christmas",
      nl: "Christmaseiland",
      pt: "Ilha Christmas",
      cs: "Vánoční ostrov",
      ro: "Insula Christmas",
      ru: "Остров Рождества"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  CY: {
    i18nNames: {
      en: "Cyprus",
      it: "Cipro",
      es: "Chipre",
      de: "Zypern",
      pl: "Cypr",
      fr: "Chypre",
      nl: "Cyprus",
      pt: "Chipre",
      cs: "Kypr",
      ro: "Cipru",
      ru: "Кипр"
    },
    rootIddCode: "+357",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CY\\d{8}[A-Z]$",
    taxIdExample: "CY12345678A"
  },
  CZ: {
    i18nNames: {
      en: "Czech Republic",
      it: "Repubblica Ceca",
      es: "República Checa",
      de: "Tschechische Republik",
      pl: "Czechy",
      fr: "République tchèque",
      nl: "Tsjechië",
      pt: "República Checa",
      cs: "Česko",
      ro: "Republica Cehă",
      ru: "Чешская Республика"
    },
    rootIddCode: "+420",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CZ(\\d{8}|\\d{9}|\\d{10})$",
    taxIdExample: "CZ12345678"
  },
  DE: {
    i18nNames: {
      en: "Germany",
      it: "Germania",
      es: "Alemania",
      de: "Deutschland",
      pl: "Niemcy",
      fr: "Allemagne",
      nl: "Duitsland",
      pt: "Alemanha",
      cs: "Německo",
      ro: "Germania",
      ru: "Германия"
    },
    rootIddCode: "+49",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: d1,
    taxIdMandatory: !1,
    taxIdPattern: "^DE\\d{9}$",
    taxIdExample: "DE123456789"
  },
  DJ: {
    i18nNames: {
      en: "Djibouti",
      it: "Gibuti",
      es: "Yibuti",
      de: "Dschibuti",
      pl: "Dżibuti",
      fr: "Djibouti",
      nl: "Djibouti",
      pt: "Djibuti",
      cs: "Džibutsko",
      ro: "Djibouti",
      ru: "Джибути"
    },
    rootIddCode: "+253",
    continent: "Africa"
  },
  DK: {
    i18nNames: {
      en: "Denmark",
      it: "Danimarca",
      es: "Dinamarca",
      de: "Dänemark",
      pl: "Dania",
      fr: "Danemark",
      nl: "Denemarken",
      pt: "Dinamarca",
      cs: "Dánsko",
      ro: "Danemarca",
      ru: "Дания"
    },
    rootIddCode: "+45",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^DK\\d{8}$",
    taxIdExample: "DK12345678"
  },
  DM: {
    i18nNames: {
      en: "Dominica",
      it: "Dominica",
      es: "Dominica",
      de: "Dominica",
      pl: "Dominika",
      fr: "Dominique",
      nl: "Dominica",
      pt: "Dominica",
      cs: "Dominika",
      ro: "Dominica",
      ru: "Доминика"
    },
    rootIddCode: "+1767",
    continent: "NorthAmerica"
  },
  DO: {
    i18nNames: {
      en: "Dominican Republic",
      es: "República Dominicana",
      it: "Repubblica Dominicana",
      de: "Dominikanische Republik",
      pl: "Dominikana",
      fr: "République dominicaine",
      nl: "Dominicaanse Republiek",
      pt: "República Dominicana",
      cs: "Dominikánská republika",
      ro: "Republica Dominicană",
      ru: "Доминиканская Республика"
    },
    rootIddCode: "+1849",
    continent: "NorthAmerica"
  },
  DZ: {
    i18nNames: {
      en: "Algeria",
      it: "Algeria",
      es: "Argelia",
      de: "Algerien",
      pl: "Algieria",
      fr: "Algérie",
      nl: "Algerije",
      pt: "Argélia",
      cs: "Alžírsko",
      ro: "Algeria",
      ru: "Алжир"
    },
    rootIddCode: "+213",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{15}|\\d{20})$",
    taxIdExample: "123456789012345"
  },
  EC: {
    i18nNames: {
      en: "Ecuador",
      it: "Ecuador",
      es: "Ecuador",
      de: "Ecuador",
      pl: "Ekwador",
      fr: "Équateur",
      nl: "Ecuador",
      pt: "Equador",
      cs: "Ekvádor",
      ro: "Ecuador",
      ru: "Эквадор"
    },
    rootIddCode: "+593",
    continent: "SouthAmerica"
  },
  EE: {
    i18nNames: {
      en: "Estonia",
      it: "Estonia",
      es: "Estonia",
      de: "Estland",
      pl: "Estonia",
      fr: "Estonie",
      nl: "Estland",
      pt: "Estónia",
      cs: "Estonsko",
      ro: "Estonia",
      ru: "Эстония"
    },
    rootIddCode: "+372",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EE\\d{9}$",
    taxIdExample: "EE123456789"
  },
  EG: {
    i18nNames: {
      en: "Egypt",
      it: "Egitto",
      es: "Egipto",
      de: "Ägypten",
      pl: "Egipt",
      fr: "Égypte",
      nl: "Egypte",
      pt: "Egito",
      cs: "Egypt",
      ro: "Egipt",
      ru: "Египет"
    },
    rootIddCode: "+20",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  EH: {
    i18nNames: {
      en: "Western Sahara",
      it: "Sahara Occidentale",
      es: "Sáhara Occidental",
      de: "Westsahara",
      pl: "Sahara Zachodnia",
      fr: "Sahara occidental",
      nl: "Westelijke Sahara",
      pt: "Saara Ocidental",
      cs: "Západní Sahara",
      ro: "Sahara Occidentală",
      ru: "Западная Сахара"
    },
    rootIddCode: "+2125289",
    continent: "Africa"
  },
  ER: {
    i18nNames: {
      en: "Eritrea",
      it: "Eritrea",
      es: "Eritrea",
      de: "Eritrea",
      pl: "Erytrea",
      fr: "Érythrée",
      nl: "Eritrea",
      pt: "Eritreia",
      cs: "Eritrea",
      ro: "Eritreea",
      ru: "Эритрея"
    },
    rootIddCode: "+291",
    continent: "Africa"
  },
  ES: {
    i18nNames: {
      en: "Spain",
      it: "Spagna",
      es: "España",
      de: "Spanien",
      pl: "Hiszpania",
      fr: "Espagne",
      nl: "Spanje",
      pt: "Espanha",
      cs: "Španělsko",
      ro: "Spania",
      ru: "Испания"
    },
    rootIddCode: "+34",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: h1,
    taxIdMandatory: !0,
    taxIdPattern: "^ES[A-Z0-9]\\d{7}[A-Z0-9]$",
    taxIdExample: "ESX1234567Y"
  },
  ET: {
    i18nNames: {
      en: "Ethiopia",
      it: "Etiopia",
      es: "Etiopía",
      de: "Äthiopien",
      pl: "Etiopia",
      fr: "Éthiopie",
      nl: "Ethiopië",
      pt: "Etiópia",
      cs: "Etiopie",
      ro: "Etiopia",
      ru: "Эфиопия"
    },
    rootIddCode: "+251",
    continent: "Africa"
  },
  FI: {
    i18nNames: {
      en: "Finland",
      it: "Finlandia",
      es: "Finlandia",
      de: "Finnland",
      pl: "Finlandia",
      fr: "Finlande",
      nl: "Finland",
      pt: "Finlândia",
      cs: "Finsko",
      ro: "Finlanda",
      ru: "Финляндия"
    },
    rootIddCode: "+358",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FI\\d{8}$",
    taxIdExample: "FI12345678"
  },
  FJ: {
    i18nNames: {
      en: "Fiji",
      it: "Figi",
      es: "Fiyi",
      de: "Fidschi",
      pl: "Fidżi",
      fr: "Fidji",
      nl: "Fiji",
      pt: "Fiji",
      cs: "Fidži",
      ro: "Fiji",
      ru: "Фиджи"
    },
    rootIddCode: "+679",
    continent: "Oceania"
  },
  FK: {
    i18nNames: {
      en: "Falkland Islands",
      es: "Islas Malvinas",
      it: "Isole Falkland o Isole Malvine",
      de: "Falklandinseln",
      pl: "Wyspy Falklandzkie",
      fr: "Îles Falkland",
      nl: "Falklandeilanden",
      pt: "Ilhas Malvinas",
      cs: "Falklandské ostrovy",
      ro: "Insulele Falkland",
      ru: "Фолклендские острова"
    },
    rootIddCode: "+500",
    continent: "SouthAmerica"
  },
  FM: {
    i18nNames: {
      en: "Micronesia",
      it: "Micronesia",
      es: "Estados Federados de Micronesia",
      de: "Mikronesien",
      pl: "Mikronezja",
      fr: "Micronésie",
      nl: "Micronesië",
      pt: "Micronésia",
      cs: "Mikronésie",
      ro: "Micronezia",
      ru: "Микронезия"
    },
    rootIddCode: "+691",
    continent: "Oceania"
  },
  FO: {
    i18nNames: {
      en: "Faroe Islands",
      it: "Isole Far Oer",
      es: "Islas Feroe",
      de: "Färöer-Inseln",
      pl: "Wyspy Owcze",
      fr: "Îles Féroé",
      nl: "Faeröer",
      pt: "Ilhas Faroé",
      cs: "Faerské ostrovy",
      ro: "Insulele Feroe",
      ru: "Фарерские острова"
    },
    rootIddCode: "+298",
    continent: "Europe"
  },
  FR: {
    i18nNames: {
      en: "France",
      it: "Francia",
      es: "Francia",
      de: "Frankreich",
      pl: "Francja",
      fr: "France",
      nl: "Frankrijk",
      pt: "França",
      cs: "Francie",
      ro: "Franța",
      ru: "Франция"
    },
    rootIddCode: "+33",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR1A123456789"
  },
  GA: {
    i18nNames: {
      en: "Gabon",
      it: "Gabon",
      es: "Gabón",
      de: "Gabun",
      pl: "Gabon",
      fr: "Gabon",
      nl: "Gabon",
      pt: "Gabão",
      cs: "Gabon",
      ro: "Gabon",
      ru: "Габон"
    },
    rootIddCode: "+241",
    continent: "Africa"
  },
  GB: {
    i18nNames: {
      en: "United Kingdom",
      it: "Regno Unito",
      es: "Reino Unido",
      de: "Vereinigtes Königreich",
      pl: "Zjednoczone Królestwo",
      fr: "Royaume-Uni",
      nl: "Verenigd Koninkrijk",
      pt: "Reino Unido",
      cs: "Spojené království",
      ro: "Regatul Unit",
      ru: "Великобритания"
    },
    rootIddCode: "+44",
    continent: "Europe",
    taxIdMandatory: !1,
    taxIdPattern: "^GB(\\d{9}|\\d{12}|GD(0\\d{2}|[1-4]\\d{2})|HA([5-9]\\d{2}))$",
    taxIdExample: "GB123456789"
  },
  GD: {
    i18nNames: {
      en: "Grenada",
      it: "Grenada",
      es: "Granada",
      de: "Grenada",
      pl: "Grenada",
      fr: "Grenade",
      nl: "Grenada",
      pt: "Granada",
      cs: "Grenada",
      ro: "Grenada",
      ru: "Гренада"
    },
    rootIddCode: "+1473",
    continent: "NorthAmerica"
  },
  GE: {
    i18nNames: {
      en: "Georgia",
      it: "Georgia",
      es: "Georgia",
      de: "Georgien",
      pl: "Gruzja",
      fr: "Géorgie",
      nl: "Georgië",
      pt: "Geórgia",
      cs: "Gruzie",
      ro: "Georgia",
      ru: "Грузия"
    },
    rootIddCode: "+995",
    continent: "Europe"
  },
  GF: {
    i18nNames: {
      en: "French Guiana",
      it: "Guyana francese",
      es: "Guayana Francesa",
      de: "Französisch-Guayana",
      pl: "Gujana Francuska",
      fr: "Guyane française",
      nl: "Frans-Guyana",
      pt: "Guiana Francesa",
      cs: "Francouzská Guyana",
      ro: "Guyana Franceză",
      ru: "Французская Гвиана"
    },
    rootIddCode: "+594",
    continent: "SouthAmerica",
    blocMemberships: ["EU"]
  },
  GG: {
    i18nNames: {
      en: "Guernsey",
      it: "Guernsey",
      es: "Guernsey",
      de: "Guernsey",
      pl: "Guernsey",
      fr: "Guernesey",
      nl: "Guernsey",
      pt: "Guernsey",
      cs: "Guernsey",
      ro: "Guernsey",
      ru: "Гернси"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  GH: {
    i18nNames: {
      en: "Ghana",
      it: "Ghana",
      es: "Ghana",
      de: "Ghana",
      pl: "Ghana",
      fr: "Ghana",
      nl: "Ghana",
      pt: "Gana",
      cs: "Ghana",
      ro: "Ghana",
      ru: "Гана"
    },
    rootIddCode: "+233",
    continent: "Africa"
  },
  GI: {
    i18nNames: {
      en: "Gibraltar",
      it: "Gibilterra",
      es: "Gibraltar",
      de: "Gibraltar",
      pl: "Gibraltar",
      fr: "Gibraltar",
      nl: "Gibraltar",
      pt: "Gibraltar",
      cs: "Gibraltar",
      ro: "Gibraltar",
      ru: "Гибралтар"
    },
    rootIddCode: "+350",
    continent: "Europe"
  },
  GL: {
    i18nNames: {
      en: "Greenland",
      it: "Groenlandia",
      es: "Groenlandia",
      de: "Grönland",
      pl: "Grenlandia",
      fr: "Groenland",
      nl: "Groenland",
      pt: "Gronelândia",
      cs: "Grónsko",
      ro: "Groenlanda",
      ru: "Гренландия"
    },
    rootIddCode: "+299",
    continent: "NorthAmerica"
  },
  GM: {
    i18nNames: {
      en: "Gambia",
      it: "Gambia",
      es: "Gambia",
      de: "Gambia",
      pl: "Gambia",
      fr: "Gambie",
      nl: "Gambia",
      pt: "Gâmbia",
      cs: "Gambie",
      ro: "Gambia",
      ru: "Гамбия"
    },
    rootIddCode: "+220",
    continent: "Africa"
  },
  GN: {
    i18nNames: {
      en: "Guinea",
      it: "Guinea",
      es: "Guinea",
      de: "Guinea",
      pl: "Gwinea",
      fr: "Guinée",
      nl: "Guinee",
      pt: "Guiné",
      cs: "Guinea",
      ro: "Guineea",
      ru: "Гвинея"
    },
    rootIddCode: "+224",
    continent: "Africa"
  },
  GP: {
    i18nNames: {
      en: "Guadeloupe",
      it: "Guadeloupa",
      es: "Guadalupe",
      de: "Guadeloupe",
      pl: "Gwadelupa",
      fr: "Guadeloupe",
      nl: "Guadeloupe",
      pt: "Guadalupe",
      cs: "Guadeloupe",
      ro: "Guadelupa",
      ru: "Гваделупа"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  GQ: {
    i18nNames: {
      en: "Equatorial Guinea",
      es: "Guinea Ecuatorial",
      it: "Guinea Equatoriale",
      de: "Äquatorialguinea",
      pl: "Gwinea Równikowa",
      fr: "Guinée équatoriale",
      nl: "Equatoriaal-Guinea",
      pt: "Guiné Equatorial",
      cs: "Rovníková Guinea",
      ro: "Guineea Ecuatorială",
      ru: "Экваториальная Гвинея"
    },
    rootIddCode: "+240",
    continent: "Africa"
  },
  GR: {
    i18nNames: {
      en: "Greece",
      it: "Grecia",
      es: "Grecia",
      de: "Griechenland",
      pl: "Grecja",
      fr: "Grèce",
      nl: "Griekenland",
      pt: "Grécia",
      cs: "Řecko",
      ro: "Grecia",
      ru: "Греция"
    },
    rootIddCode: "+30",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EL\\d{9}$",
    taxIdExample: "EL123456789"
  },
  GS: {
    i18nNames: {
      en: "South Georgia",
      it: "Georgia del Sud e Isole Sandwich Meridionali",
      es: "Islas Georgias del Sur y Sandwich del Sur",
      de: "Südgeorgien",
      pl: "Georgia Południowa",
      fr: "Géorgie du Sud et îles Sandwich du Sud",
      nl: "Zuid-Georgië en Zuidelijke Sandwicheilanden",
      pt: "Geórgia do Sul e Ilhas Sandwich do Sul",
      cs: "Jižní Georgie a Jižní Sandwichovy ostrovy",
      ro: "Georgia de Sud și Insulele Sandwich de Sud",
      ru: "Южная Георгия и Южные Сандвичевы острова"
    },
    rootIddCode: "+500",
    continent: "Oceania"
  },
  GT: {
    i18nNames: {
      en: "Guatemala",
      it: "Guatemala",
      es: "Guatemala",
      de: "Guatemala",
      pl: "Gwatemala",
      fr: "Guatemala",
      nl: "Guatemala",
      pt: "Guatemala",
      cs: "Guatemala",
      ro: "Guatemala",
      ru: "Гватемала"
    },
    rootIddCode: "+502",
    continent: "NorthAmerica"
  },
  GU: {
    i18nNames: {
      en: "Guam",
      it: "Guam",
      es: "Guam",
      de: "Guam",
      pl: "Guam",
      fr: "Guam",
      nl: "Guam",
      pt: "Guam",
      cs: "Guam",
      ro: "Guam",
      ru: "Гуам"
    },
    rootIddCode: "+1671",
    continent: "NorthAmerica"
  },
  GW: {
    i18nNames: {
      en: "Guinea-Bissau",
      it: "Guinea-Bissau",
      es: "Guinea-Bisáu",
      de: "Guinea-Bissau",
      pl: "Gwinea-Bissau",
      fr: "Guinée-Bissau",
      nl: "Guinee-Bissau",
      pt: "Guiné-Bissau",
      cs: "Guinea-Bissau",
      ro: "Guineea-Bissau",
      ru: "Гвинея-Бисау"
    },
    rootIddCode: "+245",
    continent: "Africa"
  },
  GY: {
    i18nNames: {
      en: "Guyana",
      it: "Guyana",
      es: "Guyana",
      de: "Guyana",
      pl: "Gujana",
      fr: "Guyana",
      nl: "Guyana",
      pt: "Guiana",
      cs: "Guyana",
      ro: "Guyana",
      ru: "Гайана"
    },
    rootIddCode: "+592",
    continent: "NorthAmerica"
  },
  HK: {
    i18nNames: {
      en: "Hong Kong",
      it: "Hong Kong",
      es: "Hong Kong",
      de: "Hongkong",
      pl: "Hongkong",
      fr: "Hong Kong",
      nl: "Hongkong",
      pt: "Hong Kong",
      cs: "Hongkong",
      ro: "Hong Kong",
      ru: "Гонконг"
    },
    rootIddCode: "+852",
    continent: "Asia"
  },
  HM: {
    i18nNames: {
      en: "Heard Island and McDonald Islands",
      es: "Islas Heard y McDonald",
      it: "Isole Heard e McDonald",
      de: "Heard und McDonaldinseln",
      pl: "Wyspy Heard i McDonalda",
      fr: "Îles Heard et McDonald",
      nl: "Heard en McDonaldeilanden",
      pt: "Ilhas Heard e McDonald",
      cs: "Heardův ostrov a McDonaldovy ostrovy",
      ro: "Insula Heard și Insulele McDonald",
      ru: "Остров Херд и острова Макдональд"
    },
    rootIddCode: "undefined",
    continent: "Oceania"
  },
  HN: {
    i18nNames: {
      en: "Honduras",
      it: "Honduras",
      es: "Honduras",
      de: "Honduras",
      pl: "Honduras",
      fr: "Honduras",
      nl: "Honduras",
      pt: "Honduras",
      cs: "Honduras",
      ro: "Honduras",
      ru: "Гондурас"
    },
    rootIddCode: "+504",
    continent: "NorthAmerica"
  },
  HR: {
    i18nNames: {
      en: "Croatia",
      it: "Croazia",
      es: "Croacia",
      de: "Kroatien",
      pl: "Chorwacja",
      fr: "Croatie",
      nl: "Kroatië",
      pt: "Croácia",
      cs: "Chorvatsko",
      ro: "Croația",
      ru: "Хорватия"
    },
    rootIddCode: "+385",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HR\\d{11}$",
    taxIdExample: "HR12345678901"
  },
  HT: {
    i18nNames: {
      en: "Haiti",
      it: "Haiti",
      es: "Haití",
      de: "Haiti",
      pl: "Haiti",
      fr: "Haïti",
      nl: "Haïti",
      pt: "Haiti",
      cs: "Haiti",
      ro: "Haiti",
      ru: "Гаити"
    },
    rootIddCode: "+509",
    continent: "NorthAmerica"
  },
  HU: {
    i18nNames: {
      en: "Hungary",
      it: "Ungheria",
      es: "Hungría",
      de: "Ungarn",
      pl: "Węgry",
      fr: "Hongrie",
      nl: "Hongarije",
      pt: "Hungria",
      cs: "Maďarsko",
      ro: "Ungaria",
      ru: "Венгрия"
    },
    rootIddCode: "+36",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HU\\d{8}$",
    taxIdExample: "HU12345678"
  },
  ID: {
    i18nNames: {
      en: "Indonesia",
      it: "Indonesia",
      es: "Indonesia",
      de: "Indonesien",
      pl: "Indonezja",
      fr: "Indonésie",
      nl: "Indonesië",
      pt: "Indonésia",
      cs: "Indonésie",
      ro: "Indonezia",
      ru: "Индонезия"
    },
    rootIddCode: "+62",
    continent: "Asia"
  },
  IE: {
    i18nNames: {
      en: "Ireland",
      it: "Irlanda",
      es: "Irlanda",
      de: "Irland",
      pl: "Irlandia",
      fr: "Irlande",
      nl: "Ierland",
      pt: "Irlanda",
      cs: "Irsko",
      ro: "Irlanda",
      ru: "Ирландия"
    },
    rootIddCode: "+353",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^IE\\d{7}[A-Z]{1,2}$",
    taxIdExample: "IE1234567A"
  },
  IL: {
    i18nNames: {
      en: "Israel",
      it: "Israele",
      es: "Israel",
      de: "Israel",
      pl: "Израиль",
      fr: "Israël",
      nl: "Israël",
      pt: "Israel",
      cs: "Izrael",
      ro: "Israel",
      ru: "Израиль"
    },
    rootIddCode: "+972",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  IM: {
    i18nNames: {
      en: "Isle of Man",
      it: "Isola di Man",
      es: "Isla de Man",
      de: "Isle of Man",
      pl: "Wyspa Man",
      fr: "Île de Man",
      nl: "Isle of Man",
      pt: "Ilha de Man",
      cs: "Ostrov Man",
      ro: "Insula Man",
      ru: "Остров Мэн"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  IN: {
    i18nNames: {
      en: "India",
      it: "India",
      es: "India",
      de: "Indien",
      pl: "Indie",
      fr: "Inde",
      nl: "India",
      pt: "Índia",
      cs: "Indie",
      ro: "India",
      ru: "Индия"
    },
    rootIddCode: "+91",
    continent: "Asia"
  },
  IO: {
    i18nNames: {
      en: "British Indian Ocean Territory",
      es: "Territorio Británico del Océano Índico",
      it: "Territorio britannico dell'oceano indiano",
      de: "Britisches Territorium im Indischen Ozean",
      pl: "Brytyjskie Terytorium Oceanu Indyjskiego",
      fr: "Territoire britannique de l'océan Indien",
      nl: "Brits Indische Oceaanterritorium",
      pt: "Território Britânico do Oceano Índico",
      cs: "Britské indickooceánské území",
      ro: "Teritoriul Britanic din Oceanul Indian",
      ru: "Британская территория в Индийском океане"
    },
    rootIddCode: "+246",
    continent: "Asia"
  },
  IQ: {
    i18nNames: {
      en: "Iraq",
      it: "Iraq",
      es: "Irak",
      de: "Ирак",
      pl: "Irak",
      fr: "Irak",
      nl: "Irak",
      pt: "Iraque",
      cs: "Irák",
      ro: "Irak",
      ru: "Ирак"
    },
    rootIddCode: "+964",
    continent: "Asia"
  },
  IR: {
    i18nNames: {
      en: "Iran",
      it: "Iran",
      es: "Irán",
      de: "Iran",
      pl: "Iran",
      fr: "Iran",
      nl: "Iran",
      pt: "Irã",
      cs: "Írán",
      ro: "Iran",
      ru: "Иран"
    },
    rootIddCode: "+98",
    continent: "Asia"
  },
  IS: {
    i18nNames: {
      en: "Iceland",
      it: "Islanda",
      es: "Islandia",
      de: "Island",
      pl: "Islandia",
      fr: "Islande",
      nl: "IJsland",
      pt: "Islândia",
      cs: "Island",
      ro: "Islanda",
      ru: "Исландия"
    },
    rootIddCode: "+354",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^IS\\d{5,6}$",
    taxIdExample: "IS123456"
  },
  IT: {
    i18nNames: {
      en: "Italy",
      it: "Italia",
      es: "Italia",
      de: "Italien",
      pl: "Włochy",
      fr: "Italie",
      nl: "Italie",
      pt: "Itália",
      cs: "Itálie",
      ro: "Italia",
      ru: "Италия"
    },
    rootIddCode: "+39",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: p1,
    taxIdMandatory: !0,
    taxIdPattern: "^IT\\d{11}$",
    taxIdExample: "IT12345678901"
  },
  JE: {
    i18nNames: {
      en: "Jersey",
      it: "Isola di Jersey",
      es: "Jersey",
      de: "Jersey",
      pl: "Jersey",
      fr: "Jersey",
      nl: "Jersey",
      pt: "Jersey",
      cs: "Jersey",
      ro: "Jersey",
      ru: "Джерси"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  JM: {
    i18nNames: {
      en: "Jamaica",
      it: "Giamaica",
      es: "Jamaica",
      de: "Jamaika",
      pl: "Jamajka",
      fr: "Jamaïque",
      nl: "Jamaica",
      pt: "Jamaica",
      cs: "Jamajka",
      ro: "Jamaica",
      ru: "Ямайка"
    },
    rootIddCode: "+1876",
    continent: "NorthAmerica"
  },
  JO: {
    i18nNames: {
      en: "Jordan",
      it: "Giordania",
      es: "Jordania",
      de: "Jordanien",
      pl: "Jordania",
      fr: "Jordanie",
      nl: "Jordanië",
      pt: "Jordânia",
      cs: "Jordánsko",
      ro: "Iordania",
      ru: "Иордания"
    },
    rootIddCode: "+962",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{7}$",
    taxIdExample: "1234567"
  },
  JP: {
    i18nNames: {
      en: "Japan",
      it: "Giappone",
      es: "Japón",
      de: "Japan",
      pl: "Japonia",
      fr: "Japon",
      nl: "Japan",
      pt: "Japão",
      cs: "Japonsko",
      ro: "Japonia",
      ru: "Япония"
    },
    rootIddCode: "+81",
    continent: "Asia"
  },
  KE: {
    i18nNames: {
      en: "Kenya",
      it: "Kenya",
      es: "Kenia",
      de: "Kenia",
      pl: "Kenia",
      fr: "Kenya",
      nl: "Kenia",
      pt: "Quênia",
      cs: "Keňa",
      ro: "Kenya",
      ru: "Кения"
    },
    rootIddCode: "+254",
    continent: "Africa"
  },
  KG: {
    i18nNames: {
      en: "Kyrgyzstan",
      it: "Kirghizistan",
      es: "Kirguistán",
      de: "Kirgisistan",
      pl: "Kirgistan",
      fr: "Kirghizistan",
      nl: "Kirgizië",
      pt: "Quirguistão",
      cs: "Kyrgyzstán",
      ro: "Kârgâzstan",
      ru: "Киргизия"
    },
    rootIddCode: "+996",
    continent: "Asia"
  },
  KH: {
    i18nNames: {
      en: "Cambodia",
      it: "Cambogia",
      es: "Camboya",
      de: "Kambodscha",
      pl: "Kambodża",
      fr: "Cambodge",
      nl: "Cambodja",
      pt: "Camboja",
      cs: "Kambodža",
      ro: "Cambodgia",
      ru: "Камбоджа"
    },
    rootIddCode: "+855",
    continent: "Asia"
  },
  KI: {
    i18nNames: {
      en: "Kiribati",
      it: "Kiribati",
      es: "Kiribati",
      de: "Kiribati",
      pl: "Kiribati",
      fr: "Kiribati",
      nl: "Kiribati",
      pt: "Kiribati",
      cs: "Kiribati",
      ro: "Kiribati",
      ru: "Кирибати"
    },
    rootIddCode: "+686",
    continent: "Oceania"
  },
  KM: {
    i18nNames: {
      en: "Comoros",
      it: "Comore",
      es: "Comoras",
      de: "Komoren",
      pl: "Komory",
      fr: "Comores",
      nl: "Comoren",
      pt: "Comores",
      cs: "Komory",
      ro: "Comore",
      ru: "Коморы"
    },
    rootIddCode: "+269",
    continent: "Africa"
  },
  KN: {
    i18nNames: {
      en: "Saint Kitts and Nevis",
      es: "San Cristóbal y Nieves",
      it: "Saint Kitts e Nevis",
      de: "St. Kitts und Nevis",
      pl: "Saint Kitts i Nevis",
      fr: "Saint-Christophe-et-Niévès",
      nl: "Saint Kitts en Nevis",
      pt: "São Cristóvão e Névis",
      cs: "Svatý Kryštof a Nevis",
      ro: "Sfântul Kitts și Nevis",
      ru: "Сент-Китс и Невис"
    },
    rootIddCode: "+1869",
    continent: "NorthAmerica"
  },
  KP: {
    i18nNames: {
      en: "North Korea",
      it: "Corea del Nord",
      es: "Corea del Norte",
      de: "Nordkorea",
      pl: "Korea Północna",
      fr: "Corée du Nord",
      nl: "Noord-Korea",
      pt: "Coreia do Norte",
      cs: "Severní Korea",
      ro: "Coreea de Nord",
      ru: "Северная Корея"
    },
    rootIddCode: "+850",
    continent: "Asia"
  },
  KR: {
    i18nNames: {
      en: "South Korea",
      it: "Corea del Sud",
      es: "Corea del Sur",
      de: "Südkorea",
      pl: "Korea Południowa",
      fr: "Corée du Sud",
      nl: "Zuid-Korea",
      pt: "Coreia do Sul",
      cs: "Jižní Korea",
      ro: "Coreea de Sud",
      ru: "Южная Корея"
    },
    rootIddCode: "+82",
    continent: "Asia"
  },
  KW: {
    i18nNames: {
      en: "Kuwait",
      it: "Kuwait",
      es: "Kuwait",
      de: "Kuwait",
      pl: "Kuwejt",
      fr: "Koweït",
      nl: "Кувейт",
      pt: "Kuwait",
      cs: "Kuvajt",
      ro: "Kuweit",
      ru: "Кувейт"
    },
    rootIddCode: "+965",
    continent: "Asia"
  },
  KY: {
    i18nNames: {
      en: "Cayman Islands",
      it: "Isole Cayman",
      es: "Islas Caimán",
      de: "Kaimaninseln",
      pl: "Kajmany",
      fr: "Îles Caïmans",
      nl: "Kaaimaneilanden",
      pt: "Ilhas Cayman",
      cs: "Kajmanské ostrovy",
      ro: "Insulele Cayman",
      ru: "Каймановы острова"
    },
    rootIddCode: "+1345",
    continent: "NorthAmerica"
  },
  KZ: {
    i18nNames: {
      en: "Kazakhstan",
      it: "Kazakistan",
      es: "Kazajistán",
      de: "Kasachstan",
      pl: "Kazachstan",
      fr: "Kazakhstan",
      nl: "Kazachstan",
      pt: "Cazaquistão",
      cs: "Kazachstán",
      ro: "Kazahstan",
      ru: "Казахстан"
    },
    rootIddCode: "+77",
    continent: "Asia"
  },
  LA: {
    i18nNames: {
      en: "Laos",
      it: "Laos",
      es: "Laos",
      de: "Laos",
      pl: "Laos",
      fr: "Laos",
      nl: "Laos",
      pt: "Laos",
      cs: "Laos",
      ro: "Laos",
      ru: "Лаос"
    },
    rootIddCode: "+856",
    continent: "Asia"
  },
  LB: {
    i18nNames: {
      en: "Lebanon",
      it: "Libano",
      es: "Líbano",
      de: "Libanon",
      pl: "Liban",
      fr: "Liban",
      nl: "Libanon",
      pt: "Líbano",
      cs: "Libanon",
      ro: "Liban",
      ru: "Ливан"
    },
    rootIddCode: "+961",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{1,15}(-(601|603|604))?$",
    taxIdExample: "123456789-601"
  },
  LC: {
    i18nNames: {
      en: "Saint Lucia",
      it: "Santa Lucia",
      es: "Santa Lucía",
      de: "St. Lucia",
      pl: "Saint Lucia",
      fr: "Sainte-Lucie",
      nl: "Saint Lucia",
      pt: "Santa Lúcia",
      cs: "Svatá Lucie",
      ro: "Sfânta Lucia",
      ru: "Сент-Люсия"
    },
    rootIddCode: "+1758",
    continent: "NorthAmerica"
  },
  LI: {
    i18nNames: {
      en: "Liechtenstein",
      it: "Liechtenstein",
      es: "Liechtenstein",
      de: "Liechtenstein",
      pl: "Liechtenstein",
      fr: "Liechtenstein",
      nl: "Liechtenstein",
      pt: "Liechtenstein",
      cs: "Lichtenštejnsko",
      ro: "Liechtenstein",
      ru: "Лихтенштейн"
    },
    rootIddCode: "+423",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{5}$",
    taxIdExample: "12345"
  },
  LK: {
    i18nNames: {
      en: "Sri Lanka",
      it: "Sri Lanka",
      es: "Sri Lanka",
      de: "Sri Lanka",
      pl: "Sri Lanka",
      fr: "Sri Lanka",
      nl: "Sri Lanka",
      pt: "Sri Lanka",
      cs: "Srí Lanka",
      ro: "Sri Lanka",
      ru: "Шри-Ланка"
    },
    rootIddCode: "+94",
    continent: "Asia"
  },
  LR: {
    i18nNames: {
      en: "Liberia",
      it: "Liberia",
      es: "Liberia",
      de: "Liberia",
      pl: "Liberia",
      fr: "Libéria",
      nl: "Liberia",
      pt: "Libéria",
      cs: "Libérie",
      ro: "Liberia",
      ru: "Либерия"
    },
    rootIddCode: "+231",
    continent: "Africa"
  },
  LS: {
    i18nNames: {
      en: "Lesotho",
      it: "Lesotho",
      es: "Lesoto",
      de: "Lesotho",
      pl: "Lesotho",
      fr: "Lesotho",
      nl: "Lesotho",
      pt: "Lesoto",
      cs: "Lesotho",
      ro: "Lesotho",
      ru: "Лесото"
    },
    rootIddCode: "+266",
    continent: "Africa"
  },
  LT: {
    i18nNames: {
      en: "Lithuania",
      it: "Lituania",
      es: "Lituania",
      de: "Litauen",
      pl: "Litwa",
      fr: "Lituanie",
      nl: "Litouwen",
      pt: "Lituânia",
      cs: "Litva",
      ro: "Lituania",
      ru: "Литва"
    },
    rootIddCode: "+370",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LT(\\d{9}|\\d{12})$",
    taxIdExample: "LT123456789"
  },
  LU: {
    i18nNames: {
      en: "Luxembourg",
      it: "Lussemburgo",
      es: "Luxemburgo",
      de: "Luxemburg",
      pl: "Luksemburg",
      fr: "Luxembourg",
      nl: "Luxemburg",
      pt: "Luxemburgo",
      cs: "Lucembursko",
      ro: "Luxemburg",
      ru: "Люксембург"
    },
    rootIddCode: "+352",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LU\\d{8}$",
    taxIdExample: "LU12345678"
  },
  LV: {
    i18nNames: {
      en: "Latvia",
      it: "Lettonia",
      es: "Letonia",
      de: "Lettland",
      pl: "Łotwa",
      fr: "Lettonie",
      nl: "Letland",
      pt: "Letónia",
      cs: "Lotyšsko",
      ro: "Letonia",
      ru: "Латвия"
    },
    rootIddCode: "+371",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LV\\d{11}$",
    taxIdExample: "LV12345678901"
  },
  LY: {
    i18nNames: {
      en: "Libya",
      it: "Libia",
      es: "Libia",
      de: "Libyen",
      pl: "Libia",
      fr: "Libye",
      nl: "Libië",
      pt: "Líbia",
      cs: "Libye",
      ro: "Libia",
      ru: "Ливия"
    },
    rootIddCode: "+218",
    continent: "Africa"
  },
  MA: {
    i18nNames: {
      en: "Morocco",
      it: "Marocco",
      es: "Marruecos",
      de: "Marokko",
      pl: "Maroko",
      fr: "Maroc",
      nl: "Marokko",
      pt: "Marrocos",
      cs: "Maroko",
      ro: "Maroc",
      ru: "Марокко"
    },
    rootIddCode: "+212",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MC: {
    i18nNames: {
      en: "Monaco",
      it: "Principato di Monaco",
      es: "Mónaco",
      de: "Monaco",
      pl: "Monako",
      fr: "Monaco",
      nl: "Monaco",
      pt: "Mônaco",
      cs: "Monako",
      ro: "Monaco",
      ru: "Монако"
    },
    rootIddCode: "+377",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR9Z123456789"
  },
  MD: {
    i18nNames: {
      en: "Moldova",
      it: "Moldavia",
      es: "Moldavia",
      de: "Moldawien",
      pl: "Mołdawia",
      fr: "Moldavie",
      nl: "Moldavië",
      pt: "Moldávia",
      cs: "Moldavsko",
      ro: "Moldova",
      ru: "Молдова"
    },
    rootIddCode: "+373",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^MD\\d{7}$",
    taxIdExample: "MD1234567"
  },
  ME: {
    i18nNames: {
      en: "Montenegro",
      it: "Montenegro",
      es: "Montenegro",
      de: "Montenegro",
      pl: "Czarnogóra",
      fr: "Monténégro",
      nl: "Montenegro",
      pt: "Montenegro",
      cs: "Černá Hora",
      ro: "Muntenegru",
      ru: "Черногория"
    },
    rootIddCode: "+382",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MF: {
    i18nNames: {
      en: "Saint Martin",
      it: "Saint Martin",
      es: "San Martín (parte francesa)",
      de: "Saint-Martin",
      pl: "Saint-Martin",
      fr: "Saint-Martin",
      nl: "Saint Martin",
      pt: "São Martinho",
      cs: "Saint-Martin",
      ro: "Sfântul Martin",
      ru: "Сен-Мартен"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  MG: {
    i18nNames: {
      en: "Madagascar",
      it: "Madagascar",
      es: "Madagascar",
      de: "Madagaskar",
      pl: "Madagaskar",
      fr: "Madagascar",
      nl: "Madagaskar",
      pt: "Madagáscar",
      cs: "Madagaskar",
      ro: "Madagascar",
      ru: "Мадагаскар"
    },
    rootIddCode: "+261",
    continent: "Africa"
  },
  MH: {
    i18nNames: {
      en: "Marshall Islands",
      es: "Islas Marshall",
      it: "Isole Marshall",
      de: "Marshallinseln",
      pl: "Wyspy Marshalla",
      fr: "Îles Marshall",
      nl: "Marshalleilanden",
      pt: "Ilhas Marshall",
      cs: "Marshallovy ostrovy",
      ro: "Insulele Marshall",
      ru: "Маршалловы Острова"
    },
    rootIddCode: "+692",
    continent: "Oceania"
  },
  MK: {
    i18nNames: {
      en: "North Macedonia",
      it: "Macedonia del Nord",
      es: "Macedonia del Norte",
      de: "Nordmazedonien",
      pl: "Macedonia Północna",
      fr: "Macédoine du Nord",
      nl: "Noord-Macedonië",
      pt: "Macedônia do Norte",
      cs: "Severní Makedonie",
      ro: "Macedonia de Nord",
      ru: "Северная Македония"
    },
    rootIddCode: "+389",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{13}$",
    taxIdExample: "1234567890123"
  },
  ML: {
    i18nNames: {
      en: "Mali",
      it: "Mali",
      es: "Malí",
      de: "Mali",
      pl: "Mali",
      fr: "Mali",
      nl: "Mali",
      pt: "Mali",
      cs: "Mali",
      ro: "Mali",
      ru: "Мали"
    },
    rootIddCode: "+223",
    continent: "Africa"
  },
  MM: {
    i18nNames: {
      en: "Myanmar",
      it: "Birmania",
      es: "Birmania",
      de: "Myanmar",
      pl: "Mjanma",
      fr: "Birmanie",
      nl: "Myanmar",
      pt: "Mianmar",
      cs: "Myanmar",
      ro: "Myanmar",
      ru: "Мьянма"
    },
    rootIddCode: "+95",
    continent: "Asia"
  },
  MN: {
    i18nNames: {
      en: "Mongolia",
      it: "Mongolia",
      es: "Mongolia",
      de: "Mongolei",
      pl: "Mongolia",
      fr: "Mongolie",
      nl: "Mongolië",
      pt: "Mongólia",
      cs: "Mongolsko",
      ro: "Mongolia",
      ru: "Монголия"
    },
    rootIddCode: "+976",
    continent: "Asia"
  },
  MO: {
    i18nNames: {
      en: "Macau",
      it: "Macao",
      es: "Macao",
      de: "Macau",
      pl: "Makau",
      fr: "Macao",
      nl: "Macau",
      pt: "Macau",
      cs: "Macao",
      ro: "Macao",
      ru: "Макао"
    },
    rootIddCode: "+853",
    continent: "Asia"
  },
  MP: {
    i18nNames: {
      en: "Northern Mariana Islands",
      es: "Islas Marianas del Norte",
      it: "Isole Marianne Settentrionali",
      de: "Nördliche Marianen",
      pl: "Mariany Północne",
      fr: "Îles Mariannes du Nord",
      nl: "Noordelijke Marianen",
      pt: "Ilhas Marianas do Norte",
      cs: "Severní Mariany",
      ro: "Insulele Mariane de Nord",
      ru: "Северные Марианские острова"
    },
    rootIddCode: "+1670",
    continent: "NorthAmerica"
  },
  MQ: {
    i18nNames: {
      en: "Martinique",
      it: "Martinica",
      es: "Martinica",
      de: "Martinique",
      pl: "Martynika",
      fr: "Martinique",
      nl: "Martinique",
      pt: "Martinica",
      cs: "Martinik",
      ro: "Martinica",
      ru: "Мартиника"
    },
    rootIddCode: "+596",
    continent: "NorthAmerica"
  },
  MR: {
    i18nNames: {
      en: "Mauritania",
      it: "Mauritania",
      es: "Mauritania",
      de: "Mauretanien",
      pl: "Mauretania",
      fr: "Mauritanie",
      nl: "Mauritanië",
      pt: "Mauritânia",
      cs: "Mauritánie",
      ro: "Mauritania",
      ru: "Мавритания"
    },
    rootIddCode: "+222",
    continent: "Africa"
  },
  MS: {
    i18nNames: {
      en: "Montserrat",
      it: "Montserrat",
      es: "Montserrat",
      de: "Montserrat",
      pl: "Montserrat",
      fr: "Montserrat",
      nl: "Montserrat",
      pt: "Montserrat",
      cs: "Montserrat",
      ro: "Montserrat",
      ru: "Монтсеррат"
    },
    rootIddCode: "+1664",
    continent: "NorthAmerica"
  },
  MT: {
    i18nNames: {
      en: "Malta",
      it: "Malta",
      es: "Malta",
      de: "Malta",
      pl: "Malta",
      fr: "Malte",
      nl: "Malta",
      pt: "Malta",
      cs: "Malta",
      ro: "Malta",
      ru: "Мальта"
    },
    rootIddCode: "+356",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^MT\\d{8}$",
    taxIdExample: "MT12345678"
  },
  MU: {
    i18nNames: {
      en: "Mauritius",
      it: "Mauritius",
      es: "Mauricio",
      de: "Mauritius",
      pl: "Mauritius",
      fr: "Île Maurice",
      nl: "Mauritius",
      pt: "Maurício",
      cs: "Mauricius",
      ro: "Mauritius",
      ru: "Маврикий"
    },
    rootIddCode: "+230",
    continent: "Africa"
  },
  MV: {
    i18nNames: {
      en: "Maldives",
      it: "Maldive",
      es: "Maldivas",
      de: "Malediven",
      pl: "Malediwy",
      fr: "Maldives",
      nl: "Maldiven",
      pt: "Maldivas",
      cs: "Maledivy",
      ro: "Maldive",
      ru: "Мальдивы"
    },
    rootIddCode: "+960",
    continent: "Asia"
  },
  MW: {
    i18nNames: {
      en: "Malawi",
      it: "Malawi",
      es: "Malaui",
      de: "Malawi",
      pl: "Malawi",
      fr: "Malawi",
      nl: "Malawi",
      pt: "Maláui",
      cs: "Malawi",
      ro: "Malawi",
      ru: "Малави"
    },
    rootIddCode: "+265",
    continent: "Africa"
  },
  MX: {
    i18nNames: {
      en: "Mexico",
      it: "Messico",
      es: "México",
      de: "Mexiko",
      pl: "Meksyk",
      fr: "Mexique",
      nl: "Mexico",
      pt: "México",
      cs: "Mexiko",
      ro: "Mexic",
      ru: "Мексика"
    },
    rootIddCode: "+52",
    continent: "NorthAmerica"
  },
  MY: {
    i18nNames: {
      en: "Malaysia",
      it: "Malesia",
      es: "Malasia",
      de: "Malaysia",
      pl: "Malezja",
      fr: "Malaisie",
      nl: "Maleisië",
      pt: "Malásia",
      cs: "Malajsie",
      ro: "Malaezia",
      ru: "Малайзия"
    },
    rootIddCode: "+60",
    continent: "Asia"
  },
  MZ: {
    i18nNames: {
      en: "Mozambique",
      it: "Mozambico",
      es: "Mozambique",
      de: "Mosambik",
      pl: "Mozambik",
      fr: "Mozambique",
      nl: "Mozambique",
      pt: "Moçambique",
      cs: "Mosambik",
      ro: "Mozambic",
      ru: "Мозамбик"
    },
    rootIddCode: "+258",
    continent: "Africa"
  },
  NA: {
    i18nNames: {
      en: "Namibia",
      it: "Namibia",
      es: "Namibia",
      de: "Namibia",
      pl: "Namibia",
      fr: "Namibie",
      nl: "Namibië",
      pt: "Namíbia",
      cs: "Namibie",
      ro: "Namibia",
      ru: "Намибия"
    },
    rootIddCode: "+264",
    continent: "Africa"
  },
  NC: {
    i18nNames: {
      en: "New Caledonia",
      it: "Nuova Caledonia",
      es: "Nueva Caledonia",
      de: "Neukaledonien",
      pl: "Nowa Kaledonia",
      fr: "Nouvelle-Calédonie",
      nl: "Nieuw-Caledonië",
      pt: "Nova Caledônia",
      cs: "Nová Kaledonie",
      ro: "Noua Caledonie",
      ru: "Новая Каледония"
    },
    rootIddCode: "+687",
    continent: "Oceania"
  },
  NE: {
    i18nNames: {
      en: "Niger",
      it: "Niger",
      es: "Níger",
      de: "Niger",
      pl: "Niger",
      fr: "Niger",
      nl: "Niger",
      pt: "Níger",
      cs: "Niger",
      ro: "Niger",
      ru: "Нигер"
    },
    rootIddCode: "+227",
    continent: "Africa"
  },
  NF: {
    i18nNames: {
      en: "Norfolk Island",
      it: "Isola Norfolk",
      es: "Isla Norfolk",
      de: "Norfolkinsel",
      pl: "Wyspa Norfolk",
      fr: "Île Norfolk",
      nl: "Norfolkeiland",
      pt: "Ilha Norfolk",
      cs: "Ostrov Norfolk",
      ro: "Insula Norfolk",
      ru: "Остров Норфолк"
    },
    rootIddCode: "+672",
    continent: "Oceania"
  },
  NG: {
    i18nNames: {
      en: "Nigeria",
      it: "Nigeria",
      es: "Nigeria",
      de: "Nigeria",
      pl: "Nigeria",
      fr: "Nigeria",
      nl: "Nigeria",
      pt: "Nigéria",
      cs: "Nigérie",
      ro: "Nigeria",
      ru: "Нигерия"
    },
    rootIddCode: "+234",
    continent: "Africa"
  },
  NI: {
    i18nNames: {
      en: "Nicaragua",
      it: "Nicaragua",
      es: "Nicaragua",
      de: "Nicaragua",
      pl: "Nikaragua",
      fr: "Nicaragua",
      nl: "Nicaragua",
      pt: "Nicarágua",
      cs: "Nikaragua",
      ro: "Nicaragua",
      ru: "Никарагуа"
    },
    rootIddCode: "+505",
    continent: "NorthAmerica"
  },
  NL: {
    i18nNames: {
      en: "Netherlands",
      it: "Paesi Bassi",
      es: "Países Bajos",
      de: "Niederlande",
      pl: "Holandia",
      fr: "Pays-Bas",
      nl: "Nederland",
      pt: "Países Baixos",
      cs: "Nizozemsko",
      ro: "Țările de Jos",
      ru: "Нидерланды"
    },
    rootIddCode: "+31",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^NL\\d{9}B\\d{2}$",
    taxIdExample: "NL123456789B01"
  },
  NO: {
    i18nNames: {
      en: "Norway",
      it: "Norvegia",
      es: "Noruega",
      de: "Norwegen",
      pl: "Norwegia",
      fr: "Norvège",
      nl: "Noorwegen",
      pt: "Noruega",
      cs: "Norsko",
      ro: "Norvegia",
      ru: "Норвегия"
    },
    rootIddCode: "+47",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^NO\\d{9}MVA$",
    taxIdExample: "NO123456789MVA"
  },
  NP: {
    i18nNames: {
      en: "Nepal",
      it: "Nepal",
      es: "Nepal",
      de: "Nepal",
      pl: "Nepal",
      fr: "Népal",
      nl: "Nepal",
      pt: "Nepal",
      cs: "Nepál",
      ro: "Nepal",
      ru: "Непал"
    },
    rootIddCode: "+977",
    continent: "Asia"
  },
  NR: {
    i18nNames: {
      en: "Nauru",
      it: "Nauru",
      es: "Nauru",
      de: "Nauru",
      pl: "Nauru",
      fr: "Nauru",
      nl: "Nauru",
      pt: "Nauru",
      cs: "Nauru",
      ro: "Nauru",
      ru: "Науру"
    },
    rootIddCode: "+674",
    continent: "Oceania"
  },
  NU: {
    i18nNames: {
      en: "Niue",
      it: "Niue",
      es: "Niue",
      de: "Niue",
      pl: "Niue",
      fr: "Niue",
      nl: "Niue",
      pt: "Niue",
      cs: "Niue",
      ro: "Niue",
      ru: "Ниуэ"
    },
    rootIddCode: "+683",
    continent: "Oceania"
  },
  NZ: {
    i18nNames: {
      en: "New Zealand",
      it: "Nuova Zelanda",
      es: "Nueva Zelanda",
      de: "Neuseeland",
      pl: "Nowa Zelandia",
      fr: "Nouvelle-Zélande",
      nl: "Nieuw-Zeeland",
      pt: "Nova Zelândia",
      cs: "Nový Zéland",
      ro: "Noua Zeelandă",
      ru: "Новая Зеландия"
    },
    rootIddCode: "+64",
    continent: "Oceania"
  },
  OM: {
    i18nNames: {
      en: "Oman",
      it: "Oman",
      es: "Omán",
      de: "Oman",
      pl: "Oman",
      fr: "Oman",
      nl: "Oman",
      pt: "Omã",
      cs: "Omán",
      ro: "Oman",
      ru: "Оман"
    },
    rootIddCode: "+968",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^OM\\d{10}$",
    taxIdExample: "OM1234567890"
  },
  PA: {
    i18nNames: {
      en: "Panama",
      it: "Panama",
      es: "Panamá",
      de: "Panama",
      pl: "Panama",
      fr: "Panama",
      nl: "Panama",
      pt: "Panamá",
      cs: "Panama",
      ro: "Panama",
      ru: "Панама"
    },
    rootIddCode: "+507",
    continent: "NorthAmerica"
  },
  PE: {
    i18nNames: {
      en: "Peru",
      it: "Perù",
      es: "Perú",
      de: "Peru",
      pl: "Peru",
      fr: "Pérou",
      nl: "Peru",
      pt: "Peru",
      cs: "Peru",
      ro: "Peru",
      ru: "Перу"
    },
    rootIddCode: "+51",
    continent: "SouthAmerica"
  },
  PF: {
    i18nNames: {
      en: "French Polynesia",
      es: "Polinesia Francesa",
      it: "Polinesia Francese",
      de: "Französisch-Polynesien",
      pl: "Polinezja Francuska",
      fr: "Polynésie française",
      nl: "Frans-Polynesië",
      pt: "Polinésia Francesa",
      cs: "Francouzská Polynésie",
      ro: "Polinezia Franceză",
      ru: "Французская Полинезия"
    },
    rootIddCode: "+689",
    continent: "Oceania"
  },
  PG: {
    i18nNames: {
      en: "Papua New Guinea",
      es: "Papúa Nueva Guinea",
      it: "Papua Nuova Guinea",
      de: "Papua-Neuguinea",
      pl: "Papua-Nowa Gwinea",
      fr: "Papouasie-Nouvelle-Guinée",
      nl: "Papoea-Nieuw-Guinea",
      pt: "Papua-Nova Guiné",
      cs: "Papua-Nová Guinea",
      ro: "Papua Noua Guinee",
      ru: "Папуа — Новая Гвинея"
    },
    rootIddCode: "+675",
    continent: "Oceania"
  },
  PH: {
    i18nNames: {
      en: "Philippines",
      it: "Filippine",
      es: "Filipinas",
      de: "Philippinen",
      pl: "Filipiny",
      fr: "Philippines",
      nl: "Filipijnen",
      pt: "Filipinas",
      cs: "Filipíny",
      ro: "Filipine",
      ru: "Филиппины"
    },
    rootIddCode: "+63",
    continent: "Asia"
  },
  PK: {
    i18nNames: {
      en: "Pakistan",
      it: "Pakistan",
      es: "Pakistán",
      de: "Pakistan",
      pl: "Pakistan",
      fr: "Pakistan",
      nl: "Pakistan",
      pt: "Paquistão",
      cs: "Pákistán",
      ro: "Pakistan",
      ru: "Пакистан"
    },
    rootIddCode: "+92",
    continent: "Asia"
  },
  PL: {
    i18nNames: {
      en: "Poland",
      it: "Polonia",
      es: "Polonia",
      de: "Polen",
      pl: "Polska",
      fr: "Pologne",
      nl: "Polen",
      pt: "Polónia",
      cs: "Polsko",
      ro: "Polonia",
      ru: "Польша"
    },
    rootIddCode: "+48",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: f1,
    taxIdMandatory: !0,
    taxIdPattern: "^PL\\d{10}$",
    taxIdExample: "PL1234567890"
  },
  PM: {
    i18nNames: {
      en: "Saint Pierre and Miquelon",
      es: "San Pedro y Miquelón",
      it: "Saint-Pierre e Miquelon",
      de: "Saint-Pierre und Miquelon",
      pl: "Saint-Pierre i Miquelon",
      fr: "Saint-Pierre-et-Miquelon",
      nl: "Saint-Pierre en Miquelon",
      pt: "Saint Pierre e Miquelon",
      cs: "Saint Pierre a Miquelon",
      ro: "Saint Pierre și Miquelon",
      ru: "Сен-Пьер и Микелон"
    },
    rootIddCode: "+508",
    continent: "NorthAmerica"
  },
  PN: {
    i18nNames: {
      en: "Pitcairn Islands",
      es: "Islas Pitcairn",
      it: "Isole Pitcairn",
      de: "Pitcairninseln",
      pl: "Wyspy Pitcairn",
      fr: "Îles Pitcairn",
      nl: "Pitcairneilanden",
      pt: "Ilhas Pitcairn",
      cs: "Pitcairnovy ostrovy",
      ro: "Insulele Pitcairn",
      ru: "Острова Питкэрн"
    },
    rootIddCode: "+64",
    continent: "Oceania"
  },
  PR: {
    i18nNames: {
      en: "Puerto Rico",
      it: "Porto Rico",
      es: "Puerto Rico",
      de: "Puerto Rico",
      pl: "Portoryko",
      fr: "Porto Rico",
      nl: "Puerto Rico",
      pt: "Porto Rico",
      cs: "Portoriko",
      ro: "Puerto Rico",
      ru: "Пуэрто-Рико"
    },
    rootIddCode: "+1939",
    continent: "NorthAmerica"
  },
  PS: {
    i18nNames: {
      en: "Palestine",
      it: "Palestina",
      es: "Palestina",
      de: "Palästina",
      pl: "Palestyna",
      fr: "Palestine",
      nl: "Palestina",
      pt: "Palestina",
      cs: "Palestina",
      ro: "Palestina",
      ru: "Палестина"
    },
    rootIddCode: "+970",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  PT: {
    i18nNames: {
      en: "Portugal",
      it: "Portogallo",
      es: "Portugal",
      de: "Portugal",
      pl: "Portugalia",
      fr: "Portugal",
      nl: "Portugal",
      pt: "Portugal",
      cs: "Portugalsko",
      ro: "Portugalia",
      ru: "Португалия"
    },
    rootIddCode: "+351",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^PT\\d{9}$",
    taxIdExample: "PT123456789"
  },
  PW: {
    i18nNames: {
      en: "Palau",
      it: "Palau",
      es: "Palaos",
      de: "Palau",
      pl: "Palau",
      fr: "Palaos",
      nl: "Palau",
      pt: "Palau",
      cs: "Palau",
      ro: "Palau",
      ru: "Палау"
    },
    rootIddCode: "+680",
    continent: "Oceania"
  },
  PY: {
    i18nNames: {
      en: "Paraguay",
      it: "Paraguay",
      es: "Paraguay",
      de: "Paraguay",
      pl: "Paragwaj",
      fr: "Paraguay",
      nl: "Paraguay",
      pt: "Paraguai",
      cs: "Paraguay",
      ro: "Paraguay",
      ru: "Парагвай"
    },
    rootIddCode: "+595",
    continent: "SouthAmerica"
  },
  QA: {
    i18nNames: {
      en: "Qatar",
      it: "Qatar",
      es: "Catar",
      de: "Katar",
      pl: "Katar",
      fr: "Qatar",
      nl: "Qatar",
      pt: "Catar",
      cs: "Katar",
      ro: "Qatar",
      ru: "Катар"
    },
    rootIddCode: "+974",
    continent: "Asia"
  },
  RE: {
    i18nNames: {
      en: "Réunion",
      it: "Riunione",
      es: "Reunión",
      de: "Réunion",
      pl: "Reunion",
      fr: "Réunion",
      nl: "Réunion",
      pt: "Reunião",
      cs: "Réunion",
      ro: "Réunion",
      ru: "Реюньон"
    },
    rootIddCode: "+262",
    continent: "Africa"
  },
  RO: {
    i18nNames: {
      en: "Romania",
      it: "Romania",
      es: "Rumanía",
      de: "Rumänien",
      pl: "Rumunia",
      fr: "Roumanie",
      nl: "Roemenië",
      pt: "Romênia",
      cs: "Rumunsko",
      ro: "România",
      ru: "Румыния"
    },
    rootIddCode: "+40",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^RO\\d{2,10}$",
    taxIdExample: "RO123456"
  },
  RS: {
    i18nNames: {
      en: "Serbia",
      it: "Serbia",
      es: "Serbia",
      de: "Serbien",
      pl: "Serbia",
      fr: "Serbie",
      nl: "Servië",
      pt: "Sérvia",
      cs: "Srbsko",
      ro: "Serbia",
      ru: "Сербия"
    },
    rootIddCode: "+381",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  RU: {
    i18nNames: {
      en: "Russia",
      it: "Russia",
      es: "Rusia",
      de: "Russland",
      pl: "Rosja",
      fr: "Russie",
      nl: "Rusland",
      pt: "Rússia",
      cs: "Rusko",
      ro: "Rusia",
      ru: "Россия"
    },
    rootIddCode: "+79",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{10}$",
    taxIdExample: "1234567890"
  },
  RW: {
    i18nNames: {
      en: "Rwanda",
      it: "Ruanda",
      es: "Ruanda",
      de: "Ruanda",
      pl: "Rwanda",
      fr: "Rwanda",
      nl: "Rwanda",
      pt: "Ruanda",
      cs: "Rwanda",
      ro: "Rwanda",
      ru: "Руанда"
    },
    rootIddCode: "+250",
    continent: "Africa"
  },
  SA: {
    i18nNames: {
      en: "Saudi Arabia",
      it: "Arabia Saudita",
      es: "Arabia Saudita",
      de: "Saudi-Arabien",
      pl: "Arabia Saudyjska",
      fr: "Arabie Saoudite",
      nl: "Saoedi-Arabië",
      pt: "Arábia Saudita",
      cs: "Saúdská Arábie",
      ro: "Arabia Saudită",
      ru: "Саудовская Аравия"
    },
    rootIddCode: "+966",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BA: {
    i18nNames: {
      en: "Bosnia and Herzegovina",
      es: "Bosnia y Herzegovina",
      it: "Bosnia ed Erzegovina",
      de: "Bosnien und Herzegовина",
      pl: "Bośnia i Hercegowina",
      fr: "Bosnie-Herzégovine",
      nl: "Bosnië en Herzegovina",
      pt: "Bósnia e Herzegovina",
      cs: "Bosna a Hercegovina",
      ro: "Bosnia și Herțegovina",
      ru: "Босния и Герцеговина"
    },
    rootIddCode: "+387",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{12}|\\d{13})$",
    taxIdExample: "123456789012"
  },
  SB: {
    i18nNames: {
      en: "Solomon Islands",
      it: "Isole Salomone",
      es: "Islas Salomón",
      de: "Salomonen",
      pl: "Wyspy Salomona",
      fr: "Îles Salomon",
      nl: "Salomonseilanden",
      pt: "Ilhas Salomão",
      cs: "Šalamounovy ostrovy",
      ro: "Insulele Solomon",
      ru: "Соломоновы Острова"
    },
    rootIddCode: "+677",
    continent: "Oceania"
  },
  SC: {
    i18nNames: {
      en: "Seychelles",
      it: "Seychelles",
      es: "Seychelles",
      de: "Seychellen",
      pl: "Seszele",
      fr: "Seychelles",
      nl: "Seychellen",
      pt: "Seicheles",
      cs: "Seychely",
      ro: "Seychelles",
      ru: "Сейшельские Острова"
    },
    rootIddCode: "+248",
    continent: "Africa"
  },
  SD: {
    i18nNames: {
      en: "Sudan",
      it: "Sudan",
      es: "Sudán",
      de: "Sudan",
      pl: "Sudan",
      fr: "Soudan",
      nl: "Soedan",
      pt: "Sudão",
      cs: "Súdán",
      ro: "Sudan",
      ru: "Судан"
    },
    rootIddCode: "+249",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{12}$",
    taxIdExample: "123456789012"
  },
  SE: {
    i18nNames: {
      en: "Sweden",
      it: "Svezia",
      es: "Suecia",
      de: "Schweden",
      pl: "Szwecja",
      fr: "Suède",
      nl: "Zweden",
      pt: "Suécia",
      cs: "Švédsko",
      ro: "Suedia",
      ru: "Швеция"
    },
    rootIddCode: "+46",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SE\\d{12}$",
    taxIdExample: "SE123456789012"
  },
  SG: {
    i18nNames: {
      en: "Singapore",
      it: "Singapore",
      es: "Singapur",
      de: "Singapur",
      pl: "Singapur",
      fr: "Singapour",
      nl: "Singapore",
      pt: "Singapura",
      cs: "Singapur",
      ro: "Singapore",
      ru: "Сингапур"
    },
    rootIddCode: "+65",
    continent: "Asia"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  SH: {
    i18nNames: {
      en: "Saint Helena, Ascension and Tristan da Cunha",
      es: "Santa Elena",
      it: "Sant'Elena, Ascensione e Tristan da Cunha",
      de: "Sankt Helena, Ascension und Tristan da Cunha",
      pl: "Wyspa Świętej Heleny, Wniebowstąpienia i Tristan da Cunha",
      fr: "Sainte-Hélène, Ascension et Tristan da Cunha",
      nl: "Sint-Helena, Ascension en Tristan da Cunha",
      pt: "Santa Helena, Ascensão e Tristão da Cunha",
      cs: "Svatá Helena, Ascension a Tristan da Cunha",
      ro: "Sfânta Elena, Ascension și Tristan da Cunha",
      ru: "Остров Святой Елены, Вознесения и Тристан-да-Кунья"
    },
    rootIddCode: "+247",
    continent: "Africa"
  },
  SI: {
    i18nNames: {
      en: "Slovenia",
      it: "Slovenia",
      es: "Eslovenia",
      de: "Slowenien",
      pl: "Słowenia",
      fr: "Slovénie",
      nl: "Slovenië",
      pt: "Eslovênia",
      cs: "Slovinsko",
      ro: "Slovenia",
      ru: "Словения"
    },
    rootIddCode: "+386",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SI\\d{8}$",
    taxIdExample: "SI12345678"
  },
  SJ: {
    i18nNames: {
      en: "Svalbard and Jan Mayen",
      es: "Svalbard y Jan Mayen",
      it: "Svalbard e Jan Mayen",
      de: "Svalbard und Jan Mayen",
      pl: "Svalbard i Jan Mayen",
      fr: "Svalbard et Jan Mayen",
      nl: "Spitsbergen en Jan Mayen",
      pt: "Svalbard e Jan Mayen",
      cs: "Špicberky a Jan Mayen",
      ro: "Svalbard și Jan Mayen",
      ru: "Шпицберген и Ян-Майен"
    },
    rootIddCode: "+4779",
    continent: "Europe"
  },
  SK: {
    i18nNames: {
      en: "Slovakia",
      it: "Slovacchia",
      es: "Eslovaquia",
      de: "Slowakei",
      pl: "Słowacja",
      fr: "Slovaquie",
      nl: "Slowakije",
      pt: "Eslováquia",
      cs: "Slovensko",
      ro: "Slovacia",
      ru: "Словакия"
    },
    rootIddCode: "+421",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SK\\d{10}$",
    taxIdExample: "SK1234567890"
  },
  SL: {
    i18nNames: {
      en: "Sierra Leone",
      it: "Sierra Leone",
      es: "Sierra Leona",
      de: "Sierra Leone",
      pl: "Sierra Leone",
      fr: "Sierra Leone",
      nl: "Sierra Leone",
      pt: "Serra Leoa",
      cs: "Sierra Leone",
      ro: "Sierra Leone",
      ru: "Сьерра-Леоне"
    },
    rootIddCode: "+232",
    continent: "Africa"
  },
  SM: {
    i18nNames: {
      en: "San Marino",
      it: "San Marino",
      es: "San Marino",
      de: "San Marino",
      pl: "San Marino",
      fr: "Saint-Marin",
      nl: "San Marino",
      pt: "San Marino",
      cs: "San Marino",
      ro: "San Marino",
      ru: "Сан-Марино"
    },
    rootIddCode: "+378",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^SM\\d{5}$",
    taxIdExample: "SM12345"
  },
  SN: {
    i18nNames: {
      en: "Senegal",
      it: "Senegal",
      es: "Senegal",
      de: "Senegal",
      pl: "Senegal",
      fr: "Sénégal",
      nl: "Senegal",
      pt: "Senegal",
      cs: "Senegal",
      ro: "Senegal",
      ru: "Сенегал"
    },
    rootIddCode: "+221",
    continent: "Africa"
  },
  SO: {
    i18nNames: {
      en: "Somalia",
      it: "Somalia",
      es: "Somalia",
      de: "Somalia",
      pl: "Somalia",
      fr: "Somalie",
      nl: "Somalië",
      pt: "Somália",
      cs: "Somálsko",
      ro: "Somalia",
      ru: "Сомали"
    },
    rootIddCode: "+252",
    continent: "Africa"
  },
  SR: {
    i18nNames: {
      en: "Suriname",
      it: "Suriname",
      es: "Surinam",
      de: "Suriname",
      pl: "Surinam",
      fr: "Suriname",
      nl: "Suriname",
      pt: "Suriname",
      cs: "Surinam",
      ro: "Surinam",
      ru: "Суринам"
    },
    rootIddCode: "+597",
    continent: "SouthAmerica"
  },
  SS: {
    i18nNames: {
      en: "South Sudan",
      it: "Sudan del sud",
      es: "Sudán del Sur",
      de: "Südsudan",
      pl: "Sudan Południowy",
      fr: "Soudan du Sud",
      nl: "Zuid-Soedan",
      pt: "Sudão do Sul",
      cs: "Jižní Súdán",
      ro: "Sudanul de Sud",
      ru: "Южный Судан"
    },
    rootIddCode: "+211",
    continent: "Africa"
  },
  ST: {
    i18nNames: {
      en: "São Tomé and Príncipe",
      es: "Santo Tomé y Príncipe",
      it: "São Tomé e Príncipe",
      de: "São Tomé und Príncipe",
      pl: "Wyspy Świętego Tomasza i Książęca",
      fr: "Sao Tomé-et-Principe",
      nl: "Sao Tomé en Principe",
      pt: "São Tomé e Príncipe",
      cs: "Svatý Tomáš a Princův ostrov",
      ro: "São Tomé și Príncipe",
      ru: "Сан-Томе и Принсипи"
    },
    rootIddCode: "+239",
    continent: "Africa"
  },
  SV: {
    i18nNames: {
      en: "El Salvador",
      it: "El Salvador",
      es: "El Salvador",
      de: "El Salvador",
      pl: "Salwador",
      fr: "Le Salvador",
      nl: "El Salvador",
      pt: "El Salvador",
      cs: "Salvador",
      ro: "El Salvador",
      ru: "Сальвадор"
    },
    rootIddCode: "+503",
    continent: "NorthAmerica"
  },
  SX: {
    i18nNames: {
      en: "Sint Maarten",
      it: "Sint Maarten",
      es: "San Martín (parte neerlandesa)",
      de: "Sint Maarten",
      pl: "Sint Maarten",
      fr: "Saint-Martin (partie néerlandaise)",
      nl: "Sint Maarten",
      pt: "Sint Maarten",
      cs: "Svatý Martin (nizozemská část)",
      ro: "Sint Maarten",
      ru: "Синт-Мартен"
    },
    rootIddCode: "+1721",
    continent: "NorthAmerica"
  },
  SY: {
    i18nNames: {
      en: "Syria",
      it: "Siria",
      es: "Siria",
      de: "Сирия",
      pl: "Syria",
      fr: "Syrie",
      nl: "Syrië",
      pt: "Síria",
      cs: "Sýrie",
      ro: "Siria",
      ru: "Сирия"
    },
    rootIddCode: "+963",
    continent: "Asia"
  },
  SZ: {
    i18nNames: {
      en: "Eswatini",
      it: "Swaziland",
      es: "Suazilandia",
      de: "Eswatini",
      pl: "Eswatini",
      fr: "Eswatini",
      nl: "Eswatini",
      pt: "Essuatíni",
      cs: "Eswatini",
      ro: "Eswatini",
      ru: "Эсватини"
    },
    rootIddCode: "+268",
    continent: "Africa"
  },
  TC: {
    i18nNames: {
      en: "Turks and Caicos Islands",
      es: "Islas Turcas y Caicos",
      it: "Isole Turks e Caicos",
      de: "Turks- und Caicosinseln",
      pl: "Turks i Caicos",
      fr: "Îles Turques-et-Caïques",
      nl: "Turks- en Caicoseilanden",
      pt: "Ilhas Turcas e Caicos",
      cs: "Ostrovy Turks a Caicos",
      ro: "Insulele Turks și Caicos",
      ru: "Теркс и Кайкос"
    },
    rootIddCode: "+1649",
    continent: "NorthAmerica"
  },
  TD: {
    i18nNames: {
      en: "Chad",
      it: "Ciad",
      es: "Chad",
      de: "Tschad",
      pl: "Czad",
      fr: "Tchad",
      nl: "Tsjaad",
      pt: "Chade",
      cs: "Čад",
      ro: "Ciad",
      ru: "Чад"
    },
    rootIddCode: "+235",
    continent: "Africa"
  },
  TF: {
    i18nNames: {
      en: "French Southern and Antarctic Lands",
      es: "Territorios Australes Franceses",
      it: "Territori Francesi del Sud",
      de: "Französische Süd- und Antarktisgebiete",
      pl: "Francuskie Terytoria Południowe i Antarktyczne",
      fr: "Terres australes et antarctiques françaises",
      nl: "Franse Zuidelijke en Antarctische Gebieden",
      pt: "Terras Austrais e Antárticas Francesas",
      cs: "Francouzská jižní a antarktická území",
      ro: "Teritoriile Australe și Antarctice Franceze",
      ru: "Французские южные и антарктические территории"
    },
    rootIddCode: "+262",
    continent: "Oceania"
  },
  TG: {
    i18nNames: {
      en: "Togo",
      it: "Togo",
      es: "Togo",
      de: "Togo",
      pl: "Togo",
      fr: "Togo",
      nl: "Togo",
      pt: "Togo",
      cs: "Togo",
      ro: "Togo",
      ru: "Того"
    },
    rootIddCode: "+228",
    continent: "Africa"
  },
  TH: {
    i18nNames: {
      en: "Thailand",
      it: "Tailandia",
      es: "Tailandia",
      de: "Thailand",
      pl: "Tajlandia",
      fr: "Thaïlande",
      nl: "Thailand",
      pt: "Tailândia",
      cs: "Thajsko",
      ro: "Thailanda",
      ru: "Таиланд"
    },
    rootIddCode: "+66",
    continent: "Asia"
  },
  TJ: {
    i18nNames: {
      en: "Tajikistan",
      it: "Tagikistan",
      es: "Tayikistán",
      de: "Tadschikistan",
      pl: "Tadżykistan",
      fr: "Tadjikistan",
      nl: "Tadzjikistan",
      pt: "Tajiquistão",
      cs: "Tádžikistán",
      ro: "Tadjikistan",
      ru: "Таджикистан"
    },
    rootIddCode: "+992",
    continent: "Asia"
  },
  TK: {
    i18nNames: {
      en: "Tokelau",
      it: "Isole Tokelau",
      es: "Tokelau",
      de: "Tokelau",
      pl: "Tokelau",
      fr: "Tokelau",
      nl: "Tokelau",
      pt: "Tokelau",
      cs: "Tokelau",
      ro: "Tokelau",
      ru: "Токелау"
    },
    rootIddCode: "+690",
    continent: "Oceania"
  },
  TL: {
    i18nNames: {
      en: "Timor-Leste",
      it: "Timor Est",
      es: "Timor-Leste",
      de: "Osttimor",
      pl: "Timor Wschodni",
      fr: "Timor oriental",
      nl: "Oost-Timor",
      pt: "Timor-Leste",
      cs: "Východní Timor",
      ro: "Timorul de Est",
      ru: "Восточный Тимор"
    },
    rootIddCode: "+670",
    continent: "Asia"
  },
  TM: {
    i18nNames: {
      en: "Turkmenistan",
      it: "Turkmenistan",
      es: "Turkmenistán",
      de: "Turkmenistan",
      pl: "Turkmenistan",
      fr: "Turkménistan",
      nl: "Turkmenistan",
      pt: "Turquemenistão",
      cs: "Turkmenistán",
      ro: "Turkmenistan",
      ru: "Туркменистан"
    },
    rootIddCode: "+993",
    continent: "Asia"
  },
  TN: {
    i18nNames: {
      en: "Tunisia",
      it: "Tunisia",
      es: "Túnez",
      de: "Tunesien",
      pl: "Tunezja",
      fr: "Tunisie",
      nl: "Tunesië",
      pt: "Tunísia",
      cs: "Tunisko",
      ro: "Tunisia",
      ru: "Тунис"
    },
    rootIddCode: "+216",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  TO: {
    i18nNames: {
      en: "Tonga",
      it: "Tonga",
      es: "Tonga",
      de: "Tonga",
      pl: "Tonga",
      fr: "Tonga",
      nl: "Tonga",
      pt: "Tonga",
      cs: "Tonga",
      ro: "Tonga",
      ru: "Тонга"
    },
    rootIddCode: "+676",
    continent: "Oceania"
  },
  TR: {
    i18nNames: {
      en: "Turkey",
      it: "Turchia",
      es: "Turquía",
      de: "Türkei",
      pl: "Turcja",
      fr: "Turquie",
      nl: "Turkije",
      pt: "Turquia",
      cs: "Turecko",
      ro: "Turcia",
      ru: "Турция"
    },
    rootIddCode: "+90",
    continent: "Europe"
  },
  TT: {
    i18nNames: {
      en: "Trinidad and Tobago",
      es: "Trinidad y Tobago",
      it: "Trinidad e Tobago",
      de: "Trinidad und Tobago",
      pl: "Trynidad i Tobago",
      fr: "Trinité-et-Tobago",
      nl: "Trinidad en Tobago",
      pt: "Trinidad e Tobago",
      cs: "Trinidad a Tobago",
      ro: "Trinidad și Tobago",
      ru: "Тринидад и Тобаго"
    },
    rootIddCode: "+1868",
    continent: "NorthAmerica"
  },
  TV: {
    i18nNames: {
      en: "Tuvalu",
      it: "Tuvalu",
      es: "Tuvalu",
      de: "Tuvalu",
      pl: "Tuvalu",
      fr: "Tuvalu",
      nl: "Tuvalu",
      pt: "Tuvalu",
      cs: "Tuvalu",
      ro: "Tuvalu",
      ru: "Тувалу"
    },
    rootIddCode: "+688",
    continent: "Oceania"
  },
  TW: {
    i18nNames: {
      en: "Taiwan",
      it: "Taiwan",
      es: "Taiwán",
      de: "Taiwan",
      pl: "Tajwan",
      fr: "Taïwan",
      nl: "Taiwan",
      pt: "Taiwan",
      cs: "Tchaj-wan",
      ro: "Taiwan",
      ru: "Тайвань"
    },
    rootIddCode: "+886",
    continent: "Asia"
  },
  TZ: {
    i18nNames: {
      en: "Tanzania",
      it: "Tanzania",
      es: "Tanzania",
      de: "Tansania",
      pl: "Tanzania",
      fr: "Tanzanie",
      nl: "Tanzania",
      pt: "Tanzânia",
      cs: "Tanzanie",
      ro: "Tanzania",
      ru: "Танзания"
    },
    rootIddCode: "+255",
    continent: "Africa"
  },
  UA: {
    i18nNames: {
      en: "Ukraine",
      it: "Ucraina",
      es: "Ucrania",
      de: "Ukraine",
      pl: "Ukraina",
      fr: "Ukraine",
      nl: "Oekraïne",
      pt: "Ucrânia",
      cs: "Ukrajina",
      ro: "Ucraina",
      ru: "Украина"
    },
    rootIddCode: "+380",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{8}|\\d{12})$",
    taxIdExample: "12345678"
  },
  UG: {
    i18nNames: {
      en: "Uganda",
      it: "Uganda",
      es: "Uganda",
      de: "Uganda",
      pl: "Uganda",
      fr: "Ouganda",
      nl: "Oeganda",
      pt: "Uganda",
      cs: "Uganda",
      ro: "Uganda",
      ru: "Уганда"
    },
    rootIddCode: "+256",
    continent: "Africa"
  },
  UM: {
    i18nNames: {
      en: "United States Minor Outlying Islands",
      es: "Islas menores alejadas de los Estados Unidos",
      it: "Isole minori esterne degli Stati Uniti d'America",
      de: "Kleinere Inselbesitzungen der Vereinigten Staaten",
      pl: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
      fr: "Îles mineures éloignées des États-Unis",
      nl: "Kleine afgelegen eilanden van de Verenigde Staten",
      pt: "Ilhas Menores Distantes dos EUA",
      cs: "Menší odlehlé ostrovy USA",
      ro: "Insulele S.U.A. din Oceanul Pacific",
      ru: "Внешние малые острова США"
    },
    rootIddCode: "+268",
    continent: "NorthAmerica"
  },
  US: {
    i18nNames: {
      en: "United States",
      it: "Stati Uniti d'America",
      es: "Estados Unidos",
      de: "Vereinigte Staaten",
      pl: "Stany Zjednoczone",
      fr: "États-Unis",
      nl: "Verenigde Staten",
      pt: "Estados Unidos",
      cs: "Spojené státy americké",
      ro: "Statele Unite ale Americii",
      ru: "Соединённые Штаты"
    },
    rootIddCode: "+1989",
    continent: "NorthAmerica"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  UY: {
    i18nNames: {
      en: "Uruguay",
      it: "Uruguay",
      es: "Uruguay",
      de: "Uruguay",
      pl: "Urugwaj",
      fr: "Uruguay",
      nl: "Uruguay",
      pt: "Uruguai",
      cs: "Uruguay",
      ro: "Uruguay",
      ru: "Уругвай"
    },
    rootIddCode: "+598",
    continent: "SouthAmerica"
  },
  UZ: {
    i18nNames: {
      en: "Uzbekistan",
      it: "Uzbekistan",
      es: "Uzbekistán",
      de: "Usbekistan",
      pl: "Uzbekistan",
      fr: "Ouzbékistan",
      nl: "Oezbekistan",
      pt: "Uzbequistão",
      cs: "Uzbekistán",
      ro: "Uzbekistan",
      ru: "Узбекистан"
    },
    rootIddCode: "+998",
    continent: "Asia"
  },
  VA: {
    i18nNames: {
      en: "Vatican City",
      it: "Città del Vaticano",
      es: "Ciudad del Vaticano",
      de: "Vatikanstadt",
      pl: "Watykan",
      fr: "Cité du Vatican",
      nl: "Vaticaanstad",
      pt: "Cidade do Vaticano",
      cs: "Vatikán",
      ro: "Vatican",
      ru: "Ватикан"
    },
    rootIddCode: "+379",
    continent: "Europe"
  },
  VC: {
    i18nNames: {
      en: "Saint Vincent and the Grenadines",
      es: "San Vicente y las Granadinas",
      it: "Saint Vincent e Grenadine",
      de: "St. Vincent und die Grenadinen",
      pl: "Saint Vincent i Grenadyny",
      fr: "Saint-Vincent-et-les-Grenadines",
      nl: "Saint Vincent en de Grenadines",
      pt: "São Vicente e Granadinas",
      cs: "Svatý Vincenc a Grenadiny",
      ro: "Sfântul Vincent și Grenadine",
      ru: "Сент-Винсент и Гренадины"
    },
    rootIddCode: "+1784",
    continent: "NorthAmerica"
  },
  VE: {
    i18nNames: {
      en: "Venezuela",
      it: "Venezuela",
      es: "Venezuela",
      de: "Venezuela",
      pl: "Wenezuela",
      fr: "Venezuela",
      nl: "Venezuela",
      pt: "Venezuela",
      cs: "Venezuela",
      ro: "Venezuela",
      ru: "Венесуэла"
    },
    rootIddCode: "+58",
    continent: "SouthAmerica"
  },
  VG: {
    i18nNames: {
      en: "British Virgin Islands",
      es: "Islas Vírgenes Británicas",
      it: "Isole Vergini Britanniche",
      de: "Britische Jungferninseln",
      pl: "Brytyjskie Wyspy Dziewicze",
      fr: "Îles Vierges britanniques",
      nl: "Britse Maagdeneilanden",
      pt: "Ilhas Virgens Britânicas",
      cs: "Britské Panenské ostrovy",
      ro: "Insulele Virgine Britanice",
      ru: "Британские Виргинские острова"
    },
    rootIddCode: "+1284",
    continent: "NorthAmerica"
  },
  VI: {
    i18nNames: {
      en: "United States Virgin Islands",
      es: "Islas Vírgenes de los Estados Unidos",
      it: "Isole Vergini americane",
      de: "Amerikanische Jungferninseln",
      pl: "Wyspy Dziewицze Stanów Зjednoczonych",
      fr: "Îles Vierges des États-Unis",
      nl: "Amerikaanse Maagdeneilanden",
      pt: "Ilhas Virgens dos Estados Unidos",
      cs: "Americké Panenské остроvy",
      ro: "Insulele Virgine Americane",
      ru: "Виргинские острова США"
    },
    rootIddCode: "+1340",
    continent: "NorthAmerica"
  },
  VN: {
    i18nNames: {
      en: "Vietnam",
      it: "Vietnam",
      es: "Vietnam",
      de: "Vietnam",
      pl: "Wietnam",
      fr: "Vietnam",
      nl: "Vietnam",
      pt: "Vietnã",
      cs: "Vietnam",
      ro: "Vietnam",
      ru: "Вьетнам"
    },
    rootIddCode: "+84",
    continent: "Asia"
  },
  VU: {
    i18nNames: {
      en: "Vanuatu",
      it: "Vanuatu",
      es: "Vanuatu",
      de: "Vanuatu",
      pl: "Vanuatu",
      fr: "Vanuatu",
      nl: "Vanuatu",
      pt: "Vanuatu",
      cs: "Vanuatu",
      ro: "Vanuatu",
      ru: "Вануату"
    },
    rootIddCode: "+678",
    continent: "Oceania"
  },
  WF: {
    i18nNames: {
      en: "Wallis and Futuna",
      es: "Wallis y Futuna",
      it: "Wallis e Futuna",
      de: "Wallis und Futuna",
      pl: "Wallis i Futuna",
      fr: "Wallis-et-Futuna",
      nl: "Wallis en Futuna",
      pt: "Wallis e Futuna",
      cs: "Wallis a Futuna",
      ro: "Wallis și Futuna",
      ru: "Уоллис и Футуна"
    },
    rootIddCode: "+681",
    continent: "Oceania"
  },
  WS: {
    i18nNames: {
      en: "Samoa",
      it: "Samoa",
      es: "Samoa",
      de: "Samoa",
      pl: "Samoa",
      fr: "Samoa",
      nl: "Samoa",
      pt: "Samoa",
      cs: "Samoa",
      ro: "Samoa",
      ru: "Самоа"
    },
    rootIddCode: "+685",
    continent: "Oceania"
  },
  XK: {
    i18nNames: {
      en: "Kosovo",
      it: "Kosovo",
      es: "Kosovo",
      de: "Kosovo",
      pl: "Kosowo",
      fr: "Kosovo",
      nl: "Kosovo",
      pt: "Kosovo",
      cs: "Kosovo",
      ro: "Kosovo",
      ru: "Косово"
    },
    rootIddCode: "+383",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  YE: {
    i18nNames: {
      en: "Yemen",
      it: "Yemen",
      es: "Yemen",
      de: "Jemen",
      pl: "Jemen",
      fr: "Yémen",
      nl: "Jemen",
      pt: "Iémen",
      cs: "Jemen",
      ro: "Yemen",
      ru: "Йемен"
    },
    rootIddCode: "+967",
    continent: "Asia"
  },
  YT: {
    i18nNames: {
      en: "Mayotte",
      it: "Mayotte",
      es: "Mayotte",
      de: "Mayotte",
      pl: "Majotta",
      fr: "Mayotte",
      nl: "Mayotte",
      pt: "Mayotte",
      cs: "Mayotte",
      ro: "Mayotte",
      ru: "Майотта"
    },
    rootIddCode: "+262",
    continent: "Africa"
  },
  ZA: {
    i18nNames: {
      en: "South Africa",
      it: "Sud Africa",
      es: "Sudáfrica",
      de: "Südafrika",
      pl: "Republika Południowej Afryki",
      fr: "Afrique du Sud",
      nl: "Zuid-Afrika",
      pt: "África do Sul",
      cs: "Jihoafrická republika",
      ro: "Africa de Sud",
      ru: "Южная Африка"
    },
    rootIddCode: "+27",
    continent: "Africa"
  },
  ZM: {
    i18nNames: {
      en: "Zambia",
      it: "Zambia",
      es: "Zambia",
      de: "Sambia",
      pl: "Zambia",
      fr: "Zambie",
      nl: "Zambia",
      pt: "Zâmbia",
      cs: "Zambie",
      ro: "Zambia",
      ru: "Замбия"
    },
    rootIddCode: "+260",
    continent: "Africa"
  },
  ZW: {
    i18nNames: {
      en: "Zimbabwe",
      it: "Zimbabwe",
      es: "Zimbabue",
      de: "Simbabwe",
      pl: "Zimbabwe",
      fr: "Zimbabwe",
      nl: "Zimbabwe",
      pt: "Zimbábue",
      cs: "Zimbabwe",
      ro: "Zimbabwe",
      ru: "Зимбабве"
    },
    rootIddCode: "+263",
    continent: "Africa"
  }
}, V1 = (n) => Gi[n].i18nNames.en;
function J1(...n) {
  const t = /* @__PURE__ */ new Set();
  for (const [o, a] of Object.entries(Gi))
    n.includes(a.continent) && t.add(o);
  return t;
}
const Nc = [
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "XK",
  // Kosovo
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW"
];
function j1(n) {
  if (m1(n) !== !0)
    throw new Error(`'${n}' is not a valid ISO 3166-1 alpha-2 Country code`);
  return n;
}
function m1(n) {
  return typeof n == "string" && Nc.includes(n);
}
const xc = {
  AD: "AND",
  AE: "ARE",
  AF: "AFG",
  AG: "ATG",
  AI: "AIA",
  AL: "ALB",
  AM: "ARM",
  AO: "AGO",
  AQ: "ATA",
  AR: "ARG",
  AS: "ASM",
  AT: "AUT",
  AU: "AUS",
  AW: "ABW",
  AX: "ALA",
  AZ: "AZE",
  BB: "BRB",
  BD: "BGD",
  BE: "BEL",
  BF: "BFA",
  BG: "BGR",
  BH: "BHR",
  BI: "BDI",
  BJ: "BEN",
  BL: "BLM",
  BM: "BMU",
  BN: "BRN",
  BO: "BOL",
  BQ: "BES",
  BR: "BRA",
  BS: "BHS",
  BT: "BTN",
  BV: "BVT",
  BW: "BWA",
  BY: "BLR",
  BZ: "BLZ",
  CA: "CAN",
  CC: "CCK",
  CD: "COD",
  CF: "CAF",
  CG: "COG",
  CH: "CHE",
  CI: "CIV",
  CK: "COK",
  CL: "CHL",
  CM: "CMR",
  CN: "CHN",
  CO: "COL",
  CR: "CRI",
  CU: "CUB",
  CV: "CPV",
  CW: "CUW",
  CX: "CXR",
  CY: "CYP",
  CZ: "CZE",
  DE: "DEU",
  DJ: "DJI",
  DK: "DNK",
  DM: "DMA",
  DO: "DOM",
  DZ: "DZA",
  EC: "ECU",
  EE: "EST",
  EG: "EGY",
  EH: "ESH",
  ER: "ERI",
  ES: "ESP",
  ET: "ETH",
  FI: "FIN",
  FJ: "FJI",
  FK: "FLK",
  FM: "FSM",
  FO: "FRO",
  FR: "FRA",
  GA: "GAB",
  GB: "GBR",
  GD: "GRD",
  GE: "GEO",
  GF: "GUF",
  GG: "GGY",
  GH: "GHA",
  GI: "GIB",
  GL: "GRL",
  GM: "GMB",
  GN: "GIN",
  GP: "GLP",
  GQ: "GNQ",
  GR: "GRC",
  GS: "SGS",
  GT: "GTM",
  GU: "GUM",
  GW: "GNB",
  GY: "GUY",
  HK: "HKG",
  HM: "HMD",
  HN: "HND",
  HR: "HRV",
  HT: "HTI",
  HU: "HUN",
  ID: "IDN",
  IE: "IRL",
  IL: "ISR",
  IM: "IMN",
  IN: "IND",
  IO: "IOT",
  IQ: "IRQ",
  IR: "IRN",
  IS: "ISL",
  IT: "ITA",
  JE: "JEY",
  JM: "JAM",
  JO: "JOR",
  JP: "JPN",
  KE: "KEN",
  KG: "KGZ",
  KH: "KHM",
  KI: "KIR",
  KM: "COM",
  KN: "KNA",
  KP: "PRK",
  KR: "KOR",
  KW: "KWT",
  KY: "CYM",
  KZ: "KAZ",
  LA: "LAO",
  LB: "LBN",
  LC: "LCA",
  LI: "LIE",
  LK: "LKA",
  LR: "LBR",
  LS: "LSO",
  LT: "LTU",
  LU: "LUX",
  LV: "LVA",
  LY: "LBY",
  MA: "MAR",
  MC: "MCO",
  MD: "MDA",
  ME: "MNE",
  MF: "MAF",
  MG: "MDG",
  MH: "MHL",
  MK: "MKD",
  ML: "MLI",
  MM: "MMR",
  MN: "MNG",
  MO: "MAC",
  MP: "MNP",
  MQ: "MTQ",
  MR: "MRT",
  MS: "MSR",
  MT: "MLT",
  MU: "MUS",
  MV: "MDV",
  MW: "MWI",
  MX: "MEX",
  MY: "MYS",
  MZ: "MOZ",
  NA: "NAM",
  NC: "NCL",
  NE: "NER",
  NF: "NFK",
  NG: "NGA",
  NI: "NIC",
  NL: "NLD",
  NO: "NOR",
  NP: "NPL",
  NR: "NRU",
  NU: "NIU",
  NZ: "NZL",
  OM: "OMN",
  PA: "PAN",
  PE: "PER",
  PF: "PYF",
  PG: "PNG",
  PH: "PHL",
  PK: "PAK",
  PL: "POL",
  PM: "SPM",
  PN: "PCN",
  PR: "PRI",
  PS: "PSE",
  PT: "PRT",
  PW: "PLW",
  PY: "PRY",
  QA: "QAT",
  RE: "REU",
  RO: "ROU",
  RS: "SRB",
  RU: "RUS",
  RW: "RWA",
  SA: "SAU",
  BA: "BIH",
  SB: "SLB",
  SC: "SYC",
  SD: "SDN",
  SE: "SWE",
  SG: "SGP",
  SH: "SHN",
  SI: "SVN",
  SJ: "SJM",
  SK: "SVK",
  SL: "SLE",
  SM: "SMR",
  SN: "SEN",
  SO: "SOM",
  SR: "SUR",
  SS: "SSD",
  ST: "STP",
  SV: "SLV",
  SX: "SXM",
  SY: "SYR",
  SZ: "SWZ",
  TC: "TCA",
  TD: "TCD",
  TF: "ATF",
  TG: "TGO",
  TH: "THA",
  TJ: "TJK",
  TK: "TKL",
  TL: "TLS",
  TM: "TKM",
  TN: "TUN",
  TO: "TON",
  TR: "TUR",
  TT: "TTO",
  TV: "TUV",
  TW: "TWN",
  TZ: "TZA",
  UA: "UKR",
  UG: "UGA",
  UM: "UMI",
  US: "USA",
  UY: "URY",
  UZ: "UZB",
  VA: "VAT",
  VC: "VCT",
  VE: "VEN",
  VG: "VGB",
  VI: "VIR",
  VN: "VNM",
  VU: "VUT",
  WF: "WLF",
  WS: "WSM",
  XK: "UNK",
  YE: "YEM",
  YT: "MYT",
  ZA: "ZAF",
  ZM: "ZMB",
  ZW: "ZWE"
};
function _1(n) {
  return typeof n == "string" && Object.values(xc).includes(n);
}
function Y1(n) {
  if (_1(n) !== !0)
    throw new Error(`'${n}' is not a valid ISO 3166-1 alpha-3 Country code`);
  return n;
}
function X1(n) {
  return xc[n];
}
const Q1 = 10 * 1024 * 1024, e0 = "pdf", g1 = Object.fromEntries(
  Object.entries(Gi).map(([n, t]) => [
    n,
    ("regions" in t ? t.regions : []).flatMap(
      (o) => ("provinces" in o ? o.provinces : []).map((a) => a)
    )
  ])
), v1 = [
  "aa",
  "ab",
  "ae",
  "af",
  "ak",
  "am",
  "an",
  "ar",
  "as",
  "av",
  "ay",
  "az",
  "ba",
  "be",
  "bg",
  "bh",
  "bi",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "ca",
  "ce",
  "ch",
  "co",
  "cr",
  "cs",
  "cu",
  "cv",
  "cy",
  "da",
  "de",
  "dv",
  "dz",
  "ee",
  "el",
  "en",
  "eo",
  "es",
  "et",
  "eu",
  "fa",
  "ff",
  "fi",
  "fj",
  "fo",
  "fr",
  "fy",
  "ga",
  "gd",
  "gl",
  "gn",
  "gu",
  "gv",
  "ha",
  "he",
  "hi",
  "ho",
  "hr",
  "ht",
  "hu",
  "hy",
  "hz",
  "ia",
  "id",
  "ie",
  "ig",
  "ii",
  "ik",
  "io",
  "is",
  "it",
  "iu",
  "ja",
  "jv",
  "ka",
  "kg",
  "ki",
  "kj",
  "kk",
  "kl",
  "km",
  "kn",
  "ko",
  "kr",
  "ks",
  "ku",
  "kv",
  "kw",
  "ky",
  "la",
  "lb",
  "lg",
  "li",
  "ln",
  "lo",
  "lt",
  "lu",
  "lv",
  "mg",
  "mh",
  "mi",
  "mk",
  "ml",
  "mn",
  "mr",
  "ms",
  "mt",
  "my",
  "na",
  "nb",
  "nd",
  "ne",
  "ng",
  "nl",
  "nn",
  "no",
  "nr",
  "nv",
  "ny",
  "oc",
  "oj",
  "om",
  "or",
  "os",
  "pa",
  "pi",
  "pl",
  "ps",
  "pt",
  "qu",
  "rm",
  "rn",
  "ro",
  "ru",
  "rw",
  "sa",
  "sc",
  "sd",
  "se",
  "sg",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sq",
  "sr",
  "ss",
  "st",
  "su",
  "sv",
  "sw",
  "ta",
  "te",
  "tg",
  "th",
  "ti",
  "tk",
  "tl",
  "tn",
  "to",
  "tr",
  "ts",
  "tt",
  "tw",
  "ty",
  "ug",
  "uk",
  "ur",
  "uz",
  "ve",
  "vi",
  "vo",
  "wa",
  "wo",
  "xh",
  "yi",
  "yo",
  "za",
  "zh",
  "zu"
], I1 = Tc(v1), n0 = (n) => I1.parse(n), r0 = {
  aa: "Afar",
  ab: "Abkhazian",
  ae: "Avestan",
  af: "Afrikaans",
  ak: "Akan",
  am: "Amharic",
  an: "Aragonese",
  ar: "Arabic",
  as: "Assamese",
  av: "Avaric",
  ay: "Aymara",
  az: "Azerbaijani",
  ba: "Bashkir",
  be: "Belarusian",
  bg: "Bulgarian",
  bh: "Bihari languages",
  bi: "Bislama",
  bm: "Bambara",
  bn: "Bengali",
  bo: "Tibetan",
  br: "Breton",
  bs: "Bosnian",
  ca: "Catalan",
  ce: "Chechen",
  ch: "Chamorro",
  co: "Corsican",
  cr: "Cree",
  cs: "Czech",
  cu: "Church Slavic",
  cv: "Chuvash",
  cy: "Welsh",
  da: "Danish",
  de: "German",
  dv: "Dhivehi",
  dz: "Dzongkha",
  ee: "Ewe",
  el: "Greek",
  en: "English",
  eo: "Esperanto",
  es: "Spanish",
  et: "Estonian",
  eu: "Basque",
  fa: "Persian",
  ff: "Fulah",
  fi: "Finnish",
  fj: "Fijian",
  fo: "Faroese",
  fr: "French",
  fy: "Western Frisian",
  ga: "Irish",
  gd: "Scottish Gaelic",
  gl: "Galician",
  gn: "Guarani",
  gu: "Gujarati",
  gv: "Manx",
  ha: "Hausa",
  he: "Hebrew",
  hi: "Hindi",
  ho: "Hiri Motu",
  hr: "Croatian",
  ht: "Haitian Creole",
  hu: "Hungarian",
  hy: "Armenian",
  hz: "Herero",
  ia: "Interlingua",
  id: "Indonesian",
  ie: "Interlingue",
  ig: "Igbo",
  ii: "Sichuan Yi (Nuosu)",
  ik: "Inupiaq",
  io: "Ido",
  is: "Icelandic",
  it: "Italian",
  iu: "Inuktitut",
  ja: "Japanese",
  jv: "Javanese",
  ka: "Georgian",
  kg: "Kongo",
  ki: "Kikuyu",
  kj: "Kuanyama",
  kk: "Kazakh",
  kl: "Kalaallisut",
  km: "Khmer",
  kn: "Kannada",
  ko: "Korean",
  kr: "Kanuri",
  ks: "Kashmiri",
  ku: "Kurdish",
  kv: "Komi",
  kw: "Cornish",
  ky: "Kyrgyz",
  la: "Latin",
  lb: "Luxembourgish",
  lg: "Ganda",
  li: "Limburgish",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lv: "Latvian",
  mg: "Malagasy",
  mh: "Marshallese",
  mi: "Māori",
  mk: "Macedonian",
  ml: "Malayalam",
  mn: "Mongolian",
  mr: "Marathi",
  ms: "Malay",
  mt: "Maltese",
  my: "Burmese",
  na: "Nauru",
  nb: "Norwegian Bokmål",
  nd: "North Ndebele",
  ne: "Nepali",
  ng: "Ndonga",
  nl: "Dutch",
  nn: "Norwegian Nynorsk",
  no: "Norwegian",
  nr: "South Ndebele",
  nv: "Navajo",
  ny: "Chichewa",
  oc: "Occitan",
  oj: "Ojibwa",
  om: "Oromo",
  or: "Odia",
  os: "Ossetian",
  pa: "Punjabi",
  pi: "Pali",
  pl: "Polish",
  ps: "Pashto",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ro: "Romanian",
  ru: "Russian",
  rw: "Kinyarwanda",
  sa: "Sanskrit",
  sc: "Sardinian",
  sd: "Sindhi",
  se: "Northern Sami",
  sg: "Sango",
  si: "Sinhala",
  sk: "Slovak",
  sl: "Slovenian",
  sm: "Samoan",
  sn: "Shona",
  so: "Somali",
  sq: "Albanian",
  sr: "Serbian",
  ss: "Swati",
  st: "Southern Sotho",
  su: "Sundanese",
  sv: "Swedish",
  sw: "Swahili",
  ta: "Tamil",
  te: "Telugu",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  tk: "Turkmen",
  tl: "Tagalog",
  tn: "Tswana",
  to: "Tongan",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  tw: "Twi",
  ty: "Tahitian",
  ug: "Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang",
  zh: "Chinese",
  zu: "Zulu"
}, b1 = [...Nc, "EU", "EXTRA_EU"];
function S1(n) {
  return typeof n == "string" && b1.includes(n);
}
function t0(n) {
  if (S1(n) !== !0)
    throw new Error(`'${n}' is not a valid tax code origin`);
  return n;
}
const Di = "https://145031484.fs1.hubspotusercontent-eu1.net/hubfs/145031484", o0 = (n) => `${Di}/sales/${n}.jpeg`, i0 = `${Di}/sales/fleequid-expert.webp`, a0 = (n) => `${Di}/flags/${n}.svg`, s0 = "backoffice@fleequid.com", u0 = "+39 0287176063", c0 = {
  geocodeForward: {
    url: "https://api.mapbox.com/search/geocode/v6/forward",
    params: { types: "place,street,address" }
  }
}, A1 = {
  AD: "ca",
  AE: "ar",
  AF: "ps",
  AG: "en",
  AI: "en",
  AL: "sq",
  AM: "hy",
  AO: "pt",
  AQ: "en",
  AR: "es",
  AS: "sm",
  AT: "de",
  AU: "en",
  AW: "nl",
  AX: "sv",
  AZ: "az",
  BA: "bs",
  BB: "en",
  BD: "bn",
  BE: "fr",
  BF: "fr",
  BG: "bg",
  BH: "ar",
  BI: "rn",
  BJ: "fr",
  BL: "fr",
  BM: "en",
  BN: "ms",
  BO: "es",
  BQ: "nl",
  BR: "pt",
  BS: "en",
  BT: "dz",
  BV: "no",
  BW: "en",
  BY: "ru",
  BZ: "en",
  CA: "fr",
  CC: "en",
  CD: "fr",
  CF: "fr",
  CG: "fr",
  CH: "de",
  CI: "fr",
  CK: "en",
  CL: "es",
  CM: "fr",
  CN: "zh",
  CO: "es",
  CR: "es",
  CU: "es",
  CV: "pt",
  CW: "nl",
  CX: "en",
  CY: "el",
  CZ: "cs",
  DE: "de",
  DJ: "fr",
  DK: "da",
  DM: "en",
  DO: "es",
  DZ: "ar",
  EC: "es",
  EE: "et",
  EG: "ar",
  EH: "ar",
  ER: "ti",
  ES: "es",
  ET: "am",
  FI: "fi",
  FJ: "en",
  FK: "en",
  FM: "en",
  FO: "fo",
  FR: "fr",
  GA: "fr",
  GB: "en",
  GD: "en",
  GE: "ka",
  GF: "fr",
  GG: "en",
  GH: "en",
  GI: "en",
  GL: "kl",
  GM: "en",
  GN: "fr",
  GP: "fr",
  GQ: "es",
  GR: "el",
  GS: "en",
  GT: "es",
  GU: "en",
  GW: "pt",
  GY: "en",
  HK: "zh",
  HM: "en",
  HN: "es",
  HR: "hr",
  HT: "fr",
  HU: "hu",
  ID: "id",
  IE: "en",
  IL: "he",
  IM: "en",
  IN: "hi",
  IO: "en",
  IQ: "ar",
  IR: "fa",
  IS: "is",
  IT: "it",
  JE: "en",
  JM: "en",
  JO: "ar",
  JP: "ja",
  KE: "sw",
  KG: "ru",
  KH: "km",
  KI: "en",
  KM: "ar",
  KN: "en",
  KP: "ko",
  KR: "ko",
  KW: "ar",
  KY: "en",
  KZ: "ru",
  LA: "lo",
  LB: "ar",
  LC: "en",
  LI: "de",
  LK: "si",
  LR: "en",
  LS: "st",
  LT: "lt",
  LU: "de",
  LV: "lv",
  LY: "ar",
  MA: "ar",
  MC: "fr",
  MD: "ro",
  ME: "sr",
  MF: "fr",
  MG: "fr",
  MH: "en",
  MK: "mk",
  ML: "fr",
  MM: "my",
  MN: "mn",
  MO: "zh",
  MP: "en",
  MQ: "fr",
  MR: "ar",
  MS: "en",
  MT: "mt",
  MU: "en",
  MV: "dv",
  MW: "ny",
  MX: "es",
  MY: "ms",
  MZ: "pt",
  NA: "en",
  NC: "fr",
  NE: "fr",
  NF: "en",
  NG: "en",
  NI: "es",
  NL: "nl",
  NO: "no",
  NP: "ne",
  NR: "en",
  NU: "en",
  NZ: "en",
  OM: "ar",
  PA: "es",
  PE: "es",
  PF: "fr",
  PG: "en",
  PH: "tl",
  PK: "ur",
  PL: "pl",
  PM: "fr",
  PN: "en",
  PR: "es",
  PS: "ar",
  PT: "pt",
  PW: "en",
  PY: "es",
  QA: "ar",
  RE: "fr",
  RO: "ro",
  RS: "sr",
  RU: "ru",
  RW: "fr",
  SA: "ar",
  SB: "en",
  SC: "en",
  SD: "ar",
  SE: "sv",
  SG: "en",
  SH: "en",
  SI: "sl",
  SJ: "no",
  SK: "sk",
  SL: "en",
  SM: "it",
  SN: "fr",
  SO: "so",
  SR: "nl",
  SS: "en",
  ST: "pt",
  SV: "es",
  SX: "nl",
  SY: "ar",
  SZ: "ss",
  TC: "en",
  TD: "fr",
  TF: "fr",
  TG: "fr",
  TH: "th",
  TJ: "tg",
  TK: "en",
  TL: "pt",
  TM: "tk",
  TN: "ar",
  TO: "to",
  TR: "tr",
  TT: "en",
  TV: "en",
  TW: "zh",
  TZ: "sw",
  UA: "uk",
  UG: "en",
  UM: "en",
  US: "en",
  UY: "es",
  UZ: "uz",
  VA: "it",
  VC: "en",
  VE: "es",
  VG: "en",
  VI: "en",
  VN: "vi",
  VU: "bi",
  WF: "fr",
  WS: "sm",
  XK: "sq",
  YE: "ar",
  YT: "fr",
  ZA: "en",
  ZM: "en",
  ZW: "en"
};
function l0(n) {
  return A1[n];
}
const d0 = {
  cs: "CZ",
  de: "DE",
  en: "GB",
  es: "ES",
  fr: "FR",
  it: "IT",
  nl: "NL",
  pl: "PL",
  pt: "PT",
  ro: "RO",
  ru: "RU"
}, p0 = 2, f0 = 100, wc = {
  addressNumber: ye().optional().nullable(),
  alternate: ye().optional().nullable(),
  country: ye(),
  countryCode: ye(),
  fullAddress: ye(),
  latitude: Gu(),
  longitude: Gu(),
  mapboxId: ye(),
  place: ye(),
  postcode: ye().optional().nullable(),
  region: ye(),
  streetName: ye().optional().nullable()
}, h0 = Xt(wc), m0 = (n) => Xt(wc, { error: n }), T1 = "AdminUserPasswordResetToken", _0 = Xt({
  type: KS(T1),
  adminUserId: ye(),
  /**
   * NB: this field is consumed by the client only, only has a presentational purposes
   */
  email: ye()
}), C1 = /^\+[1-9]\d{1,14}$/, g0 = (n) => /^[+]?[\s0-9]{6,}$/.test(n), Mc = (n) => typeof n != "string" || (n.match(/\s/g)?.length ?? 0) > 1 ? !1 : C1.test(n.replace(/\s/g, "")), kc = "Phone must be in E.164 format (e.g. +393331234567)", v0 = () => ye().refine(Mc, { message: kc }), I0 = () => ye().refine((n) => !n || Mc(n), { message: kc }).optional(), Bc = ye().min(5).brand("Tin");
function b0(n) {
  return Bc.safeParse(n).success;
}
function y1(n) {
  const t = Bc.safeParse(n);
  if (t.success)
    return t.data;
  throw new Error(`Could not parse '${n}' as Tin: ${t.error.issues.map(({ message: o }) => o).join(", ")}`);
}
function S0(n) {
  return y1(n.replace(/[^a-zA-Z0-9]/g, ""));
}
const A0 = (n) => Math.ceil(n * 1.35962), T0 = (n, ...t) => n ? t.map((o) => typeof o == "function" ? o() : o) : [];
function E1(n) {
  return n.length > 0 && !!n[0] && typeof n[0] == "object";
}
const C0 = (n) => {
  if (!n)
    return {};
  const o = Object.keys(n).map((a) => Array.isArray(n[a]) && n[a].length > 0 ? E1(n[a]) ? n[a].map(
    (u, f) => Object.keys(u).map((p) => [`${a}[${f}][${p}]`, u[p]])
  ).flat() : [[`${a}[]`, n[a]]] : n[a] !== null && typeof n[a] == "object" && !Array.isArray(n[a]) ? Object.keys(n[a]).map((u) => [`${a}[${u}]`, n[a][u]]) : [[a, n[a]]]).flat();
  return Object.fromEntries(o);
};
var Ut = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Kr = { exports: {} };
var N1 = Kr.exports, Hu;
function x1() {
  return Hu || (Hu = 1, (function(n, t) {
    (function() {
      var o, a = "4.18.1", u = 200, f = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", p = "Expected a function", g = "Invalid `variable` option passed into `_.template`", S = "Invalid `imports` option passed into `_.template`", E = "__lodash_hash_undefined__", w = 500, G = "__lodash_placeholder__", B = 1, L = 2, ae = 4, ee = 1, cn = 2, ke = 1, bn = 2, Be = 4, ne = 8, me = 16, nn = 32, Pn = 64, ln = 128, Ir = 256, Qt = 512, Fc = 30, Gc = "...", Dc = 800, Zc = 16, Ui = 1, Uc = 2, $c = 3, Rn = 1 / 0, Sn = 9007199254740991, Kc = 17976931348623157e292, Vr = NaN, rn = 4294967295, Hc = rn - 1, qc = rn >>> 1, Wc = [
        ["ary", ln],
        ["bind", ke],
        ["bindKey", bn],
        ["curry", ne],
        ["curryRight", me],
        ["flip", Qt],
        ["partial", nn],
        ["partialRight", Pn],
        ["rearg", Ir]
      ], Jn = "[object Arguments]", Jr = "[object Array]", Vc = "[object AsyncFunction]", br = "[object Boolean]", Sr = "[object Date]", Jc = "[object DOMException]", jr = "[object Error]", Yr = "[object Function]", $i = "[object GeneratorFunction]", Ve = "[object Map]", Ar = "[object Number]", jc = "[object Null]", dn = "[object Object]", Ki = "[object Promise]", Yc = "[object Proxy]", Tr = "[object RegExp]", Je = "[object Set]", Cr = "[object String]", Xr = "[object Symbol]", Xc = "[object Undefined]", yr = "[object WeakMap]", Qc = "[object WeakSet]", Er = "[object ArrayBuffer]", jn = "[object DataView]", eo = "[object Float32Array]", no = "[object Float64Array]", ro = "[object Int8Array]", to = "[object Int16Array]", oo = "[object Int32Array]", io = "[object Uint8Array]", ao = "[object Uint8ClampedArray]", so = "[object Uint16Array]", uo = "[object Uint32Array]", el = /\b__p \+= '';/g, nl = /\b(__p \+=) '' \+/g, rl = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Hi = /&(?:amp|lt|gt|quot|#39);/g, qi = /[&<>"']/g, tl = RegExp(Hi.source), ol = RegExp(qi.source), il = /<%-([\s\S]+?)%>/g, al = /<%([\s\S]+?)%>/g, Wi = /<%=([\s\S]+?)%>/g, sl = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ul = /^\w*$/, cl = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, co = /[\\^$.*+?()[\]{}|]/g, ll = RegExp(co.source), lo = /^\s+/, dl = /\s/, pl = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, fl = /\{\n\/\* \[wrapped with (.+)\] \*/, hl = /,? & /, ml = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Vi = /[()=,{}\[\]\/\s]/, _l = /\\(\\)?/g, gl = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ji = /\w*$/, vl = /^[-+]0x[0-9a-f]+$/i, Il = /^0b[01]+$/i, bl = /^\[object .+?Constructor\]$/, Sl = /^0o[0-7]+$/i, Al = /^(?:0|[1-9]\d*)$/, Tl = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Qr = /($^)/, Cl = /['\n\r\u2028\u2029\\]/g, et = "\\ud800-\\udfff", yl = "\\u0300-\\u036f", El = "\\ufe20-\\ufe2f", Nl = "\\u20d0-\\u20ff", ji = yl + El + Nl, Yi = "\\u2700-\\u27bf", Xi = "a-z\\xdf-\\xf6\\xf8-\\xff", xl = "\\xac\\xb1\\xd7\\xf7", wl = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ml = "\\u2000-\\u206f", kl = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Qi = "A-Z\\xc0-\\xd6\\xd8-\\xde", ea = "\\ufe0e\\ufe0f", na = xl + wl + Ml + kl, po = "['’]", Bl = "[" + et + "]", ra = "[" + na + "]", nt = "[" + ji + "]", ta = "\\d+", Pl = "[" + Yi + "]", oa = "[" + Xi + "]", ia = "[^" + et + na + ta + Yi + Xi + Qi + "]", fo = "\\ud83c[\\udffb-\\udfff]", Rl = "(?:" + nt + "|" + fo + ")", aa = "[^" + et + "]", ho = "(?:\\ud83c[\\udde6-\\uddff]){2}", mo = "[\\ud800-\\udbff][\\udc00-\\udfff]", Yn = "[" + Qi + "]", sa = "\\u200d", ua = "(?:" + oa + "|" + ia + ")", Ol = "(?:" + Yn + "|" + ia + ")", ca = "(?:" + po + "(?:d|ll|m|re|s|t|ve))?", la = "(?:" + po + "(?:D|LL|M|RE|S|T|VE))?", da = Rl + "?", pa = "[" + ea + "]?", zl = "(?:" + sa + "(?:" + [aa, ho, mo].join("|") + ")" + pa + da + ")*", Ll = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Fl = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", fa = pa + da + zl, Gl = "(?:" + [Pl, ho, mo].join("|") + ")" + fa, Dl = "(?:" + [aa + nt + "?", nt, ho, mo, Bl].join("|") + ")", Zl = RegExp(po, "g"), Ul = RegExp(nt, "g"), _o = RegExp(fo + "(?=" + fo + ")|" + Dl + fa, "g"), $l = RegExp([
        Yn + "?" + oa + "+" + ca + "(?=" + [ra, Yn, "$"].join("|") + ")",
        Ol + "+" + la + "(?=" + [ra, Yn + ua, "$"].join("|") + ")",
        Yn + "?" + ua + "+" + ca,
        Yn + "+" + la,
        Fl,
        Ll,
        ta,
        Gl
      ].join("|"), "g"), Kl = RegExp("[" + sa + et + ji + ea + "]"), Hl = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, ql = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], Wl = -1, Q = {};
      Q[eo] = Q[no] = Q[ro] = Q[to] = Q[oo] = Q[io] = Q[ao] = Q[so] = Q[uo] = !0, Q[Jn] = Q[Jr] = Q[Er] = Q[br] = Q[jn] = Q[Sr] = Q[jr] = Q[Yr] = Q[Ve] = Q[Ar] = Q[dn] = Q[Tr] = Q[Je] = Q[Cr] = Q[yr] = !1;
      var X = {};
      X[Jn] = X[Jr] = X[Er] = X[jn] = X[br] = X[Sr] = X[eo] = X[no] = X[ro] = X[to] = X[oo] = X[Ve] = X[Ar] = X[dn] = X[Tr] = X[Je] = X[Cr] = X[Xr] = X[io] = X[ao] = X[so] = X[uo] = !0, X[jr] = X[Yr] = X[yr] = !1;
      var Vl = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, Jl = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, jl = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, Yl = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, Xl = parseFloat, Ql = parseInt, ha = typeof Ut == "object" && Ut && Ut.Object === Object && Ut, ed = typeof self == "object" && self && self.Object === Object && self, _e = ha || ed || Function("return this")(), go = t && !t.nodeType && t, On = go && !0 && n && !n.nodeType && n, ma = On && On.exports === go, vo = ma && ha.process, De = (function() {
        try {
          var _ = On && On.require && On.require("util").types;
          return _ || vo && vo.binding && vo.binding("util");
        } catch {
        }
      })(), _a = De && De.isArrayBuffer, ga = De && De.isDate, va = De && De.isMap, Ia = De && De.isRegExp, ba = De && De.isSet, Sa = De && De.isTypedArray;
      function Pe(_, b, I) {
        switch (I.length) {
          case 0:
            return _.call(b);
          case 1:
            return _.call(b, I[0]);
          case 2:
            return _.call(b, I[0], I[1]);
          case 3:
            return _.call(b, I[0], I[1], I[2]);
        }
        return _.apply(b, I);
      }
      function nd(_, b, I, x) {
        for (var F = -1, W = _ == null ? 0 : _.length; ++F < W; ) {
          var pe = _[F];
          b(x, pe, I(pe), _);
        }
        return x;
      }
      function Re(_, b) {
        for (var I = -1, x = _ == null ? 0 : _.length; ++I < x && b(_[I], I, _) !== !1; )
          ;
        return _;
      }
      function rd(_, b) {
        for (var I = _ == null ? 0 : _.length; I-- && b(_[I], I, _) !== !1; )
          ;
        return _;
      }
      function Aa(_, b) {
        for (var I = -1, x = _ == null ? 0 : _.length; ++I < x; )
          if (!b(_[I], I, _))
            return !1;
        return !0;
      }
      function An(_, b) {
        for (var I = -1, x = _ == null ? 0 : _.length, F = 0, W = []; ++I < x; ) {
          var pe = _[I];
          b(pe, I, _) && (W[F++] = pe);
        }
        return W;
      }
      function rt(_, b) {
        var I = _ == null ? 0 : _.length;
        return !!I && Xn(_, b, 0) > -1;
      }
      function Io(_, b, I) {
        for (var x = -1, F = _ == null ? 0 : _.length; ++x < F; )
          if (I(b, _[x]))
            return !0;
        return !1;
      }
      function re(_, b) {
        for (var I = -1, x = _ == null ? 0 : _.length, F = Array(x); ++I < x; )
          F[I] = b(_[I], I, _);
        return F;
      }
      function Tn(_, b) {
        for (var I = -1, x = b.length, F = _.length; ++I < x; )
          _[F + I] = b[I];
        return _;
      }
      function bo(_, b, I, x) {
        var F = -1, W = _ == null ? 0 : _.length;
        for (x && W && (I = _[++F]); ++F < W; )
          I = b(I, _[F], F, _);
        return I;
      }
      function td(_, b, I, x) {
        var F = _ == null ? 0 : _.length;
        for (x && F && (I = _[--F]); F--; )
          I = b(I, _[F], F, _);
        return I;
      }
      function So(_, b) {
        for (var I = -1, x = _ == null ? 0 : _.length; ++I < x; )
          if (b(_[I], I, _))
            return !0;
        return !1;
      }
      var od = Ao("length");
      function id(_) {
        return _.split("");
      }
      function ad(_) {
        return _.match(ml) || [];
      }
      function Ta(_, b, I) {
        var x;
        return I(_, function(F, W, pe) {
          if (b(F, W, pe))
            return x = W, !1;
        }), x;
      }
      function tt(_, b, I, x) {
        for (var F = _.length, W = I + (x ? 1 : -1); x ? W-- : ++W < F; )
          if (b(_[W], W, _))
            return W;
        return -1;
      }
      function Xn(_, b, I) {
        return b === b ? vd(_, b, I) : tt(_, Ca, I);
      }
      function sd(_, b, I, x) {
        for (var F = I - 1, W = _.length; ++F < W; )
          if (x(_[F], b))
            return F;
        return -1;
      }
      function Ca(_) {
        return _ !== _;
      }
      function ya(_, b) {
        var I = _ == null ? 0 : _.length;
        return I ? Co(_, b) / I : Vr;
      }
      function Ao(_) {
        return function(b) {
          return b == null ? o : b[_];
        };
      }
      function To(_) {
        return function(b) {
          return _ == null ? o : _[b];
        };
      }
      function Ea(_, b, I, x, F) {
        return F(_, function(W, pe, Y) {
          I = x ? (x = !1, W) : b(I, W, pe, Y);
        }), I;
      }
      function ud(_, b) {
        var I = _.length;
        for (_.sort(b); I--; )
          _[I] = _[I].value;
        return _;
      }
      function Co(_, b) {
        for (var I, x = -1, F = _.length; ++x < F; ) {
          var W = b(_[x]);
          W !== o && (I = I === o ? W : I + W);
        }
        return I;
      }
      function yo(_, b) {
        for (var I = -1, x = Array(_); ++I < _; )
          x[I] = b(I);
        return x;
      }
      function cd(_, b) {
        return re(b, function(I) {
          return [I, _[I]];
        });
      }
      function Na(_) {
        return _ && _.slice(0, ka(_) + 1).replace(lo, "");
      }
      function Oe(_) {
        return function(b) {
          return _(b);
        };
      }
      function Eo(_, b) {
        return re(b, function(I) {
          return _[I];
        });
      }
      function Nr(_, b) {
        return _.has(b);
      }
      function xa(_, b) {
        for (var I = -1, x = _.length; ++I < x && Xn(b, _[I], 0) > -1; )
          ;
        return I;
      }
      function wa(_, b) {
        for (var I = _.length; I-- && Xn(b, _[I], 0) > -1; )
          ;
        return I;
      }
      function ld(_, b) {
        for (var I = _.length, x = 0; I--; )
          _[I] === b && ++x;
        return x;
      }
      var dd = To(Vl), pd = To(Jl);
      function fd(_) {
        return "\\" + Yl[_];
      }
      function hd(_, b) {
        return _ == null ? o : _[b];
      }
      function Qn(_) {
        return Kl.test(_);
      }
      function md(_) {
        return Hl.test(_);
      }
      function _d(_) {
        for (var b, I = []; !(b = _.next()).done; )
          I.push(b.value);
        return I;
      }
      function No(_) {
        var b = -1, I = Array(_.size);
        return _.forEach(function(x, F) {
          I[++b] = [F, x];
        }), I;
      }
      function Ma(_, b) {
        return function(I) {
          return _(b(I));
        };
      }
      function Cn(_, b) {
        for (var I = -1, x = _.length, F = 0, W = []; ++I < x; ) {
          var pe = _[I];
          (pe === b || pe === G) && (_[I] = G, W[F++] = I);
        }
        return W;
      }
      function ot(_) {
        var b = -1, I = Array(_.size);
        return _.forEach(function(x) {
          I[++b] = x;
        }), I;
      }
      function gd(_) {
        var b = -1, I = Array(_.size);
        return _.forEach(function(x) {
          I[++b] = [x, x];
        }), I;
      }
      function vd(_, b, I) {
        for (var x = I - 1, F = _.length; ++x < F; )
          if (_[x] === b)
            return x;
        return -1;
      }
      function Id(_, b, I) {
        for (var x = I + 1; x--; )
          if (_[x] === b)
            return x;
        return x;
      }
      function er(_) {
        return Qn(_) ? Sd(_) : od(_);
      }
      function je(_) {
        return Qn(_) ? Ad(_) : id(_);
      }
      function ka(_) {
        for (var b = _.length; b-- && dl.test(_.charAt(b)); )
          ;
        return b;
      }
      var bd = To(jl);
      function Sd(_) {
        for (var b = _o.lastIndex = 0; _o.test(_); )
          ++b;
        return b;
      }
      function Ad(_) {
        return _.match(_o) || [];
      }
      function Td(_) {
        return _.match($l) || [];
      }
      var Cd = (function _(b) {
        b = b == null ? _e : nr.defaults(_e.Object(), b, nr.pick(_e, ql));
        var I = b.Array, x = b.Date, F = b.Error, W = b.Function, pe = b.Math, Y = b.Object, xo = b.RegExp, yd = b.String, Ze = b.TypeError, it = I.prototype, Ed = W.prototype, rr = Y.prototype, at = b["__core-js_shared__"], st = Ed.toString, V = rr.hasOwnProperty, Nd = 0, Ba = (function() {
          var e = /[^.]+$/.exec(at && at.keys && at.keys.IE_PROTO || "");
          return e ? "Symbol(src)_1." + e : "";
        })(), ut = rr.toString, xd = st.call(Y), wd = _e._, Md = xo(
          "^" + st.call(V).replace(co, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), ct = ma ? b.Buffer : o, yn = b.Symbol, lt = b.Uint8Array, Pa = ct ? ct.allocUnsafe : o, dt = Ma(Y.getPrototypeOf, Y), Ra = Y.create, Oa = rr.propertyIsEnumerable, pt = it.splice, za = yn ? yn.isConcatSpreadable : o, xr = yn ? yn.iterator : o, zn = yn ? yn.toStringTag : o, ft = (function() {
          try {
            var e = Zn(Y, "defineProperty");
            return e({}, "", {}), e;
          } catch {
          }
        })(), kd = b.clearTimeout !== _e.clearTimeout && b.clearTimeout, Bd = x && x.now !== _e.Date.now && x.now, Pd = b.setTimeout !== _e.setTimeout && b.setTimeout, ht = pe.ceil, mt = pe.floor, wo = Y.getOwnPropertySymbols, Rd = ct ? ct.isBuffer : o, La = b.isFinite, Od = it.join, zd = Ma(Y.keys, Y), fe = pe.max, Ie = pe.min, Ld = x.now, Fd = b.parseInt, Fa = pe.random, Gd = it.reverse, Mo = Zn(b, "DataView"), wr = Zn(b, "Map"), ko = Zn(b, "Promise"), tr = Zn(b, "Set"), Mr = Zn(b, "WeakMap"), kr = Zn(Y, "create"), _t = Mr && new Mr(), or = {}, Dd = Un(Mo), Zd = Un(wr), Ud = Un(ko), $d = Un(tr), Kd = Un(Mr), gt = yn ? yn.prototype : o, Br = gt ? gt.valueOf : o, Ga = gt ? gt.toString : o;
        function l(e) {
          if (se(e) && !D(e) && !(e instanceof H)) {
            if (e instanceof Ue)
              return e;
            if (V.call(e, "__wrapped__"))
              return Ds(e);
          }
          return new Ue(e);
        }
        var ir = /* @__PURE__ */ (function() {
          function e() {
          }
          return function(r) {
            if (!oe(r))
              return {};
            if (Ra)
              return Ra(r);
            e.prototype = r;
            var i = new e();
            return e.prototype = o, i;
          };
        })();
        function vt() {
        }
        function Ue(e, r) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!r, this.__index__ = 0, this.__values__ = o;
        }
        l.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: il,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: al,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Wi,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: l
          }
        }, l.prototype = vt.prototype, l.prototype.constructor = l, Ue.prototype = ir(vt.prototype), Ue.prototype.constructor = Ue;
        function H(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = rn, this.__views__ = [];
        }
        function Hd() {
          var e = new H(this.__wrapped__);
          return e.__actions__ = Ee(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Ee(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Ee(this.__views__), e;
        }
        function qd() {
          if (this.__filtered__) {
            var e = new H(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else
            e = this.clone(), e.__dir__ *= -1;
          return e;
        }
        function Wd() {
          var e = this.__wrapped__.value(), r = this.__dir__, i = D(e), s = r < 0, c = i ? e.length : 0, d = af(0, c, this.__views__), h = d.start, m = d.end, v = m - h, A = s ? m : h - 1, C = this.__iteratees__, y = C.length, N = 0, M = Ie(v, this.__takeCount__);
          if (!i || !s && c == v && M == v)
            return cs(e, this.__actions__);
          var z = [];
          e:
            for (; v-- && N < M; ) {
              A += r;
              for (var U = -1, R = e[A]; ++U < y; ) {
                var K = C[U], q = K.iteratee, Fe = K.type, Te = q(R);
                if (Fe == Uc)
                  R = Te;
                else if (!Te) {
                  if (Fe == Ui)
                    continue e;
                  break e;
                }
              }
              z[N++] = R;
            }
          return z;
        }
        H.prototype = ir(vt.prototype), H.prototype.constructor = H;
        function Ln(e) {
          var r = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++r < i; ) {
            var s = e[r];
            this.set(s[0], s[1]);
          }
        }
        function Vd() {
          this.__data__ = kr ? kr(null) : {}, this.size = 0;
        }
        function Jd(e) {
          var r = this.has(e) && delete this.__data__[e];
          return this.size -= r ? 1 : 0, r;
        }
        function jd(e) {
          var r = this.__data__;
          if (kr) {
            var i = r[e];
            return i === E ? o : i;
          }
          return V.call(r, e) ? r[e] : o;
        }
        function Yd(e) {
          var r = this.__data__;
          return kr ? r[e] !== o : V.call(r, e);
        }
        function Xd(e, r) {
          var i = this.__data__;
          return this.size += this.has(e) ? 0 : 1, i[e] = kr && r === o ? E : r, this;
        }
        Ln.prototype.clear = Vd, Ln.prototype.delete = Jd, Ln.prototype.get = jd, Ln.prototype.has = Yd, Ln.prototype.set = Xd;
        function pn(e) {
          var r = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++r < i; ) {
            var s = e[r];
            this.set(s[0], s[1]);
          }
        }
        function Qd() {
          this.__data__ = [], this.size = 0;
        }
        function ep(e) {
          var r = this.__data__, i = It(r, e);
          if (i < 0)
            return !1;
          var s = r.length - 1;
          return i == s ? r.pop() : pt.call(r, i, 1), --this.size, !0;
        }
        function np(e) {
          var r = this.__data__, i = It(r, e);
          return i < 0 ? o : r[i][1];
        }
        function rp(e) {
          return It(this.__data__, e) > -1;
        }
        function tp(e, r) {
          var i = this.__data__, s = It(i, e);
          return s < 0 ? (++this.size, i.push([e, r])) : i[s][1] = r, this;
        }
        pn.prototype.clear = Qd, pn.prototype.delete = ep, pn.prototype.get = np, pn.prototype.has = rp, pn.prototype.set = tp;
        function fn(e) {
          var r = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++r < i; ) {
            var s = e[r];
            this.set(s[0], s[1]);
          }
        }
        function op() {
          this.size = 0, this.__data__ = {
            hash: new Ln(),
            map: new (wr || pn)(),
            string: new Ln()
          };
        }
        function ip(e) {
          var r = kt(this, e).delete(e);
          return this.size -= r ? 1 : 0, r;
        }
        function ap(e) {
          return kt(this, e).get(e);
        }
        function sp(e) {
          return kt(this, e).has(e);
        }
        function up(e, r) {
          var i = kt(this, e), s = i.size;
          return i.set(e, r), this.size += i.size == s ? 0 : 1, this;
        }
        fn.prototype.clear = op, fn.prototype.delete = ip, fn.prototype.get = ap, fn.prototype.has = sp, fn.prototype.set = up;
        function Fn(e) {
          var r = -1, i = e == null ? 0 : e.length;
          for (this.__data__ = new fn(); ++r < i; )
            this.add(e[r]);
        }
        function cp(e) {
          return this.__data__.set(e, E), this;
        }
        function lp(e) {
          return this.__data__.has(e);
        }
        Fn.prototype.add = Fn.prototype.push = cp, Fn.prototype.has = lp;
        function Ye(e) {
          var r = this.__data__ = new pn(e);
          this.size = r.size;
        }
        function dp() {
          this.__data__ = new pn(), this.size = 0;
        }
        function pp(e) {
          var r = this.__data__, i = r.delete(e);
          return this.size = r.size, i;
        }
        function fp(e) {
          return this.__data__.get(e);
        }
        function hp(e) {
          return this.__data__.has(e);
        }
        function mp(e, r) {
          var i = this.__data__;
          if (i instanceof pn) {
            var s = i.__data__;
            if (!wr || s.length < u - 1)
              return s.push([e, r]), this.size = ++i.size, this;
            i = this.__data__ = new fn(s);
          }
          return i.set(e, r), this.size = i.size, this;
        }
        Ye.prototype.clear = dp, Ye.prototype.delete = pp, Ye.prototype.get = fp, Ye.prototype.has = hp, Ye.prototype.set = mp;
        function Da(e, r) {
          var i = D(e), s = !i && $n(e), c = !i && !s && Mn(e), d = !i && !s && !c && cr(e), h = i || s || c || d, m = h ? yo(e.length, yd) : [], v = m.length;
          for (var A in e)
            (r || V.call(e, A)) && !(h && // Safari 9 has enumerable `arguments.length` in strict mode.
            (A == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            c && (A == "offset" || A == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            d && (A == "buffer" || A == "byteLength" || A == "byteOffset") || // Skip index properties.
            _n(A, v))) && m.push(A);
          return m;
        }
        function Za(e) {
          var r = e.length;
          return r ? e[Uo(0, r - 1)] : o;
        }
        function _p(e, r) {
          return Bt(Ee(e), Gn(r, 0, e.length));
        }
        function gp(e) {
          return Bt(Ee(e));
        }
        function Bo(e, r, i) {
          (i !== o && !Qe(e[r], i) || i === o && !(r in e)) && tn(e, r, i);
        }
        function Pr(e, r, i) {
          var s = e[r];
          (!(V.call(e, r) && Qe(s, i)) || i === o && !(r in e)) && tn(e, r, i);
        }
        function It(e, r) {
          for (var i = e.length; i--; )
            if (Qe(e[i][0], r))
              return i;
          return -1;
        }
        function vp(e, r, i, s) {
          return En(e, function(c, d, h) {
            r(s, c, i(c), h);
          }), s;
        }
        function Ua(e, r) {
          return e && an(r, he(r), e);
        }
        function Ip(e, r) {
          return e && an(r, xe(r), e);
        }
        function tn(e, r, i) {
          r == "__proto__" && ft ? ft(e, r, {
            configurable: !0,
            enumerable: !0,
            value: i,
            writable: !0
          }) : e[r] = i;
        }
        function Po(e, r) {
          for (var i = -1, s = r.length, c = I(s), d = e == null; ++i < s; )
            c[i] = d ? o : hi(e, r[i]);
          return c;
        }
        function Gn(e, r, i) {
          return e === e && (i !== o && (e = e <= i ? e : i), r !== o && (e = e >= r ? e : r)), e;
        }
        function $e(e, r, i, s, c, d) {
          var h, m = r & B, v = r & L, A = r & ae;
          if (i && (h = c ? i(e, s, c, d) : i(e)), h !== o)
            return h;
          if (!oe(e))
            return e;
          var C = D(e);
          if (C) {
            if (h = uf(e), !m)
              return Ee(e, h);
          } else {
            var y = be(e), N = y == Yr || y == $i;
            if (Mn(e))
              return ps(e, m);
            if (y == dn || y == Jn || N && !c) {
              if (h = v || N ? {} : ks(e), !m)
                return v ? jp(e, Ip(h, e)) : Jp(e, Ua(h, e));
            } else {
              if (!X[y])
                return c ? e : {};
              h = cf(e, y, m);
            }
          }
          d || (d = new Ye());
          var M = d.get(e);
          if (M)
            return M;
          d.set(e, h), au(e) ? e.forEach(function(R) {
            h.add($e(R, r, i, R, e, d));
          }) : ou(e) && e.forEach(function(R, K) {
            h.set(K, $e(R, r, i, K, e, d));
          });
          var z = A ? v ? Qo : Xo : v ? xe : he, U = C ? o : z(e);
          return Re(U || e, function(R, K) {
            U && (K = R, R = e[K]), Pr(h, K, $e(R, r, i, K, e, d));
          }), h;
        }
        function bp(e) {
          var r = he(e);
          return function(i) {
            return $a(i, e, r);
          };
        }
        function $a(e, r, i) {
          var s = i.length;
          if (e == null)
            return !s;
          for (e = Y(e); s--; ) {
            var c = i[s], d = r[c], h = e[c];
            if (h === o && !(c in e) || !d(h))
              return !1;
          }
          return !0;
        }
        function Ka(e, r, i) {
          if (typeof e != "function")
            throw new Ze(p);
          return Dr(function() {
            e.apply(o, i);
          }, r);
        }
        function Rr(e, r, i, s) {
          var c = -1, d = rt, h = !0, m = e.length, v = [], A = r.length;
          if (!m)
            return v;
          i && (r = re(r, Oe(i))), s ? (d = Io, h = !1) : r.length >= u && (d = Nr, h = !1, r = new Fn(r));
          e:
            for (; ++c < m; ) {
              var C = e[c], y = i == null ? C : i(C);
              if (C = s || C !== 0 ? C : 0, h && y === y) {
                for (var N = A; N--; )
                  if (r[N] === y)
                    continue e;
                v.push(C);
              } else d(r, y, s) || v.push(C);
            }
          return v;
        }
        var En = gs(on), Ha = gs(Oo, !0);
        function Sp(e, r) {
          var i = !0;
          return En(e, function(s, c, d) {
            return i = !!r(s, c, d), i;
          }), i;
        }
        function bt(e, r, i) {
          for (var s = -1, c = e.length; ++s < c; ) {
            var d = e[s], h = r(d);
            if (h != null && (m === o ? h === h && !Le(h) : i(h, m)))
              var m = h, v = d;
          }
          return v;
        }
        function Ap(e, r, i, s) {
          var c = e.length;
          for (i = Z(i), i < 0 && (i = -i > c ? 0 : c + i), s = s === o || s > c ? c : Z(s), s < 0 && (s += c), s = i > s ? 0 : uu(s); i < s; )
            e[i++] = r;
          return e;
        }
        function qa(e, r) {
          var i = [];
          return En(e, function(s, c, d) {
            r(s, c, d) && i.push(s);
          }), i;
        }
        function ge(e, r, i, s, c) {
          var d = -1, h = e.length;
          for (i || (i = df), c || (c = []); ++d < h; ) {
            var m = e[d];
            r > 0 && i(m) ? r > 1 ? ge(m, r - 1, i, s, c) : Tn(c, m) : s || (c[c.length] = m);
          }
          return c;
        }
        var Ro = vs(), Wa = vs(!0);
        function on(e, r) {
          return e && Ro(e, r, he);
        }
        function Oo(e, r) {
          return e && Wa(e, r, he);
        }
        function St(e, r) {
          return An(r, function(i) {
            return gn(e[i]);
          });
        }
        function Dn(e, r) {
          r = xn(r, e);
          for (var i = 0, s = r.length; e != null && i < s; )
            e = e[Xe(r[i++])];
          return i && i == s ? e : o;
        }
        function Va(e, r, i) {
          var s = r(e);
          return D(e) ? s : Tn(s, i(e));
        }
        function Se(e) {
          return e == null ? e === o ? Xc : jc : zn && zn in Y(e) ? of(e) : vf(e);
        }
        function zo(e, r) {
          return e > r;
        }
        function Tp(e, r) {
          return e != null && V.call(e, r);
        }
        function Cp(e, r) {
          return e != null && r in Y(e);
        }
        function yp(e, r, i) {
          return e >= Ie(r, i) && e < fe(r, i);
        }
        function Lo(e, r, i) {
          for (var s = i ? Io : rt, c = e[0].length, d = e.length, h = d, m = I(d), v = 1 / 0, A = []; h--; ) {
            var C = e[h];
            h && r && (C = re(C, Oe(r))), v = Ie(C.length, v), m[h] = !i && (r || c >= 120 && C.length >= 120) ? new Fn(h && C) : o;
          }
          C = e[0];
          var y = -1, N = m[0];
          e:
            for (; ++y < c && A.length < v; ) {
              var M = C[y], z = r ? r(M) : M;
              if (M = i || M !== 0 ? M : 0, !(N ? Nr(N, z) : s(A, z, i))) {
                for (h = d; --h; ) {
                  var U = m[h];
                  if (!(U ? Nr(U, z) : s(e[h], z, i)))
                    continue e;
                }
                N && N.push(z), A.push(M);
              }
            }
          return A;
        }
        function Ep(e, r, i, s) {
          return on(e, function(c, d, h) {
            r(s, i(c), d, h);
          }), s;
        }
        function Or(e, r, i) {
          r = xn(r, e), e = Os(e, r);
          var s = e == null ? e : e[Xe(He(r))];
          return s == null ? o : Pe(s, e, i);
        }
        function Ja(e) {
          return se(e) && Se(e) == Jn;
        }
        function Np(e) {
          return se(e) && Se(e) == Er;
        }
        function xp(e) {
          return se(e) && Se(e) == Sr;
        }
        function zr(e, r, i, s, c) {
          return e === r ? !0 : e == null || r == null || !se(e) && !se(r) ? e !== e && r !== r : wp(e, r, i, s, zr, c);
        }
        function wp(e, r, i, s, c, d) {
          var h = D(e), m = D(r), v = h ? Jr : be(e), A = m ? Jr : be(r);
          v = v == Jn ? dn : v, A = A == Jn ? dn : A;
          var C = v == dn, y = A == dn, N = v == A;
          if (N && Mn(e)) {
            if (!Mn(r))
              return !1;
            h = !0, C = !1;
          }
          if (N && !C)
            return d || (d = new Ye()), h || cr(e) ? xs(e, r, i, s, c, d) : rf(e, r, v, i, s, c, d);
          if (!(i & ee)) {
            var M = C && V.call(e, "__wrapped__"), z = y && V.call(r, "__wrapped__");
            if (M || z) {
              var U = M ? e.value() : e, R = z ? r.value() : r;
              return d || (d = new Ye()), c(U, R, i, s, d);
            }
          }
          return N ? (d || (d = new Ye()), tf(e, r, i, s, c, d)) : !1;
        }
        function Mp(e) {
          return se(e) && be(e) == Ve;
        }
        function Fo(e, r, i, s) {
          var c = i.length, d = c, h = !s;
          if (e == null)
            return !d;
          for (e = Y(e); c--; ) {
            var m = i[c];
            if (h && m[2] ? m[1] !== e[m[0]] : !(m[0] in e))
              return !1;
          }
          for (; ++c < d; ) {
            m = i[c];
            var v = m[0], A = e[v], C = m[1];
            if (h && m[2]) {
              if (A === o && !(v in e))
                return !1;
            } else {
              var y = new Ye();
              if (s)
                var N = s(A, C, v, e, r, y);
              if (!(N === o ? zr(C, A, ee | cn, s, y) : N))
                return !1;
            }
          }
          return !0;
        }
        function ja(e) {
          if (!oe(e) || ff(e))
            return !1;
          var r = gn(e) ? Md : bl;
          return r.test(Un(e));
        }
        function kp(e) {
          return se(e) && Se(e) == Tr;
        }
        function Bp(e) {
          return se(e) && be(e) == Je;
        }
        function Pp(e) {
          return se(e) && Ft(e.length) && !!Q[Se(e)];
        }
        function Ya(e) {
          return typeof e == "function" ? e : e == null ? we : typeof e == "object" ? D(e) ? es(e[0], e[1]) : Qa(e) : bu(e);
        }
        function Go(e) {
          if (!Gr(e))
            return zd(e);
          var r = [];
          for (var i in Y(e))
            V.call(e, i) && i != "constructor" && r.push(i);
          return r;
        }
        function Rp(e) {
          if (!oe(e))
            return gf(e);
          var r = Gr(e), i = [];
          for (var s in e)
            s == "constructor" && (r || !V.call(e, s)) || i.push(s);
          return i;
        }
        function Do(e, r) {
          return e < r;
        }
        function Xa(e, r) {
          var i = -1, s = Ne(e) ? I(e.length) : [];
          return En(e, function(c, d, h) {
            s[++i] = r(c, d, h);
          }), s;
        }
        function Qa(e) {
          var r = ni(e);
          return r.length == 1 && r[0][2] ? Ps(r[0][0], r[0][1]) : function(i) {
            return i === e || Fo(i, e, r);
          };
        }
        function es(e, r) {
          return ti(e) && Bs(r) ? Ps(Xe(e), r) : function(i) {
            var s = hi(i, e);
            return s === o && s === r ? mi(i, e) : zr(r, s, ee | cn);
          };
        }
        function At(e, r, i, s, c) {
          e !== r && Ro(r, function(d, h) {
            if (c || (c = new Ye()), oe(d))
              Op(e, r, h, i, At, s, c);
            else {
              var m = s ? s(ii(e, h), d, h + "", e, r, c) : o;
              m === o && (m = d), Bo(e, h, m);
            }
          }, xe);
        }
        function Op(e, r, i, s, c, d, h) {
          var m = ii(e, i), v = ii(r, i), A = h.get(v);
          if (A) {
            Bo(e, i, A);
            return;
          }
          var C = d ? d(m, v, i + "", e, r, h) : o, y = C === o;
          if (y) {
            var N = D(v), M = !N && Mn(v), z = !N && !M && cr(v);
            C = v, N || M || z ? D(m) ? C = m : ue(m) ? C = Ee(m) : M ? (y = !1, C = ps(v, !0)) : z ? (y = !1, C = fs(v, !0)) : C = [] : Zr(v) || $n(v) ? (C = m, $n(m) ? C = cu(m) : (!oe(m) || gn(m)) && (C = ks(v))) : y = !1;
          }
          y && (h.set(v, C), c(C, v, s, d, h), h.delete(v)), Bo(e, i, C);
        }
        function ns(e, r) {
          var i = e.length;
          if (i)
            return r += r < 0 ? i : 0, _n(r, i) ? e[r] : o;
        }
        function rs(e, r, i) {
          r.length ? r = re(r, function(d) {
            return D(d) ? function(h) {
              return Dn(h, d.length === 1 ? d[0] : d);
            } : d;
          }) : r = [we];
          var s = -1;
          r = re(r, Oe(O()));
          var c = Xa(e, function(d, h, m) {
            var v = re(r, function(A) {
              return A(d);
            });
            return { criteria: v, index: ++s, value: d };
          });
          return ud(c, function(d, h) {
            return Vp(d, h, i);
          });
        }
        function zp(e, r) {
          return ts(e, r, function(i, s) {
            return mi(e, s);
          });
        }
        function ts(e, r, i) {
          for (var s = -1, c = r.length, d = {}; ++s < c; ) {
            var h = r[s], m = Dn(e, h);
            i(m, h) && Lr(d, xn(h, e), m);
          }
          return d;
        }
        function Lp(e) {
          return function(r) {
            return Dn(r, e);
          };
        }
        function Zo(e, r, i, s) {
          var c = s ? sd : Xn, d = -1, h = r.length, m = e;
          for (e === r && (r = Ee(r)), i && (m = re(e, Oe(i))); ++d < h; )
            for (var v = 0, A = r[d], C = i ? i(A) : A; (v = c(m, C, v, s)) > -1; )
              m !== e && pt.call(m, v, 1), pt.call(e, v, 1);
          return e;
        }
        function os(e, r) {
          for (var i = e ? r.length : 0, s = i - 1; i--; ) {
            var c = r[i];
            if (i == s || c !== d) {
              var d = c;
              _n(c) ? pt.call(e, c, 1) : Ho(e, c);
            }
          }
          return e;
        }
        function Uo(e, r) {
          return e + mt(Fa() * (r - e + 1));
        }
        function Fp(e, r, i, s) {
          for (var c = -1, d = fe(ht((r - e) / (i || 1)), 0), h = I(d); d--; )
            h[s ? d : ++c] = e, e += i;
          return h;
        }
        function $o(e, r) {
          var i = "";
          if (!e || r < 1 || r > Sn)
            return i;
          do
            r % 2 && (i += e), r = mt(r / 2), r && (e += e);
          while (r);
          return i;
        }
        function $(e, r) {
          return ai(Rs(e, r, we), e + "");
        }
        function Gp(e) {
          return Za(lr(e));
        }
        function Dp(e, r) {
          var i = lr(e);
          return Bt(i, Gn(r, 0, i.length));
        }
        function Lr(e, r, i, s) {
          if (!oe(e))
            return e;
          r = xn(r, e);
          for (var c = -1, d = r.length, h = d - 1, m = e; m != null && ++c < d; ) {
            var v = Xe(r[c]), A = i;
            if (v === "__proto__" || v === "constructor" || v === "prototype")
              return e;
            if (c != h) {
              var C = m[v];
              A = s ? s(C, v, m) : o, A === o && (A = oe(C) ? C : _n(r[c + 1]) ? [] : {});
            }
            Pr(m, v, A), m = m[v];
          }
          return e;
        }
        var is = _t ? function(e, r) {
          return _t.set(e, r), e;
        } : we, Zp = ft ? function(e, r) {
          return ft(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: gi(r),
            writable: !0
          });
        } : we;
        function Up(e) {
          return Bt(lr(e));
        }
        function Ke(e, r, i) {
          var s = -1, c = e.length;
          r < 0 && (r = -r > c ? 0 : c + r), i = i > c ? c : i, i < 0 && (i += c), c = r > i ? 0 : i - r >>> 0, r >>>= 0;
          for (var d = I(c); ++s < c; )
            d[s] = e[s + r];
          return d;
        }
        function $p(e, r) {
          var i;
          return En(e, function(s, c, d) {
            return i = r(s, c, d), !i;
          }), !!i;
        }
        function Tt(e, r, i) {
          var s = 0, c = e == null ? s : e.length;
          if (typeof r == "number" && r === r && c <= qc) {
            for (; s < c; ) {
              var d = s + c >>> 1, h = e[d];
              h !== null && !Le(h) && (i ? h <= r : h < r) ? s = d + 1 : c = d;
            }
            return c;
          }
          return Ko(e, r, we, i);
        }
        function Ko(e, r, i, s) {
          var c = 0, d = e == null ? 0 : e.length;
          if (d === 0)
            return 0;
          r = i(r);
          for (var h = r !== r, m = r === null, v = Le(r), A = r === o; c < d; ) {
            var C = mt((c + d) / 2), y = i(e[C]), N = y !== o, M = y === null, z = y === y, U = Le(y);
            if (h)
              var R = s || z;
            else A ? R = z && (s || N) : m ? R = z && N && (s || !M) : v ? R = z && N && !M && (s || !U) : M || U ? R = !1 : R = s ? y <= r : y < r;
            R ? c = C + 1 : d = C;
          }
          return Ie(d, Hc);
        }
        function as(e, r) {
          for (var i = -1, s = e.length, c = 0, d = []; ++i < s; ) {
            var h = e[i], m = r ? r(h) : h;
            if (!i || !Qe(m, v)) {
              var v = m;
              d[c++] = h === 0 ? 0 : h;
            }
          }
          return d;
        }
        function ss(e) {
          return typeof e == "number" ? e : Le(e) ? Vr : +e;
        }
        function ze(e) {
          if (typeof e == "string")
            return e;
          if (D(e))
            return re(e, ze) + "";
          if (Le(e))
            return Ga ? Ga.call(e) : "";
          var r = e + "";
          return r == "0" && 1 / e == -Rn ? "-0" : r;
        }
        function Nn(e, r, i) {
          var s = -1, c = rt, d = e.length, h = !0, m = [], v = m;
          if (i)
            h = !1, c = Io;
          else if (d >= u) {
            var A = r ? null : ef(e);
            if (A)
              return ot(A);
            h = !1, c = Nr, v = new Fn();
          } else
            v = r ? [] : m;
          e:
            for (; ++s < d; ) {
              var C = e[s], y = r ? r(C) : C;
              if (C = i || C !== 0 ? C : 0, h && y === y) {
                for (var N = v.length; N--; )
                  if (v[N] === y)
                    continue e;
                r && v.push(y), m.push(C);
              } else c(v, y, i) || (v !== m && v.push(y), m.push(C));
            }
          return m;
        }
        function Ho(e, r) {
          r = xn(r, e);
          var i = -1, s = r.length;
          if (!s)
            return !0;
          for (; ++i < s; ) {
            var c = Xe(r[i]);
            if (c === "__proto__" && !V.call(e, "__proto__") || (c === "constructor" || c === "prototype") && i < s - 1)
              return !1;
          }
          var d = Os(e, r);
          return d == null || delete d[Xe(He(r))];
        }
        function us(e, r, i, s) {
          return Lr(e, r, i(Dn(e, r)), s);
        }
        function Ct(e, r, i, s) {
          for (var c = e.length, d = s ? c : -1; (s ? d-- : ++d < c) && r(e[d], d, e); )
            ;
          return i ? Ke(e, s ? 0 : d, s ? d + 1 : c) : Ke(e, s ? d + 1 : 0, s ? c : d);
        }
        function cs(e, r) {
          var i = e;
          return i instanceof H && (i = i.value()), bo(r, function(s, c) {
            return c.func.apply(c.thisArg, Tn([s], c.args));
          }, i);
        }
        function qo(e, r, i) {
          var s = e.length;
          if (s < 2)
            return s ? Nn(e[0]) : [];
          for (var c = -1, d = I(s); ++c < s; )
            for (var h = e[c], m = -1; ++m < s; )
              m != c && (d[c] = Rr(d[c] || h, e[m], r, i));
          return Nn(ge(d, 1), r, i);
        }
        function ls(e, r, i) {
          for (var s = -1, c = e.length, d = r.length, h = {}; ++s < c; ) {
            var m = s < d ? r[s] : o;
            i(h, e[s], m);
          }
          return h;
        }
        function Wo(e) {
          return ue(e) ? e : [];
        }
        function Vo(e) {
          return typeof e == "function" ? e : we;
        }
        function xn(e, r) {
          return D(e) ? e : ti(e, r) ? [e] : Gs(J(e));
        }
        var Kp = $;
        function wn(e, r, i) {
          var s = e.length;
          return i = i === o ? s : i, !r && i >= s ? e : Ke(e, r, i);
        }
        var ds = kd || function(e) {
          return _e.clearTimeout(e);
        };
        function ps(e, r) {
          if (r)
            return e.slice();
          var i = e.length, s = Pa ? Pa(i) : new e.constructor(i);
          return e.copy(s), s;
        }
        function Jo(e) {
          var r = new e.constructor(e.byteLength);
          return new lt(r).set(new lt(e)), r;
        }
        function Hp(e, r) {
          var i = r ? Jo(e.buffer) : e.buffer;
          return new e.constructor(i, e.byteOffset, e.byteLength);
        }
        function qp(e) {
          var r = new e.constructor(e.source, Ji.exec(e));
          return r.lastIndex = e.lastIndex, r;
        }
        function Wp(e) {
          return Br ? Y(Br.call(e)) : {};
        }
        function fs(e, r) {
          var i = r ? Jo(e.buffer) : e.buffer;
          return new e.constructor(i, e.byteOffset, e.length);
        }
        function hs(e, r) {
          if (e !== r) {
            var i = e !== o, s = e === null, c = e === e, d = Le(e), h = r !== o, m = r === null, v = r === r, A = Le(r);
            if (!m && !A && !d && e > r || d && h && v && !m && !A || s && h && v || !i && v || !c)
              return 1;
            if (!s && !d && !A && e < r || A && i && c && !s && !d || m && i && c || !h && c || !v)
              return -1;
          }
          return 0;
        }
        function Vp(e, r, i) {
          for (var s = -1, c = e.criteria, d = r.criteria, h = c.length, m = i.length; ++s < h; ) {
            var v = hs(c[s], d[s]);
            if (v) {
              if (s >= m)
                return v;
              var A = i[s];
              return v * (A == "desc" ? -1 : 1);
            }
          }
          return e.index - r.index;
        }
        function ms(e, r, i, s) {
          for (var c = -1, d = e.length, h = i.length, m = -1, v = r.length, A = fe(d - h, 0), C = I(v + A), y = !s; ++m < v; )
            C[m] = r[m];
          for (; ++c < h; )
            (y || c < d) && (C[i[c]] = e[c]);
          for (; A--; )
            C[m++] = e[c++];
          return C;
        }
        function _s(e, r, i, s) {
          for (var c = -1, d = e.length, h = -1, m = i.length, v = -1, A = r.length, C = fe(d - m, 0), y = I(C + A), N = !s; ++c < C; )
            y[c] = e[c];
          for (var M = c; ++v < A; )
            y[M + v] = r[v];
          for (; ++h < m; )
            (N || c < d) && (y[M + i[h]] = e[c++]);
          return y;
        }
        function Ee(e, r) {
          var i = -1, s = e.length;
          for (r || (r = I(s)); ++i < s; )
            r[i] = e[i];
          return r;
        }
        function an(e, r, i, s) {
          var c = !i;
          i || (i = {});
          for (var d = -1, h = r.length; ++d < h; ) {
            var m = r[d], v = s ? s(i[m], e[m], m, i, e) : o;
            v === o && (v = e[m]), c ? tn(i, m, v) : Pr(i, m, v);
          }
          return i;
        }
        function Jp(e, r) {
          return an(e, ri(e), r);
        }
        function jp(e, r) {
          return an(e, ws(e), r);
        }
        function yt(e, r) {
          return function(i, s) {
            var c = D(i) ? nd : vp, d = r ? r() : {};
            return c(i, e, O(s, 2), d);
          };
        }
        function ar(e) {
          return $(function(r, i) {
            var s = -1, c = i.length, d = c > 1 ? i[c - 1] : o, h = c > 2 ? i[2] : o;
            for (d = e.length > 3 && typeof d == "function" ? (c--, d) : o, h && Ae(i[0], i[1], h) && (d = c < 3 ? o : d, c = 1), r = Y(r); ++s < c; ) {
              var m = i[s];
              m && e(r, m, s, d);
            }
            return r;
          });
        }
        function gs(e, r) {
          return function(i, s) {
            if (i == null)
              return i;
            if (!Ne(i))
              return e(i, s);
            for (var c = i.length, d = r ? c : -1, h = Y(i); (r ? d-- : ++d < c) && s(h[d], d, h) !== !1; )
              ;
            return i;
          };
        }
        function vs(e) {
          return function(r, i, s) {
            for (var c = -1, d = Y(r), h = s(r), m = h.length; m--; ) {
              var v = h[e ? m : ++c];
              if (i(d[v], v, d) === !1)
                break;
            }
            return r;
          };
        }
        function Yp(e, r, i) {
          var s = r & ke, c = Fr(e);
          function d() {
            var h = this && this !== _e && this instanceof d ? c : e;
            return h.apply(s ? i : this, arguments);
          }
          return d;
        }
        function Is(e) {
          return function(r) {
            r = J(r);
            var i = Qn(r) ? je(r) : o, s = i ? i[0] : r.charAt(0), c = i ? wn(i, 1).join("") : r.slice(1);
            return s[e]() + c;
          };
        }
        function sr(e) {
          return function(r) {
            return bo(vu(gu(r).replace(Zl, "")), e, "");
          };
        }
        function Fr(e) {
          return function() {
            var r = arguments;
            switch (r.length) {
              case 0:
                return new e();
              case 1:
                return new e(r[0]);
              case 2:
                return new e(r[0], r[1]);
              case 3:
                return new e(r[0], r[1], r[2]);
              case 4:
                return new e(r[0], r[1], r[2], r[3]);
              case 5:
                return new e(r[0], r[1], r[2], r[3], r[4]);
              case 6:
                return new e(r[0], r[1], r[2], r[3], r[4], r[5]);
              case 7:
                return new e(r[0], r[1], r[2], r[3], r[4], r[5], r[6]);
            }
            var i = ir(e.prototype), s = e.apply(i, r);
            return oe(s) ? s : i;
          };
        }
        function Xp(e, r, i) {
          var s = Fr(e);
          function c() {
            for (var d = arguments.length, h = I(d), m = d, v = ur(c); m--; )
              h[m] = arguments[m];
            var A = d < 3 && h[0] !== v && h[d - 1] !== v ? [] : Cn(h, v);
            if (d -= A.length, d < i)
              return Cs(
                e,
                r,
                Et,
                c.placeholder,
                o,
                h,
                A,
                o,
                o,
                i - d
              );
            var C = this && this !== _e && this instanceof c ? s : e;
            return Pe(C, this, h);
          }
          return c;
        }
        function bs(e) {
          return function(r, i, s) {
            var c = Y(r);
            if (!Ne(r)) {
              var d = O(i, 3);
              r = he(r), i = function(m) {
                return d(c[m], m, c);
              };
            }
            var h = e(r, i, s);
            return h > -1 ? c[d ? r[h] : h] : o;
          };
        }
        function Ss(e) {
          return mn(function(r) {
            var i = r.length, s = i, c = Ue.prototype.thru;
            for (e && r.reverse(); s--; ) {
              var d = r[s];
              if (typeof d != "function")
                throw new Ze(p);
              if (c && !h && Mt(d) == "wrapper")
                var h = new Ue([], !0);
            }
            for (s = h ? s : i; ++s < i; ) {
              d = r[s];
              var m = Mt(d), v = m == "wrapper" ? ei(d) : o;
              v && oi(v[0]) && v[1] == (ln | ne | nn | Ir) && !v[4].length && v[9] == 1 ? h = h[Mt(v[0])].apply(h, v[3]) : h = d.length == 1 && oi(d) ? h[m]() : h.thru(d);
            }
            return function() {
              var A = arguments, C = A[0];
              if (h && A.length == 1 && D(C))
                return h.plant(C).value();
              for (var y = 0, N = i ? r[y].apply(this, A) : C; ++y < i; )
                N = r[y].call(this, N);
              return N;
            };
          });
        }
        function Et(e, r, i, s, c, d, h, m, v, A) {
          var C = r & ln, y = r & ke, N = r & bn, M = r & (ne | me), z = r & Qt, U = N ? o : Fr(e);
          function R() {
            for (var K = arguments.length, q = I(K), Fe = K; Fe--; )
              q[Fe] = arguments[Fe];
            if (M)
              var Te = ur(R), Ge = ld(q, Te);
            if (s && (q = ms(q, s, c, M)), d && (q = _s(q, d, h, M)), K -= Ge, M && K < A) {
              var ce = Cn(q, Te);
              return Cs(
                e,
                r,
                Et,
                R.placeholder,
                i,
                q,
                ce,
                m,
                v,
                A - K
              );
            }
            var en = y ? i : this, In = N ? en[e] : e;
            return K = q.length, m ? q = If(q, m) : z && K > 1 && q.reverse(), C && v < K && (q.length = v), this && this !== _e && this instanceof R && (In = U || Fr(In)), In.apply(en, q);
          }
          return R;
        }
        function As(e, r) {
          return function(i, s) {
            return Ep(i, e, r(s), {});
          };
        }
        function Nt(e, r) {
          return function(i, s) {
            var c;
            if (i === o && s === o)
              return r;
            if (i !== o && (c = i), s !== o) {
              if (c === o)
                return s;
              typeof i == "string" || typeof s == "string" ? (i = ze(i), s = ze(s)) : (i = ss(i), s = ss(s)), c = e(i, s);
            }
            return c;
          };
        }
        function jo(e) {
          return mn(function(r) {
            return r = re(r, Oe(O())), $(function(i) {
              var s = this;
              return e(r, function(c) {
                return Pe(c, s, i);
              });
            });
          });
        }
        function xt(e, r) {
          r = r === o ? " " : ze(r);
          var i = r.length;
          if (i < 2)
            return i ? $o(r, e) : r;
          var s = $o(r, ht(e / er(r)));
          return Qn(r) ? wn(je(s), 0, e).join("") : s.slice(0, e);
        }
        function Qp(e, r, i, s) {
          var c = r & ke, d = Fr(e);
          function h() {
            for (var m = -1, v = arguments.length, A = -1, C = s.length, y = I(C + v), N = this && this !== _e && this instanceof h ? d : e; ++A < C; )
              y[A] = s[A];
            for (; v--; )
              y[A++] = arguments[++m];
            return Pe(N, c ? i : this, y);
          }
          return h;
        }
        function Ts(e) {
          return function(r, i, s) {
            return s && typeof s != "number" && Ae(r, i, s) && (i = s = o), r = vn(r), i === o ? (i = r, r = 0) : i = vn(i), s = s === o ? r < i ? 1 : -1 : vn(s), Fp(r, i, s, e);
          };
        }
        function wt(e) {
          return function(r, i) {
            return typeof r == "string" && typeof i == "string" || (r = qe(r), i = qe(i)), e(r, i);
          };
        }
        function Cs(e, r, i, s, c, d, h, m, v, A) {
          var C = r & ne, y = C ? h : o, N = C ? o : h, M = C ? d : o, z = C ? o : d;
          r |= C ? nn : Pn, r &= ~(C ? Pn : nn), r & Be || (r &= -4);
          var U = [
            e,
            r,
            c,
            M,
            y,
            z,
            N,
            m,
            v,
            A
          ], R = i.apply(o, U);
          return oi(e) && zs(R, U), R.placeholder = s, Ls(R, e, r);
        }
        function Yo(e) {
          var r = pe[e];
          return function(i, s) {
            if (i = qe(i), s = s == null ? 0 : Ie(Z(s), 292), s && La(i)) {
              var c = (J(i) + "e").split("e"), d = r(c[0] + "e" + (+c[1] + s));
              return c = (J(d) + "e").split("e"), +(c[0] + "e" + (+c[1] - s));
            }
            return r(i);
          };
        }
        var ef = tr && 1 / ot(new tr([, -0]))[1] == Rn ? function(e) {
          return new tr(e);
        } : bi;
        function ys(e) {
          return function(r) {
            var i = be(r);
            return i == Ve ? No(r) : i == Je ? gd(r) : cd(r, e(r));
          };
        }
        function hn(e, r, i, s, c, d, h, m) {
          var v = r & bn;
          if (!v && typeof e != "function")
            throw new Ze(p);
          var A = s ? s.length : 0;
          if (A || (r &= -97, s = c = o), h = h === o ? h : fe(Z(h), 0), m = m === o ? m : Z(m), A -= c ? c.length : 0, r & Pn) {
            var C = s, y = c;
            s = c = o;
          }
          var N = v ? o : ei(e), M = [
            e,
            r,
            i,
            s,
            c,
            C,
            y,
            d,
            h,
            m
          ];
          if (N && _f(M, N), e = M[0], r = M[1], i = M[2], s = M[3], c = M[4], m = M[9] = M[9] === o ? v ? 0 : e.length : fe(M[9] - A, 0), !m && r & (ne | me) && (r &= -25), !r || r == ke)
            var z = Yp(e, r, i);
          else r == ne || r == me ? z = Xp(e, r, m) : (r == nn || r == (ke | nn)) && !c.length ? z = Qp(e, r, i, s) : z = Et.apply(o, M);
          var U = N ? is : zs;
          return Ls(U(z, M), e, r);
        }
        function Es(e, r, i, s) {
          return e === o || Qe(e, rr[i]) && !V.call(s, i) ? r : e;
        }
        function Ns(e, r, i, s, c, d) {
          return oe(e) && oe(r) && (d.set(r, e), At(e, r, o, Ns, d), d.delete(r)), e;
        }
        function nf(e) {
          return Zr(e) ? o : e;
        }
        function xs(e, r, i, s, c, d) {
          var h = i & ee, m = e.length, v = r.length;
          if (m != v && !(h && v > m))
            return !1;
          var A = d.get(e), C = d.get(r);
          if (A && C)
            return A == r && C == e;
          var y = -1, N = !0, M = i & cn ? new Fn() : o;
          for (d.set(e, r), d.set(r, e); ++y < m; ) {
            var z = e[y], U = r[y];
            if (s)
              var R = h ? s(U, z, y, r, e, d) : s(z, U, y, e, r, d);
            if (R !== o) {
              if (R)
                continue;
              N = !1;
              break;
            }
            if (M) {
              if (!So(r, function(K, q) {
                if (!Nr(M, q) && (z === K || c(z, K, i, s, d)))
                  return M.push(q);
              })) {
                N = !1;
                break;
              }
            } else if (!(z === U || c(z, U, i, s, d))) {
              N = !1;
              break;
            }
          }
          return d.delete(e), d.delete(r), N;
        }
        function rf(e, r, i, s, c, d, h) {
          switch (i) {
            case jn:
              if (e.byteLength != r.byteLength || e.byteOffset != r.byteOffset)
                return !1;
              e = e.buffer, r = r.buffer;
            case Er:
              return !(e.byteLength != r.byteLength || !d(new lt(e), new lt(r)));
            case br:
            case Sr:
            case Ar:
              return Qe(+e, +r);
            case jr:
              return e.name == r.name && e.message == r.message;
            case Tr:
            case Cr:
              return e == r + "";
            case Ve:
              var m = No;
            case Je:
              var v = s & ee;
              if (m || (m = ot), e.size != r.size && !v)
                return !1;
              var A = h.get(e);
              if (A)
                return A == r;
              s |= cn, h.set(e, r);
              var C = xs(m(e), m(r), s, c, d, h);
              return h.delete(e), C;
            case Xr:
              if (Br)
                return Br.call(e) == Br.call(r);
          }
          return !1;
        }
        function tf(e, r, i, s, c, d) {
          var h = i & ee, m = Xo(e), v = m.length, A = Xo(r), C = A.length;
          if (v != C && !h)
            return !1;
          for (var y = v; y--; ) {
            var N = m[y];
            if (!(h ? N in r : V.call(r, N)))
              return !1;
          }
          var M = d.get(e), z = d.get(r);
          if (M && z)
            return M == r && z == e;
          var U = !0;
          d.set(e, r), d.set(r, e);
          for (var R = h; ++y < v; ) {
            N = m[y];
            var K = e[N], q = r[N];
            if (s)
              var Fe = h ? s(q, K, N, r, e, d) : s(K, q, N, e, r, d);
            if (!(Fe === o ? K === q || c(K, q, i, s, d) : Fe)) {
              U = !1;
              break;
            }
            R || (R = N == "constructor");
          }
          if (U && !R) {
            var Te = e.constructor, Ge = r.constructor;
            Te != Ge && "constructor" in e && "constructor" in r && !(typeof Te == "function" && Te instanceof Te && typeof Ge == "function" && Ge instanceof Ge) && (U = !1);
          }
          return d.delete(e), d.delete(r), U;
        }
        function mn(e) {
          return ai(Rs(e, o, $s), e + "");
        }
        function Xo(e) {
          return Va(e, he, ri);
        }
        function Qo(e) {
          return Va(e, xe, ws);
        }
        var ei = _t ? function(e) {
          return _t.get(e);
        } : bi;
        function Mt(e) {
          for (var r = e.name + "", i = or[r], s = V.call(or, r) ? i.length : 0; s--; ) {
            var c = i[s], d = c.func;
            if (d == null || d == e)
              return c.name;
          }
          return r;
        }
        function ur(e) {
          var r = V.call(l, "placeholder") ? l : e;
          return r.placeholder;
        }
        function O() {
          var e = l.iteratee || vi;
          return e = e === vi ? Ya : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }
        function kt(e, r) {
          var i = e.__data__;
          return pf(r) ? i[typeof r == "string" ? "string" : "hash"] : i.map;
        }
        function ni(e) {
          for (var r = he(e), i = r.length; i--; ) {
            var s = r[i], c = e[s];
            r[i] = [s, c, Bs(c)];
          }
          return r;
        }
        function Zn(e, r) {
          var i = hd(e, r);
          return ja(i) ? i : o;
        }
        function of(e) {
          var r = V.call(e, zn), i = e[zn];
          try {
            e[zn] = o;
            var s = !0;
          } catch {
          }
          var c = ut.call(e);
          return s && (r ? e[zn] = i : delete e[zn]), c;
        }
        var ri = wo ? function(e) {
          return e == null ? [] : (e = Y(e), An(wo(e), function(r) {
            return Oa.call(e, r);
          }));
        } : Si, ws = wo ? function(e) {
          for (var r = []; e; )
            Tn(r, ri(e)), e = dt(e);
          return r;
        } : Si, be = Se;
        (Mo && be(new Mo(new ArrayBuffer(1))) != jn || wr && be(new wr()) != Ve || ko && be(ko.resolve()) != Ki || tr && be(new tr()) != Je || Mr && be(new Mr()) != yr) && (be = function(e) {
          var r = Se(e), i = r == dn ? e.constructor : o, s = i ? Un(i) : "";
          if (s)
            switch (s) {
              case Dd:
                return jn;
              case Zd:
                return Ve;
              case Ud:
                return Ki;
              case $d:
                return Je;
              case Kd:
                return yr;
            }
          return r;
        });
        function af(e, r, i) {
          for (var s = -1, c = i.length; ++s < c; ) {
            var d = i[s], h = d.size;
            switch (d.type) {
              case "drop":
                e += h;
                break;
              case "dropRight":
                r -= h;
                break;
              case "take":
                r = Ie(r, e + h);
                break;
              case "takeRight":
                e = fe(e, r - h);
                break;
            }
          }
          return { start: e, end: r };
        }
        function sf(e) {
          var r = e.match(fl);
          return r ? r[1].split(hl) : [];
        }
        function Ms(e, r, i) {
          r = xn(r, e);
          for (var s = -1, c = r.length, d = !1; ++s < c; ) {
            var h = Xe(r[s]);
            if (!(d = e != null && i(e, h)))
              break;
            e = e[h];
          }
          return d || ++s != c ? d : (c = e == null ? 0 : e.length, !!c && Ft(c) && _n(h, c) && (D(e) || $n(e)));
        }
        function uf(e) {
          var r = e.length, i = new e.constructor(r);
          return r && typeof e[0] == "string" && V.call(e, "index") && (i.index = e.index, i.input = e.input), i;
        }
        function ks(e) {
          return typeof e.constructor == "function" && !Gr(e) ? ir(dt(e)) : {};
        }
        function cf(e, r, i) {
          var s = e.constructor;
          switch (r) {
            case Er:
              return Jo(e);
            case br:
            case Sr:
              return new s(+e);
            case jn:
              return Hp(e, i);
            case eo:
            case no:
            case ro:
            case to:
            case oo:
            case io:
            case ao:
            case so:
            case uo:
              return fs(e, i);
            case Ve:
              return new s();
            case Ar:
            case Cr:
              return new s(e);
            case Tr:
              return qp(e);
            case Je:
              return new s();
            case Xr:
              return Wp(e);
          }
        }
        function lf(e, r) {
          var i = r.length;
          if (!i)
            return e;
          var s = i - 1;
          return r[s] = (i > 1 ? "& " : "") + r[s], r = r.join(i > 2 ? ", " : " "), e.replace(pl, `{
/* [wrapped with ` + r + `] */
`);
        }
        function df(e) {
          return D(e) || $n(e) || !!(za && e && e[za]);
        }
        function _n(e, r) {
          var i = typeof e;
          return r = r ?? Sn, !!r && (i == "number" || i != "symbol" && Al.test(e)) && e > -1 && e % 1 == 0 && e < r;
        }
        function Ae(e, r, i) {
          if (!oe(i))
            return !1;
          var s = typeof r;
          return (s == "number" ? Ne(i) && _n(r, i.length) : s == "string" && r in i) ? Qe(i[r], e) : !1;
        }
        function ti(e, r) {
          if (D(e))
            return !1;
          var i = typeof e;
          return i == "number" || i == "symbol" || i == "boolean" || e == null || Le(e) ? !0 : ul.test(e) || !sl.test(e) || r != null && e in Y(r);
        }
        function pf(e) {
          var r = typeof e;
          return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
        }
        function oi(e) {
          var r = Mt(e), i = l[r];
          if (typeof i != "function" || !(r in H.prototype))
            return !1;
          if (e === i)
            return !0;
          var s = ei(i);
          return !!s && e === s[0];
        }
        function ff(e) {
          return !!Ba && Ba in e;
        }
        var hf = at ? gn : Ai;
        function Gr(e) {
          var r = e && e.constructor, i = typeof r == "function" && r.prototype || rr;
          return e === i;
        }
        function Bs(e) {
          return e === e && !oe(e);
        }
        function Ps(e, r) {
          return function(i) {
            return i == null ? !1 : i[e] === r && (r !== o || e in Y(i));
          };
        }
        function mf(e) {
          var r = zt(e, function(s) {
            return i.size === w && i.clear(), s;
          }), i = r.cache;
          return r;
        }
        function _f(e, r) {
          var i = e[1], s = r[1], c = i | s, d = c < (ke | bn | ln), h = s == ln && i == ne || s == ln && i == Ir && e[7].length <= r[8] || s == (ln | Ir) && r[7].length <= r[8] && i == ne;
          if (!(d || h))
            return e;
          s & ke && (e[2] = r[2], c |= i & ke ? 0 : Be);
          var m = r[3];
          if (m) {
            var v = e[3];
            e[3] = v ? ms(v, m, r[4]) : m, e[4] = v ? Cn(e[3], G) : r[4];
          }
          return m = r[5], m && (v = e[5], e[5] = v ? _s(v, m, r[6]) : m, e[6] = v ? Cn(e[5], G) : r[6]), m = r[7], m && (e[7] = m), s & ln && (e[8] = e[8] == null ? r[8] : Ie(e[8], r[8])), e[9] == null && (e[9] = r[9]), e[0] = r[0], e[1] = c, e;
        }
        function gf(e) {
          var r = [];
          if (e != null)
            for (var i in Y(e))
              r.push(i);
          return r;
        }
        function vf(e) {
          return ut.call(e);
        }
        function Rs(e, r, i) {
          return r = fe(r === o ? e.length - 1 : r, 0), function() {
            for (var s = arguments, c = -1, d = fe(s.length - r, 0), h = I(d); ++c < d; )
              h[c] = s[r + c];
            c = -1;
            for (var m = I(r + 1); ++c < r; )
              m[c] = s[c];
            return m[r] = i(h), Pe(e, this, m);
          };
        }
        function Os(e, r) {
          return r.length < 2 ? e : Dn(e, Ke(r, 0, -1));
        }
        function If(e, r) {
          for (var i = e.length, s = Ie(r.length, i), c = Ee(e); s--; ) {
            var d = r[s];
            e[s] = _n(d, i) ? c[d] : o;
          }
          return e;
        }
        function ii(e, r) {
          if (!(r === "constructor" && typeof e[r] == "function") && r != "__proto__")
            return e[r];
        }
        var zs = Fs(is), Dr = Pd || function(e, r) {
          return _e.setTimeout(e, r);
        }, ai = Fs(Zp);
        function Ls(e, r, i) {
          var s = r + "";
          return ai(e, lf(s, bf(sf(s), i)));
        }
        function Fs(e) {
          var r = 0, i = 0;
          return function() {
            var s = Ld(), c = Zc - (s - i);
            if (i = s, c > 0) {
              if (++r >= Dc)
                return arguments[0];
            } else
              r = 0;
            return e.apply(o, arguments);
          };
        }
        function Bt(e, r) {
          var i = -1, s = e.length, c = s - 1;
          for (r = r === o ? s : r; ++i < r; ) {
            var d = Uo(i, c), h = e[d];
            e[d] = e[i], e[i] = h;
          }
          return e.length = r, e;
        }
        var Gs = mf(function(e) {
          var r = [];
          return e.charCodeAt(0) === 46 && r.push(""), e.replace(cl, function(i, s, c, d) {
            r.push(c ? d.replace(_l, "$1") : s || i);
          }), r;
        });
        function Xe(e) {
          if (typeof e == "string" || Le(e))
            return e;
          var r = e + "";
          return r == "0" && 1 / e == -Rn ? "-0" : r;
        }
        function Un(e) {
          if (e != null) {
            try {
              return st.call(e);
            } catch {
            }
            try {
              return e + "";
            } catch {
            }
          }
          return "";
        }
        function bf(e, r) {
          return Re(Wc, function(i) {
            var s = "_." + i[0];
            r & i[1] && !rt(e, s) && e.push(s);
          }), e.sort();
        }
        function Ds(e) {
          if (e instanceof H)
            return e.clone();
          var r = new Ue(e.__wrapped__, e.__chain__);
          return r.__actions__ = Ee(e.__actions__), r.__index__ = e.__index__, r.__values__ = e.__values__, r;
        }
        function Sf(e, r, i) {
          (i ? Ae(e, r, i) : r === o) ? r = 1 : r = fe(Z(r), 0);
          var s = e == null ? 0 : e.length;
          if (!s || r < 1)
            return [];
          for (var c = 0, d = 0, h = I(ht(s / r)); c < s; )
            h[d++] = Ke(e, c, c += r);
          return h;
        }
        function Af(e) {
          for (var r = -1, i = e == null ? 0 : e.length, s = 0, c = []; ++r < i; ) {
            var d = e[r];
            d && (c[s++] = d);
          }
          return c;
        }
        function Tf() {
          var e = arguments.length;
          if (!e)
            return [];
          for (var r = I(e - 1), i = arguments[0], s = e; s--; )
            r[s - 1] = arguments[s];
          return Tn(D(i) ? Ee(i) : [i], ge(r, 1));
        }
        var Cf = $(function(e, r) {
          return ue(e) ? Rr(e, ge(r, 1, ue, !0)) : [];
        }), yf = $(function(e, r) {
          var i = He(r);
          return ue(i) && (i = o), ue(e) ? Rr(e, ge(r, 1, ue, !0), O(i, 2)) : [];
        }), Ef = $(function(e, r) {
          var i = He(r);
          return ue(i) && (i = o), ue(e) ? Rr(e, ge(r, 1, ue, !0), o, i) : [];
        });
        function Nf(e, r, i) {
          var s = e == null ? 0 : e.length;
          return s ? (r = i || r === o ? 1 : Z(r), Ke(e, r < 0 ? 0 : r, s)) : [];
        }
        function xf(e, r, i) {
          var s = e == null ? 0 : e.length;
          return s ? (r = i || r === o ? 1 : Z(r), r = s - r, Ke(e, 0, r < 0 ? 0 : r)) : [];
        }
        function wf(e, r) {
          return e && e.length ? Ct(e, O(r, 3), !0, !0) : [];
        }
        function Mf(e, r) {
          return e && e.length ? Ct(e, O(r, 3), !0) : [];
        }
        function kf(e, r, i, s) {
          var c = e == null ? 0 : e.length;
          return c ? (i && typeof i != "number" && Ae(e, r, i) && (i = 0, s = c), Ap(e, r, i, s)) : [];
        }
        function Zs(e, r, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var c = i == null ? 0 : Z(i);
          return c < 0 && (c = fe(s + c, 0)), tt(e, O(r, 3), c);
        }
        function Us(e, r, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var c = s - 1;
          return i !== o && (c = Z(i), c = i < 0 ? fe(s + c, 0) : Ie(c, s - 1)), tt(e, O(r, 3), c, !0);
        }
        function $s(e) {
          var r = e == null ? 0 : e.length;
          return r ? ge(e, 1) : [];
        }
        function Bf(e) {
          var r = e == null ? 0 : e.length;
          return r ? ge(e, Rn) : [];
        }
        function Pf(e, r) {
          var i = e == null ? 0 : e.length;
          return i ? (r = r === o ? 1 : Z(r), ge(e, r)) : [];
        }
        function Rf(e) {
          for (var r = -1, i = e == null ? 0 : e.length, s = {}; ++r < i; ) {
            var c = e[r];
            tn(s, c[0], c[1]);
          }
          return s;
        }
        function Ks(e) {
          return e && e.length ? e[0] : o;
        }
        function Of(e, r, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var c = i == null ? 0 : Z(i);
          return c < 0 && (c = fe(s + c, 0)), Xn(e, r, c);
        }
        function zf(e) {
          var r = e == null ? 0 : e.length;
          return r ? Ke(e, 0, -1) : [];
        }
        var Lf = $(function(e) {
          var r = re(e, Wo);
          return r.length && r[0] === e[0] ? Lo(r) : [];
        }), Ff = $(function(e) {
          var r = He(e), i = re(e, Wo);
          return r === He(i) ? r = o : i.pop(), i.length && i[0] === e[0] ? Lo(i, O(r, 2)) : [];
        }), Gf = $(function(e) {
          var r = He(e), i = re(e, Wo);
          return r = typeof r == "function" ? r : o, r && i.pop(), i.length && i[0] === e[0] ? Lo(i, o, r) : [];
        });
        function Df(e, r) {
          return e == null ? "" : Od.call(e, r);
        }
        function He(e) {
          var r = e == null ? 0 : e.length;
          return r ? e[r - 1] : o;
        }
        function Zf(e, r, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var c = s;
          return i !== o && (c = Z(i), c = c < 0 ? fe(s + c, 0) : Ie(c, s - 1)), r === r ? Id(e, r, c) : tt(e, Ca, c, !0);
        }
        function Uf(e, r) {
          return e && e.length ? ns(e, Z(r)) : o;
        }
        var $f = $(Hs);
        function Hs(e, r) {
          return e && e.length && r && r.length ? Zo(e, r) : e;
        }
        function Kf(e, r, i) {
          return e && e.length && r && r.length ? Zo(e, r, O(i, 2)) : e;
        }
        function Hf(e, r, i) {
          return e && e.length && r && r.length ? Zo(e, r, o, i) : e;
        }
        var qf = mn(function(e, r) {
          var i = e == null ? 0 : e.length, s = Po(e, r);
          return os(e, re(r, function(c) {
            return _n(c, i) ? +c : c;
          }).sort(hs)), s;
        });
        function Wf(e, r) {
          var i = [];
          if (!(e && e.length))
            return i;
          var s = -1, c = [], d = e.length;
          for (r = O(r, 3); ++s < d; ) {
            var h = e[s];
            r(h, s, e) && (i.push(h), c.push(s));
          }
          return os(e, c), i;
        }
        function si(e) {
          return e == null ? e : Gd.call(e);
        }
        function Vf(e, r, i) {
          var s = e == null ? 0 : e.length;
          return s ? (i && typeof i != "number" && Ae(e, r, i) ? (r = 0, i = s) : (r = r == null ? 0 : Z(r), i = i === o ? s : Z(i)), Ke(e, r, i)) : [];
        }
        function Jf(e, r) {
          return Tt(e, r);
        }
        function jf(e, r, i) {
          return Ko(e, r, O(i, 2));
        }
        function Yf(e, r) {
          var i = e == null ? 0 : e.length;
          if (i) {
            var s = Tt(e, r);
            if (s < i && Qe(e[s], r))
              return s;
          }
          return -1;
        }
        function Xf(e, r) {
          return Tt(e, r, !0);
        }
        function Qf(e, r, i) {
          return Ko(e, r, O(i, 2), !0);
        }
        function eh(e, r) {
          var i = e == null ? 0 : e.length;
          if (i) {
            var s = Tt(e, r, !0) - 1;
            if (Qe(e[s], r))
              return s;
          }
          return -1;
        }
        function nh(e) {
          return e && e.length ? as(e) : [];
        }
        function rh(e, r) {
          return e && e.length ? as(e, O(r, 2)) : [];
        }
        function th(e) {
          var r = e == null ? 0 : e.length;
          return r ? Ke(e, 1, r) : [];
        }
        function oh(e, r, i) {
          return e && e.length ? (r = i || r === o ? 1 : Z(r), Ke(e, 0, r < 0 ? 0 : r)) : [];
        }
        function ih(e, r, i) {
          var s = e == null ? 0 : e.length;
          return s ? (r = i || r === o ? 1 : Z(r), r = s - r, Ke(e, r < 0 ? 0 : r, s)) : [];
        }
        function ah(e, r) {
          return e && e.length ? Ct(e, O(r, 3), !1, !0) : [];
        }
        function sh(e, r) {
          return e && e.length ? Ct(e, O(r, 3)) : [];
        }
        var uh = $(function(e) {
          return Nn(ge(e, 1, ue, !0));
        }), ch = $(function(e) {
          var r = He(e);
          return ue(r) && (r = o), Nn(ge(e, 1, ue, !0), O(r, 2));
        }), lh = $(function(e) {
          var r = He(e);
          return r = typeof r == "function" ? r : o, Nn(ge(e, 1, ue, !0), o, r);
        });
        function dh(e) {
          return e && e.length ? Nn(e) : [];
        }
        function ph(e, r) {
          return e && e.length ? Nn(e, O(r, 2)) : [];
        }
        function fh(e, r) {
          return r = typeof r == "function" ? r : o, e && e.length ? Nn(e, o, r) : [];
        }
        function ui(e) {
          if (!(e && e.length))
            return [];
          var r = 0;
          return e = An(e, function(i) {
            if (ue(i))
              return r = fe(i.length, r), !0;
          }), yo(r, function(i) {
            return re(e, Ao(i));
          });
        }
        function qs(e, r) {
          if (!(e && e.length))
            return [];
          var i = ui(e);
          return r == null ? i : re(i, function(s) {
            return Pe(r, o, s);
          });
        }
        var hh = $(function(e, r) {
          return ue(e) ? Rr(e, r) : [];
        }), mh = $(function(e) {
          return qo(An(e, ue));
        }), _h = $(function(e) {
          var r = He(e);
          return ue(r) && (r = o), qo(An(e, ue), O(r, 2));
        }), gh = $(function(e) {
          var r = He(e);
          return r = typeof r == "function" ? r : o, qo(An(e, ue), o, r);
        }), vh = $(ui);
        function Ih(e, r) {
          return ls(e || [], r || [], Pr);
        }
        function bh(e, r) {
          return ls(e || [], r || [], Lr);
        }
        var Sh = $(function(e) {
          var r = e.length, i = r > 1 ? e[r - 1] : o;
          return i = typeof i == "function" ? (e.pop(), i) : o, qs(e, i);
        });
        function Ws(e) {
          var r = l(e);
          return r.__chain__ = !0, r;
        }
        function Ah(e, r) {
          return r(e), e;
        }
        function Pt(e, r) {
          return r(e);
        }
        var Th = mn(function(e) {
          var r = e.length, i = r ? e[0] : 0, s = this.__wrapped__, c = function(d) {
            return Po(d, e);
          };
          return r > 1 || this.__actions__.length || !(s instanceof H) || !_n(i) ? this.thru(c) : (s = s.slice(i, +i + (r ? 1 : 0)), s.__actions__.push({
            func: Pt,
            args: [c],
            thisArg: o
          }), new Ue(s, this.__chain__).thru(function(d) {
            return r && !d.length && d.push(o), d;
          }));
        });
        function Ch() {
          return Ws(this);
        }
        function yh() {
          return new Ue(this.value(), this.__chain__);
        }
        function Eh() {
          this.__values__ === o && (this.__values__ = su(this.value()));
          var e = this.__index__ >= this.__values__.length, r = e ? o : this.__values__[this.__index__++];
          return { done: e, value: r };
        }
        function Nh() {
          return this;
        }
        function xh(e) {
          for (var r, i = this; i instanceof vt; ) {
            var s = Ds(i);
            s.__index__ = 0, s.__values__ = o, r ? c.__wrapped__ = s : r = s;
            var c = s;
            i = i.__wrapped__;
          }
          return c.__wrapped__ = e, r;
        }
        function wh() {
          var e = this.__wrapped__;
          if (e instanceof H) {
            var r = e;
            return this.__actions__.length && (r = new H(this)), r = r.reverse(), r.__actions__.push({
              func: Pt,
              args: [si],
              thisArg: o
            }), new Ue(r, this.__chain__);
          }
          return this.thru(si);
        }
        function Mh() {
          return cs(this.__wrapped__, this.__actions__);
        }
        var kh = yt(function(e, r, i) {
          V.call(e, i) ? ++e[i] : tn(e, i, 1);
        });
        function Bh(e, r, i) {
          var s = D(e) ? Aa : Sp;
          return i && Ae(e, r, i) && (r = o), s(e, O(r, 3));
        }
        function Ph(e, r) {
          var i = D(e) ? An : qa;
          return i(e, O(r, 3));
        }
        var Rh = bs(Zs), Oh = bs(Us);
        function zh(e, r) {
          return ge(Rt(e, r), 1);
        }
        function Lh(e, r) {
          return ge(Rt(e, r), Rn);
        }
        function Fh(e, r, i) {
          return i = i === o ? 1 : Z(i), ge(Rt(e, r), i);
        }
        function Vs(e, r) {
          var i = D(e) ? Re : En;
          return i(e, O(r, 3));
        }
        function Js(e, r) {
          var i = D(e) ? rd : Ha;
          return i(e, O(r, 3));
        }
        var Gh = yt(function(e, r, i) {
          V.call(e, i) ? e[i].push(r) : tn(e, i, [r]);
        });
        function Dh(e, r, i, s) {
          e = Ne(e) ? e : lr(e), i = i && !s ? Z(i) : 0;
          var c = e.length;
          return i < 0 && (i = fe(c + i, 0)), Gt(e) ? i <= c && e.indexOf(r, i) > -1 : !!c && Xn(e, r, i) > -1;
        }
        var Zh = $(function(e, r, i) {
          var s = -1, c = typeof r == "function", d = Ne(e) ? I(e.length) : [];
          return En(e, function(h) {
            d[++s] = c ? Pe(r, h, i) : Or(h, r, i);
          }), d;
        }), Uh = yt(function(e, r, i) {
          tn(e, i, r);
        });
        function Rt(e, r) {
          var i = D(e) ? re : Xa;
          return i(e, O(r, 3));
        }
        function $h(e, r, i, s) {
          return e == null ? [] : (D(r) || (r = r == null ? [] : [r]), i = s ? o : i, D(i) || (i = i == null ? [] : [i]), rs(e, r, i));
        }
        var Kh = yt(function(e, r, i) {
          e[i ? 0 : 1].push(r);
        }, function() {
          return [[], []];
        });
        function Hh(e, r, i) {
          var s = D(e) ? bo : Ea, c = arguments.length < 3;
          return s(e, O(r, 4), i, c, En);
        }
        function qh(e, r, i) {
          var s = D(e) ? td : Ea, c = arguments.length < 3;
          return s(e, O(r, 4), i, c, Ha);
        }
        function Wh(e, r) {
          var i = D(e) ? An : qa;
          return i(e, Lt(O(r, 3)));
        }
        function Vh(e) {
          var r = D(e) ? Za : Gp;
          return r(e);
        }
        function Jh(e, r, i) {
          (i ? Ae(e, r, i) : r === o) ? r = 1 : r = Z(r);
          var s = D(e) ? _p : Dp;
          return s(e, r);
        }
        function jh(e) {
          var r = D(e) ? gp : Up;
          return r(e);
        }
        function Yh(e) {
          if (e == null)
            return 0;
          if (Ne(e))
            return Gt(e) ? er(e) : e.length;
          var r = be(e);
          return r == Ve || r == Je ? e.size : Go(e).length;
        }
        function Xh(e, r, i) {
          var s = D(e) ? So : $p;
          return i && Ae(e, r, i) && (r = o), s(e, O(r, 3));
        }
        var Qh = $(function(e, r) {
          if (e == null)
            return [];
          var i = r.length;
          return i > 1 && Ae(e, r[0], r[1]) ? r = [] : i > 2 && Ae(r[0], r[1], r[2]) && (r = [r[0]]), rs(e, ge(r, 1), []);
        }), Ot = Bd || function() {
          return _e.Date.now();
        };
        function em(e, r) {
          if (typeof r != "function")
            throw new Ze(p);
          return e = Z(e), function() {
            if (--e < 1)
              return r.apply(this, arguments);
          };
        }
        function js(e, r, i) {
          return r = i ? o : r, r = e && r == null ? e.length : r, hn(e, ln, o, o, o, o, r);
        }
        function Ys(e, r) {
          var i;
          if (typeof r != "function")
            throw new Ze(p);
          return e = Z(e), function() {
            return --e > 0 && (i = r.apply(this, arguments)), e <= 1 && (r = o), i;
          };
        }
        var ci = $(function(e, r, i) {
          var s = ke;
          if (i.length) {
            var c = Cn(i, ur(ci));
            s |= nn;
          }
          return hn(e, s, r, i, c);
        }), Xs = $(function(e, r, i) {
          var s = ke | bn;
          if (i.length) {
            var c = Cn(i, ur(Xs));
            s |= nn;
          }
          return hn(r, s, e, i, c);
        });
        function Qs(e, r, i) {
          r = i ? o : r;
          var s = hn(e, ne, o, o, o, o, o, r);
          return s.placeholder = Qs.placeholder, s;
        }
        function eu(e, r, i) {
          r = i ? o : r;
          var s = hn(e, me, o, o, o, o, o, r);
          return s.placeholder = eu.placeholder, s;
        }
        function nu(e, r, i) {
          var s, c, d, h, m, v, A = 0, C = !1, y = !1, N = !0;
          if (typeof e != "function")
            throw new Ze(p);
          r = qe(r) || 0, oe(i) && (C = !!i.leading, y = "maxWait" in i, d = y ? fe(qe(i.maxWait) || 0, r) : d, N = "trailing" in i ? !!i.trailing : N);
          function M(ce) {
            var en = s, In = c;
            return s = c = o, A = ce, h = e.apply(In, en), h;
          }
          function z(ce) {
            return A = ce, m = Dr(K, r), C ? M(ce) : h;
          }
          function U(ce) {
            var en = ce - v, In = ce - A, Su = r - en;
            return y ? Ie(Su, d - In) : Su;
          }
          function R(ce) {
            var en = ce - v, In = ce - A;
            return v === o || en >= r || en < 0 || y && In >= d;
          }
          function K() {
            var ce = Ot();
            if (R(ce))
              return q(ce);
            m = Dr(K, U(ce));
          }
          function q(ce) {
            return m = o, N && s ? M(ce) : (s = c = o, h);
          }
          function Fe() {
            m !== o && ds(m), A = 0, s = v = c = m = o;
          }
          function Te() {
            return m === o ? h : q(Ot());
          }
          function Ge() {
            var ce = Ot(), en = R(ce);
            if (s = arguments, c = this, v = ce, en) {
              if (m === o)
                return z(v);
              if (y)
                return ds(m), m = Dr(K, r), M(v);
            }
            return m === o && (m = Dr(K, r)), h;
          }
          return Ge.cancel = Fe, Ge.flush = Te, Ge;
        }
        var nm = $(function(e, r) {
          return Ka(e, 1, r);
        }), rm = $(function(e, r, i) {
          return Ka(e, qe(r) || 0, i);
        });
        function tm(e) {
          return hn(e, Qt);
        }
        function zt(e, r) {
          if (typeof e != "function" || r != null && typeof r != "function")
            throw new Ze(p);
          var i = function() {
            var s = arguments, c = r ? r.apply(this, s) : s[0], d = i.cache;
            if (d.has(c))
              return d.get(c);
            var h = e.apply(this, s);
            return i.cache = d.set(c, h) || d, h;
          };
          return i.cache = new (zt.Cache || fn)(), i;
        }
        zt.Cache = fn;
        function Lt(e) {
          if (typeof e != "function")
            throw new Ze(p);
          return function() {
            var r = arguments;
            switch (r.length) {
              case 0:
                return !e.call(this);
              case 1:
                return !e.call(this, r[0]);
              case 2:
                return !e.call(this, r[0], r[1]);
              case 3:
                return !e.call(this, r[0], r[1], r[2]);
            }
            return !e.apply(this, r);
          };
        }
        function om(e) {
          return Ys(2, e);
        }
        var im = Kp(function(e, r) {
          r = r.length == 1 && D(r[0]) ? re(r[0], Oe(O())) : re(ge(r, 1), Oe(O()));
          var i = r.length;
          return $(function(s) {
            for (var c = -1, d = Ie(s.length, i); ++c < d; )
              s[c] = r[c].call(this, s[c]);
            return Pe(e, this, s);
          });
        }), li = $(function(e, r) {
          var i = Cn(r, ur(li));
          return hn(e, nn, o, r, i);
        }), ru = $(function(e, r) {
          var i = Cn(r, ur(ru));
          return hn(e, Pn, o, r, i);
        }), am = mn(function(e, r) {
          return hn(e, Ir, o, o, o, r);
        });
        function sm(e, r) {
          if (typeof e != "function")
            throw new Ze(p);
          return r = r === o ? r : Z(r), $(e, r);
        }
        function um(e, r) {
          if (typeof e != "function")
            throw new Ze(p);
          return r = r == null ? 0 : fe(Z(r), 0), $(function(i) {
            var s = i[r], c = wn(i, 0, r);
            return s && Tn(c, s), Pe(e, this, c);
          });
        }
        function cm(e, r, i) {
          var s = !0, c = !0;
          if (typeof e != "function")
            throw new Ze(p);
          return oe(i) && (s = "leading" in i ? !!i.leading : s, c = "trailing" in i ? !!i.trailing : c), nu(e, r, {
            leading: s,
            maxWait: r,
            trailing: c
          });
        }
        function lm(e) {
          return js(e, 1);
        }
        function dm(e, r) {
          return li(Vo(r), e);
        }
        function pm() {
          if (!arguments.length)
            return [];
          var e = arguments[0];
          return D(e) ? e : [e];
        }
        function fm(e) {
          return $e(e, ae);
        }
        function hm(e, r) {
          return r = typeof r == "function" ? r : o, $e(e, ae, r);
        }
        function mm(e) {
          return $e(e, B | ae);
        }
        function _m(e, r) {
          return r = typeof r == "function" ? r : o, $e(e, B | ae, r);
        }
        function gm(e, r) {
          return r == null || $a(e, r, he(r));
        }
        function Qe(e, r) {
          return e === r || e !== e && r !== r;
        }
        var vm = wt(zo), Im = wt(function(e, r) {
          return e >= r;
        }), $n = Ja(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? Ja : function(e) {
          return se(e) && V.call(e, "callee") && !Oa.call(e, "callee");
        }, D = I.isArray, bm = _a ? Oe(_a) : Np;
        function Ne(e) {
          return e != null && Ft(e.length) && !gn(e);
        }
        function ue(e) {
          return se(e) && Ne(e);
        }
        function Sm(e) {
          return e === !0 || e === !1 || se(e) && Se(e) == br;
        }
        var Mn = Rd || Ai, Am = ga ? Oe(ga) : xp;
        function Tm(e) {
          return se(e) && e.nodeType === 1 && !Zr(e);
        }
        function Cm(e) {
          if (e == null)
            return !0;
          if (Ne(e) && (D(e) || typeof e == "string" || typeof e.splice == "function" || Mn(e) || cr(e) || $n(e)))
            return !e.length;
          var r = be(e);
          if (r == Ve || r == Je)
            return !e.size;
          if (Gr(e))
            return !Go(e).length;
          for (var i in e)
            if (V.call(e, i))
              return !1;
          return !0;
        }
        function ym(e, r) {
          return zr(e, r);
        }
        function Em(e, r, i) {
          i = typeof i == "function" ? i : o;
          var s = i ? i(e, r) : o;
          return s === o ? zr(e, r, o, i) : !!s;
        }
        function di(e) {
          if (!se(e))
            return !1;
          var r = Se(e);
          return r == jr || r == Jc || typeof e.message == "string" && typeof e.name == "string" && !Zr(e);
        }
        function Nm(e) {
          return typeof e == "number" && La(e);
        }
        function gn(e) {
          if (!oe(e))
            return !1;
          var r = Se(e);
          return r == Yr || r == $i || r == Vc || r == Yc;
        }
        function tu(e) {
          return typeof e == "number" && e == Z(e);
        }
        function Ft(e) {
          return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Sn;
        }
        function oe(e) {
          var r = typeof e;
          return e != null && (r == "object" || r == "function");
        }
        function se(e) {
          return e != null && typeof e == "object";
        }
        var ou = va ? Oe(va) : Mp;
        function xm(e, r) {
          return e === r || Fo(e, r, ni(r));
        }
        function wm(e, r, i) {
          return i = typeof i == "function" ? i : o, Fo(e, r, ni(r), i);
        }
        function Mm(e) {
          return iu(e) && e != +e;
        }
        function km(e) {
          if (hf(e))
            throw new F(f);
          return ja(e);
        }
        function Bm(e) {
          return e === null;
        }
        function Pm(e) {
          return e == null;
        }
        function iu(e) {
          return typeof e == "number" || se(e) && Se(e) == Ar;
        }
        function Zr(e) {
          if (!se(e) || Se(e) != dn)
            return !1;
          var r = dt(e);
          if (r === null)
            return !0;
          var i = V.call(r, "constructor") && r.constructor;
          return typeof i == "function" && i instanceof i && st.call(i) == xd;
        }
        var pi = Ia ? Oe(Ia) : kp;
        function Rm(e) {
          return tu(e) && e >= -Sn && e <= Sn;
        }
        var au = ba ? Oe(ba) : Bp;
        function Gt(e) {
          return typeof e == "string" || !D(e) && se(e) && Se(e) == Cr;
        }
        function Le(e) {
          return typeof e == "symbol" || se(e) && Se(e) == Xr;
        }
        var cr = Sa ? Oe(Sa) : Pp;
        function Om(e) {
          return e === o;
        }
        function zm(e) {
          return se(e) && be(e) == yr;
        }
        function Lm(e) {
          return se(e) && Se(e) == Qc;
        }
        var Fm = wt(Do), Gm = wt(function(e, r) {
          return e <= r;
        });
        function su(e) {
          if (!e)
            return [];
          if (Ne(e))
            return Gt(e) ? je(e) : Ee(e);
          if (xr && e[xr])
            return _d(e[xr]());
          var r = be(e), i = r == Ve ? No : r == Je ? ot : lr;
          return i(e);
        }
        function vn(e) {
          if (!e)
            return e === 0 ? e : 0;
          if (e = qe(e), e === Rn || e === -Rn) {
            var r = e < 0 ? -1 : 1;
            return r * Kc;
          }
          return e === e ? e : 0;
        }
        function Z(e) {
          var r = vn(e), i = r % 1;
          return r === r ? i ? r - i : r : 0;
        }
        function uu(e) {
          return e ? Gn(Z(e), 0, rn) : 0;
        }
        function qe(e) {
          if (typeof e == "number")
            return e;
          if (Le(e))
            return Vr;
          if (oe(e)) {
            var r = typeof e.valueOf == "function" ? e.valueOf() : e;
            e = oe(r) ? r + "" : r;
          }
          if (typeof e != "string")
            return e === 0 ? e : +e;
          e = Na(e);
          var i = Il.test(e);
          return i || Sl.test(e) ? Ql(e.slice(2), i ? 2 : 8) : vl.test(e) ? Vr : +e;
        }
        function cu(e) {
          return an(e, xe(e));
        }
        function Dm(e) {
          return e ? Gn(Z(e), -Sn, Sn) : e === 0 ? e : 0;
        }
        function J(e) {
          return e == null ? "" : ze(e);
        }
        var Zm = ar(function(e, r) {
          if (Gr(r) || Ne(r)) {
            an(r, he(r), e);
            return;
          }
          for (var i in r)
            V.call(r, i) && Pr(e, i, r[i]);
        }), lu = ar(function(e, r) {
          an(r, xe(r), e);
        }), du = ar(function(e, r, i, s) {
          an(r, xe(r), e, s);
        }), fi = ar(function(e, r, i, s) {
          an(r, he(r), e, s);
        }), Um = mn(Po);
        function $m(e, r) {
          var i = ir(e);
          return r == null ? i : Ua(i, r);
        }
        var Km = $(function(e, r) {
          e = Y(e);
          var i = -1, s = r.length, c = s > 2 ? r[2] : o;
          for (c && Ae(r[0], r[1], c) && (s = 1); ++i < s; )
            for (var d = r[i], h = xe(d), m = -1, v = h.length; ++m < v; ) {
              var A = h[m], C = e[A];
              (C === o || Qe(C, rr[A]) && !V.call(e, A)) && (e[A] = d[A]);
            }
          return e;
        }), Hm = $(function(e) {
          return e.push(o, Ns), Pe(pu, o, e);
        });
        function qm(e, r) {
          return Ta(e, O(r, 3), on);
        }
        function Wm(e, r) {
          return Ta(e, O(r, 3), Oo);
        }
        function Vm(e, r) {
          return e == null ? e : Ro(e, O(r, 3), xe);
        }
        function Jm(e, r) {
          return e == null ? e : Wa(e, O(r, 3), xe);
        }
        function jm(e, r) {
          return e && on(e, O(r, 3));
        }
        function Ym(e, r) {
          return e && Oo(e, O(r, 3));
        }
        function Xm(e) {
          return e == null ? [] : St(e, he(e));
        }
        function Qm(e) {
          return e == null ? [] : St(e, xe(e));
        }
        function hi(e, r, i) {
          var s = e == null ? o : Dn(e, r);
          return s === o ? i : s;
        }
        function e_(e, r) {
          return e != null && Ms(e, r, Tp);
        }
        function mi(e, r) {
          return e != null && Ms(e, r, Cp);
        }
        var n_ = As(function(e, r, i) {
          r != null && typeof r.toString != "function" && (r = ut.call(r)), e[r] = i;
        }, gi(we)), r_ = As(function(e, r, i) {
          r != null && typeof r.toString != "function" && (r = ut.call(r)), V.call(e, r) ? e[r].push(i) : e[r] = [i];
        }, O), t_ = $(Or);
        function he(e) {
          return Ne(e) ? Da(e) : Go(e);
        }
        function xe(e) {
          return Ne(e) ? Da(e, !0) : Rp(e);
        }
        function o_(e, r) {
          var i = {};
          return r = O(r, 3), on(e, function(s, c, d) {
            tn(i, r(s, c, d), s);
          }), i;
        }
        function i_(e, r) {
          var i = {};
          return r = O(r, 3), on(e, function(s, c, d) {
            tn(i, c, r(s, c, d));
          }), i;
        }
        var a_ = ar(function(e, r, i) {
          At(e, r, i);
        }), pu = ar(function(e, r, i, s) {
          At(e, r, i, s);
        }), s_ = mn(function(e, r) {
          var i = {};
          if (e == null)
            return i;
          var s = !1;
          r = re(r, function(d) {
            return d = xn(d, e), s || (s = d.length > 1), d;
          }), an(e, Qo(e), i), s && (i = $e(i, B | L | ae, nf));
          for (var c = r.length; c--; )
            Ho(i, r[c]);
          return i;
        });
        function u_(e, r) {
          return fu(e, Lt(O(r)));
        }
        var c_ = mn(function(e, r) {
          return e == null ? {} : zp(e, r);
        });
        function fu(e, r) {
          if (e == null)
            return {};
          var i = re(Qo(e), function(s) {
            return [s];
          });
          return r = O(r), ts(e, i, function(s, c) {
            return r(s, c[0]);
          });
        }
        function l_(e, r, i) {
          r = xn(r, e);
          var s = -1, c = r.length;
          for (c || (c = 1, e = o); ++s < c; ) {
            var d = e == null ? o : e[Xe(r[s])];
            d === o && (s = c, d = i), e = gn(d) ? d.call(e) : d;
          }
          return e;
        }
        function d_(e, r, i) {
          return e == null ? e : Lr(e, r, i);
        }
        function p_(e, r, i, s) {
          return s = typeof s == "function" ? s : o, e == null ? e : Lr(e, r, i, s);
        }
        var hu = ys(he), mu = ys(xe);
        function f_(e, r, i) {
          var s = D(e), c = s || Mn(e) || cr(e);
          if (r = O(r, 4), i == null) {
            var d = e && e.constructor;
            c ? i = s ? new d() : [] : oe(e) ? i = gn(d) ? ir(dt(e)) : {} : i = {};
          }
          return (c ? Re : on)(e, function(h, m, v) {
            return r(i, h, m, v);
          }), i;
        }
        function h_(e, r) {
          return e == null ? !0 : Ho(e, r);
        }
        function m_(e, r, i) {
          return e == null ? e : us(e, r, Vo(i));
        }
        function __(e, r, i, s) {
          return s = typeof s == "function" ? s : o, e == null ? e : us(e, r, Vo(i), s);
        }
        function lr(e) {
          return e == null ? [] : Eo(e, he(e));
        }
        function g_(e) {
          return e == null ? [] : Eo(e, xe(e));
        }
        function v_(e, r, i) {
          return i === o && (i = r, r = o), i !== o && (i = qe(i), i = i === i ? i : 0), r !== o && (r = qe(r), r = r === r ? r : 0), Gn(qe(e), r, i);
        }
        function I_(e, r, i) {
          return r = vn(r), i === o ? (i = r, r = 0) : i = vn(i), e = qe(e), yp(e, r, i);
        }
        function b_(e, r, i) {
          if (i && typeof i != "boolean" && Ae(e, r, i) && (r = i = o), i === o && (typeof r == "boolean" ? (i = r, r = o) : typeof e == "boolean" && (i = e, e = o)), e === o && r === o ? (e = 0, r = 1) : (e = vn(e), r === o ? (r = e, e = 0) : r = vn(r)), e > r) {
            var s = e;
            e = r, r = s;
          }
          if (i || e % 1 || r % 1) {
            var c = Fa();
            return Ie(e + c * (r - e + Xl("1e-" + ((c + "").length - 1))), r);
          }
          return Uo(e, r);
        }
        var S_ = sr(function(e, r, i) {
          return r = r.toLowerCase(), e + (i ? _u(r) : r);
        });
        function _u(e) {
          return _i(J(e).toLowerCase());
        }
        function gu(e) {
          return e = J(e), e && e.replace(Tl, dd).replace(Ul, "");
        }
        function A_(e, r, i) {
          e = J(e), r = ze(r);
          var s = e.length;
          i = i === o ? s : Gn(Z(i), 0, s);
          var c = i;
          return i -= r.length, i >= 0 && e.slice(i, c) == r;
        }
        function T_(e) {
          return e = J(e), e && ol.test(e) ? e.replace(qi, pd) : e;
        }
        function C_(e) {
          return e = J(e), e && ll.test(e) ? e.replace(co, "\\$&") : e;
        }
        var y_ = sr(function(e, r, i) {
          return e + (i ? "-" : "") + r.toLowerCase();
        }), E_ = sr(function(e, r, i) {
          return e + (i ? " " : "") + r.toLowerCase();
        }), N_ = Is("toLowerCase");
        function x_(e, r, i) {
          e = J(e), r = Z(r);
          var s = r ? er(e) : 0;
          if (!r || s >= r)
            return e;
          var c = (r - s) / 2;
          return xt(mt(c), i) + e + xt(ht(c), i);
        }
        function w_(e, r, i) {
          e = J(e), r = Z(r);
          var s = r ? er(e) : 0;
          return r && s < r ? e + xt(r - s, i) : e;
        }
        function M_(e, r, i) {
          e = J(e), r = Z(r);
          var s = r ? er(e) : 0;
          return r && s < r ? xt(r - s, i) + e : e;
        }
        function k_(e, r, i) {
          return i || r == null ? r = 0 : r && (r = +r), Fd(J(e).replace(lo, ""), r || 0);
        }
        function B_(e, r, i) {
          return (i ? Ae(e, r, i) : r === o) ? r = 1 : r = Z(r), $o(J(e), r);
        }
        function P_() {
          var e = arguments, r = J(e[0]);
          return e.length < 3 ? r : r.replace(e[1], e[2]);
        }
        var R_ = sr(function(e, r, i) {
          return e + (i ? "_" : "") + r.toLowerCase();
        });
        function O_(e, r, i) {
          return i && typeof i != "number" && Ae(e, r, i) && (r = i = o), i = i === o ? rn : i >>> 0, i ? (e = J(e), e && (typeof r == "string" || r != null && !pi(r)) && (r = ze(r), !r && Qn(e)) ? wn(je(e), 0, i) : e.split(r, i)) : [];
        }
        var z_ = sr(function(e, r, i) {
          return e + (i ? " " : "") + _i(r);
        });
        function L_(e, r, i) {
          return e = J(e), i = i == null ? 0 : Gn(Z(i), 0, e.length), r = ze(r), e.slice(i, i + r.length) == r;
        }
        function F_(e, r, i) {
          var s = l.templateSettings;
          i && Ae(e, r, i) && (r = o), e = J(e), r = fi({}, r, s, Es);
          var c = fi({}, r.imports, s.imports, Es), d = he(c), h = Eo(c, d);
          Re(d, function(R) {
            if (Vi.test(R))
              throw new F(S);
          });
          var m, v, A = 0, C = r.interpolate || Qr, y = "__p += '", N = xo(
            (r.escape || Qr).source + "|" + C.source + "|" + (C === Wi ? gl : Qr).source + "|" + (r.evaluate || Qr).source + "|$",
            "g"
          ), M = "//# sourceURL=" + (V.call(r, "sourceURL") ? (r.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Wl + "]") + `
`;
          e.replace(N, function(R, K, q, Fe, Te, Ge) {
            return q || (q = Fe), y += e.slice(A, Ge).replace(Cl, fd), K && (m = !0, y += `' +
__e(` + K + `) +
'`), Te && (v = !0, y += `';
` + Te + `;
__p += '`), q && (y += `' +
((__t = (` + q + `)) == null ? '' : __t) +
'`), A = Ge + R.length, R;
          }), y += `';
`;
          var z = V.call(r, "variable") && r.variable;
          if (!z)
            y = `with (obj) {
` + y + `
}
`;
          else if (Vi.test(z))
            throw new F(g);
          y = (v ? y.replace(el, "") : y).replace(nl, "$1").replace(rl, "$1;"), y = "function(" + (z || "obj") + `) {
` + (z ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (m ? ", __e = _.escape" : "") + (v ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + y + `return __p
}`;
          var U = Iu(function() {
            return W(d, M + "return " + y).apply(o, h);
          });
          if (U.source = y, di(U))
            throw U;
          return U;
        }
        function G_(e) {
          return J(e).toLowerCase();
        }
        function D_(e) {
          return J(e).toUpperCase();
        }
        function Z_(e, r, i) {
          if (e = J(e), e && (i || r === o))
            return Na(e);
          if (!e || !(r = ze(r)))
            return e;
          var s = je(e), c = je(r), d = xa(s, c), h = wa(s, c) + 1;
          return wn(s, d, h).join("");
        }
        function U_(e, r, i) {
          if (e = J(e), e && (i || r === o))
            return e.slice(0, ka(e) + 1);
          if (!e || !(r = ze(r)))
            return e;
          var s = je(e), c = wa(s, je(r)) + 1;
          return wn(s, 0, c).join("");
        }
        function $_(e, r, i) {
          if (e = J(e), e && (i || r === o))
            return e.replace(lo, "");
          if (!e || !(r = ze(r)))
            return e;
          var s = je(e), c = xa(s, je(r));
          return wn(s, c).join("");
        }
        function K_(e, r) {
          var i = Fc, s = Gc;
          if (oe(r)) {
            var c = "separator" in r ? r.separator : c;
            i = "length" in r ? Z(r.length) : i, s = "omission" in r ? ze(r.omission) : s;
          }
          e = J(e);
          var d = e.length;
          if (Qn(e)) {
            var h = je(e);
            d = h.length;
          }
          if (i >= d)
            return e;
          var m = i - er(s);
          if (m < 1)
            return s;
          var v = h ? wn(h, 0, m).join("") : e.slice(0, m);
          if (c === o)
            return v + s;
          if (h && (m += v.length - m), pi(c)) {
            if (e.slice(m).search(c)) {
              var A, C = v;
              for (c.global || (c = xo(c.source, J(Ji.exec(c)) + "g")), c.lastIndex = 0; A = c.exec(C); )
                var y = A.index;
              v = v.slice(0, y === o ? m : y);
            }
          } else if (e.indexOf(ze(c), m) != m) {
            var N = v.lastIndexOf(c);
            N > -1 && (v = v.slice(0, N));
          }
          return v + s;
        }
        function H_(e) {
          return e = J(e), e && tl.test(e) ? e.replace(Hi, bd) : e;
        }
        var q_ = sr(function(e, r, i) {
          return e + (i ? " " : "") + r.toUpperCase();
        }), _i = Is("toUpperCase");
        function vu(e, r, i) {
          return e = J(e), r = i ? o : r, r === o ? md(e) ? Td(e) : ad(e) : e.match(r) || [];
        }
        var Iu = $(function(e, r) {
          try {
            return Pe(e, o, r);
          } catch (i) {
            return di(i) ? i : new F(i);
          }
        }), W_ = mn(function(e, r) {
          return Re(r, function(i) {
            i = Xe(i), tn(e, i, ci(e[i], e));
          }), e;
        });
        function V_(e) {
          var r = e == null ? 0 : e.length, i = O();
          return e = r ? re(e, function(s) {
            if (typeof s[1] != "function")
              throw new Ze(p);
            return [i(s[0]), s[1]];
          }) : [], $(function(s) {
            for (var c = -1; ++c < r; ) {
              var d = e[c];
              if (Pe(d[0], this, s))
                return Pe(d[1], this, s);
            }
          });
        }
        function J_(e) {
          return bp($e(e, B));
        }
        function gi(e) {
          return function() {
            return e;
          };
        }
        function j_(e, r) {
          return e == null || e !== e ? r : e;
        }
        var Y_ = Ss(), X_ = Ss(!0);
        function we(e) {
          return e;
        }
        function vi(e) {
          return Ya(typeof e == "function" ? e : $e(e, B));
        }
        function Q_(e) {
          return Qa($e(e, B));
        }
        function eg(e, r) {
          return es(e, $e(r, B));
        }
        var ng = $(function(e, r) {
          return function(i) {
            return Or(i, e, r);
          };
        }), rg = $(function(e, r) {
          return function(i) {
            return Or(e, i, r);
          };
        });
        function Ii(e, r, i) {
          var s = he(r), c = St(r, s);
          i == null && !(oe(r) && (c.length || !s.length)) && (i = r, r = e, e = this, c = St(r, he(r)));
          var d = !(oe(i) && "chain" in i) || !!i.chain, h = gn(e);
          return Re(c, function(m) {
            var v = r[m];
            e[m] = v, h && (e.prototype[m] = function() {
              var A = this.__chain__;
              if (d || A) {
                var C = e(this.__wrapped__), y = C.__actions__ = Ee(this.__actions__);
                return y.push({ func: v, args: arguments, thisArg: e }), C.__chain__ = A, C;
              }
              return v.apply(e, Tn([this.value()], arguments));
            });
          }), e;
        }
        function tg() {
          return _e._ === this && (_e._ = wd), this;
        }
        function bi() {
        }
        function og(e) {
          return e = Z(e), $(function(r) {
            return ns(r, e);
          });
        }
        var ig = jo(re), ag = jo(Aa), sg = jo(So);
        function bu(e) {
          return ti(e) ? Ao(Xe(e)) : Lp(e);
        }
        function ug(e) {
          return function(r) {
            return e == null ? o : Dn(e, r);
          };
        }
        var cg = Ts(), lg = Ts(!0);
        function Si() {
          return [];
        }
        function Ai() {
          return !1;
        }
        function dg() {
          return {};
        }
        function pg() {
          return "";
        }
        function fg() {
          return !0;
        }
        function hg(e, r) {
          if (e = Z(e), e < 1 || e > Sn)
            return [];
          var i = rn, s = Ie(e, rn);
          r = O(r), e -= rn;
          for (var c = yo(s, r); ++i < e; )
            r(i);
          return c;
        }
        function mg(e) {
          return D(e) ? re(e, Xe) : Le(e) ? [e] : Ee(Gs(J(e)));
        }
        function _g(e) {
          var r = ++Nd;
          return J(e) + r;
        }
        var gg = Nt(function(e, r) {
          return e + r;
        }, 0), vg = Yo("ceil"), Ig = Nt(function(e, r) {
          return e / r;
        }, 1), bg = Yo("floor");
        function Sg(e) {
          return e && e.length ? bt(e, we, zo) : o;
        }
        function Ag(e, r) {
          return e && e.length ? bt(e, O(r, 2), zo) : o;
        }
        function Tg(e) {
          return ya(e, we);
        }
        function Cg(e, r) {
          return ya(e, O(r, 2));
        }
        function yg(e) {
          return e && e.length ? bt(e, we, Do) : o;
        }
        function Eg(e, r) {
          return e && e.length ? bt(e, O(r, 2), Do) : o;
        }
        var Ng = Nt(function(e, r) {
          return e * r;
        }, 1), xg = Yo("round"), wg = Nt(function(e, r) {
          return e - r;
        }, 0);
        function Mg(e) {
          return e && e.length ? Co(e, we) : 0;
        }
        function kg(e, r) {
          return e && e.length ? Co(e, O(r, 2)) : 0;
        }
        return l.after = em, l.ary = js, l.assign = Zm, l.assignIn = lu, l.assignInWith = du, l.assignWith = fi, l.at = Um, l.before = Ys, l.bind = ci, l.bindAll = W_, l.bindKey = Xs, l.castArray = pm, l.chain = Ws, l.chunk = Sf, l.compact = Af, l.concat = Tf, l.cond = V_, l.conforms = J_, l.constant = gi, l.countBy = kh, l.create = $m, l.curry = Qs, l.curryRight = eu, l.debounce = nu, l.defaults = Km, l.defaultsDeep = Hm, l.defer = nm, l.delay = rm, l.difference = Cf, l.differenceBy = yf, l.differenceWith = Ef, l.drop = Nf, l.dropRight = xf, l.dropRightWhile = wf, l.dropWhile = Mf, l.fill = kf, l.filter = Ph, l.flatMap = zh, l.flatMapDeep = Lh, l.flatMapDepth = Fh, l.flatten = $s, l.flattenDeep = Bf, l.flattenDepth = Pf, l.flip = tm, l.flow = Y_, l.flowRight = X_, l.fromPairs = Rf, l.functions = Xm, l.functionsIn = Qm, l.groupBy = Gh, l.initial = zf, l.intersection = Lf, l.intersectionBy = Ff, l.intersectionWith = Gf, l.invert = n_, l.invertBy = r_, l.invokeMap = Zh, l.iteratee = vi, l.keyBy = Uh, l.keys = he, l.keysIn = xe, l.map = Rt, l.mapKeys = o_, l.mapValues = i_, l.matches = Q_, l.matchesProperty = eg, l.memoize = zt, l.merge = a_, l.mergeWith = pu, l.method = ng, l.methodOf = rg, l.mixin = Ii, l.negate = Lt, l.nthArg = og, l.omit = s_, l.omitBy = u_, l.once = om, l.orderBy = $h, l.over = ig, l.overArgs = im, l.overEvery = ag, l.overSome = sg, l.partial = li, l.partialRight = ru, l.partition = Kh, l.pick = c_, l.pickBy = fu, l.property = bu, l.propertyOf = ug, l.pull = $f, l.pullAll = Hs, l.pullAllBy = Kf, l.pullAllWith = Hf, l.pullAt = qf, l.range = cg, l.rangeRight = lg, l.rearg = am, l.reject = Wh, l.remove = Wf, l.rest = sm, l.reverse = si, l.sampleSize = Jh, l.set = d_, l.setWith = p_, l.shuffle = jh, l.slice = Vf, l.sortBy = Qh, l.sortedUniq = nh, l.sortedUniqBy = rh, l.split = O_, l.spread = um, l.tail = th, l.take = oh, l.takeRight = ih, l.takeRightWhile = ah, l.takeWhile = sh, l.tap = Ah, l.throttle = cm, l.thru = Pt, l.toArray = su, l.toPairs = hu, l.toPairsIn = mu, l.toPath = mg, l.toPlainObject = cu, l.transform = f_, l.unary = lm, l.union = uh, l.unionBy = ch, l.unionWith = lh, l.uniq = dh, l.uniqBy = ph, l.uniqWith = fh, l.unset = h_, l.unzip = ui, l.unzipWith = qs, l.update = m_, l.updateWith = __, l.values = lr, l.valuesIn = g_, l.without = hh, l.words = vu, l.wrap = dm, l.xor = mh, l.xorBy = _h, l.xorWith = gh, l.zip = vh, l.zipObject = Ih, l.zipObjectDeep = bh, l.zipWith = Sh, l.entries = hu, l.entriesIn = mu, l.extend = lu, l.extendWith = du, Ii(l, l), l.add = gg, l.attempt = Iu, l.camelCase = S_, l.capitalize = _u, l.ceil = vg, l.clamp = v_, l.clone = fm, l.cloneDeep = mm, l.cloneDeepWith = _m, l.cloneWith = hm, l.conformsTo = gm, l.deburr = gu, l.defaultTo = j_, l.divide = Ig, l.endsWith = A_, l.eq = Qe, l.escape = T_, l.escapeRegExp = C_, l.every = Bh, l.find = Rh, l.findIndex = Zs, l.findKey = qm, l.findLast = Oh, l.findLastIndex = Us, l.findLastKey = Wm, l.floor = bg, l.forEach = Vs, l.forEachRight = Js, l.forIn = Vm, l.forInRight = Jm, l.forOwn = jm, l.forOwnRight = Ym, l.get = hi, l.gt = vm, l.gte = Im, l.has = e_, l.hasIn = mi, l.head = Ks, l.identity = we, l.includes = Dh, l.indexOf = Of, l.inRange = I_, l.invoke = t_, l.isArguments = $n, l.isArray = D, l.isArrayBuffer = bm, l.isArrayLike = Ne, l.isArrayLikeObject = ue, l.isBoolean = Sm, l.isBuffer = Mn, l.isDate = Am, l.isElement = Tm, l.isEmpty = Cm, l.isEqual = ym, l.isEqualWith = Em, l.isError = di, l.isFinite = Nm, l.isFunction = gn, l.isInteger = tu, l.isLength = Ft, l.isMap = ou, l.isMatch = xm, l.isMatchWith = wm, l.isNaN = Mm, l.isNative = km, l.isNil = Pm, l.isNull = Bm, l.isNumber = iu, l.isObject = oe, l.isObjectLike = se, l.isPlainObject = Zr, l.isRegExp = pi, l.isSafeInteger = Rm, l.isSet = au, l.isString = Gt, l.isSymbol = Le, l.isTypedArray = cr, l.isUndefined = Om, l.isWeakMap = zm, l.isWeakSet = Lm, l.join = Df, l.kebabCase = y_, l.last = He, l.lastIndexOf = Zf, l.lowerCase = E_, l.lowerFirst = N_, l.lt = Fm, l.lte = Gm, l.max = Sg, l.maxBy = Ag, l.mean = Tg, l.meanBy = Cg, l.min = yg, l.minBy = Eg, l.stubArray = Si, l.stubFalse = Ai, l.stubObject = dg, l.stubString = pg, l.stubTrue = fg, l.multiply = Ng, l.nth = Uf, l.noConflict = tg, l.noop = bi, l.now = Ot, l.pad = x_, l.padEnd = w_, l.padStart = M_, l.parseInt = k_, l.random = b_, l.reduce = Hh, l.reduceRight = qh, l.repeat = B_, l.replace = P_, l.result = l_, l.round = xg, l.runInContext = _, l.sample = Vh, l.size = Yh, l.snakeCase = R_, l.some = Xh, l.sortedIndex = Jf, l.sortedIndexBy = jf, l.sortedIndexOf = Yf, l.sortedLastIndex = Xf, l.sortedLastIndexBy = Qf, l.sortedLastIndexOf = eh, l.startCase = z_, l.startsWith = L_, l.subtract = wg, l.sum = Mg, l.sumBy = kg, l.template = F_, l.times = hg, l.toFinite = vn, l.toInteger = Z, l.toLength = uu, l.toLower = G_, l.toNumber = qe, l.toSafeInteger = Dm, l.toString = J, l.toUpper = D_, l.trim = Z_, l.trimEnd = U_, l.trimStart = $_, l.truncate = K_, l.unescape = H_, l.uniqueId = _g, l.upperCase = q_, l.upperFirst = _i, l.each = Vs, l.eachRight = Js, l.first = Ks, Ii(l, (function() {
          var e = {};
          return on(l, function(r, i) {
            V.call(l.prototype, i) || (e[i] = r);
          }), e;
        })(), { chain: !1 }), l.VERSION = a, Re(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
          l[e].placeholder = l;
        }), Re(["drop", "take"], function(e, r) {
          H.prototype[e] = function(i) {
            i = i === o ? 1 : fe(Z(i), 0);
            var s = this.__filtered__ && !r ? new H(this) : this.clone();
            return s.__filtered__ ? s.__takeCount__ = Ie(i, s.__takeCount__) : s.__views__.push({
              size: Ie(i, rn),
              type: e + (s.__dir__ < 0 ? "Right" : "")
            }), s;
          }, H.prototype[e + "Right"] = function(i) {
            return this.reverse()[e](i).reverse();
          };
        }), Re(["filter", "map", "takeWhile"], function(e, r) {
          var i = r + 1, s = i == Ui || i == $c;
          H.prototype[e] = function(c) {
            var d = this.clone();
            return d.__iteratees__.push({
              iteratee: O(c, 3),
              type: i
            }), d.__filtered__ = d.__filtered__ || s, d;
          };
        }), Re(["head", "last"], function(e, r) {
          var i = "take" + (r ? "Right" : "");
          H.prototype[e] = function() {
            return this[i](1).value()[0];
          };
        }), Re(["initial", "tail"], function(e, r) {
          var i = "drop" + (r ? "" : "Right");
          H.prototype[e] = function() {
            return this.__filtered__ ? new H(this) : this[i](1);
          };
        }), H.prototype.compact = function() {
          return this.filter(we);
        }, H.prototype.find = function(e) {
          return this.filter(e).head();
        }, H.prototype.findLast = function(e) {
          return this.reverse().find(e);
        }, H.prototype.invokeMap = $(function(e, r) {
          return typeof e == "function" ? new H(this) : this.map(function(i) {
            return Or(i, e, r);
          });
        }), H.prototype.reject = function(e) {
          return this.filter(Lt(O(e)));
        }, H.prototype.slice = function(e, r) {
          e = Z(e);
          var i = this;
          return i.__filtered__ && (e > 0 || r < 0) ? new H(i) : (e < 0 ? i = i.takeRight(-e) : e && (i = i.drop(e)), r !== o && (r = Z(r), i = r < 0 ? i.dropRight(-r) : i.take(r - e)), i);
        }, H.prototype.takeRightWhile = function(e) {
          return this.reverse().takeWhile(e).reverse();
        }, H.prototype.toArray = function() {
          return this.take(rn);
        }, on(H.prototype, function(e, r) {
          var i = /^(?:filter|find|map|reject)|While$/.test(r), s = /^(?:head|last)$/.test(r), c = l[s ? "take" + (r == "last" ? "Right" : "") : r], d = s || /^find/.test(r);
          c && (l.prototype[r] = function() {
            var h = this.__wrapped__, m = s ? [1] : arguments, v = h instanceof H, A = m[0], C = v || D(h), y = function(K) {
              var q = c.apply(l, Tn([K], m));
              return s && N ? q[0] : q;
            };
            C && i && typeof A == "function" && A.length != 1 && (v = C = !1);
            var N = this.__chain__, M = !!this.__actions__.length, z = d && !N, U = v && !M;
            if (!d && C) {
              h = U ? h : new H(this);
              var R = e.apply(h, m);
              return R.__actions__.push({ func: Pt, args: [y], thisArg: o }), new Ue(R, N);
            }
            return z && U ? e.apply(this, m) : (R = this.thru(y), z ? s ? R.value()[0] : R.value() : R);
          });
        }), Re(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
          var r = it[e], i = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", s = /^(?:pop|shift)$/.test(e);
          l.prototype[e] = function() {
            var c = arguments;
            if (s && !this.__chain__) {
              var d = this.value();
              return r.apply(D(d) ? d : [], c);
            }
            return this[i](function(h) {
              return r.apply(D(h) ? h : [], c);
            });
          };
        }), on(H.prototype, function(e, r) {
          var i = l[r];
          if (i) {
            var s = i.name + "";
            V.call(or, s) || (or[s] = []), or[s].push({ name: r, func: i });
          }
        }), or[Et(o, bn).name] = [{
          name: "wrapper",
          func: o
        }], H.prototype.clone = Hd, H.prototype.reverse = qd, H.prototype.value = Wd, l.prototype.at = Th, l.prototype.chain = Ch, l.prototype.commit = yh, l.prototype.next = Eh, l.prototype.plant = xh, l.prototype.reverse = wh, l.prototype.toJSON = l.prototype.valueOf = l.prototype.value = Mh, l.prototype.first = l.prototype.head, xr && (l.prototype[xr] = Nh), l;
      }), nr = Cd();
      On ? ((On.exports = nr)._ = nr, go._ = nr) : _e._ = nr;
    }).call(N1);
  })(Kr, Kr.exports)), Kr.exports;
}
var Hr = x1();
const y0 = (n, t) => {
  const o = Hr.mapValues(n, (u) => u === "" || u === void 0 ? null : u);
  return Hr.omit(o, t);
}, E0 = (n, t, o) => {
  const a = o ? Hr.omitBy(o, (u) => u === null) : {};
  Hr.assign(n, t, Hr.pick(a, Object.keys(n)));
}, N0 = (n) => {
  const { properties: t } = n, { context: o } = t;
  return {
    addressNumber: o.address?.address_number,
    alternate: o.region?.alternate?.name,
    country: o.country?.name,
    countryCode: o.country?.country_code,
    fullAddress: t.full_address,
    latitude: t.coordinates.latitude,
    longitude: t.coordinates.longitude,
    mapboxId: t.mapbox_id,
    place: o.place?.name,
    postcode: o.postcode?.name,
    region: o.region?.name,
    streetName: o.street?.name
  };
}, x0 = (n, t) => {
  if (t == null)
    return null;
  const o = t.trim();
  if (o.length === 0)
    return null;
  const a = g1[n] ?? [];
  if (a.length === 0)
    return o.toUpperCase();
  const u = o.toLowerCase(), f = a.find((p) => p.code.toLowerCase() === u || p.name.toLowerCase() === u);
  return f ? f.code.toUpperCase() : null;
}, w0 = (n) => {
  if (typeof n != "string") return !1;
  const t = n.replace(/-\d{1,2}$/, ""), o = /^\d+$/.test(t), a = /^[a-zA-Z0-9]+$/.test(t), u = t.length;
  return o && u >= 8 && u <= 10 || a && u === 17;
}, M0 = (n, t) => {
  if (typeof n != "number" || !Number.isInteger(n)) return !1;
  const o = -(2 ** (t - 1)), a = 2 ** (t - 1) - 1;
  return n >= o && n <= a;
}, w1 = [
  { threshold: 0, step: 1 },
  { threshold: 10, step: 5 },
  { threshold: 50, step: 10 },
  { threshold: 100, step: 50 },
  { threshold: 1e3, step: 100 },
  { threshold: 5e3, step: 200 },
  { threshold: 1e4, step: 500 },
  { threshold: 5e4, step: 1e3 }
];
class Pc {
  constructor(t) {
    if (!t[0])
      throw new Error("SaleSteppedPrice requires at least one tier");
    this.tiers = [...t].sort((a, u) => a.threshold - u.threshold);
    const o = this.tiers[0];
    if (!o)
      throw new Error("SaleSteppedPrice requires at least one tier");
    this.firstTier = o;
  }
  /** Creates an instance with the default MVP1 tiers (see DEFAULT_SALE_STEP_TIERS). */
  static createDefault() {
    return new Pc(w1);
  }
  /**
   * Checks whether an amount falls on the stepped price grid.
   *
   * @example validateAmount(1200) // true  (tier 1000-4999, step 100: (1200-1000) % 100 === 0)
   * @example validateAmount(1250) // false (tier 1000-4999, step 100: (1250-1000) % 100 !== 0)
   */
  validateAmount(t) {
    if (t < 0)
      return !1;
    const o = this.getTierForAmount(t, "up");
    return (t - o.threshold) % o.step === 0;
  }
  /**
   * Rounds an amount down (floor) to the nearest valid step value.
   *
   * @example getStepRoundedAmount(5300) // 5200 (tier 5000-9999, step 200)
   */
  getStepRoundedAmount(t) {
    return this.getStepRoundedValue(t, Math.floor);
  }
  /**
   * Rounds a reserve price up (ceil) to the nearest valid step value.
   *
   * @example getStepRoundedReservePrice(5100) // 5200 (tier 5000-9999, step 200)
   */
  getStepRoundedReservePrice(t) {
    return this.getStepRoundedValue(t, Math.ceil);
  }
  /**
   * From a valid base amount, computes the amount N steps away.
   * Positive deltaSteps moves up, negative moves down. Correctly
   * switches step size when crossing tier boundaries.
   * Throws if baseAmount is not on the grid.
   *
   * @example getDeltaStepsAmount(4900, 2)  // 5200 (4900+100=5000, then 5000+200=5200)
   * @example getDeltaStepsAmount(5000, -1) // 4900 (at boundary, uses lower tier step 100)
   */
  getDeltaStepsAmount(t, o) {
    if (!this.validateAmount(t))
      throw new Error("Error in SaleSteppedPrice.getDeltaStepsAmount, base is not a valid amount");
    return this.computeDeltaStepsAmount(t, o);
  }
  /**
   * Computes a default starting price for an auction given its reserve price.
   * Uses an exponential decay formula (BSD-3693) so the gap between starting
   * and reserve grows fast for cheap items and plateaus at ~25.000 for expensive ones.
   *
   * @example getAuctionStartingPriceDefaultValue(10000)  // 4600
   * @example getAuctionStartingPriceDefaultValue(100000) // 76500
   */
  getAuctionStartingPriceDefaultValue(t) {
    const a = t - 25e3 * (1 - Math.exp(-25e-6 * t));
    return this.getStepRoundedAmount(a);
  }
  /**
   * Returns the minimum negotiation offer for a direct sale: 30% of the price,
   * rounded down to the nearest valid step.
   *
   * @example getDirectSaleMinNegotiationOfferDefaultValue(10000) // 3000
   */
  getDirectSaleMinNegotiationOfferDefaultValue(t) {
    return this.getStepRoundedAmount(t * 0.3);
  }
  /**
   * Computes the suggested (discounted) price for a direct sale.
   * Uses a sigmoid that yields ~76% for low prices, trending toward
   * 100% for very high prices. Result is rounded down to the nearest valid step.
   *
   * @example getDirectSaleSuggestedPriceDefaultValue(5000)   // 4050  (~81%)
   * @example getDirectSaleSuggestedPriceDefaultValue(100000) // 88000 (~89%)
   */
  getDirectSaleSuggestedPriceDefaultValue(t) {
    const u = 0.98 - 0.16999999999999993 * Math.exp(-6e-6 * t);
    return this.getStepRoundedAmount(t * u);
  }
  /**
   * Finds the applicable tier for a given amount.
   * - direction 'up': returns the tier whose threshold is <= amount (used for validation/rounding)
   * - direction 'down': returns the tier whose threshold is < amount (at a boundary, picks the lower tier)
   */
  getTierForAmount(t, o) {
    const a = o === "up" ? (u) => u <= t : (u) => u < t;
    for (let u = this.tiers.length - 1; u >= 0; u--) {
      const f = this.tiers[u];
      if (f && a(f.threshold))
        return f;
    }
    return this.firstTier;
  }
  /** Rounds a value to the nearest valid step using the given rounding function (floor or ceil). */
  getStepRoundedValue(t, o) {
    const a = this.getTierForAmount(t, "up"), u = t - a.threshold;
    return o(u / a.step) * a.step + a.threshold;
  }
  /** Recursive implementation of getDeltaStepsAmount. Moves one step per call, recalculating the tier each time. */
  computeDeltaStepsAmount(t, o) {
    if (o === 0)
      return t;
    const a = o / Math.abs(o), u = o > 0 ? "up" : "down", f = this.getTierForAmount(t, u);
    return this.computeDeltaStepsAmount(t + f.step * a, o - a);
  }
}
const k0 = ({
  reservePrice: n,
  isToBeScraped: t,
  isOneEuro: o
}) => {
  const a = t || n < 5e3 ? 50 : n < 1e4 ? 100 : n < 5e4 ? 500 : 1e3, u = t ? 50 : n < 5e3 ? 100 : n < 1e4 ? 500 : (n < 5e4, 1e3), f = t ? 1e3 : n < 5e3 ? 5e3 : n < 1e4 ? 1e4 : 5e4, p = t || o ? 250 : n <= 5e4 ? 500 : 1e3;
  return {
    minStepDefaultValue: a,
    maxStepDefaultValue: u,
    thresholdDefaultValue: f,
    bailDefaultValue: p
  };
};
function _r(n) {
  const t = Object.prototype.toString.call(n);
  return n instanceof Date || typeof n == "object" && t === "[object Date]" ? new n.constructor(+n) : typeof n == "number" || t === "[object Number]" || typeof n == "string" || t === "[object String]" ? new Date(n) : /* @__PURE__ */ new Date(NaN);
}
function M1(n, t) {
  const o = _r(n), a = _r(t);
  return o.getTime() > a.getTime();
}
function k1(n, t) {
  const o = _r(n), a = _r(t);
  return +o < +a;
}
function qu(n, t) {
  const o = _r(n), a = _r(t);
  return +o == +a;
}
function Zi(n) {
  throw new Error("Should not have reached this line");
}
var sn = /* @__PURE__ */ ((n) => (n.Seller = "Seller", n.Buyer = "Buyer", n))(sn || {}), un = /* @__PURE__ */ ((n) => (n.FixedPercentage = "FixedPercentage", n.FixedAmount = "FixedAmount", n.Standard = "Standard", n))(un || {});
const B1 = /* @__PURE__ */ new Date("2025-11-24"), P1 = /* @__PURE__ */ new Date("2025-11-28"), fr = 250, xi = 0.0875, Rc = 0.0375, Oc = 5250, wi = 1e5, zc = 2500, R1 = (n, [t, o]) => (qu(n, t) || M1(n, t)) && (k1(n, o) || qu(n, o)), Lc = ({
  feeTarget: n,
  baseAmount: t,
  assetsCount: o,
  feeConfiguration: a
}) => {
  const u = {
    [sn.Seller]: 1,
    [sn.Buyer]: -1
  }[n], f = t / o;
  return (() => {
    if (!a || a.type === un.Standard) {
      const p = zc - fr * u;
      return (() => {
        if (f <= p) return f + fr * u;
        const S = wi - fr * u - xi * wi * u;
        return f <= S ? (f + fr * u) / (1 - xi * u) : (f + Oc * u) / (1 - Rc * u);
      })() * o;
    }
    if (a.type === un.FixedPercentage)
      return t / (1 - a.feeOverrideValue * u);
    if (a.type === un.FixedAmount)
      return t + a.feeOverrideValue * u;
    Zi(a.type);
  })();
}, B0 = ({
  feeTarget: n,
  baseAmount: t,
  assetsCount: o,
  referenceDate: a,
  feeConfiguration: u
}) => {
  const f = t / o, p = (() => {
    if (!u || u.type === un.Standard)
      return f <= zc ? fr * o : f <= wi ? (fr + xi * f) * o : (Oc + Rc * f) * o;
    if (u.type === un.FixedPercentage)
      return t * u.feeOverrideValue;
    if (u.type === un.FixedAmount)
      return u.feeOverrideValue;
    Zi(u.type);
  })(), S = n === sn.Buyer && a && R1(a, [B1, P1]) ? p * 0.5 : p;
  return {
    grossTotal: Math.ceil(n === sn.Buyer ? t + p : t),
    grossNet: Math.ceil(n === sn.Buyer ? t : t - p),
    grossFees: Math.ceil(p),
    total: Math.ceil(n === sn.Buyer ? t + S : t),
    net: Math.ceil(n === sn.Buyer ? t : t - S),
    fees: Math.ceil(S)
  };
}, P0 = ({
  sellerReservePrice: n,
  assetsCount: t,
  feeConfiguration: o
}) => {
  const a = Math.ceil(
    Lc({
      feeTarget: sn.Seller,
      baseAmount: n,
      assetsCount: t,
      feeConfiguration: o
    })
  );
  return {
    sellerReservePrice: n,
    fees: a - n,
    reservePrice: a
  };
}, R0 = ({
  buyerBudget: n,
  assetsCount: t,
  feeConfiguration: o
}) => {
  const a = Math.ceil(
    Lc({
      feeTarget: sn.Buyer,
      baseAmount: n,
      assetsCount: t,
      feeConfiguration: o
    })
  );
  return {
    buyerBudget: n,
    fees: n - a,
    buyerMaxOffer: a
  };
}, O0 = ({
  sellerReservePrice: n,
  feeConfiguration: t
}) => {
  const o = (() => {
    if (!t || t.type === un.Standard)
      return n <= 2250 ? 250 : n <= 91e3 ? (n + 250) / 0.9125 : (n + 5250) / 0.9625;
    if (t.type === un.FixedPercentage)
      return n / (1 - t.feeOverrideValue);
    if (t.type === un.FixedAmount)
      return n + t.feeOverrideValue;
    Zi(t.type);
  })();
  return Math.ceil(o);
}, z0 = ({
  isSeller: n,
  isCustomerService: t,
  isAssignedSalesRep: o
}) => n || t || o;
var O1 = /* @__PURE__ */ ((n) => (n.VEHICLE_TOO_OLD = "VEHICLE_TOO_OLD", n.ELECTRIC_OR_HYBRID = "ELECTRIC_OR_HYBRID", n.MILEAGE_OR_MAINTENANCE_EXCEEDED = "MILEAGE_OR_MAINTENANCE_EXCEEDED", n.NOT_SUPPORTED_VEHICLE_CLASS = "NOT_SUPPORTED_VEHICLE_CLASS", n.MISSING_REQUIRED_DATA = "MISSING_REQUIRED_DATA", n))(O1 || {});
const L0 = {
  FleequidCare: {
    coverageCap: 1e4,
    warrantyDurationMonths: 3,
    creditPercentageGuidelines: [
      { maxAmount: 3e3, minCreditPercentage: 50 },
      { maxAmount: 5e3, minCreditPercentage: 45 },
      { maxAmount: 7e3, minCreditPercentage: 40 },
      { maxAmount: 9e3, minCreditPercentage: 35 },
      { maxAmount: 1e4, minCreditPercentage: 30 }
    ]
  },
  PowertrainWarranty: {
    coverageCap: 25e3,
    mileageLimits: [
      { durationMonths: 3, maxKm: 15e3 },
      { durationMonths: 6, maxKm: 3e4 },
      { durationMonths: 9, maxKm: 45e3 },
      { durationMonths: 12, maxKm: 6e4 }
    ],
    creditPercentageGuidelines: [
      { maxAmount: 1e4, minCreditPercentage: 30 },
      { maxAmount: 15e3, minCreditPercentage: 25 },
      { maxAmount: 2e4, minCreditPercentage: 20 },
      { maxAmount: 25e3, minCreditPercentage: 10 }
    ]
  }
};
export {
  T1 as ADMIN_USER_PASSWORD_RESET_TOKEN_PAYLOAD_TYPE,
  _0 as AdminUserPasswordResetTokenPayloadSchema,
  H1 as BANK_TRANSFER_BAIL_AUTHORIZATION_ID_PREFIX,
  q1 as BUS_ASSET_BASE_IMAGES,
  W1 as BUS_ASSET_COVER_IMAGES,
  U1 as CalcomBookingMetadataSchema,
  w1 as DEFAULT_SALE_STEP_TIERS,
  e0 as FILE_UPLOAD_EXTENSIONS,
  Q1 as FILE_UPLOAD_PDF_MAX_SIZE,
  sn as FeeTarget,
  un as FeeType,
  I1 as LanguageISO6391Schema,
  c0 as MAPBOX_API_CONFIG,
  K1 as ONE_EURO_STARTING_PRICE,
  O1 as PowertrainWarrantyIneligibilityReason,
  f0 as SEARCH_SUGGEST_MAX_QUERY_LENGTH,
  p0 as SEARCH_SUGGEST_MIN_QUERY_LENGTH,
  $1 as STEP_LOWEST_COMMON_DENOMINATOR,
  Pc as SaleSteppedPrice,
  L0 as VAS_CLAIM_CONFIGURATION,
  y0 as adaptFormDataToDto,
  N0 as adaptMapboxFeatureToAddressBody,
  h0 as addressFormFieldSchema,
  R0 as computeBuyerMaxOfferAndFees,
  B0 as computeFees,
  z0 as computeIsSellerPov,
  O0 as computeReservePrice,
  k0 as computeSaleDefaultValues,
  P0 as computeSellerReservePriceAndFees,
  A0 as convertKwToHp,
  Gi as countriesConfig,
  Nc as countryIso2List,
  s0 as customerServiceEmail,
  u0 as customerServicePhone,
  C0 as fetchFormatQuery,
  m0 as getAddressFormFieldSchema,
  j1 as getAsCountryISO2,
  Y1 as getAsCountryISO3,
  n0 as getAsLanguageISO6391,
  t0 as getAsTaxCodeOrigin,
  y1 as getAsTin,
  Z1 as getBusDossierDocumentResponsibility,
  L1 as getBusDossierFieldResponsibility,
  F1 as getBusDossierRequiredVaryingFields,
  J1 as getCountryCodesByContinent,
  X1 as getCountryISO3FromISO2,
  V1 as getCountryNameInEnglish,
  a0 as getHubspotFlagUrl,
  o0 as getHubspotSalesRepImageUrl,
  l0 as getLanguage6391FromCountryIso2,
  i0 as hubspotDefaultSalesRepImageUrl,
  Di as hubspotPublicFilesBaseUrl,
  E0 as initFormData,
  T0 as insertIf,
  G1 as isBusDossierDocumentHidden,
  D1 as isBusDossierDocumentRequired,
  z1 as isBusDossierFieldHidden,
  Pg as isBusDossierFieldRequired,
  m1 as isCountryISO2,
  _1 as isCountryISO3,
  M0 as isDbIntegerValidator,
  S1 as isTaxCodeOrigin,
  b0 as isTin,
  r0 as languageNames,
  d0 as languageToRepresentativeCountryMap,
  S0 as parseAsTin,
  g0 as phoneValidator,
  Mc as phoneValidatorE164,
  g1 as provinces,
  x0 as resolveProvinceCode,
  b1 as taxCodeOriginList,
  w0 as vinValidator,
  v0 as zodPhoneE164,
  I0 as zodPhoneE164Optional
};
//# sourceMappingURL=shared.mjs.map
